export default [
  {
    top: [
      [2, 131.5],
      [5, 141.5],
      [8, 105.5],
      [11, 105.5],
      [14, 123.5],
      [17, 110.5],
      [20, 137.5],
      [23, 126.5],
      [26, 135.5],
      [29, 144.5],
      [32, 104.5],
      [35, 138.5],
      [38, 143.2766],
      [41, 128.5],
      [44, 142.5],
      [47, 108.5],
      [50, 128.5],
      [53, 142.5],
      [56, 144.5],
      [59, 129.5],
      [62, 136.5],
      [65, 134.5],
      [68, 112.5],
      [71, 120.5],
      [74, 121.5],
      [77, 126.5],
      [80, 135.5],
      [83, 122.5],
      [86, 134.5],
      [89, 139.5],
      [92, 109.5],
      [95, 133.5],
      [98, 127.5],
      [101, 126.5],
      [104, 120.5],
      [107, 114.5],
      [110, 125.5],
      [113, 141.5],
      [116, 126.5],
      [119, 132.5],
      [122, 127.5],
      [125, 122.5],
      [128, 104.5],
      [131, 110.5],
      [134, 113.5],
      [137, 104.5],
      [140, 131.5],
      [143, 119.5],
      [146, 124.5],
      [149, 140.5],
      [152, 108.5],
      [155, 131.5],
      [158, 142.5],
      [161, 125.5],
      [164, 129.5],
      [167, 98.5],
      [170, 119.5],
      [173, 135.5],
      [176, 119.5],
      [179, 133.5],
      [182, 116.5],
      [185, 130.5],
      [188, 142.5],
      [191, 105.5],
      [194, 108.5],
      [197, 99.5],
      [200, 137.5],
      [203, 116.5],
      [206, 113.5],
      [209, 134.5],
      [212, 102.5],
      [215, 127.5],
      [218, 138.5],
      [221, 115.5],
      [224, 129.5],
      [227, 116.5],
      [230, 122.5],
      [233, 128.5],
      [236, 111.5],
      [239, 122.5],
      [242, 127.5],
      [245, 131.5],
      [248, 132.5],
      [251, 109.5],
      [254, 108.5],
      [257, 103.5],
      [260, 128.5],
      [263, 133.5],
      [266, 115.5],
      [269, 117.5],
      [272, 104.5],
      [275, 132.5],
      [278, 131.5],
      [281, 116.5],
      [284, 116.5],
      [287, 109.5],
      [290, 111.5],
      [293, 130.5],
      [296, 112.5],
      [299, 107.5],
      [302, 114.5],
      [305, 129.5],
      [308, 125.5],
      [311, 98.5],
      [314, 123.5],
      [317, 111.5],
      [320, 127.5],
      [323, 113.5],
      [326, 119.5],
      [329, 123.5],
      [332, 108.5],
      [335, 138.5],
      [338, 124.5],
      [341, 118.5],
      [344, 109.5],
      [347, 102.5],
      [350, 126.5],
      [353, 120.5],
      [356, 110.5],
      [359, 115.5],
      [362, 113.5],
      [365, 129.5],
      [368, 88.5],
      [371, 108.5],
      [374, 123.5],
      [377, 124.5],
      [380, 137.5],
      [383, 113.5],
      [386, 118.5],
      [389, 123.5],
      [392, 108.5],
      [395, 128.5],
      [398, 129.5],
      [401, 109.5],
      [404, 98.5],
      [407, 108.5],
      [410, 125.5],
      [413, 120.5],
      [416, 122.5],
      [419, 107.5],
      [422, 112.5],
      [425, 128.5],
      [428, 119.5],
      [431, 114.5],
      [434, 116.5],
      [437, 117.5],
      [440, 119.5],
      [443, 112.5],
      [446, 125.5],
      [449, 116.5],
      [452, 102.5],
      [455, 126.5],
      [458, 117.5],
      [461, 108.5],
      [464, 101.5],
      [467, 106.5],
      [470, 125.5],
      [473, 128.5],
      [476, 106.5],
      [479, 129.5],
      [482, 107.5],
      [485, 119.5],
      [488, 128.5],
      [491, 101.5],
      [494, 111.5],
      [497, 98.5],
      [500, 121.5],
      [503, 120.5],
      [506, 111.5],
      [509, 116.5],
      [512, 96.5],
      [515, 132.5],
      [518, 127.5],
      [521, 106.5],
      [524, 107.5],
      [527, 104.5],
      [530, 112.5],
      [533, 130.5],
      [536, 119.5],
      [539, 119.5],
      [542, 111.5],
      [545, 114.5],
      [548, 104.5],
      [551, 104.5],
      [554, 104.5],
      [557, 126.5],
      [560, 128.5],
      [563, 128.5],
      [566, 122.5],
      [569, 127.5],
      [572, 98.5],
      [575, 122.5],
      [578, 124.5],
      [581, 118.5],
      [584, 112.5],
      [587, 109.5],
      [590, 126.5],
      [593, 124.5],
      [596, 126.5],
      [599, 115.5],
      [602, 127.5],
      [605, 130.5],
      [608, 115.5],
      [611, 101.5],
      [614, 110.5],
      [617, 97.5],
      [620, 123.5],
      [623, 129.5],
      [626, 112.5],
      [629, 127.5],
      [632, 100.5],
      [635, 119.5],
      [638, 119.5],
      [641, 107.5],
      [644, 112.5],
      [647, 112.5],
      [650, 117.5],
      [653, 118.5],
      [656, 108.5],
      [659, 107.5],
      [662, 114.5],
      [665, 107.5],
      [668, 117.5],
      [671, 117.5],
      [674, 107.5],
      [677, 105.5],
      [680, 115.5],
      [683, 111.5],
      [686, 121.5],
      [689, 126.5],
      [692, 120.5],
      [695, 113.5],
      [698, 109.5],
      [701, 108.5],
      [704, 109.5],
      [707, 92.5],
      [710, 103.5],
      [713, 111.5],
      [716, 101.5],
      [719, 116.5],
      [722, 105.5],
      [725, 106.5],
      [728, 109.5],
      [731, 107.5],
      [734, 107.5],
      [737, 115.5],
      [740, 117.5],
      [743, 120.5],
      [746, 125.5],
      [749, 108.5],
      [752, 113.5],
      [755, 113.5],
      [758, 108.5],
      [761, 116.5],
      [764, 103.5],
      [767, 95.5],
      [770, 126.5],
      [773, 125.5],
      [776, 109.5],
      [779, 113.5],
      [782, 117.5],
      [785, 108.5],
      [788, 97.5],
      [791, 97.5],
      [794, 115.5],
      [797, 108.5],
      [800, 123.5],
      [803, 125.5],
      [806, 114.5],
      [809, 118.5],
      [812, 92.5],
      [815, 113.5],
      [818, 125.5],
      [821, 104.5],
      [824, 122.5],
      [827, 110.5],
      [830, 115.5],
      [833, 122.5],
      [836, 119.5],
      [839, 101.5],
      [842, 120.5],
      [845, 110.5],
      [848, 111.5],
      [851, 105.5],
      [854, 102.5],
      [857, 96.5],
      [860, 119.5],
      [863, 130.5],
      [866, 123.5],
      [869, 118.5],
      [872, 104.5],
      [875, 122.5],
      [878, 112.5],
      [881, 120.5],
      [884, 110.5],
      [887, 113.5],
      [890, 114.5],
      [893, 112.5],
      [896, 116.5],
      [899, 111.5],
      [902, 113.5],
      [905, 114.5],
      [908, 113.5],
      [911, 108.5],
      [914, 109.5],
      [917, 117.5],
      [920, 120.5],
      [923, 109.5],
      [926, 117.5],
      [929, 118.5],
      [932, 111.5],
      [935, 112.5],
      [938, 105.5],
      [941, 112.5],
      [944, 107.5],
      [947, 103.5],
      [950, 119.5],
      [953, 112.5],
      [956, 117.5],
      [959, 111.5],
      [962, 110.5],
      [965, 114.5],
      [968, 104.5],
      [971, 103.5],
      [974, 107.5],
      [977, 97.5],
      [980, 126.5],
      [983, 120.5],
      [986, 105.5],
      [989, 109.5],
      [992, 106.5],
      [995, 103.5],
      [998, 102.5],
      [1001, 109.5],
      [1004, 117.5],
      [1007, 111.5],
      [1010, 129.5],
      [1013, 126.5],
      [1016, 121.5],
      [1019, 123.5],
      [1022, 105.5],
      [1025, 123.5],
      [1028, 110.5],
      [1031, 103.5],
      [1034, 102.5],
      [1037, 96.5],
      [1040, 120.5],
      [1043, 113.5],
      [1046, 104.5],
      [1049, 129.5],
      [1052, 99.5],
      [1055, 119.5],
      [1058, 111.5],
      [1061, 99.5],
      [1064, 111.5],
      [1067, 101.5],
      [1070, 119.5],
      [1073, 128.5],
      [1076, 104.5],
      [1079, 108.5],
      [1082, 107.5],
      [1085, 111.5],
      [1088, 111.5],
      [1091, 101.5],
      [1094, 112.5],
      [1097, 98.5],
      [1100, 118.5],
      [1103, 125.5],
      [1106, 110.5],
      [1109, 114.5],
      [1112, 97.5],
      [1115, 125.5],
      [1118, 125.5],
      [1121, 100.5],
      [1124, 106.5],
      [1127, 94.5],
      [1130, 109.5],
      [1133, 127.5],
      [1136, 114.5],
      [1139, 110.5],
      [1142, 115.5],
      [1145, 115.5],
      [1148, 118.5],
      [1151, 98.5],
      [1154, 98.5],
      [1157, 104.5],
      [1160, 117.5],
      [1163, 110.5],
      [1166, 115.5],
      [1169, 118.5],
      [1172, 100.5],
      [1175, 120.5],
      [1178, 118.5],
      [1181, 103.5],
      [1184, 118.5],
      [1187, 91.5],
      [1190, 105.5],
      [1193, 123.5],
      [1196, 118.5],
      [1199, 121.5],
      [1202, 96.5],
      [1205, 115.5],
      [1208, 110.5],
      [1211, 95.5],
      [1214, 99.5],
      [1217, 99.5],
      [1220, 109.5],
      [1223, 112.5],
      [1226, 114.5],
      [1229, 104.5],
      [1232, 106.5],
      [1235, 115.5],
      [1238, 114.5],
      [1241, 104.5],
      [1244, 109.5],
      [1247, 94.5],
      [1250, 103.5],
      [1253, 127.5],
      [1256, 97.5],
      [1259, 103.5],
      [1262, 111.5],
      [1265, 120.5],
      [1268, 112.5],
      [1271, 119.5],
      [1274, 119.5],
      [1277, 111.5],
      [1280, 118.5],
      [1283, 127.5],
      [1286, 114.5],
      [1289, 123.5],
      [1292, 92.5],
      [1295, 105.5],
      [1298, 116.5],
      [1301, 103.5],
      [1304, 109.5],
      [1307, 101.5],
      [1310, 121.5],
      [1313, 126.5],
      [1316, 119.5],
      [1319, 106.5],
      [1322, 110.5],
      [1325, 119.5],
      [1328, 117.5],
      [1331, 99.5],
      [1334, 102.5],
      [1337, 95.5],
      [1340, 114.5],
      [1343, 126.5],
      [1346, 97.5],
      [1349, 117.5],
      [1352, 98.5],
      [1355, 123.5],
      [1358, 116.5],
      [1361, 115.5],
      [1364, 111.5],
      [1367, 106.5],
      [1370, 101.5],
      [1373, 124.5],
      [1376, 103.5],
      [1379, 101.5],
      [1382, 116.5],
      [1385, 112.5],
      [1388, 117.5],
      [1391, 104.5],
      [1394, 102.5],
      [1397, 102.5],
      [1400, 113.5],
      [1403, 119.5],
      [1406, 107.5],
      [1409, 124.5],
      [1412, 92.5],
      [1415, 104.5],
      [1418, 121.5],
      [1421, 106.5],
      [1424, 104.5],
      [1427, 95.5],
      [1430, 117.5],
      [1433, 120.5],
      [1436, 121.5],
      [1439, 99.5],
      [1442, 106.5],
      [1445, 114.5],
      [1448, 120.5],
      [1451, 115.5],
      [1454, 106.5],
      [1457, 104.5],
      [1460, 120.5],
      [1463, 116.5],
      [1466, 110.5],
      [1469, 101.5],
      [1472, 100.5],
      [1475, 108.5],
      [1478, 112.5],
      [1481, 96.5],
      [1484, 111.5],
      [1487, 103.5],
      [1490, 104.5],
      [1493, 118.5],
      [1496, 110.5],
      [1499, 102.5],
      [1502, 98.5],
      [1505, 119.5],
      [1508, 114.5],
      [1511, 114.5],
      [1514, 102.5],
      [1517, 97.5],
      [1520, 110.5],
      [1523, 94.5],
      [1526, 93.5],
      [1529, 83.5],
      [1532, 83.5],
      [1535, 78.5],
      [1538, 76.5],
      [1541, 75.5],
      [1544, 75.5],
      [1547, 75.5],
      [1550, 75.5],
    ],
    bottom: [
      [1548, 75.5],
      [1545, 75.5],
      [1542, 75.5],
      [1539, 74.5],
      [1536, 73.5],
      [1533, 68.5],
      [1530, 64.5],
      [1527, 60.5],
      [1524, 54.5],
      [1521, 36.5],
      [1518, 35.5],
      [1515, 42.5],
      [1512, 44.5],
      [1509, 38.5],
      [1506, 34.5],
      [1503, 40.5],
      [1500, 33.5],
      [1497, 41.5],
      [1494, 48.5],
      [1491, 37.5],
      [1488, 36.5],
      [1485, 36.5],
      [1482, 53.5],
      [1479, 45.5],
      [1476, 47.5],
      [1473, 41.5],
      [1470, 35.5],
      [1467, 40.5],
      [1464, 41.5],
      [1461, 40.5],
      [1458, 38.5],
      [1455, 41.5],
      [1452, 34.5],
      [1449, 42.5],
      [1446, 46.5],
      [1443, 37.5],
      [1440, 40.5],
      [1437, 47.5],
      [1434, 36.5],
      [1431, 43.5],
      [1428, 44.5],
      [1425, 34.5],
      [1422, 50.5],
      [1419, 37.5],
      [1416, 49.5],
      [1413, 33.5],
      [1410, 45.5],
      [1407, 41.5],
      [1404, 49.5],
      [1401, 46.5],
      [1398, 35.5],
      [1395, 35.5],
      [1392, 52.5],
      [1389, 43.5],
      [1386, 48.5],
      [1383, 34.5],
      [1380, 29.5],
      [1377, 47.5],
      [1374, 55.5],
      [1371, 43.5],
      [1368, 46.5],
      [1365, 33.5],
      [1362, 37.5],
      [1359, 44.5],
      [1356, 33.5],
      [1353, 27.5],
      [1350, 41.5],
      [1347, 54.5],
      [1344, 41.5],
      [1341, 41.5],
      [1338, 33.5],
      [1335, 30.5],
      [1332, 53.5],
      [1329, 27.5],
      [1326, 49.5],
      [1323, 36.5],
      [1320, 31.5],
      [1317, 49.5],
      [1314, 39.5],
      [1311, 42.5],
      [1308, 37.5],
      [1305, 35.5],
      [1302, 47.5],
      [1299, 45.5],
      [1296, 49.5],
      [1293, 36.5],
      [1290, 46.5],
      [1287, 57.5],
      [1284, 39.5],
      [1281, 36.5],
      [1278, 34.5],
      [1275, 31.5],
      [1272, 41.5],
      [1269, 31.5],
      [1266, 45.5],
      [1263, 31.5],
      [1260, 39.5],
      [1257, 48.5],
      [1254, 42.5],
      [1251, 49.5],
      [1248, 33.5],
      [1245, 37.5],
      [1242, 43.5],
      [1239, 42.5],
      [1236, 49.5],
      [1233, 42.5],
      [1230, 29.5],
      [1227, 47.5],
      [1224, 30.5],
      [1221, 46.5],
      [1218, 28.5],
      [1215, 42.5],
      [1212, 59.5],
      [1209, 36.5],
      [1206, 55.5],
      [1203, 44.5],
      [1200, 36.5],
      [1197, 48.5],
      [1194, 41.5],
      [1191, 51.5],
      [1188, 51.5],
      [1185, 28.5],
      [1182, 39.5],
      [1179, 48.5],
      [1176, 49.5],
      [1173, 36.5],
      [1170, 47.5],
      [1167, 49.5],
      [1164, 34.5],
      [1161, 40.5],
      [1158, 35.5],
      [1155, 42.5],
      [1152, 56.5],
      [1149, 48.5],
      [1146, 41.5],
      [1143, 34.5],
      [1140, 25.5],
      [1137, 54.5],
      [1134, 43.5],
      [1131, 54.5],
      [1128, 43.5],
      [1125, 32.5],
      [1122, 51.5],
      [1119, 40.5],
      [1116, 41.5],
      [1113, 32.5],
      [1110, 31.5],
      [1107, 55.5],
      [1104, 35.5],
      [1101, 42.5],
      [1098, 28.5],
      [1095, 24.5],
      [1092, 52.5],
      [1089, 34.5],
      [1086, 50.5],
      [1083, 40.5],
      [1080, 29.5],
      [1077, 50.5],
      [1074, 38.5],
      [1071, 55.5],
      [1068, 29.5],
      [1065, 38.5],
      [1062, 42.5],
      [1059, 43.5],
      [1056, 47.5],
      [1053, 28.5],
      [1050, 49.5],
      [1047, 59.5],
      [1044, 45.5],
      [1041, 49.5],
      [1038, 35.5],
      [1035, 34.5],
      [1032, 39.5],
      [1029, 37.5],
      [1026, 38.5],
      [1023, 33.5],
      [1020, 27.5],
      [1017, 41.5],
      [1014, 21.5],
      [1011, 27.5],
      [1008, 30.5],
      [1005, 19.5],
      [1002, 41.5],
      [999, 49.5],
      [996, 44.5],
      [993, 47.5],
      [990, 29.5],
      [987, 34.5],
      [984, 25.5],
      [981, 39.5],
      [978, 42.5],
      [975, 44.5],
      [972, 44.5],
      [969, 31.5],
      [966, 40.5],
      [963, 42.5],
      [960, 17.5],
      [957, 39.5],
      [954, 30.5],
      [951, 47.5],
      [948, 42.5],
      [945, 37.5],
      [942, 50.5],
      [939, 36.5],
      [936, 44.5],
      [933, 30.5],
      [930, 21.5],
      [927, 41.5],
      [924, 35.5],
      [921, 33.5],
      [918, 47.5],
      [915, 28.5],
      [912, 42.5],
      [909, 40.5],
      [906, 41.5],
      [903, 34.5],
      [900, 29.5],
      [897, 41.5],
      [894, 34.5],
      [891, 43.5],
      [888, 46.5],
      [885, 38.5],
      [882, 34.5],
      [879, 45.5],
      [876, 28.5],
      [873, 36.5],
      [870, 23.5],
      [867, 37.5],
      [864, 27.5],
      [861, 44.5],
      [858, 44.5],
      [855, 27.5],
      [852, 49.5],
      [849, 35.5],
      [846, 47.5],
      [843, 39.5],
      [840, 25.5],
      [837, 48.5],
      [834, 40.5],
      [831, 55.5],
      [828, 29.5],
      [825, 28.5],
      [822, 32.5],
      [819, 47.5],
      [816, 39.5],
      [813, 35.5],
      [810, 48.5],
      [807, 50.5],
      [804, 29.5],
      [801, 45.5],
      [798, 26.5],
      [795, 32.5],
      [792, 59.5],
      [789, 43.5],
      [786, 36.5],
      [783, 28.5],
      [780, 26.5],
      [777, 42.5],
      [774, 30.5],
      [771, 51.5],
      [768, 51.5],
      [765, 27.5],
      [762, 43.5],
      [759, 39.5],
      [756, 35.5],
      [753, 38.5],
      [750, 36.5],
      [747, 45.5],
      [744, 34.5],
      [741, 33.5],
      [738, 51.5],
      [735, 42.5],
      [732, 42.5],
      [729, 53.5],
      [726, 40.5],
      [723, 37.5],
      [720, 34.5],
      [717, 50.5],
      [714, 43.5],
      [711, 57.5],
      [708, 38.5],
      [705, 44.5],
      [702, 48.5],
      [699, 42.5],
      [696, 43.5],
      [693, 29.5],
      [690, 25.5],
      [687, 35.5],
      [684, 36.5],
      [681, 39.5],
      [678, 51.5],
      [675, 38.5],
      [672, 42.5],
      [669, 40.5],
      [666, 33.5],
      [663, 39.5],
      [660, 38.5],
      [657, 39.5],
      [654, 38.5],
      [651, 46.5],
      [648, 27.5],
      [645, 40.5],
      [642, 51.5],
      [639, 34.5],
      [636, 33.5],
      [633, 33.5],
      [630, 38.5],
      [627, 47.5],
      [624, 32.5],
      [621, 44.5],
      [618, 31.5],
      [615, 30.5],
      [612, 55.5],
      [609, 25.5],
      [606, 45.5],
      [603, 18.5],
      [600, 28.5],
      [597, 41.5],
      [594, 39.5],
      [591, 51.5],
      [588, 33.5],
      [585, 24.5],
      [582, 32.5],
      [579, 35.5],
      [576, 47.5],
      [573, 36.5],
      [570, 42.5],
      [567, 47.5],
      [564, 40.5],
      [561, 33.5],
      [558, 13.5],
      [555, 24.5],
      [552, 60.5],
      [549, 30.5],
      [546, 41.5],
      [543, 31.5],
      [540, 32.5],
      [537, 43.5],
      [534, 49.5],
      [531, 53.5],
      [528, 31.5],
      [525, 29.5],
      [522, 38.5],
      [519, 36.5],
      [516, 35.5],
      [513, 15.5],
      [510, 32.5],
      [507, 47.5],
      [504, 34.5],
      [501, 38.5],
      [498, 31.5],
      [495, 32.5],
      [492, 56.5],
      [489, 21.5],
      [486, 43.5],
      [483, 36.5],
      [480, 22.5],
      [477, 33.5],
      [474, 40.5],
      [471, 35.5],
      [468, 18.5],
      [465, 27.5],
      [462, 44.5],
      [459, 38.5],
      [456, 37.5],
      [453, 30.5],
      [450, 18.5],
      [447, 28.5],
      [444, 43.5],
      [441, 40.5],
      [438, 25.5],
      [435, 26.5],
      [432, 26.5],
      [429, 43.5],
      [426, 18.5],
      [423, 37.5],
      [420, 18.5],
      [417, 35.5],
      [414, 33.5],
      [411, 28.5],
      [408, 39.5],
      [405, 33.5],
      [402, 37.5],
      [399, 20.5],
      [396, 27.5],
      [393, 23.5],
      [390, 13.5],
      [387, 31.5],
      [384, 30.5],
      [381, 34.5],
      [378, 12.5],
      [375, 17.5],
      [372, 31.5],
      [369, 49.5],
      [366, 43.5],
      [363, 49.5],
      [360, 14.5],
      [357, 33.5],
      [354, 31.5],
      [351, 46.5],
      [348, 21.5],
      [345, 22.5],
      [342, 33.5],
      [339, 34.5],
      [336, 23.5],
      [333, 22.5],
      [330, 19.5],
      [327, 35.5],
      [324, 43.5],
      [321, 30.5],
      [318, 11.5],
      [315, 19.5],
      [312, 54.5],
      [309, 27.5],
      [306, 38.5],
      [303, 21.5],
      [300, 22.5],
      [297, 50.5],
      [294, 38.5],
      [291, 44.5],
      [288, 19.5],
      [285, 29.5],
      [282, 36.5],
      [279, 38.5],
      [276, 41.5],
      [273, 37.5],
      [270, 9.5],
      [267, 43.5],
      [264, 32.5],
      [261, 42.5],
      [258, 18.5],
      [255, 23.5],
      [252, 46.5],
      [249, 22.5],
      [246, 30.5],
      [243, 34.5],
      [240, 15.5],
      [237, 25.5],
      [234, 41.5],
      [231, 44.5],
      [228, 27.5],
      [225, 18.5],
      [222, 23.5],
      [219, 38.5],
      [216, 44.5],
      [213, 12.5],
      [210, 36.5],
      [207, 52.5],
      [204, 26.5],
      [201, 25.5],
      [198, 15.5],
      [195, 18.5],
      [192, 32.5],
      [189, 42.5],
      [186, 39.5],
      [183, 13.5],
      [180, 9.5],
      [177, 44.5],
      [174, 29.5],
      [171, 46.5],
      [168, 34.5],
      [165, 12.5],
      [162, 31.5],
      [159, 25.5],
      [156, 14.5],
      [153, 29.5],
      [150, 13.5],
      [147, 29.5],
      [144, 29.5],
      [141, 39.5],
      [138, 33.5],
      [135, 22.5],
      [132, 56.5],
      [129, 24.5],
      [126, 23.5],
      [123, 31.5],
      [120, 30.5],
      [117, 43.5],
      [114, 39.5],
      [111, 44.5],
      [108, 56.5],
      [105, 30.5],
      [102, 23.5],
      [99, 31.5],
      [96, 33.5],
      [93, 19.5],
      [90, 25.5],
      [87, 38.5],
      [84, 36.5],
      [81, 19.5],
      [78, 23.5],
      [75, 18.5],
      [72, 56.5],
      [69, 22.5],
      [66, 18.5],
      [63, 34.5],
      [60, 13.5],
      [57, 29.5],
      [54, 28.5],
      [51, 47.5],
      [48, 60.5],
      [45, 30.5],
      [42, 21.5],
      [39, 27.5],
      [36, 23.5],
      [33, 20.5],
      [30, 22.5],
      [27, 36.5],
      [24, 16.5],
      [21, 24.5],
      [18, 17.5],
      [15, 18.5],
      [12, 48.5],
      [9, 3.6385999999999967],
      [6, 14.5],
      [3, 19.5],
      [0, 35.5],
    ],
  },
  {
    top: [
      [2, 129.5],
      [5, 143.2766],
      [8, 106.5],
      [11, 105.5],
      [14, 128.5],
      [17, 114.5],
      [20, 139.5],
      [23, 128.5],
      [26, 138.5],
      [29, 144.1054],
      [32, 105.5],
      [35, 137.5],
      [38, 144.875],
      [41, 126.5],
      [44, 143.6984],
      [47, 111.5],
      [50, 133.5],
      [53, 144.5],
      [56, 142.5],
      [59, 135.5],
      [62, 137.5],
      [65, 132.5],
      [68, 113.5],
      [71, 122.5],
      [74, 120.5],
      [77, 128.5],
      [80, 138.5],
      [83, 119.5],
      [86, 137.5],
      [89, 145.5],
      [92, 109.5],
      [95, 134.5],
      [98, 128.5],
      [101, 130.5],
      [104, 122.5],
      [107, 112.5],
      [110, 126.5],
      [113, 144.5],
      [116, 126.5],
      [119, 139.5],
      [122, 125.5],
      [125, 123.5],
      [128, 103.5],
      [131, 108.5],
      [134, 117.5],
      [137, 108.5],
      [140, 135.5],
      [143, 122.5],
      [146, 126.5],
      [149, 144.1054],
      [152, 108.5],
      [155, 131.5],
      [158, 144.5],
      [161, 124.5],
      [164, 131.5],
      [167, 98.5],
      [170, 125.5],
      [173, 133.5],
      [176, 123.5],
      [179, 139.5],
      [182, 114.5],
      [185, 128.5],
      [188, 143.6984],
      [191, 109.5],
      [194, 110.5],
      [197, 100.5],
      [200, 141.5],
      [203, 120.5],
      [206, 114.5],
      [209, 143.6984],
      [212, 103.5],
      [215, 128.5],
      [218, 139.5],
      [221, 114.5],
      [224, 133.5],
      [227, 121.5],
      [230, 128.5],
      [233, 134.5],
      [236, 113.5],
      [239, 125.5],
      [242, 132.5],
      [245, 135.5],
      [248, 134.5],
      [251, 115.5],
      [254, 110.5],
      [257, 105.5],
      [260, 129.5],
      [263, 133.5],
      [266, 113.5],
      [269, 119.5],
      [272, 108.5],
      [275, 130.5],
      [278, 136.5],
      [281, 116.5],
      [284, 116.5],
      [287, 110.5],
      [290, 115.5],
      [293, 134.5],
      [296, 113.5],
      [299, 111.5],
      [302, 121.5],
      [305, 127.5],
      [308, 136.5],
      [311, 102.5],
      [314, 124.5],
      [317, 112.5],
      [320, 126.5],
      [323, 113.5],
      [326, 119.5],
      [329, 128.5],
      [332, 112.5],
      [335, 143.5],
      [338, 127.5],
      [341, 118.5],
      [344, 110.5],
      [347, 101.5],
      [350, 133.5],
      [353, 125.5],
      [356, 110.5],
      [359, 118.5],
      [362, 112.5],
      [365, 131.5],
      [368, 90.5],
      [371, 109.5],
      [374, 122.5],
      [377, 123.5],
      [380, 139.5],
      [383, 115.5],
      [386, 121.5],
      [389, 126.5],
      [392, 110.5],
      [395, 126.5],
      [398, 134.5],
      [401, 110.5],
      [404, 100.5],
      [407, 108.5],
      [410, 128.5],
      [413, 123.5],
      [416, 124.5],
      [419, 109.5],
      [422, 113.5],
      [425, 134.5],
      [428, 124.5],
      [431, 115.5],
      [434, 118.5],
      [437, 123.5],
      [440, 125.5],
      [443, 114.5],
      [446, 129.5],
      [449, 117.5],
      [452, 101.5],
      [455, 125.5],
      [458, 119.5],
      [461, 110.5],
      [464, 102.5],
      [467, 109.5],
      [470, 128.5],
      [473, 130.5],
      [476, 104.5],
      [479, 127.5],
      [482, 106.5],
      [485, 121.5],
      [488, 130.5],
      [491, 104.5],
      [494, 109.5],
      [497, 100.5],
      [500, 122.5],
      [503, 118.5],
      [506, 114.5],
      [509, 114.5],
      [512, 99.5],
      [515, 131.5],
      [518, 124.5],
      [521, 105.5],
      [524, 106.5],
      [527, 103.5],
      [530, 109.5],
      [533, 127.5],
      [536, 125.5],
      [539, 119.5],
      [542, 111.5],
      [545, 114.5],
      [548, 107.5],
      [551, 105.5],
      [554, 105.5],
      [557, 129.5],
      [560, 124.5],
      [563, 127.5],
      [566, 127.5],
      [569, 127.5],
      [572, 99.5],
      [575, 120.5],
      [578, 122.5],
      [581, 118.5],
      [584, 111.5],
      [587, 108.5],
      [590, 126.5],
      [593, 120.5],
      [596, 133.5],
      [599, 113.5],
      [602, 130.5],
      [605, 127.5],
      [608, 115.5],
      [611, 101.5],
      [614, 112.5],
      [617, 97.5],
      [620, 123.5],
      [623, 126.5],
      [626, 119.5],
      [629, 125.5],
      [632, 100.5],
      [635, 117.5],
      [638, 121.5],
      [641, 108.5],
      [644, 109.5],
      [647, 114.5],
      [650, 116.5],
      [653, 114.5],
      [656, 113.5],
      [659, 105.5],
      [662, 112.5],
      [665, 103.5],
      [668, 113.5],
      [671, 119.5],
      [674, 106.5],
      [677, 110.5],
      [680, 120.5],
      [683, 110.5],
      [686, 127.5],
      [689, 121.5],
      [692, 124.5],
      [695, 112.5],
      [698, 108.5],
      [701, 112.5],
      [704, 111.5],
      [707, 92.5],
      [710, 104.5],
      [713, 108.5],
      [716, 99.5],
      [719, 113.5],
      [722, 104.5],
      [725, 108.5],
      [728, 113.5],
      [731, 111.5],
      [734, 104.5],
      [737, 118.5],
      [740, 118.5],
      [743, 115.5],
      [746, 129.5],
      [749, 107.5],
      [752, 113.5],
      [755, 113.5],
      [758, 109.5],
      [761, 113.5],
      [764, 103.5],
      [767, 94.5],
      [770, 121.5],
      [773, 121.5],
      [776, 114.5],
      [779, 111.5],
      [782, 121.5],
      [785, 106.5],
      [788, 98.5],
      [791, 98.5],
      [794, 114.5],
      [797, 107.5],
      [800, 118.5],
      [803, 127.5],
      [806, 118.5],
      [809, 119.5],
      [812, 93.5],
      [815, 115.5],
      [818, 122.5],
      [821, 101.5],
      [824, 118.5],
      [827, 112.5],
      [830, 119.5],
      [833, 121.5],
      [836, 125.5],
      [839, 102.5],
      [842, 117.5],
      [845, 113.5],
      [848, 108.5],
      [851, 106.5],
      [854, 100.5],
      [857, 95.5],
      [860, 117.5],
      [863, 130.5],
      [866, 129.5],
      [869, 118.5],
      [872, 105.5],
      [875, 120.5],
      [878, 110.5],
      [881, 120.5],
      [884, 111.5],
      [887, 111.5],
      [890, 122.5],
      [893, 114.5],
      [896, 120.5],
      [899, 110.5],
      [902, 110.5],
      [905, 110.5],
      [908, 111.5],
      [911, 105.5],
      [914, 111.5],
      [917, 118.5],
      [920, 121.5],
      [923, 112.5],
      [926, 123.5],
      [929, 117.5],
      [932, 106.5],
      [935, 108.5],
      [938, 104.5],
      [941, 109.5],
      [944, 107.5],
      [947, 101.5],
      [950, 116.5],
      [953, 110.5],
      [956, 113.5],
      [959, 116.5],
      [962, 108.5],
      [965, 111.5],
      [968, 105.5],
      [971, 103.5],
      [974, 107.5],
      [977, 96.5],
      [980, 121.5],
      [983, 122.5],
      [986, 105.5],
      [989, 113.5],
      [992, 109.5],
      [995, 102.5],
      [998, 101.5],
      [1001, 109.5],
      [1004, 121.5],
      [1007, 107.5],
      [1010, 124.5],
      [1013, 133.5],
      [1016, 123.5],
      [1019, 128.5],
      [1022, 105.5],
      [1025, 119.5],
      [1028, 107.5],
      [1031, 101.5],
      [1034, 101.5],
      [1037, 98.5],
      [1040, 118.5],
      [1043, 118.5],
      [1046, 105.5],
      [1049, 133.5],
      [1052, 97.5],
      [1055, 118.5],
      [1058, 113.5],
      [1061, 99.5],
      [1064, 110.5],
      [1067, 100.5],
      [1070, 118.5],
      [1073, 136.5],
      [1076, 103.5],
      [1079, 112.5],
      [1082, 107.5],
      [1085, 110.5],
      [1088, 110.5],
      [1091, 98.5],
      [1094, 115.5],
      [1097, 97.5],
      [1100, 114.5],
      [1103, 132.5],
      [1106, 109.5],
      [1109, 115.5],
      [1112, 96.5],
      [1115, 122.5],
      [1118, 121.5],
      [1121, 99.5],
      [1124, 103.5],
      [1127, 95.5],
      [1130, 106.5],
      [1133, 137.5],
      [1136, 111.5],
      [1139, 115.5],
      [1142, 112.5],
      [1145, 112.5],
      [1148, 115.5],
      [1151, 100.5],
      [1154, 98.5],
      [1157, 103.5],
      [1160, 112.5],
      [1163, 119.5],
      [1166, 110.5],
      [1169, 116.5],
      [1172, 97.5],
      [1175, 114.5],
      [1178, 114.5],
      [1181, 100.5],
      [1184, 122.5],
      [1187, 92.5],
      [1190, 105.5],
      [1193, 120.5],
      [1196, 121.5],
      [1199, 123.5],
      [1202, 96.5],
      [1205, 115.5],
      [1208, 111.5],
      [1211, 93.5],
      [1214, 100.5],
      [1217, 97.5],
      [1220, 107.5],
      [1223, 119.5],
      [1226, 114.5],
      [1229, 107.5],
      [1232, 103.5],
      [1235, 114.5],
      [1238, 112.5],
      [1241, 107.5],
      [1244, 111.5],
      [1247, 93.5],
      [1250, 100.5],
      [1253, 135.5],
      [1256, 99.5],
      [1259, 105.5],
      [1262, 108.5],
      [1265, 114.5],
      [1268, 112.5],
      [1271, 119.5],
      [1274, 120.5],
      [1277, 110.5],
      [1280, 116.5],
      [1283, 136.5],
      [1286, 116.5],
      [1289, 123.5],
      [1292, 92.5],
      [1295, 103.5],
      [1298, 112.5],
      [1301, 99.5],
      [1304, 109.5],
      [1307, 101.5],
      [1310, 119.5],
      [1313, 134.5],
      [1316, 119.5],
      [1319, 103.5],
      [1322, 108.5],
      [1325, 115.5],
      [1328, 114.5],
      [1331, 99.5],
      [1334, 101.5],
      [1337, 96.5],
      [1340, 114.5],
      [1343, 133.5],
      [1346, 97.5],
      [1349, 116.5],
      [1352, 96.5],
      [1355, 119.5],
      [1358, 114.5],
      [1361, 118.5],
      [1364, 108.5],
      [1367, 105.5],
      [1370, 103.5],
      [1373, 131.5],
      [1376, 103.5],
      [1379, 98.5],
      [1382, 111.5],
      [1385, 107.5],
      [1388, 113.5],
      [1391, 103.5],
      [1394, 106.5],
      [1397, 101.5],
      [1400, 116.5],
      [1403, 121.5],
      [1406, 110.5],
      [1409, 119.5],
      [1412, 92.5],
      [1415, 105.5],
      [1418, 120.5],
      [1421, 103.5],
      [1424, 103.5],
      [1427, 94.5],
      [1430, 112.5],
      [1433, 117.5],
      [1436, 124.5],
      [1439, 103.5],
      [1442, 106.5],
      [1445, 112.5],
      [1448, 118.5],
      [1451, 118.5],
      [1454, 105.5],
      [1457, 105.5],
      [1460, 123.5],
      [1463, 123.5],
      [1466, 115.5],
      [1469, 100.5],
      [1472, 99.5],
      [1475, 110.5],
      [1478, 112.5],
      [1481, 98.5],
      [1484, 110.5],
      [1487, 102.5],
      [1490, 107.5],
      [1493, 122.5],
      [1496, 115.5],
      [1499, 99.5],
      [1502, 97.5],
      [1505, 117.5],
      [1508, 115.5],
      [1511, 111.5],
      [1514, 100.5],
      [1517, 96.5],
      [1520, 113.5],
      [1523, 95.5],
      [1526, 95.5],
      [1529, 83.5],
      [1532, 83.5],
      [1535, 78.5],
      [1538, 76.5],
      [1541, 76.5],
      [1544, 75.5],
      [1547, 75.5],
      [1550, 75.5],
    ],
    bottom: [
      [1548, 75.5],
      [1545, 75.5],
      [1542, 75.5],
      [1539, 74.5],
      [1536, 73.5],
      [1533, 68.5],
      [1530, 65.5],
      [1527, 58.5],
      [1524, 54.5],
      [1521, 29.5],
      [1518, 37.5],
      [1515, 44.5],
      [1512, 47.5],
      [1509, 37.5],
      [1506, 37.5],
      [1503, 43.5],
      [1500, 37.5],
      [1497, 34.5],
      [1494, 47.5],
      [1491, 29.5],
      [1488, 38.5],
      [1485, 35.5],
      [1482, 53.5],
      [1479, 47.5],
      [1476, 46.5],
      [1473, 41.5],
      [1470, 37.5],
      [1467, 33.5],
      [1464, 39.5],
      [1461, 35.5],
      [1458, 37.5],
      [1455, 41.5],
      [1452, 31.5],
      [1449, 43.5],
      [1446, 47.5],
      [1443, 38.5],
      [1440, 37.5],
      [1437, 43.5],
      [1434, 38.5],
      [1431, 46.5],
      [1428, 46.5],
      [1425, 37.5],
      [1422, 52.5],
      [1419, 36.5],
      [1416, 51.5],
      [1413, 36.5],
      [1410, 47.5],
      [1407, 40.5],
      [1404, 50.5],
      [1401, 42.5],
      [1398, 37.5],
      [1395, 36.5],
      [1392, 53.5],
      [1389, 47.5],
      [1386, 51.5],
      [1383, 39.5],
      [1380, 35.5],
      [1377, 49.5],
      [1374, 51.5],
      [1371, 39.5],
      [1368, 47.5],
      [1365, 37.5],
      [1362, 34.5],
      [1359, 45.5],
      [1356, 36.5],
      [1353, 30.5],
      [1350, 42.5],
      [1347, 53.5],
      [1344, 39.5],
      [1341, 37.5],
      [1338, 31.5],
      [1335, 32.5],
      [1332, 54.5],
      [1329, 25.5],
      [1326, 50.5],
      [1323, 37.5],
      [1320, 35.5],
      [1317, 47.5],
      [1314, 36.5],
      [1311, 39.5],
      [1308, 37.5],
      [1305, 36.5],
      [1302, 50.5],
      [1299, 48.5],
      [1296, 52.5],
      [1293, 36.5],
      [1290, 47.5],
      [1287, 55.5],
      [1284, 35.5],
      [1281, 34.5],
      [1278, 32.5],
      [1275, 36.5],
      [1272, 38.5],
      [1269, 36.5],
      [1266, 48.5],
      [1263, 35.5],
      [1260, 38.5],
      [1257, 44.5],
      [1254, 37.5],
      [1251, 48.5],
      [1248, 36.5],
      [1245, 39.5],
      [1242, 39.5],
      [1239, 43.5],
      [1236, 49.5],
      [1233, 43.5],
      [1230, 28.5],
      [1227, 45.5],
      [1224, 28.5],
      [1221, 46.5],
      [1218, 31.5],
      [1215, 37.5],
      [1212, 60.5],
      [1209, 39.5],
      [1206, 54.5],
      [1203, 43.5],
      [1200, 37.5],
      [1197, 48.5],
      [1194, 44.5],
      [1191, 53.5],
      [1188, 47.5],
      [1185, 26.5],
      [1182, 38.5],
      [1179, 50.5],
      [1176, 52.5],
      [1173, 40.5],
      [1170, 50.5],
      [1167, 51.5],
      [1164, 28.5],
      [1161, 41.5],
      [1158, 34.5],
      [1155, 42.5],
      [1152, 55.5],
      [1149, 49.5],
      [1146, 45.5],
      [1143, 36.5],
      [1140, 23.5],
      [1137, 51.5],
      [1134, 38.5],
      [1131, 55.5],
      [1128, 41.5],
      [1125, 36.5],
      [1122, 52.5],
      [1119, 41.5],
      [1116, 44.5],
      [1113, 36.5],
      [1110, 33.5],
      [1107, 54.5],
      [1104, 29.5],
      [1101, 45.5],
      [1098, 29.5],
      [1095, 21.5],
      [1092, 53.5],
      [1089, 37.5],
      [1086, 50.5],
      [1083, 39.5],
      [1080, 29.5],
      [1077, 49.5],
      [1074, 33.5],
      [1071, 56.5],
      [1068, 30.5],
      [1065, 38.5],
      [1062, 42.5],
      [1059, 45.5],
      [1056, 47.5],
      [1053, 31.5],
      [1050, 47.5],
      [1047, 60.5],
      [1044, 41.5],
      [1041, 50.5],
      [1038, 36.5],
      [1035, 35.5],
      [1032, 42.5],
      [1029, 39.5],
      [1026, 42.5],
      [1023, 37.5],
      [1020, 25.5],
      [1017, 39.5],
      [1014, 13.5],
      [1011, 32.5],
      [1008, 35.5],
      [1005, 15.5],
      [1002, 39.5],
      [999, 49.5],
      [996, 46.5],
      [993, 45.5],
      [990, 25.5],
      [987, 38.5],
      [984, 17.5],
      [981, 42.5],
      [978, 45.5],
      [975, 44.5],
      [972, 43.5],
      [969, 28.5],
      [966, 43.5],
      [963, 46.5],
      [960, 11.5],
      [957, 43.5],
      [954, 33.5],
      [951, 50.5],
      [948, 42.5],
      [945, 37.5],
      [942, 50.5],
      [939, 39.5],
      [936, 47.5],
      [933, 35.5],
      [930, 24.5],
      [927, 41.5],
      [924, 29.5],
      [921, 34.5],
      [918, 49.5],
      [915, 23.5],
      [912, 45.5],
      [909, 42.5],
      [906, 42.5],
      [903, 35.5],
      [900, 32.5],
      [897, 43.5],
      [894, 27.5],
      [891, 42.5],
      [888, 48.5],
      [885, 33.5],
      [882, 35.5],
      [879, 45.5],
      [876, 31.5],
      [873, 40.5],
      [870, 19.5],
      [867, 37.5],
      [864, 21.5],
      [861, 46.5],
      [858, 44.5],
      [855, 30.5],
      [852, 49.5],
      [849, 38.5],
      [846, 46.5],
      [843, 43.5],
      [840, 25.5],
      [837, 47.5],
      [834, 36.5],
      [831, 54.5],
      [828, 31.5],
      [825, 27.5],
      [822, 36.5],
      [819, 49.5],
      [816, 38.5],
      [813, 34.5],
      [810, 46.5],
      [807, 49.5],
      [804, 24.5],
      [801, 47.5],
      [798, 29.5],
      [795, 33.5],
      [792, 60.5],
      [789, 43.5],
      [786, 37.5],
      [783, 27.5],
      [780, 23.5],
      [777, 40.5],
      [774, 26.5],
      [771, 53.5],
      [768, 53.5],
      [765, 27.5],
      [762, 45.5],
      [759, 40.5],
      [756, 35.5],
      [753, 40.5],
      [750, 34.5],
      [747, 43.5],
      [744, 36.5],
      [741, 34.5],
      [738, 50.5],
      [735, 41.5],
      [732, 42.5],
      [729, 51.5],
      [726, 35.5],
      [723, 37.5],
      [720, 36.5],
      [717, 52.5],
      [714, 47.5],
      [711, 56.5],
      [708, 39.5],
      [705, 45.5],
      [702, 44.5],
      [699, 44.5],
      [696, 42.5],
      [693, 25.5],
      [690, 29.5],
      [687, 32.5],
      [684, 36.5],
      [681, 40.5],
      [678, 48.5],
      [675, 41.5],
      [672, 38.5],
      [669, 42.5],
      [666, 37.5],
      [663, 40.5],
      [660, 40.5],
      [657, 35.5],
      [654, 39.5],
      [651, 47.5],
      [648, 23.5],
      [645, 42.5],
      [642, 51.5],
      [639, 31.5],
      [636, 33.5],
      [633, 32.5],
      [630, 39.5],
      [627, 42.5],
      [624, 34.5],
      [621, 43.5],
      [618, 30.5],
      [615, 26.5],
      [612, 55.5],
      [609, 28.5],
      [606, 47.5],
      [603, 14.5],
      [600, 30.5],
      [597, 36.5],
      [594, 41.5],
      [591, 52.5],
      [588, 34.5],
      [585, 28.5],
      [582, 31.5],
      [579, 36.5],
      [576, 46.5],
      [573, 35.5],
      [570, 43.5],
      [567, 44.5],
      [564, 42.5],
      [561, 36.5],
      [558, 9.5],
      [555, 26.5],
      [552, 59.5],
      [549, 31.5],
      [546, 40.5],
      [543, 31.5],
      [540, 30.5],
      [537, 38.5],
      [534, 51.5],
      [531, 54.5],
      [528, 33.5],
      [525, 32.5],
      [522, 37.5],
      [519, 40.5],
      [516, 36.5],
      [513, 9.5],
      [510, 33.5],
      [507, 45.5],
      [504, 36.5],
      [501, 40.5],
      [498, 27.5],
      [495, 35.5],
      [492, 54.5],
      [489, 20.5],
      [486, 44.5],
      [483, 33.5],
      [480, 23.5],
      [477, 36.5],
      [474, 42.5],
      [471, 35.5],
      [468, 13.5],
      [465, 28.5],
      [462, 38.5],
      [459, 37.5],
      [456, 37.5],
      [453, 31.5],
      [450, 19.5],
      [447, 18.5],
      [444, 41.5],
      [441, 38.5],
      [438, 14.5],
      [435, 22.5],
      [432, 24.5],
      [429, 41.5],
      [426, 13.5],
      [423, 34.5],
      [420, 18.5],
      [417, 29.5],
      [414, 30.5],
      [411, 27.5],
      [408, 39.5],
      [405, 29.5],
      [402, 37.5],
      [399, 18.5],
      [396, 27.5],
      [393, 22.5],
      [390, 16.5],
      [387, 23.5],
      [384, 30.5],
      [381, 34.5],
      [378, 13.5],
      [375, 19.5],
      [372, 26.5],
      [369, 47.5],
      [366, 39.5],
      [363, 50.5],
      [360, 13.5],
      [357, 29.5],
      [354, 27.5],
      [351, 40.5],
      [348, 23.5],
      [345, 16.5],
      [342, 33.5],
      [339, 33.5],
      [336, 20.5],
      [333, 21.5],
      [330, 16.5],
      [327, 33.5],
      [324, 45.5],
      [321, 33.5],
      [318, 10.5],
      [315, 18.5],
      [312, 52.5],
      [309, 20.5],
      [306, 40.5],
      [303, 19.5],
      [300, 14.5],
      [297, 48.5],
      [294, 33.5],
      [291, 37.5],
      [288, 16.5],
      [285, 31.5],
      [282, 32.5],
      [279, 38.5],
      [276, 42.5],
      [273, 33.5],
      [270, 11.5],
      [267, 43.5],
      [264, 34.5],
      [261, 37.5],
      [258, 14.5],
      [255, 22.5],
      [252, 45.5],
      [249, 19.5],
      [246, 26.5],
      [243, 31.5],
      [240, 11.5],
      [237, 24.5],
      [234, 37.5],
      [231, 41.5],
      [228, 23.5],
      [225, 13.5],
      [222, 23.5],
      [219, 36.5],
      [216, 42.5],
      [213, 9.5],
      [210, 32.5],
      [207, 50.5],
      [204, 25.5],
      [201, 20.5],
      [198, 16.5],
      [195, 16.5],
      [192, 30.5],
      [189, 40.5],
      [186, 36.5],
      [183, 14.5],
      [180, 5.5],
      [177, 43.5],
      [174, 28.5],
      [171, 43.5],
      [168, 30.5],
      [165, 15.5],
      [162, 33.5],
      [159, 24.5],
      [156, 10.5],
      [153, 30.5],
      [150, 6.502399999999994],
      [147, 30.5],
      [144, 21.5],
      [141, 36.5],
      [138, 29.5],
      [135, 21.5],
      [132, 56.5],
      [129, 25.5],
      [126, 18.5],
      [123, 32.5],
      [120, 23.5],
      [117, 43.5],
      [114, 39.5],
      [111, 42.5],
      [108, 56.5],
      [105, 29.5],
      [102, 20.5],
      [99, 28.5],
      [96, 32.5],
      [93, 15.5],
      [90, 21.5],
      [87, 35.5],
      [84, 37.5],
      [81, 18.5],
      [78, 24.5],
      [75, 16.5],
      [72, 55.5],
      [69, 22.5],
      [66, 16.5],
      [63, 33.5],
      [60, 6.5],
      [57, 30.5],
      [54, 28.5],
      [51, 45.5],
      [48, 60.5],
      [45, 27.5],
      [42, 19.5],
      [39, 25.5],
      [36, 25.5],
      [33, 17.5],
      [30, 16.5],
      [27, 35.5],
      [24, 18.5],
      [21, 23.5],
      [18, 12.5],
      [15, 9.5],
      [12, 46.5],
      [9, 2.395399999999995],
      [6, 13.5],
      [3, 18.5],
      [0, 39.5],
    ],
  },
  {
    top: [
      [2, 128.5],
      [5, 143.6984],
      [8, 106.5],
      [11, 106.5],
      [14, 129.5],
      [17, 115.5],
      [20, 142.5],
      [23, 128.5],
      [26, 139.5],
      [29, 144.875],
      [32, 106.5],
      [35, 136.5],
      [38, 144.875],
      [41, 127.5],
      [44, 144.4976],
      [47, 113.5],
      [50, 133.5],
      [53, 143.6984],
      [56, 141.5],
      [59, 136.5],
      [62, 138.5],
      [65, 133.5],
      [68, 113.5],
      [71, 120.5],
      [74, 121.5],
      [77, 126.5],
      [80, 135.5],
      [83, 120.5],
      [86, 137.5],
      [89, 143.2766],
      [92, 107.5],
      [95, 132.5],
      [98, 127.5],
      [101, 130.5],
      [104, 123.5],
      [107, 114.5],
      [110, 125.5],
      [113, 145.5],
      [116, 124.5],
      [119, 140.5],
      [122, 124.5],
      [125, 123.5],
      [128, 103.5],
      [131, 108.5],
      [134, 118.5],
      [137, 108.5],
      [140, 136.5],
      [143, 120.5],
      [146, 127.5],
      [149, 144.4976],
      [152, 109.5],
      [155, 130.5],
      [158, 144.5],
      [161, 123.5],
      [164, 129.5],
      [167, 96.5],
      [170, 123.5],
      [173, 131.5],
      [176, 122.5],
      [179, 140.5],
      [182, 112.5],
      [185, 125.5],
      [188, 143.2766],
      [191, 109.5],
      [194, 111.5],
      [197, 101.5],
      [200, 139.5],
      [203, 118.5],
      [206, 114.5],
      [209, 144.1054],
      [212, 104.5],
      [215, 126.5],
      [218, 137.5],
      [221, 112.5],
      [224, 134.5],
      [227, 121.5],
      [230, 129.5],
      [233, 134.5],
      [236, 113.5],
      [239, 123.5],
      [242, 136.5],
      [245, 137.5],
      [248, 138.5],
      [251, 115.5],
      [254, 110.5],
      [257, 105.5],
      [260, 130.5],
      [263, 130.5],
      [266, 112.5],
      [269, 117.5],
      [272, 107.5],
      [275, 127.5],
      [278, 135.5],
      [281, 116.5],
      [284, 114.5],
      [287, 114.5],
      [290, 116.5],
      [293, 134.5],
      [296, 112.5],
      [299, 112.5],
      [302, 120.5],
      [305, 131.5],
      [308, 135.5],
      [311, 104.5],
      [314, 124.5],
      [317, 111.5],
      [320, 124.5],
      [323, 112.5],
      [326, 116.5],
      [329, 128.5],
      [332, 110.5],
      [335, 144.5],
      [338, 127.5],
      [341, 116.5],
      [344, 110.5],
      [347, 104.5],
      [350, 133.5],
      [353, 123.5],
      [356, 109.5],
      [359, 119.5],
      [362, 111.5],
      [365, 131.5],
      [368, 91.5],
      [371, 110.5],
      [374, 122.5],
      [377, 122.5],
      [380, 140.5],
      [383, 114.5],
      [386, 120.5],
      [389, 126.5],
      [392, 111.5],
      [395, 124.5],
      [398, 131.5],
      [401, 109.5],
      [404, 100.5],
      [407, 107.5],
      [410, 128.5],
      [413, 124.5],
      [416, 124.5],
      [419, 109.5],
      [422, 114.5],
      [425, 135.5],
      [428, 127.5],
      [431, 114.5],
      [434, 119.5],
      [437, 120.5],
      [440, 124.5],
      [443, 116.5],
      [446, 131.5],
      [449, 116.5],
      [452, 100.5],
      [455, 127.5],
      [458, 116.5],
      [461, 111.5],
      [464, 103.5],
      [467, 109.5],
      [470, 128.5],
      [473, 129.5],
      [476, 105.5],
      [479, 126.5],
      [482, 107.5],
      [485, 120.5],
      [488, 130.5],
      [491, 103.5],
      [494, 108.5],
      [497, 103.5],
      [500, 122.5],
      [503, 117.5],
      [506, 115.5],
      [509, 114.5],
      [512, 99.5],
      [515, 131.5],
      [518, 121.5],
      [521, 106.5],
      [524, 105.5],
      [527, 103.5],
      [530, 109.5],
      [533, 127.5],
      [536, 125.5],
      [539, 118.5],
      [542, 114.5],
      [545, 113.5],
      [548, 108.5],
      [551, 105.5],
      [554, 103.5],
      [557, 130.5],
      [560, 125.5],
      [563, 126.5],
      [566, 128.5],
      [569, 124.5],
      [572, 99.5],
      [575, 122.5],
      [578, 121.5],
      [581, 118.5],
      [584, 108.5],
      [587, 108.5],
      [590, 127.5],
      [593, 117.5],
      [596, 134.5],
      [599, 113.5],
      [602, 131.5],
      [605, 125.5],
      [608, 113.5],
      [611, 98.5],
      [614, 113.5],
      [617, 97.5],
      [620, 122.5],
      [623, 126.5],
      [626, 120.5],
      [629, 124.5],
      [632, 99.5],
      [635, 115.5],
      [638, 121.5],
      [641, 109.5],
      [644, 108.5],
      [647, 116.5],
      [650, 116.5],
      [653, 112.5],
      [656, 113.5],
      [659, 103.5],
      [662, 111.5],
      [665, 107.5],
      [668, 111.5],
      [671, 118.5],
      [674, 104.5],
      [677, 109.5],
      [680, 119.5],
      [683, 108.5],
      [686, 128.5],
      [689, 118.5],
      [692, 124.5],
      [695, 111.5],
      [698, 108.5],
      [701, 110.5],
      [704, 111.5],
      [707, 91.5],
      [710, 102.5],
      [713, 107.5],
      [716, 97.5],
      [719, 110.5],
      [722, 104.5],
      [725, 107.5],
      [728, 113.5],
      [731, 113.5],
      [734, 104.5],
      [737, 118.5],
      [740, 117.5],
      [743, 113.5],
      [746, 130.5],
      [749, 106.5],
      [752, 110.5],
      [755, 111.5],
      [758, 106.5],
      [761, 114.5],
      [764, 101.5],
      [767, 93.5],
      [770, 117.5],
      [773, 118.5],
      [776, 115.5],
      [779, 111.5],
      [782, 122.5],
      [785, 105.5],
      [788, 97.5],
      [791, 97.5],
      [794, 111.5],
      [797, 104.5],
      [800, 115.5],
      [803, 123.5],
      [806, 119.5],
      [809, 118.5],
      [812, 93.5],
      [815, 114.5],
      [818, 121.5],
      [821, 98.5],
      [824, 116.5],
      [827, 112.5],
      [830, 117.5],
      [833, 120.5],
      [836, 126.5],
      [839, 101.5],
      [842, 116.5],
      [845, 111.5],
      [848, 105.5],
      [851, 106.5],
      [854, 98.5],
      [857, 93.5],
      [860, 118.5],
      [863, 130.5],
      [866, 130.5],
      [869, 117.5],
      [872, 104.5],
      [875, 118.5],
      [878, 109.5],
      [881, 118.5],
      [884, 109.5],
      [887, 110.5],
      [890, 124.5],
      [893, 113.5],
      [896, 120.5],
      [899, 107.5],
      [902, 107.5],
      [905, 111.5],
      [908, 109.5],
      [911, 106.5],
      [914, 112.5],
      [917, 118.5],
      [920, 118.5],
      [923, 113.5],
      [926, 124.5],
      [929, 115.5],
      [932, 104.5],
      [935, 109.5],
      [938, 100.5],
      [941, 106.5],
      [944, 107.5],
      [947, 101.5],
      [950, 117.5],
      [953, 108.5],
      [956, 110.5],
      [959, 115.5],
      [962, 107.5],
      [965, 111.5],
      [968, 105.5],
      [971, 102.5],
      [974, 108.5],
      [977, 94.5],
      [980, 117.5],
      [983, 121.5],
      [986, 105.5],
      [989, 114.5],
      [992, 107.5],
      [995, 103.5],
      [998, 101.5],
      [1001, 104.5],
      [1004, 121.5],
      [1007, 105.5],
      [1010, 120.5],
      [1013, 133.5],
      [1016, 123.5],
      [1019, 128.5],
      [1022, 104.5],
      [1025, 119.5],
      [1028, 107.5],
      [1031, 99.5],
      [1034, 99.5],
      [1037, 99.5],
      [1040, 118.5],
      [1043, 118.5],
      [1046, 104.5],
      [1049, 135.5],
      [1052, 95.5],
      [1055, 114.5],
      [1058, 112.5],
      [1061, 99.5],
      [1064, 110.5],
      [1067, 98.5],
      [1070, 116.5],
      [1073, 137.5],
      [1076, 103.5],
      [1079, 112.5],
      [1082, 108.5],
      [1085, 112.5],
      [1088, 108.5],
      [1091, 96.5],
      [1094, 115.5],
      [1097, 97.5],
      [1100, 111.5],
      [1103, 133.5],
      [1106, 108.5],
      [1109, 117.5],
      [1112, 94.5],
      [1115, 119.5],
      [1118, 118.5],
      [1121, 97.5],
      [1124, 104.5],
      [1127, 95.5],
      [1130, 103.5],
      [1133, 139.5],
      [1136, 109.5],
      [1139, 115.5],
      [1142, 109.5],
      [1145, 109.5],
      [1148, 114.5],
      [1151, 100.5],
      [1154, 98.5],
      [1157, 103.5],
      [1160, 111.5],
      [1163, 121.5],
      [1166, 107.5],
      [1169, 115.5],
      [1172, 95.5],
      [1175, 114.5],
      [1178, 114.5],
      [1181, 99.5],
      [1184, 122.5],
      [1187, 93.5],
      [1190, 103.5],
      [1193, 118.5],
      [1196, 122.5],
      [1199, 123.5],
      [1202, 96.5],
      [1205, 112.5],
      [1208, 111.5],
      [1211, 92.5],
      [1214, 100.5],
      [1217, 97.5],
      [1220, 104.5],
      [1223, 120.5],
      [1226, 114.5],
      [1229, 107.5],
      [1232, 105.5],
      [1235, 112.5],
      [1238, 112.5],
      [1241, 108.5],
      [1244, 109.5],
      [1247, 91.5],
      [1250, 97.5],
      [1253, 136.5],
      [1256, 99.5],
      [1259, 105.5],
      [1262, 106.5],
      [1265, 114.5],
      [1268, 111.5],
      [1271, 119.5],
      [1274, 120.5],
      [1277, 109.5],
      [1280, 114.5],
      [1283, 137.5],
      [1286, 116.5],
      [1289, 124.5],
      [1292, 91.5],
      [1295, 103.5],
      [1298, 110.5],
      [1301, 98.5],
      [1304, 110.5],
      [1307, 102.5],
      [1310, 117.5],
      [1313, 135.5],
      [1316, 119.5],
      [1319, 102.5],
      [1322, 108.5],
      [1325, 113.5],
      [1328, 112.5],
      [1331, 99.5],
      [1334, 101.5],
      [1337, 97.5],
      [1340, 113.5],
      [1343, 133.5],
      [1346, 98.5],
      [1349, 114.5],
      [1352, 94.5],
      [1355, 117.5],
      [1358, 114.5],
      [1361, 119.5],
      [1364, 108.5],
      [1367, 105.5],
      [1370, 102.5],
      [1373, 132.5],
      [1376, 103.5],
      [1379, 95.5],
      [1382, 108.5],
      [1385, 106.5],
      [1388, 111.5],
      [1391, 100.5],
      [1394, 107.5],
      [1397, 103.5],
      [1400, 116.5],
      [1403, 121.5],
      [1406, 111.5],
      [1409, 115.5],
      [1412, 91.5],
      [1415, 102.5],
      [1418, 120.5],
      [1421, 105.5],
      [1424, 103.5],
      [1427, 95.5],
      [1430, 112.5],
      [1433, 114.5],
      [1436, 125.5],
      [1439, 103.5],
      [1442, 106.5],
      [1445, 110.5],
      [1448, 116.5],
      [1451, 118.5],
      [1454, 103.5],
      [1457, 102.5],
      [1460, 124.5],
      [1463, 123.5],
      [1466, 115.5],
      [1469, 99.5],
      [1472, 99.5],
      [1475, 110.5],
      [1478, 112.5],
      [1481, 98.5],
      [1484, 109.5],
      [1487, 102.5],
      [1490, 108.5],
      [1493, 122.5],
      [1496, 114.5],
      [1499, 98.5],
      [1502, 95.5],
      [1505, 114.5],
      [1508, 115.5],
      [1511, 109.5],
      [1514, 100.5],
      [1517, 98.5],
      [1520, 114.5],
      [1523, 94.5],
      [1526, 95.5],
      [1529, 83.5],
      [1532, 83.5],
      [1535, 78.5],
      [1538, 76.5],
      [1541, 76.5],
      [1544, 75.5],
      [1547, 75.5],
      [1550, 75.5],
    ],
    bottom: [
      [1548, 75.5],
      [1545, 75.5],
      [1542, 75.5],
      [1539, 74.5],
      [1536, 73.5],
      [1533, 68.5],
      [1530, 64.5],
      [1527, 58.5],
      [1524, 55.5],
      [1521, 28.5],
      [1518, 39.5],
      [1515, 41.5],
      [1512, 49.5],
      [1509, 37.5],
      [1506, 40.5],
      [1503, 43.5],
      [1500, 38.5],
      [1497, 35.5],
      [1494, 48.5],
      [1491, 28.5],
      [1488, 39.5],
      [1485, 37.5],
      [1482, 55.5],
      [1479, 47.5],
      [1476, 45.5],
      [1473, 41.5],
      [1470, 37.5],
      [1467, 33.5],
      [1464, 38.5],
      [1461, 34.5],
      [1458, 39.5],
      [1455, 42.5],
      [1452, 31.5],
      [1449, 45.5],
      [1446, 49.5],
      [1443, 36.5],
      [1440, 38.5],
      [1437, 43.5],
      [1434, 40.5],
      [1431, 46.5],
      [1428, 47.5],
      [1425, 37.5],
      [1422, 51.5],
      [1419, 36.5],
      [1416, 52.5],
      [1413, 37.5],
      [1410, 48.5],
      [1407, 38.5],
      [1404, 52.5],
      [1401, 42.5],
      [1398, 36.5],
      [1395, 34.5],
      [1392, 55.5],
      [1389, 49.5],
      [1386, 52.5],
      [1383, 40.5],
      [1380, 39.5],
      [1377, 51.5],
      [1374, 50.5],
      [1371, 38.5],
      [1368, 47.5],
      [1365, 36.5],
      [1362, 33.5],
      [1359, 45.5],
      [1356, 37.5],
      [1353, 35.5],
      [1350, 45.5],
      [1347, 52.5],
      [1344, 39.5],
      [1341, 37.5],
      [1338, 29.5],
      [1335, 35.5],
      [1332, 55.5],
      [1329, 25.5],
      [1326, 53.5],
      [1323, 40.5],
      [1320, 39.5],
      [1317, 47.5],
      [1314, 36.5],
      [1311, 38.5],
      [1308, 35.5],
      [1305, 36.5],
      [1302, 52.5],
      [1299, 50.5],
      [1296, 50.5],
      [1293, 37.5],
      [1290, 48.5],
      [1287, 54.5],
      [1284, 35.5],
      [1281, 34.5],
      [1278, 32.5],
      [1275, 37.5],
      [1272, 38.5],
      [1269, 37.5],
      [1266, 48.5],
      [1263, 36.5],
      [1260, 37.5],
      [1257, 43.5],
      [1254, 37.5],
      [1251, 48.5],
      [1248, 40.5],
      [1245, 41.5],
      [1242, 37.5],
      [1239, 43.5],
      [1236, 51.5],
      [1233, 43.5],
      [1230, 30.5],
      [1227, 45.5],
      [1224, 28.5],
      [1221, 46.5],
      [1218, 34.5],
      [1215, 39.5],
      [1212, 61.5],
      [1209, 39.5],
      [1206, 57.5],
      [1203, 42.5],
      [1200, 39.5],
      [1197, 47.5],
      [1194, 46.5],
      [1191, 55.5],
      [1188, 46.5],
      [1185, 26.5],
      [1182, 38.5],
      [1179, 52.5],
      [1176, 53.5],
      [1173, 40.5],
      [1170, 51.5],
      [1167, 52.5],
      [1164, 27.5],
      [1161, 42.5],
      [1158, 34.5],
      [1155, 42.5],
      [1152, 54.5],
      [1149, 48.5],
      [1146, 46.5],
      [1143, 39.5],
      [1140, 24.5],
      [1137, 51.5],
      [1134, 37.5],
      [1131, 57.5],
      [1128, 41.5],
      [1125, 33.5],
      [1122, 54.5],
      [1119, 42.5],
      [1116, 46.5],
      [1113, 38.5],
      [1110, 31.5],
      [1107, 54.5],
      [1104, 29.5],
      [1101, 46.5],
      [1098, 30.5],
      [1095, 21.5],
      [1092, 54.5],
      [1089, 40.5],
      [1086, 50.5],
      [1083, 36.5],
      [1080, 27.5],
      [1077, 51.5],
      [1074, 32.5],
      [1071, 57.5],
      [1068, 34.5],
      [1065, 37.5],
      [1062, 42.5],
      [1059, 44.5],
      [1056, 47.5],
      [1053, 36.5],
      [1050, 46.5],
      [1047, 61.5],
      [1044, 40.5],
      [1041, 51.5],
      [1038, 37.5],
      [1035, 36.5],
      [1032, 44.5],
      [1029, 37.5],
      [1026, 43.5],
      [1023, 38.5],
      [1020, 26.5],
      [1017, 39.5],
      [1014, 12.5],
      [1011, 35.5],
      [1008, 37.5],
      [1005, 14.5],
      [1002, 41.5],
      [999, 50.5],
      [996, 46.5],
      [993, 48.5],
      [990, 25.5],
      [987, 41.5],
      [984, 16.5],
      [981, 45.5],
      [978, 49.5],
      [975, 43.5],
      [972, 44.5],
      [969, 28.5],
      [966, 45.5],
      [963, 47.5],
      [960, 11.5],
      [957, 44.5],
      [954, 37.5],
      [951, 51.5],
      [948, 44.5],
      [945, 36.5],
      [942, 52.5],
      [939, 43.5],
      [936, 45.5],
      [933, 39.5],
      [930, 25.5],
      [927, 43.5],
      [924, 28.5],
      [921, 36.5],
      [918, 51.5],
      [915, 23.5],
      [912, 43.5],
      [909, 44.5],
      [906, 42.5],
      [903, 38.5],
      [900, 34.5],
      [897, 44.5],
      [894, 26.5],
      [891, 43.5],
      [888, 47.5],
      [885, 33.5],
      [882, 34.5],
      [879, 45.5],
      [876, 32.5],
      [873, 41.5],
      [870, 19.5],
      [867, 37.5],
      [864, 20.5],
      [861, 46.5],
      [858, 46.5],
      [855, 34.5],
      [852, 51.5],
      [849, 41.5],
      [846, 47.5],
      [843, 42.5],
      [840, 25.5],
      [837, 47.5],
      [834, 35.5],
      [831, 56.5],
      [828, 32.5],
      [825, 27.5],
      [822, 40.5],
      [819, 50.5],
      [816, 40.5],
      [813, 34.5],
      [810, 46.5],
      [807, 49.5],
      [804, 24.5],
      [801, 49.5],
      [798, 32.5],
      [795, 36.5],
      [792, 62.5],
      [789, 44.5],
      [786, 37.5],
      [783, 26.5],
      [780, 22.5],
      [777, 40.5],
      [774, 26.5],
      [771, 55.5],
      [768, 54.5],
      [765, 31.5],
      [762, 44.5],
      [759, 43.5],
      [756, 37.5],
      [753, 43.5],
      [750, 34.5],
      [747, 43.5],
      [744, 36.5],
      [741, 35.5],
      [738, 49.5],
      [735, 42.5],
      [732, 42.5],
      [729, 51.5],
      [726, 37.5],
      [723, 37.5],
      [720, 38.5],
      [717, 54.5],
      [714, 47.5],
      [711, 57.5],
      [708, 41.5],
      [705, 45.5],
      [702, 45.5],
      [699, 43.5],
      [696, 42.5],
      [693, 24.5],
      [690, 31.5],
      [687, 32.5],
      [684, 38.5],
      [681, 41.5],
      [678, 48.5],
      [675, 43.5],
      [672, 40.5],
      [669, 44.5],
      [666, 36.5],
      [663, 40.5],
      [660, 39.5],
      [657, 34.5],
      [654, 40.5],
      [651, 49.5],
      [648, 23.5],
      [645, 42.5],
      [642, 51.5],
      [639, 31.5],
      [636, 34.5],
      [633, 33.5],
      [630, 41.5],
      [627, 41.5],
      [624, 36.5],
      [621, 44.5],
      [618, 32.5],
      [615, 25.5],
      [612, 57.5],
      [609, 31.5],
      [606, 47.5],
      [603, 14.5],
      [600, 29.5],
      [597, 36.5],
      [594, 43.5],
      [591, 52.5],
      [588, 35.5],
      [585, 32.5],
      [582, 32.5],
      [579, 39.5],
      [576, 45.5],
      [573, 35.5],
      [570, 43.5],
      [567, 44.5],
      [564, 43.5],
      [561, 34.5],
      [558, 8.5],
      [555, 28.5],
      [552, 58.5],
      [549, 33.5],
      [546, 42.5],
      [543, 26.5],
      [540, 31.5],
      [537, 38.5],
      [534, 49.5],
      [531, 54.5],
      [528, 33.5],
      [525, 34.5],
      [522, 36.5],
      [519, 39.5],
      [516, 37.5],
      [513, 8.5],
      [510, 34.5],
      [507, 44.5],
      [504, 36.5],
      [501, 40.5],
      [498, 24.5],
      [495, 37.5],
      [492, 54.5],
      [489, 19.5],
      [486, 44.5],
      [483, 32.5],
      [480, 23.5],
      [477, 32.5],
      [474, 44.5],
      [471, 36.5],
      [468, 13.5],
      [465, 27.5],
      [462, 36.5],
      [459, 39.5],
      [456, 36.5],
      [453, 33.5],
      [450, 20.5],
      [447, 16.5],
      [444, 41.5],
      [441, 38.5],
      [438, 17.5],
      [435, 25.5],
      [432, 25.5],
      [429, 40.5],
      [426, 13.5],
      [423, 33.5],
      [420, 18.5],
      [417, 29.5],
      [414, 30.5],
      [411, 29.5],
      [408, 40.5],
      [405, 28.5],
      [402, 37.5],
      [399, 18.5],
      [396, 30.5],
      [393, 19.5],
      [390, 16.5],
      [387, 22.5],
      [384, 32.5],
      [381, 33.5],
      [378, 11.5],
      [375, 20.5],
      [372, 25.5],
      [369, 45.5],
      [366, 37.5],
      [363, 50.5],
      [360, 13.5],
      [357, 29.5],
      [354, 28.5],
      [351, 41.5],
      [348, 15.5],
      [345, 18.5],
      [342, 33.5],
      [339, 32.5],
      [336, 18.5],
      [333, 23.5],
      [330, 17.5],
      [327, 33.5],
      [324, 46.5],
      [321, 32.5],
      [318, 12.5],
      [315, 19.5],
      [312, 51.5],
      [309, 21.5],
      [306, 36.5],
      [303, 18.5],
      [300, 12.5],
      [297, 46.5],
      [294, 33.5],
      [291, 36.5],
      [288, 12.5],
      [285, 30.5],
      [282, 33.5],
      [279, 37.5],
      [276, 44.5],
      [273, 33.5],
      [270, 15.5],
      [267, 44.5],
      [264, 36.5],
      [261, 38.5],
      [258, 13.5],
      [255, 21.5],
      [252, 45.5],
      [249, 18.5],
      [246, 24.5],
      [243, 28.5],
      [240, 13.5],
      [237, 25.5],
      [234, 37.5],
      [231, 41.5],
      [228, 23.5],
      [225, 12.5],
      [222, 23.5],
      [219, 37.5],
      [216, 42.5],
      [213, 8.5],
      [210, 33.5],
      [207, 51.5],
      [204, 26.5],
      [201, 21.5],
      [198, 14.5],
      [195, 14.5],
      [192, 31.5],
      [189, 41.5],
      [186, 37.5],
      [183, 18.5],
      [180, 5.5],
      [177, 43.5],
      [174, 29.5],
      [171, 43.5],
      [168, 32.5],
      [165, 16.5],
      [162, 35.5],
      [159, 25.5],
      [156, 11.5],
      [153, 31.5],
      [150, 6.502399999999994],
      [147, 30.5],
      [144, 24.5],
      [141, 38.5],
      [138, 29.5],
      [135, 19.5],
      [132, 56.5],
      [129, 25.5],
      [126, 18.5],
      [123, 34.5],
      [120, 21.5],
      [117, 44.5],
      [114, 39.5],
      [111, 42.5],
      [108, 56.5],
      [105, 30.5],
      [102, 22.5],
      [99, 28.5],
      [96, 33.5],
      [93, 17.5],
      [90, 20.5],
      [87, 34.5],
      [84, 37.5],
      [81, 18.5],
      [78, 26.5],
      [75, 18.5],
      [72, 56.5],
      [69, 23.5],
      [66, 15.5],
      [63, 31.5],
      [60, 5.5],
      [57, 31.5],
      [54, 25.5],
      [51, 45.5],
      [48, 60.5],
      [45, 25.5],
      [42, 19.5],
      [39, 25.5],
      [36, 25.5],
      [33, 15.5],
      [30, 15.5],
      [27, 36.5],
      [24, 18.5],
      [21, 23.5],
      [18, 9.5],
      [15, 8.5],
      [12, 44.5],
      [9, 2.099400000000003],
      [6, 14.5],
      [3, 17.5],
      [0, 40.5],
    ],
  },
  {
    top: [
      [2, 127.5],
      [5, 144.1054],
      [8, 106.5],
      [11, 108.5],
      [14, 131.5],
      [17, 114.5],
      [20, 145.5],
      [23, 126.5],
      [26, 140.5],
      [29, 144.875],
      [32, 106.5],
      [35, 134.5],
      [38, 144.875],
      [41, 127.5],
      [44, 144.4976],
      [47, 113.5],
      [50, 137.5],
      [53, 144.5],
      [56, 140.5],
      [59, 135.5],
      [62, 139.5],
      [65, 139.5],
      [68, 112.5],
      [71, 119.5],
      [74, 127.5],
      [77, 127.5],
      [80, 137.5],
      [83, 119.5],
      [86, 137.5],
      [89, 145.5],
      [92, 110.5],
      [95, 136.5],
      [98, 134.5],
      [101, 129.5],
      [104, 124.5],
      [107, 115.5],
      [110, 124.5],
      [113, 143.2766],
      [116, 127.5],
      [119, 139.5],
      [122, 127.5],
      [125, 130.5],
      [128, 104.5],
      [131, 109.5],
      [134, 119.5],
      [137, 109.5],
      [140, 145.5],
      [143, 120.5],
      [146, 129.5],
      [149, 143.2766],
      [152, 113.5],
      [155, 132.5],
      [158, 142.5],
      [161, 122.5],
      [164, 130.5],
      [167, 99.5],
      [170, 124.5],
      [173, 134.5],
      [176, 122.5],
      [179, 140.5],
      [182, 114.5],
      [185, 124.5],
      [188, 143.5],
      [191, 109.5],
      [194, 112.5],
      [197, 102.5],
      [200, 138.5],
      [203, 120.5],
      [206, 115.5],
      [209, 144.5],
      [212, 103.5],
      [215, 127.5],
      [218, 144.5],
      [221, 115.5],
      [224, 133.5],
      [227, 124.5],
      [230, 130.5],
      [233, 133.5],
      [236, 112.5],
      [239, 122.5],
      [242, 133.5],
      [245, 134.5],
      [248, 137.5],
      [251, 118.5],
      [254, 110.5],
      [257, 108.5],
      [260, 138.5],
      [263, 133.5],
      [266, 111.5],
      [269, 115.5],
      [272, 107.5],
      [275, 140.5],
      [278, 137.5],
      [281, 115.5],
      [284, 117.5],
      [287, 115.5],
      [290, 115.5],
      [293, 130.5],
      [296, 111.5],
      [299, 111.5],
      [302, 125.5],
      [305, 130.5],
      [308, 133.5],
      [311, 104.5],
      [314, 125.5],
      [317, 113.5],
      [320, 122.5],
      [323, 112.5],
      [326, 122.5],
      [329, 124.5],
      [332, 111.5],
      [335, 142.5],
      [338, 131.5],
      [341, 121.5],
      [344, 109.5],
      [347, 106.5],
      [350, 141.5],
      [353, 126.5],
      [356, 110.5],
      [359, 118.5],
      [362, 114.5],
      [365, 135.5],
      [368, 90.5],
      [371, 108.5],
      [374, 123.5],
      [377, 126.5],
      [380, 137.5],
      [383, 118.5],
      [386, 121.5],
      [389, 126.5],
      [392, 110.5],
      [395, 126.5],
      [398, 130.5],
      [401, 108.5],
      [404, 100.5],
      [407, 106.5],
      [410, 128.5],
      [413, 122.5],
      [416, 125.5],
      [419, 110.5],
      [422, 114.5],
      [425, 134.5],
      [428, 125.5],
      [431, 115.5],
      [434, 119.5],
      [437, 119.5],
      [440, 124.5],
      [443, 115.5],
      [446, 130.5],
      [449, 120.5],
      [452, 105.5],
      [455, 135.5],
      [458, 135.5],
      [461, 113.5],
      [464, 102.5],
      [467, 109.5],
      [470, 126.5],
      [473, 131.5],
      [476, 110.5],
      [479, 129.5],
      [482, 107.5],
      [485, 122.5],
      [488, 130.5],
      [491, 105.5],
      [494, 110.5],
      [497, 108.5],
      [500, 131.5],
      [503, 125.5],
      [506, 114.5],
      [509, 117.5],
      [512, 99.5],
      [515, 131.5],
      [518, 125.5],
      [521, 105.5],
      [524, 109.5],
      [527, 108.5],
      [530, 111.5],
      [533, 127.5],
      [536, 124.5],
      [539, 120.5],
      [542, 114.5],
      [545, 114.5],
      [548, 108.5],
      [551, 109.5],
      [554, 108.5],
      [557, 128.5],
      [560, 125.5],
      [563, 126.5],
      [566, 126.5],
      [569, 131.5],
      [572, 98.5],
      [575, 135.5],
      [578, 141.5],
      [581, 117.5],
      [584, 109.5],
      [587, 107.5],
      [590, 127.5],
      [593, 123.5],
      [596, 132.5],
      [599, 115.5],
      [602, 128.5],
      [605, 128.5],
      [608, 112.5],
      [611, 100.5],
      [614, 116.5],
      [617, 104.5],
      [620, 124.5],
      [623, 128.5],
      [626, 118.5],
      [629, 133.5],
      [632, 100.5],
      [635, 119.5],
      [638, 127.5],
      [641, 110.5],
      [644, 115.5],
      [647, 114.5],
      [650, 123.5],
      [653, 126.5],
      [656, 113.5],
      [659, 109.5],
      [662, 118.5],
      [665, 113.5],
      [668, 119.5],
      [671, 116.5],
      [674, 110.5],
      [677, 120.5],
      [680, 131.5],
      [683, 114.5],
      [686, 126.5],
      [689, 127.5],
      [692, 121.5],
      [695, 120.5],
      [698, 122.5],
      [701, 126.5],
      [704, 120.5],
      [707, 92.5],
      [710, 108.5],
      [713, 113.5],
      [716, 102.5],
      [719, 112.5],
      [722, 110.5],
      [725, 117.5],
      [728, 125.5],
      [731, 117.5],
      [734, 109.5],
      [737, 118.5],
      [740, 116.5],
      [743, 117.5],
      [746, 127.5],
      [749, 117.5],
      [752, 124.5],
      [755, 118.5],
      [758, 111.5],
      [761, 120.5],
      [764, 107.5],
      [767, 95.5],
      [770, 123.5],
      [773, 126.5],
      [776, 114.5],
      [779, 117.5],
      [782, 121.5],
      [785, 113.5],
      [788, 100.5],
      [791, 98.5],
      [794, 119.5],
      [797, 111.5],
      [800, 119.5],
      [803, 129.5],
      [806, 118.5],
      [809, 126.5],
      [812, 95.5],
      [815, 119.5],
      [818, 128.5],
      [821, 105.5],
      [824, 119.5],
      [827, 113.5],
      [830, 120.5],
      [833, 125.5],
      [836, 124.5],
      [839, 102.5],
      [842, 121.5],
      [845, 126.5],
      [848, 120.5],
      [851, 118.5],
      [854, 110.5],
      [857, 102.5],
      [860, 119.5],
      [863, 137.5],
      [866, 127.5],
      [869, 117.5],
      [872, 105.5],
      [875, 135.5],
      [878, 124.5],
      [881, 131.5],
      [884, 115.5],
      [887, 117.5],
      [890, 130.5],
      [893, 116.5],
      [896, 121.5],
      [899, 118.5],
      [902, 121.5],
      [905, 121.5],
      [908, 115.5],
      [911, 110.5],
      [914, 114.5],
      [917, 118.5],
      [920, 127.5],
      [923, 116.5],
      [926, 129.5],
      [929, 126.5],
      [932, 109.5],
      [935, 123.5],
      [938, 111.5],
      [941, 122.5],
      [944, 116.5],
      [947, 110.5],
      [950, 124.5],
      [953, 120.5],
      [956, 117.5],
      [959, 115.5],
      [962, 111.5],
      [965, 115.5],
      [968, 108.5],
      [971, 111.5],
      [974, 119.5],
      [977, 105.5],
      [980, 124.5],
      [983, 121.5],
      [986, 107.5],
      [989, 113.5],
      [992, 108.5],
      [995, 105.5],
      [998, 105.5],
      [1001, 116.5],
      [1004, 121.5],
      [1007, 110.5],
      [1010, 127.5],
      [1013, 132.5],
      [1016, 130.5],
      [1019, 128.5],
      [1022, 110.5],
      [1025, 122.5],
      [1028, 118.5],
      [1031, 105.5],
      [1034, 103.5],
      [1037, 105.5],
      [1040, 127.5],
      [1043, 116.5],
      [1046, 107.5],
      [1049, 132.5],
      [1052, 104.5],
      [1055, 135.5],
      [1058, 125.5],
      [1061, 103.5],
      [1064, 120.5],
      [1067, 100.5],
      [1070, 126.5],
      [1073, 134.5],
      [1076, 109.5],
      [1079, 119.5],
      [1082, 115.5],
      [1085, 121.5],
      [1088, 121.5],
      [1091, 102.5],
      [1094, 115.5],
      [1097, 99.5],
      [1100, 120.5],
      [1103, 132.5],
      [1106, 115.5],
      [1109, 117.5],
      [1112, 98.5],
      [1115, 127.5],
      [1118, 127.5],
      [1121, 105.5],
      [1124, 109.5],
      [1127, 102.5],
      [1130, 116.5],
      [1133, 139.5],
      [1136, 123.5],
      [1139, 112.5],
      [1142, 117.5],
      [1145, 124.5],
      [1148, 132.5],
      [1151, 105.5],
      [1154, 113.5],
      [1157, 111.5],
      [1160, 122.5],
      [1163, 119.5],
      [1166, 115.5],
      [1169, 120.5],
      [1172, 101.5],
      [1175, 131.5],
      [1178, 124.5],
      [1181, 108.5],
      [1184, 121.5],
      [1187, 96.5],
      [1190, 112.5],
      [1193, 126.5],
      [1196, 122.5],
      [1199, 121.5],
      [1202, 102.5],
      [1205, 118.5],
      [1208, 113.5],
      [1211, 95.5],
      [1214, 113.5],
      [1217, 98.5],
      [1220, 108.5],
      [1223, 118.5],
      [1226, 116.5],
      [1229, 107.5],
      [1232, 116.5],
      [1235, 116.5],
      [1238, 118.5],
      [1241, 114.5],
      [1244, 127.5],
      [1247, 97.5],
      [1250, 103.5],
      [1253, 136.5],
      [1256, 104.5],
      [1259, 107.5],
      [1262, 117.5],
      [1265, 119.5],
      [1268, 118.5],
      [1271, 120.5],
      [1274, 126.5],
      [1277, 115.5],
      [1280, 131.5],
      [1283, 133.5],
      [1286, 117.5],
      [1289, 123.5],
      [1292, 97.5],
      [1295, 119.5],
      [1298, 114.5],
      [1301, 104.5],
      [1304, 124.5],
      [1307, 102.5],
      [1310, 121.5],
      [1313, 132.5],
      [1316, 119.5],
      [1319, 107.5],
      [1322, 116.5],
      [1325, 127.5],
      [1328, 126.5],
      [1331, 100.5],
      [1334, 111.5],
      [1337, 97.5],
      [1340, 115.5],
      [1343, 132.5],
      [1346, 100.5],
      [1349, 116.5],
      [1352, 98.5],
      [1355, 130.5],
      [1358, 122.5],
      [1361, 118.5],
      [1364, 111.5],
      [1367, 105.5],
      [1370, 108.5],
      [1373, 134.5],
      [1376, 106.5],
      [1379, 100.5],
      [1382, 109.5],
      [1385, 116.5],
      [1388, 116.5],
      [1391, 105.5],
      [1394, 114.5],
      [1397, 100.5],
      [1400, 116.5],
      [1403, 121.5],
      [1406, 109.5],
      [1409, 123.5],
      [1412, 94.5],
      [1415, 113.5],
      [1418, 120.5],
      [1421, 109.5],
      [1424, 105.5],
      [1427, 97.5],
      [1430, 128.5],
      [1433, 118.5],
      [1436, 124.5],
      [1439, 107.5],
      [1442, 107.5],
      [1445, 110.5],
      [1448, 114.5],
      [1451, 117.5],
      [1454, 113.5],
      [1457, 110.5],
      [1460, 125.5],
      [1463, 122.5],
      [1466, 115.5],
      [1469, 104.5],
      [1472, 102.5],
      [1475, 119.5],
      [1478, 125.5],
      [1481, 110.5],
      [1484, 116.5],
      [1487, 110.5],
      [1490, 109.5],
      [1493, 128.5],
      [1496, 109.5],
      [1499, 101.5],
      [1502, 99.5],
      [1505, 129.5],
      [1508, 113.5],
      [1511, 118.5],
      [1514, 110.5],
      [1517, 100.5],
      [1520, 112.5],
      [1523, 95.5],
      [1526, 94.5],
      [1529, 85.5],
      [1532, 85.5],
      [1535, 78.5],
      [1538, 76.5],
      [1541, 76.5],
      [1544, 75.5],
      [1547, 75.5],
      [1550, 75.5],
    ],
    bottom: [
      [1548, 75.5],
      [1545, 75.5],
      [1542, 75.5],
      [1539, 74.5],
      [1536, 73.5],
      [1533, 66.5],
      [1530, 61.5],
      [1527, 59.5],
      [1524, 51.5],
      [1521, 30.5],
      [1518, 37.5],
      [1515, 31.5],
      [1512, 39.5],
      [1509, 39.5],
      [1506, 27.5],
      [1503, 35.5],
      [1500, 37.5],
      [1497, 40.5],
      [1494, 43.5],
      [1491, 28.5],
      [1488, 30.5],
      [1485, 34.5],
      [1482, 46.5],
      [1479, 30.5],
      [1476, 43.5],
      [1473, 36.5],
      [1470, 30.5],
      [1467, 34.5],
      [1464, 40.5],
      [1461, 36.5],
      [1458, 30.5],
      [1455, 27.5],
      [1452, 33.5],
      [1449, 42.5],
      [1446, 51.5],
      [1443, 36.5],
      [1440, 29.5],
      [1437, 45.5],
      [1434, 35.5],
      [1431, 37.5],
      [1428, 39.5],
      [1425, 36.5],
      [1422, 48.5],
      [1419, 38.5],
      [1416, 47.5],
      [1413, 26.5],
      [1410, 45.5],
      [1407, 39.5],
      [1404, 48.5],
      [1401, 42.5],
      [1398, 34.5],
      [1395, 28.5],
      [1392, 50.5],
      [1389, 42.5],
      [1386, 44.5],
      [1383, 35.5],
      [1380, 28.5],
      [1377, 48.5],
      [1374, 48.5],
      [1371, 38.5],
      [1368, 44.5],
      [1365, 32.5],
      [1362, 37.5],
      [1359, 37.5],
      [1356, 30.5],
      [1353, 25.5],
      [1350, 45.5],
      [1347, 53.5],
      [1344, 38.5],
      [1341, 38.5],
      [1338, 30.5],
      [1335, 24.5],
      [1332, 50.5],
      [1329, 17.5],
      [1326, 45.5],
      [1323, 31.5],
      [1320, 24.5],
      [1317, 48.5],
      [1314, 37.5],
      [1311, 39.5],
      [1308, 34.5],
      [1305, 22.5],
      [1302, 42.5],
      [1299, 46.5],
      [1296, 42.5],
      [1293, 24.5],
      [1290, 43.5],
      [1287, 56.5],
      [1284, 34.5],
      [1281, 32.5],
      [1278, 20.5],
      [1275, 23.5],
      [1272, 38.5],
      [1269, 29.5],
      [1266, 46.5],
      [1263, 28.5],
      [1260, 28.5],
      [1257, 42.5],
      [1254, 33.5],
      [1251, 48.5],
      [1248, 27.5],
      [1245, 22.5],
      [1242, 25.5],
      [1239, 39.5],
      [1236, 49.5],
      [1233, 36.5],
      [1230, 18.5],
      [1227, 46.5],
      [1224, 26.5],
      [1221, 46.5],
      [1218, 33.5],
      [1215, 24.5],
      [1212, 57.5],
      [1209, 35.5],
      [1206, 53.5],
      [1203, 39.5],
      [1200, 34.5],
      [1197, 46.5],
      [1194, 39.5],
      [1191, 47.5],
      [1188, 43.5],
      [1185, 24.5],
      [1182, 36.5],
      [1179, 46.5],
      [1176, 45.5],
      [1173, 28.5],
      [1170, 46.5],
      [1167, 49.5],
      [1164, 28.5],
      [1161, 34.5],
      [1158, 29.5],
      [1155, 28.5],
      [1152, 49.5],
      [1149, 35.5],
      [1146, 32.5],
      [1143, 33.5],
      [1140, 24.5],
      [1137, 49.5],
      [1134, 37.5],
      [1131, 51.5],
      [1128, 31.5],
      [1125, 32.5],
      [1122, 46.5],
      [1119, 38.5],
      [1116, 41.5],
      [1113, 29.5],
      [1110, 27.5],
      [1107, 52.5],
      [1104, 29.5],
      [1101, 39.5],
      [1098, 28.5],
      [1095, 19.5],
      [1092, 52.5],
      [1089, 28.5],
      [1086, 38.5],
      [1083, 30.5],
      [1080, 19.5],
      [1077, 43.5],
      [1074, 34.5],
      [1071, 54.5],
      [1068, 26.5],
      [1065, 26.5],
      [1062, 38.5],
      [1059, 39.5],
      [1056, 34.5],
      [1053, 15.5],
      [1050, 47.5],
      [1047, 60.5],
      [1044, 42.5],
      [1041, 45.5],
      [1038, 25.5],
      [1035, 33.5],
      [1032, 37.5],
      [1029, 25.5],
      [1026, 37.5],
      [1023, 29.5],
      [1020, 24.5],
      [1017, 33.5],
      [1014, 13.5],
      [1011, 26.5],
      [1008, 35.5],
      [1005, 14.5],
      [1002, 32.5],
      [999, 47.5],
      [996, 42.5],
      [993, 46.5],
      [990, 28.5],
      [987, 36.5],
      [984, 18.5],
      [981, 40.5],
      [978, 36.5],
      [975, 29.5],
      [972, 37.5],
      [969, 27.5],
      [966, 38.5],
      [963, 39.5],
      [960, 12.5],
      [957, 37.5],
      [954, 24.5],
      [951, 41.5],
      [948, 32.5],
      [945, 30.5],
      [942, 41.5],
      [939, 30.5],
      [936, 30.5],
      [933, 33.5],
      [930, 19.5],
      [927, 31.5],
      [924, 30.5],
      [921, 32.5],
      [918, 43.5],
      [915, 24.5],
      [912, 32.5],
      [909, 40.5],
      [906, 34.5],
      [903, 24.5],
      [900, 25.5],
      [897, 38.5],
      [894, 26.5],
      [891, 39.5],
      [888, 41.5],
      [885, 29.5],
      [882, 23.5],
      [879, 36.5],
      [876, 15.5],
      [873, 32.5],
      [870, 21.5],
      [867, 35.5],
      [864, 20.5],
      [861, 41.5],
      [858, 36.5],
      [855, 14.5],
      [852, 40.5],
      [849, 26.5],
      [846, 36.5],
      [843, 33.5],
      [840, 23.5],
      [837, 46.5],
      [834, 36.5],
      [831, 54.5],
      [828, 25.5],
      [825, 27.5],
      [822, 32.5],
      [819, 46.5],
      [816, 31.5],
      [813, 24.5],
      [810, 46.5],
      [807, 47.5],
      [804, 26.5],
      [801, 47.5],
      [798, 26.5],
      [795, 26.5],
      [792, 58.5],
      [789, 40.5],
      [786, 34.5],
      [783, 24.5],
      [780, 21.5],
      [777, 36.5],
      [774, 24.5],
      [771, 53.5],
      [768, 52.5],
      [765, 23.5],
      [762, 39.5],
      [759, 41.5],
      [756, 31.5],
      [753, 29.5],
      [750, 22.5],
      [747, 40.5],
      [744, 35.5],
      [741, 30.5],
      [738, 49.5],
      [735, 38.5],
      [732, 34.5],
      [729, 46.5],
      [726, 25.5],
      [723, 24.5],
      [720, 37.5],
      [717, 51.5],
      [714, 40.5],
      [711, 52.5],
      [708, 38.5],
      [705, 40.5],
      [702, 33.5],
      [699, 32.5],
      [696, 32.5],
      [693, 26.5],
      [690, 25.5],
      [687, 33.5],
      [684, 33.5],
      [681, 32.5],
      [678, 38.5],
      [675, 34.5],
      [672, 41.5],
      [669, 39.5],
      [666, 26.5],
      [663, 38.5],
      [660, 33.5],
      [657, 33.5],
      [654, 34.5],
      [651, 40.5],
      [648, 25.5],
      [645, 39.5],
      [642, 51.5],
      [639, 30.5],
      [636, 28.5],
      [633, 35.5],
      [630, 36.5],
      [627, 41.5],
      [624, 34.5],
      [621, 40.5],
      [618, 22.5],
      [615, 17.5],
      [612, 56.5],
      [609, 29.5],
      [606, 44.5],
      [603, 16.5],
      [600, 26.5],
      [597, 37.5],
      [594, 41.5],
      [591, 50.5],
      [588, 34.5],
      [585, 29.5],
      [582, 32.5],
      [579, 31.5],
      [576, 35.5],
      [573, 32.5],
      [570, 39.5],
      [567, 45.5],
      [564, 41.5],
      [561, 34.5],
      [558, 12.5],
      [555, 23.5],
      [552, 56.5],
      [549, 24.5],
      [546, 41.5],
      [543, 27.5],
      [540, 29.5],
      [537, 38.5],
      [534, 50.5],
      [531, 54.5],
      [528, 26.5],
      [525, 23.5],
      [522, 36.5],
      [519, 39.5],
      [516, 38.5],
      [513, 11.5],
      [510, 31.5],
      [507, 45.5],
      [504, 34.5],
      [501, 31.5],
      [498, 14.5],
      [495, 29.5],
      [492, 53.5],
      [489, 16.5],
      [486, 43.5],
      [483, 31.5],
      [480, 23.5],
      [477, 25.5],
      [474, 39.5],
      [471, 35.5],
      [468, 15.5],
      [465, 23.5],
      [462, 33.5],
      [459, 28.5],
      [456, 26.5],
      [453, 25.5],
      [450, 11.5],
      [447, 18.5],
      [444, 41.5],
      [441, 37.5],
      [438, 20.5],
      [435, 23.5],
      [432, 24.5],
      [429, 40.5],
      [426, 10.5],
      [423, 36.5],
      [420, 16.5],
      [417, 29.5],
      [414, 31.5],
      [411, 28.5],
      [408, 40.5],
      [405, 30.5],
      [402, 37.5],
      [399, 23.5],
      [396, 26.5],
      [393, 20.5],
      [390, 13.5],
      [387, 24.5],
      [384, 28.5],
      [381, 33.5],
      [378, 7.723399999999998],
      [375, 16.5],
      [372, 27.5],
      [369, 47.5],
      [366, 37.5],
      [363, 47.5],
      [360, 14.5],
      [357, 30.5],
      [354, 24.5],
      [351, 35.5],
      [348, 11.5],
      [345, 18.5],
      [342, 32.5],
      [339, 28.5],
      [336, 21.5],
      [333, 20.5],
      [330, 18.5],
      [327, 32.5],
      [324, 44.5],
      [321, 35.5],
      [318, 10.5],
      [315, 19.5],
      [312, 51.5],
      [309, 24.5],
      [306, 38.5],
      [303, 16.5],
      [300, 10.5],
      [297, 47.5],
      [294, 36.5],
      [291, 37.5],
      [288, 11.5],
      [285, 28.5],
      [282, 33.5],
      [279, 35.5],
      [276, 36.5],
      [273, 30.5],
      [270, 15.5],
      [267, 45.5],
      [264, 36.5],
      [261, 34.5],
      [258, 10.5],
      [255, 22.5],
      [252, 43.5],
      [249, 16.5],
      [246, 27.5],
      [243, 30.5],
      [240, 15.5],
      [237, 27.5],
      [234, 34.5],
      [231, 41.5],
      [228, 21.5],
      [225, 12.5],
      [222, 23.5],
      [219, 31.5],
      [216, 41.5],
      [213, 9.5],
      [210, 34.5],
      [207, 51.5],
      [204, 27.5],
      [201, 21.5],
      [198, 9.5],
      [195, 15.5],
      [192, 29.5],
      [189, 41.5],
      [186, 40.5],
      [183, 17.5],
      [180, 7.301600000000008],
      [177, 43.5],
      [174, 29.5],
      [171, 42.5],
      [168, 26.5],
      [165, 18.5],
      [162, 34.5],
      [159, 25.5],
      [156, 14.5],
      [153, 27.5],
      [150, 6.502399999999994],
      [147, 27.5],
      [144, 26.5],
      [141, 32.5],
      [138, 26.5],
      [135, 14.5],
      [132, 57.5],
      [129, 25.5],
      [126, 10.5],
      [123, 33.5],
      [120, 21.5],
      [117, 44.5],
      [114, 38.5],
      [111, 43.5],
      [108, 56.5],
      [105, 28.5],
      [102, 21.5],
      [99, 25.5],
      [96, 32.5],
      [93, 16.5],
      [90, 22.5],
      [87, 34.5],
      [84, 37.5],
      [81, 18.5],
      [78, 25.5],
      [75, 11.5],
      [72, 55.5],
      [69, 21.5],
      [66, 15.5],
      [63, 31.5],
      [60, 7.723399999999998],
      [57, 29.5],
      [54, 27.5],
      [51, 43.5],
      [48, 59.5],
      [45, 25.5],
      [42, 19.5],
      [39, 27.5],
      [36, 23.5],
      [33, 14.5],
      [30, 15.5],
      [27, 35.5],
      [24, 17.5],
      [21, 21.5],
      [18, 8.5],
      [15, 8.5],
      [12, 43.5],
      [9, 2.099400000000003],
      [6, 12.5],
      [3, 16.5],
      [0, 40.5],
    ],
  },
  {
    top: [
      [2, 128.5],
      [5, 144.1054],
      [8, 107.5],
      [11, 108.5],
      [14, 131.5],
      [17, 113.5],
      [20, 143.6984],
      [23, 123.5],
      [26, 139.5],
      [29, 143.2766],
      [32, 106.5],
      [35, 132.5],
      [38, 145.2376],
      [41, 125.5],
      [44, 144.875],
      [47, 111.5],
      [50, 141.5],
      [53, 141.5],
      [56, 139.5],
      [59, 135.5],
      [62, 135.5],
      [65, 134.5],
      [68, 110.5],
      [71, 116.5],
      [74, 129.5],
      [77, 128.5],
      [80, 138.5],
      [83, 117.5],
      [86, 136.5],
      [89, 145.5],
      [92, 108.5],
      [95, 134.5],
      [98, 134.5],
      [101, 129.5],
      [104, 124.5],
      [107, 116.5],
      [110, 123.5],
      [113, 144.5],
      [116, 125.5],
      [119, 140.5],
      [122, 124.5],
      [125, 135.5],
      [128, 102.5],
      [131, 108.5],
      [134, 119.5],
      [137, 107.5],
      [140, 144.875],
      [143, 119.5],
      [146, 128.5],
      [149, 145.5],
      [152, 112.5],
      [155, 129.5],
      [158, 141.5],
      [161, 120.5],
      [164, 129.5],
      [167, 99.5],
      [170, 124.5],
      [173, 136.5],
      [176, 121.5],
      [179, 140.5],
      [182, 114.5],
      [185, 121.5],
      [188, 142.5],
      [191, 109.5],
      [194, 111.5],
      [197, 100.5],
      [200, 135.5],
      [203, 120.5],
      [206, 117.5],
      [209, 141.5],
      [212, 102.5],
      [215, 124.5],
      [218, 143.6984],
      [221, 115.5],
      [224, 132.5],
      [227, 124.5],
      [230, 129.5],
      [233, 129.5],
      [236, 112.5],
      [239, 122.5],
      [242, 134.5],
      [245, 131.5],
      [248, 137.5],
      [251, 121.5],
      [254, 109.5],
      [257, 109.5],
      [260, 141.5],
      [263, 132.5],
      [266, 111.5],
      [269, 116.5],
      [272, 107.5],
      [275, 143.5],
      [278, 139.5],
      [281, 116.5],
      [284, 115.5],
      [287, 117.5],
      [290, 113.5],
      [293, 129.5],
      [296, 110.5],
      [299, 112.5],
      [302, 127.5],
      [305, 129.5],
      [308, 132.5],
      [311, 104.5],
      [314, 124.5],
      [317, 113.5],
      [320, 120.5],
      [323, 112.5],
      [326, 124.5],
      [329, 123.5],
      [332, 112.5],
      [335, 137.5],
      [338, 134.5],
      [341, 119.5],
      [344, 108.5],
      [347, 104.5],
      [350, 144.5],
      [353, 126.5],
      [356, 107.5],
      [359, 115.5],
      [362, 112.5],
      [365, 133.5],
      [368, 90.5],
      [371, 107.5],
      [374, 121.5],
      [377, 128.5],
      [380, 134.5],
      [383, 116.5],
      [386, 118.5],
      [389, 124.5],
      [392, 108.5],
      [395, 128.5],
      [398, 130.5],
      [401, 108.5],
      [404, 98.5],
      [407, 107.5],
      [410, 126.5],
      [413, 122.5],
      [416, 122.5],
      [419, 110.5],
      [422, 112.5],
      [425, 132.5],
      [428, 126.5],
      [431, 115.5],
      [434, 118.5],
      [437, 118.5],
      [440, 124.5],
      [443, 114.5],
      [446, 128.5],
      [449, 116.5],
      [452, 108.5],
      [455, 133.5],
      [458, 139.5],
      [461, 113.5],
      [464, 101.5],
      [467, 108.5],
      [470, 122.5],
      [473, 128.5],
      [476, 112.5],
      [479, 127.5],
      [482, 107.5],
      [485, 121.5],
      [488, 129.5],
      [491, 104.5],
      [494, 110.5],
      [497, 110.5],
      [500, 132.5],
      [503, 126.5],
      [506, 112.5],
      [509, 114.5],
      [512, 97.5],
      [515, 128.5],
      [518, 124.5],
      [521, 104.5],
      [524, 108.5],
      [527, 110.5],
      [530, 111.5],
      [533, 124.5],
      [536, 123.5],
      [539, 121.5],
      [542, 115.5],
      [545, 113.5],
      [548, 106.5],
      [551, 111.5],
      [554, 107.5],
      [557, 124.5],
      [560, 122.5],
      [563, 125.5],
      [566, 122.5],
      [569, 129.5],
      [572, 97.5],
      [575, 133.5],
      [578, 145.5],
      [581, 116.5],
      [584, 109.5],
      [587, 106.5],
      [590, 126.5],
      [593, 119.5],
      [596, 127.5],
      [599, 116.5],
      [602, 123.5],
      [605, 124.5],
      [608, 111.5],
      [611, 99.5],
      [614, 114.5],
      [617, 106.5],
      [620, 127.5],
      [623, 127.5],
      [626, 117.5],
      [629, 129.5],
      [632, 100.5],
      [635, 120.5],
      [638, 126.5],
      [641, 110.5],
      [644, 115.5],
      [647, 112.5],
      [650, 122.5],
      [653, 127.5],
      [656, 112.5],
      [659, 108.5],
      [662, 119.5],
      [665, 113.5],
      [668, 118.5],
      [671, 114.5],
      [674, 108.5],
      [677, 122.5],
      [680, 127.5],
      [683, 113.5],
      [686, 122.5],
      [689, 124.5],
      [692, 117.5],
      [695, 121.5],
      [698, 121.5],
      [701, 126.5],
      [704, 120.5],
      [707, 91.5],
      [710, 108.5],
      [713, 114.5],
      [716, 100.5],
      [719, 112.5],
      [722, 108.5],
      [725, 114.5],
      [728, 127.5],
      [731, 116.5],
      [734, 108.5],
      [737, 118.5],
      [740, 114.5],
      [743, 116.5],
      [746, 124.5],
      [749, 117.5],
      [752, 126.5],
      [755, 117.5],
      [758, 115.5],
      [761, 121.5],
      [764, 108.5],
      [767, 96.5],
      [770, 122.5],
      [773, 124.5],
      [776, 115.5],
      [779, 118.5],
      [782, 118.5],
      [785, 113.5],
      [788, 100.5],
      [791, 100.5],
      [794, 118.5],
      [797, 110.5],
      [800, 119.5],
      [803, 128.5],
      [806, 115.5],
      [809, 124.5],
      [812, 96.5],
      [815, 123.5],
      [818, 128.5],
      [821, 103.5],
      [824, 117.5],
      [827, 113.5],
      [830, 121.5],
      [833, 122.5],
      [836, 119.5],
      [839, 102.5],
      [842, 120.5],
      [845, 123.5],
      [848, 117.5],
      [851, 118.5],
      [854, 111.5],
      [857, 103.5],
      [860, 119.5],
      [863, 134.5],
      [866, 124.5],
      [869, 116.5],
      [872, 102.5],
      [875, 134.5],
      [878, 124.5],
      [881, 127.5],
      [884, 113.5],
      [887, 117.5],
      [890, 128.5],
      [893, 114.5],
      [896, 123.5],
      [899, 117.5],
      [902, 124.5],
      [905, 119.5],
      [908, 116.5],
      [911, 111.5],
      [914, 111.5],
      [917, 118.5],
      [920, 128.5],
      [923, 115.5],
      [926, 126.5],
      [929, 127.5],
      [932, 107.5],
      [935, 126.5],
      [938, 109.5],
      [941, 121.5],
      [944, 114.5],
      [947, 109.5],
      [950, 124.5],
      [953, 122.5],
      [956, 118.5],
      [959, 114.5],
      [962, 110.5],
      [965, 116.5],
      [968, 108.5],
      [971, 110.5],
      [974, 123.5],
      [977, 106.5],
      [980, 124.5],
      [983, 120.5],
      [986, 106.5],
      [989, 112.5],
      [992, 111.5],
      [995, 105.5],
      [998, 106.5],
      [1001, 118.5],
      [1004, 120.5],
      [1007, 108.5],
      [1010, 125.5],
      [1013, 128.5],
      [1016, 132.5],
      [1019, 131.5],
      [1022, 109.5],
      [1025, 121.5],
      [1028, 120.5],
      [1031, 105.5],
      [1034, 102.5],
      [1037, 105.5],
      [1040, 126.5],
      [1043, 114.5],
      [1046, 106.5],
      [1049, 129.5],
      [1052, 104.5],
      [1055, 138.5],
      [1058, 124.5],
      [1061, 102.5],
      [1064, 119.5],
      [1067, 101.5],
      [1070, 124.5],
      [1073, 129.5],
      [1076, 108.5],
      [1079, 121.5],
      [1082, 114.5],
      [1085, 123.5],
      [1088, 119.5],
      [1091, 100.5],
      [1094, 115.5],
      [1097, 100.5],
      [1100, 120.5],
      [1103, 133.5],
      [1106, 113.5],
      [1109, 117.5],
      [1112, 99.5],
      [1115, 128.5],
      [1118, 124.5],
      [1121, 105.5],
      [1124, 109.5],
      [1127, 102.5],
      [1130, 117.5],
      [1133, 136.5],
      [1136, 123.5],
      [1139, 109.5],
      [1142, 115.5],
      [1145, 125.5],
      [1148, 129.5],
      [1151, 103.5],
      [1154, 117.5],
      [1157, 110.5],
      [1160, 124.5],
      [1163, 115.5],
      [1166, 115.5],
      [1169, 119.5],
      [1172, 99.5],
      [1175, 134.5],
      [1178, 130.5],
      [1181, 107.5],
      [1184, 117.5],
      [1187, 94.5],
      [1190, 110.5],
      [1193, 122.5],
      [1196, 123.5],
      [1199, 118.5],
      [1202, 101.5],
      [1205, 125.5],
      [1208, 113.5],
      [1211, 94.5],
      [1214, 117.5],
      [1217, 99.5],
      [1220, 107.5],
      [1223, 114.5],
      [1226, 113.5],
      [1229, 107.5],
      [1232, 114.5],
      [1235, 120.5],
      [1238, 117.5],
      [1241, 114.5],
      [1244, 124.5],
      [1247, 96.5],
      [1250, 101.5],
      [1253, 137.5],
      [1256, 104.5],
      [1259, 106.5],
      [1262, 114.5],
      [1265, 119.5],
      [1268, 116.5],
      [1271, 117.5],
      [1274, 126.5],
      [1277, 115.5],
      [1280, 131.5],
      [1283, 128.5],
      [1286, 114.5],
      [1289, 120.5],
      [1292, 97.5],
      [1295, 120.5],
      [1298, 112.5],
      [1301, 102.5],
      [1304, 128.5],
      [1307, 103.5],
      [1310, 119.5],
      [1313, 127.5],
      [1316, 118.5],
      [1319, 104.5],
      [1322, 113.5],
      [1325, 127.5],
      [1328, 127.5],
      [1331, 101.5],
      [1334, 114.5],
      [1337, 95.5],
      [1340, 111.5],
      [1343, 126.5],
      [1346, 98.5],
      [1349, 111.5],
      [1352, 98.5],
      [1355, 136.5],
      [1358, 119.5],
      [1361, 115.5],
      [1364, 110.5],
      [1367, 104.5],
      [1370, 107.5],
      [1373, 136.5],
      [1376, 105.5],
      [1379, 104.5],
      [1382, 112.5],
      [1385, 114.5],
      [1388, 114.5],
      [1391, 104.5],
      [1394, 116.5],
      [1397, 101.5],
      [1400, 117.5],
      [1403, 120.5],
      [1406, 109.5],
      [1409, 120.5],
      [1412, 95.5],
      [1415, 111.5],
      [1418, 116.5],
      [1421, 107.5],
      [1424, 105.5],
      [1427, 96.5],
      [1430, 129.5],
      [1433, 119.5],
      [1436, 122.5],
      [1439, 104.5],
      [1442, 106.5],
      [1445, 112.5],
      [1448, 113.5],
      [1451, 116.5],
      [1454, 117.5],
      [1457, 111.5],
      [1460, 121.5],
      [1463, 118.5],
      [1466, 111.5],
      [1469, 101.5],
      [1472, 101.5],
      [1475, 122.5],
      [1478, 126.5],
      [1481, 110.5],
      [1484, 114.5],
      [1487, 108.5],
      [1490, 105.5],
      [1493, 131.5],
      [1496, 108.5],
      [1499, 101.5],
      [1502, 97.5],
      [1505, 132.5],
      [1508, 110.5],
      [1511, 117.5],
      [1514, 113.5],
      [1517, 98.5],
      [1520, 108.5],
      [1523, 93.5],
      [1526, 92.5],
      [1529, 86.5],
      [1532, 86.5],
      [1535, 78.5],
      [1538, 76.5],
      [1541, 75.5],
      [1544, 75.5],
      [1547, 75.5],
      [1550, 75.5],
    ],
    bottom: [
      [1548, 75.5],
      [1545, 75.5],
      [1542, 75.5],
      [1539, 74.5],
      [1536, 73.5],
      [1533, 66.5],
      [1530, 59.5],
      [1527, 60.5],
      [1524, 54.5],
      [1521, 35.5],
      [1518, 39.5],
      [1515, 28.5],
      [1512, 40.5],
      [1509, 41.5],
      [1506, 27.5],
      [1503, 35.5],
      [1500, 37.5],
      [1497, 41.5],
      [1494, 43.5],
      [1491, 32.5],
      [1488, 34.5],
      [1485, 34.5],
      [1482, 45.5],
      [1479, 27.5],
      [1476, 42.5],
      [1473, 34.5],
      [1470, 33.5],
      [1467, 38.5],
      [1464, 42.5],
      [1461, 40.5],
      [1458, 33.5],
      [1455, 24.5],
      [1452, 30.5],
      [1449, 44.5],
      [1446, 48.5],
      [1443, 35.5],
      [1440, 33.5],
      [1437, 47.5],
      [1434, 30.5],
      [1431, 37.5],
      [1428, 37.5],
      [1425, 38.5],
      [1422, 50.5],
      [1419, 41.5],
      [1416, 49.5],
      [1413, 21.5],
      [1410, 47.5],
      [1407, 42.5],
      [1404, 49.5],
      [1401, 44.5],
      [1398, 33.5],
      [1395, 23.5],
      [1392, 51.5],
      [1389, 44.5],
      [1386, 46.5],
      [1383, 35.5],
      [1380, 22.5],
      [1377, 48.5],
      [1374, 46.5],
      [1371, 41.5],
      [1368, 45.5],
      [1365, 33.5],
      [1362, 39.5],
      [1359, 39.5],
      [1356, 26.5],
      [1353, 22.5],
      [1350, 46.5],
      [1347, 53.5],
      [1344, 41.5],
      [1341, 42.5],
      [1338, 34.5],
      [1335, 23.5],
      [1332, 49.5],
      [1329, 13.5],
      [1326, 47.5],
      [1323, 30.5],
      [1320, 28.5],
      [1317, 50.5],
      [1314, 39.5],
      [1311, 42.5],
      [1308, 38.5],
      [1305, 20.5],
      [1302, 44.5],
      [1299, 48.5],
      [1296, 44.5],
      [1293, 20.5],
      [1290, 44.5],
      [1287, 57.5],
      [1284, 38.5],
      [1281, 33.5],
      [1278, 16.5],
      [1275, 24.5],
      [1272, 41.5],
      [1269, 31.5],
      [1266, 46.5],
      [1263, 30.5],
      [1260, 30.5],
      [1257, 44.5],
      [1254, 31.5],
      [1251, 51.5],
      [1248, 29.5],
      [1245, 26.5],
      [1242, 25.5],
      [1239, 39.5],
      [1236, 45.5],
      [1233, 38.5],
      [1230, 20.5],
      [1227, 48.5],
      [1224, 31.5],
      [1221, 47.5],
      [1218, 30.5],
      [1215, 20.5],
      [1212, 57.5],
      [1209, 33.5],
      [1206, 50.5],
      [1203, 39.5],
      [1200, 35.5],
      [1197, 47.5],
      [1194, 42.5],
      [1191, 48.5],
      [1188, 45.5],
      [1185, 26.5],
      [1182, 37.5],
      [1179, 41.5],
      [1176, 45.5],
      [1173, 27.5],
      [1170, 48.5],
      [1167, 49.5],
      [1164, 32.5],
      [1161, 33.5],
      [1158, 32.5],
      [1155, 22.5],
      [1152, 50.5],
      [1149, 37.5],
      [1146, 32.5],
      [1143, 33.5],
      [1140, 30.5],
      [1137, 51.5],
      [1134, 37.5],
      [1131, 53.5],
      [1128, 27.5],
      [1125, 30.5],
      [1122, 46.5],
      [1119, 41.5],
      [1116, 41.5],
      [1113, 28.5],
      [1110, 29.5],
      [1107, 53.5],
      [1104, 29.5],
      [1101, 41.5],
      [1098, 26.5],
      [1095, 16.5],
      [1092, 54.5],
      [1089, 30.5],
      [1086, 38.5],
      [1083, 33.5],
      [1080, 19.5],
      [1077, 43.5],
      [1074, 38.5],
      [1071, 55.5],
      [1068, 25.5],
      [1065, 27.5],
      [1062, 37.5],
      [1059, 36.5],
      [1056, 33.5],
      [1053, 14.5],
      [1050, 48.5],
      [1047, 60.5],
      [1044, 44.5],
      [1041, 47.5],
      [1038, 28.5],
      [1035, 31.5],
      [1032, 37.5],
      [1029, 24.5],
      [1026, 38.5],
      [1023, 29.5],
      [1020, 23.5],
      [1017, 34.5],
      [1014, 14.5],
      [1011, 28.5],
      [1008, 37.5],
      [1005, 17.5],
      [1002, 31.5],
      [999, 47.5],
      [996, 39.5],
      [993, 44.5],
      [990, 27.5],
      [987, 37.5],
      [984, 21.5],
      [981, 41.5],
      [978, 32.5],
      [975, 24.5],
      [972, 36.5],
      [969, 27.5],
      [966, 36.5],
      [963, 40.5],
      [960, 16.5],
      [957, 35.5],
      [954, 22.5],
      [951, 42.5],
      [948, 35.5],
      [945, 33.5],
      [942, 43.5],
      [939, 32.5],
      [936, 27.5],
      [933, 33.5],
      [930, 21.5],
      [927, 31.5],
      [924, 32.5],
      [921, 28.5],
      [918, 44.5],
      [915, 27.5],
      [912, 32.5],
      [909, 39.5],
      [906, 35.5],
      [903, 20.5],
      [900, 27.5],
      [897, 37.5],
      [894, 29.5],
      [891, 40.5],
      [888, 41.5],
      [885, 32.5],
      [882, 28.5],
      [879, 37.5],
      [876, 15.5],
      [873, 35.5],
      [870, 24.5],
      [867, 37.5],
      [864, 24.5],
      [861, 41.5],
      [858, 38.5],
      [855, 11.5],
      [852, 36.5],
      [849, 28.5],
      [846, 38.5],
      [843, 34.5],
      [840, 24.5],
      [837, 48.5],
      [834, 39.5],
      [831, 52.5],
      [828, 22.5],
      [825, 31.5],
      [822, 35.5],
      [819, 46.5],
      [816, 27.5],
      [813, 21.5],
      [810, 45.5],
      [807, 49.5],
      [804, 29.5],
      [801, 47.5],
      [798, 25.5],
      [795, 30.5],
      [792, 58.5],
      [789, 41.5],
      [786, 36.5],
      [783, 24.5],
      [780, 23.5],
      [777, 37.5],
      [774, 28.5],
      [771, 53.5],
      [768, 52.5],
      [765, 25.5],
      [762, 40.5],
      [759, 35.5],
      [756, 34.5],
      [753, 26.5],
      [750, 23.5],
      [747, 41.5],
      [744, 38.5],
      [741, 32.5],
      [738, 50.5],
      [735, 38.5],
      [732, 36.5],
      [729, 46.5],
      [726, 23.5],
      [723, 27.5],
      [720, 40.5],
      [717, 51.5],
      [714, 41.5],
      [711, 53.5],
      [708, 38.5],
      [705, 42.5],
      [702, 30.5],
      [699, 34.5],
      [696, 30.5],
      [693, 30.5],
      [690, 28.5],
      [687, 35.5],
      [684, 34.5],
      [681, 34.5],
      [678, 37.5],
      [675, 35.5],
      [672, 42.5],
      [669, 41.5],
      [666, 26.5],
      [663, 37.5],
      [660, 36.5],
      [657, 33.5],
      [654, 36.5],
      [651, 38.5],
      [648, 28.5],
      [645, 39.5],
      [642, 52.5],
      [639, 30.5],
      [636, 31.5],
      [633, 35.5],
      [630, 36.5],
      [627, 42.5],
      [624, 37.5],
      [621, 41.5],
      [618, 19.5],
      [615, 18.5],
      [612, 57.5],
      [609, 30.5],
      [606, 45.5],
      [603, 21.5],
      [600, 27.5],
      [597, 40.5],
      [594, 43.5],
      [591, 51.5],
      [588, 35.5],
      [585, 29.5],
      [582, 33.5],
      [579, 32.5],
      [576, 33.5],
      [573, 33.5],
      [570, 39.5],
      [567, 47.5],
      [564, 40.5],
      [561, 36.5],
      [558, 18.5],
      [555, 24.5],
      [552, 55.5],
      [549, 27.5],
      [546, 42.5],
      [543, 26.5],
      [540, 31.5],
      [537, 38.5],
      [534, 52.5],
      [531, 55.5],
      [528, 25.5],
      [525, 23.5],
      [522, 38.5],
      [519, 39.5],
      [516, 38.5],
      [513, 16.5],
      [510, 33.5],
      [507, 47.5],
      [504, 36.5],
      [501, 29.5],
      [498, 11.5],
      [495, 31.5],
      [492, 54.5],
      [489, 17.5],
      [486, 43.5],
      [483, 33.5],
      [480, 27.5],
      [477, 23.5],
      [474, 40.5],
      [471, 37.5],
      [468, 20.5],
      [465, 26.5],
      [462, 35.5],
      [459, 26.5],
      [456, 27.5],
      [453, 23.5],
      [450, 9.5],
      [447, 21.5],
      [444, 41.5],
      [441, 39.5],
      [438, 21.5],
      [435, 24.5],
      [432, 25.5],
      [429, 39.5],
      [426, 7.5],
      [423, 38.5],
      [420, 18.5],
      [417, 30.5],
      [414, 32.5],
      [411, 28.5],
      [408, 41.5],
      [405, 31.5],
      [402, 38.5],
      [399, 22.5],
      [396, 29.5],
      [393, 21.5],
      [390, 16.5],
      [387, 27.5],
      [384, 30.5],
      [381, 34.5],
      [378, 6.502399999999994],
      [375, 16.5],
      [372, 29.5],
      [369, 47.5],
      [366, 39.5],
      [363, 49.5],
      [360, 15.5],
      [357, 33.5],
      [354, 26.5],
      [351, 32.5],
      [348, 12.5],
      [345, 20.5],
      [342, 32.5],
      [339, 26.5],
      [336, 23.5],
      [333, 22.5],
      [330, 16.5],
      [327, 32.5],
      [324, 44.5],
      [321, 33.5],
      [318, 11.5],
      [315, 20.5],
      [312, 52.5],
      [309, 24.5],
      [306, 38.5],
      [303, 16.5],
      [300, 8.5],
      [297, 47.5],
      [294, 37.5],
      [291, 38.5],
      [288, 10.5],
      [285, 28.5],
      [282, 34.5],
      [279, 33.5],
      [276, 33.5],
      [273, 33.5],
      [270, 16.5],
      [267, 46.5],
      [264, 36.5],
      [261, 37.5],
      [258, 6.5],
      [255, 20.5],
      [252, 42.5],
      [249, 16.5],
      [246, 29.5],
      [243, 31.5],
      [240, 15.5],
      [237, 27.5],
      [234, 36.5],
      [231, 42.5],
      [228, 20.5],
      [225, 11.5],
      [222, 25.5],
      [219, 28.5],
      [216, 42.5],
      [213, 12.5],
      [210, 36.5],
      [207, 51.5],
      [204, 22.5],
      [201, 23.5],
      [198, 10.5],
      [195, 16.5],
      [192, 29.5],
      [189, 42.5],
      [186, 40.5],
      [183, 16.5],
      [180, 7.301600000000008],
      [177, 45.5],
      [174, 31.5],
      [171, 44.5],
      [168, 27.5],
      [165, 19.5],
      [162, 36.5],
      [159, 25.5],
      [156, 17.5],
      [153, 29.5],
      [150, 6.502399999999994],
      [147, 29.5],
      [144, 23.5],
      [141, 32.5],
      [138, 26.5],
      [135, 16.5],
      [132, 57.5],
      [129, 27.5],
      [126, 5.5],
      [123, 34.5],
      [120, 22.5],
      [117, 45.5],
      [114, 39.5],
      [111, 44.5],
      [108, 56.5],
      [105, 28.5],
      [102, 23.5],
      [99, 24.5],
      [96, 35.5],
      [93, 20.5],
      [90, 22.5],
      [87, 34.5],
      [84, 38.5],
      [81, 18.5],
      [78, 26.5],
      [75, 8.5],
      [72, 57.5],
      [69, 21.5],
      [66, 18.5],
      [63, 34.5],
      [60, 7.723399999999998],
      [57, 28.5],
      [54, 30.5],
      [51, 42.5],
      [48, 59.5],
      [45, 25.5],
      [42, 21.5],
      [39, 25.5],
      [36, 24.5],
      [33, 16.5],
      [30, 17.5],
      [27, 36.5],
      [24, 16.5],
      [21, 22.5],
      [18, 9.5],
      [15, 8.5],
      [12, 43.5],
      [9, 1.9735999999999905],
      [6, 14.5],
      [3, 16.5],
      [0, 42.5],
    ],
  },
  {
    top: [
      [2, 128.5],
      [5, 144.1054],
      [8, 107.5],
      [11, 108.5],
      [14, 131.5],
      [17, 111.5],
      [20, 143.6984],
      [23, 121.5],
      [26, 139.5],
      [29, 144.5],
      [32, 105.5],
      [35, 133.5],
      [38, 145.5854],
      [41, 121.5],
      [44, 144.875],
      [47, 110.5],
      [50, 142.5],
      [53, 139.5],
      [56, 137.5],
      [59, 135.5],
      [62, 135.5],
      [65, 133.5],
      [68, 109.5],
      [71, 116.5],
      [74, 130.5],
      [77, 129.5],
      [80, 137.5],
      [83, 120.5],
      [86, 134.5],
      [89, 143.5],
      [92, 105.5],
      [95, 131.5],
      [98, 133.5],
      [101, 127.5],
      [104, 123.5],
      [107, 115.5],
      [110, 118.5],
      [113, 143.5],
      [116, 123.5],
      [119, 140.5],
      [122, 124.5],
      [125, 136.5],
      [128, 102.5],
      [131, 108.5],
      [134, 120.5],
      [137, 106.5],
      [140, 144.875],
      [143, 120.5],
      [146, 126.5],
      [149, 142.5],
      [152, 111.5],
      [155, 128.5],
      [158, 140.5],
      [161, 117.5],
      [164, 128.5],
      [167, 99.5],
      [170, 125.5],
      [173, 137.5],
      [176, 121.5],
      [179, 141.5],
      [182, 112.5],
      [185, 122.5],
      [188, 137.5],
      [191, 109.5],
      [194, 110.5],
      [197, 100.5],
      [200, 136.5],
      [203, 119.5],
      [206, 116.5],
      [209, 143.5],
      [212, 102.5],
      [215, 126.5],
      [218, 144.4976],
      [221, 115.5],
      [224, 130.5],
      [227, 124.5],
      [230, 128.5],
      [233, 134.5],
      [236, 111.5],
      [239, 122.5],
      [242, 132.5],
      [245, 129.5],
      [248, 136.5],
      [251, 121.5],
      [254, 107.5],
      [257, 108.5],
      [260, 141.5],
      [263, 130.5],
      [266, 111.5],
      [269, 115.5],
      [272, 107.5],
      [275, 143.5],
      [278, 138.5],
      [281, 117.5],
      [284, 113.5],
      [287, 114.5],
      [290, 110.5],
      [293, 133.5],
      [296, 111.5],
      [299, 113.5],
      [302, 128.5],
      [305, 130.5],
      [308, 132.5],
      [311, 104.5],
      [314, 123.5],
      [317, 112.5],
      [320, 122.5],
      [323, 112.5],
      [326, 125.5],
      [329, 121.5],
      [332, 112.5],
      [335, 134.5],
      [338, 135.5],
      [341, 118.5],
      [344, 108.5],
      [347, 102.5],
      [350, 145.5],
      [353, 125.5],
      [356, 107.5],
      [359, 113.5],
      [362, 110.5],
      [365, 132.5],
      [368, 90.5],
      [371, 109.5],
      [374, 119.5],
      [377, 128.5],
      [380, 131.5],
      [383, 115.5],
      [386, 116.5],
      [389, 120.5],
      [392, 107.5],
      [395, 126.5],
      [398, 128.5],
      [401, 107.5],
      [404, 99.5],
      [407, 107.5],
      [410, 125.5],
      [413, 119.5],
      [416, 120.5],
      [419, 110.5],
      [422, 112.5],
      [425, 129.5],
      [428, 128.5],
      [431, 114.5],
      [434, 118.5],
      [437, 118.5],
      [440, 123.5],
      [443, 113.5],
      [446, 124.5],
      [449, 113.5],
      [452, 109.5],
      [455, 129.5],
      [458, 140.5],
      [461, 110.5],
      [464, 99.5],
      [467, 105.5],
      [470, 119.5],
      [473, 125.5],
      [476, 112.5],
      [479, 126.5],
      [482, 107.5],
      [485, 119.5],
      [488, 127.5],
      [491, 103.5],
      [494, 111.5],
      [497, 110.5],
      [500, 132.5],
      [503, 126.5],
      [506, 109.5],
      [509, 111.5],
      [512, 96.5],
      [515, 124.5],
      [518, 123.5],
      [521, 103.5],
      [524, 107.5],
      [527, 111.5],
      [530, 110.5],
      [533, 118.5],
      [536, 123.5],
      [539, 121.5],
      [542, 114.5],
      [545, 112.5],
      [548, 106.5],
      [551, 112.5],
      [554, 105.5],
      [557, 120.5],
      [560, 121.5],
      [563, 123.5],
      [566, 118.5],
      [569, 126.5],
      [572, 97.5],
      [575, 132.5],
      [578, 145.5],
      [581, 115.5],
      [584, 104.5],
      [587, 105.5],
      [590, 123.5],
      [593, 114.5],
      [596, 121.5],
      [599, 113.5],
      [602, 119.5],
      [605, 120.5],
      [608, 111.5],
      [611, 96.5],
      [614, 112.5],
      [617, 107.5],
      [620, 123.5],
      [623, 122.5],
      [626, 116.5],
      [629, 128.5],
      [632, 98.5],
      [635, 117.5],
      [638, 123.5],
      [641, 108.5],
      [644, 111.5],
      [647, 109.5],
      [650, 120.5],
      [653, 127.5],
      [656, 112.5],
      [659, 107.5],
      [662, 116.5],
      [665, 110.5],
      [668, 114.5],
      [671, 113.5],
      [674, 106.5],
      [677, 123.5],
      [680, 121.5],
      [683, 110.5],
      [686, 117.5],
      [689, 120.5],
      [692, 113.5],
      [695, 121.5],
      [698, 120.5],
      [701, 126.5],
      [704, 119.5],
      [707, 90.5],
      [710, 104.5],
      [713, 110.5],
      [716, 99.5],
      [719, 110.5],
      [722, 105.5],
      [725, 112.5],
      [728, 128.5],
      [731, 112.5],
      [734, 107.5],
      [737, 119.5],
      [740, 112.5],
      [743, 114.5],
      [746, 119.5],
      [749, 112.5],
      [752, 127.5],
      [755, 113.5],
      [758, 114.5],
      [761, 115.5],
      [764, 105.5],
      [767, 94.5],
      [770, 117.5],
      [773, 118.5],
      [776, 115.5],
      [779, 117.5],
      [782, 113.5],
      [785, 109.5],
      [788, 98.5],
      [791, 98.5],
      [794, 113.5],
      [797, 108.5],
      [800, 114.5],
      [803, 123.5],
      [806, 110.5],
      [809, 119.5],
      [812, 94.5],
      [815, 124.5],
      [818, 128.5],
      [821, 101.5],
      [824, 113.5],
      [827, 112.5],
      [830, 120.5],
      [833, 117.5],
      [836, 115.5],
      [839, 101.5],
      [842, 115.5],
      [845, 117.5],
      [848, 112.5],
      [851, 118.5],
      [854, 111.5],
      [857, 104.5],
      [860, 115.5],
      [863, 127.5],
      [866, 118.5],
      [869, 112.5],
      [872, 99.5],
      [875, 128.5],
      [878, 125.5],
      [881, 122.5],
      [884, 108.5],
      [887, 112.5],
      [890, 122.5],
      [893, 109.5],
      [896, 123.5],
      [899, 112.5],
      [902, 125.5],
      [905, 116.5],
      [908, 110.5],
      [911, 108.5],
      [914, 107.5],
      [917, 117.5],
      [920, 122.5],
      [923, 110.5],
      [926, 123.5],
      [929, 127.5],
      [932, 103.5],
      [935, 127.5],
      [938, 105.5],
      [941, 116.5],
      [944, 110.5],
      [947, 105.5],
      [950, 120.5],
      [953, 123.5],
      [956, 115.5],
      [959, 109.5],
      [962, 105.5],
      [965, 110.5],
      [968, 104.5],
      [971, 106.5],
      [974, 124.5],
      [977, 105.5],
      [980, 124.5],
      [983, 114.5],
      [986, 102.5],
      [989, 107.5],
      [992, 108.5],
      [995, 103.5],
      [998, 106.5],
      [1001, 112.5],
      [1004, 116.5],
      [1007, 105.5],
      [1010, 119.5],
      [1013, 124.5],
      [1016, 132.5],
      [1019, 124.5],
      [1022, 106.5],
      [1025, 116.5],
      [1028, 120.5],
      [1031, 104.5],
      [1034, 100.5],
      [1037, 104.5],
      [1040, 122.5],
      [1043, 109.5],
      [1046, 103.5],
      [1049, 123.5],
      [1052, 103.5],
      [1055, 138.5],
      [1058, 118.5],
      [1061, 99.5],
      [1064, 114.5],
      [1067, 99.5],
      [1070, 119.5],
      [1073, 123.5],
      [1076, 106.5],
      [1079, 121.5],
      [1082, 110.5],
      [1085, 118.5],
      [1088, 113.5],
      [1091, 97.5],
      [1094, 116.5],
      [1097, 98.5],
      [1100, 115.5],
      [1103, 133.5],
      [1106, 110.5],
      [1109, 112.5],
      [1112, 97.5],
      [1115, 124.5],
      [1118, 120.5],
      [1121, 103.5],
      [1124, 105.5],
      [1127, 102.5],
      [1130, 117.5],
      [1133, 133.5],
      [1136, 121.5],
      [1139, 105.5],
      [1142, 111.5],
      [1145, 119.5],
      [1148, 123.5],
      [1151, 100.5],
      [1154, 117.5],
      [1157, 108.5],
      [1160, 119.5],
      [1163, 110.5],
      [1166, 110.5],
      [1169, 114.5],
      [1172, 97.5],
      [1175, 135.5],
      [1178, 130.5],
      [1181, 104.5],
      [1184, 112.5],
      [1187, 92.5],
      [1190, 105.5],
      [1193, 117.5],
      [1196, 124.5],
      [1199, 114.5],
      [1202, 100.5],
      [1205, 125.5],
      [1208, 111.5],
      [1211, 93.5],
      [1214, 118.5],
      [1217, 96.5],
      [1220, 104.5],
      [1223, 109.5],
      [1226, 108.5],
      [1229, 106.5],
      [1232, 110.5],
      [1235, 121.5],
      [1238, 114.5],
      [1241, 109.5],
      [1244, 118.5],
      [1247, 94.5],
      [1250, 101.5],
      [1253, 137.5],
      [1256, 104.5],
      [1259, 102.5],
      [1262, 110.5],
      [1265, 114.5],
      [1268, 111.5],
      [1271, 113.5],
      [1274, 121.5],
      [1277, 114.5],
      [1280, 130.5],
      [1283, 120.5],
      [1286, 110.5],
      [1289, 114.5],
      [1292, 97.5],
      [1295, 120.5],
      [1298, 110.5],
      [1301, 99.5],
      [1304, 128.5],
      [1307, 103.5],
      [1310, 115.5],
      [1313, 121.5],
      [1316, 118.5],
      [1319, 100.5],
      [1322, 109.5],
      [1325, 121.5],
      [1328, 127.5],
      [1331, 100.5],
      [1334, 114.5],
      [1337, 94.5],
      [1340, 111.5],
      [1343, 120.5],
      [1346, 97.5],
      [1349, 114.5],
      [1352, 97.5],
      [1355, 134.5],
      [1358, 116.5],
      [1361, 112.5],
      [1364, 107.5],
      [1367, 102.5],
      [1370, 104.5],
      [1373, 136.5],
      [1376, 102.5],
      [1379, 104.5],
      [1382, 112.5],
      [1385, 113.5],
      [1388, 112.5],
      [1391, 105.5],
      [1394, 115.5],
      [1397, 101.5],
      [1400, 114.5],
      [1403, 117.5],
      [1406, 108.5],
      [1409, 118.5],
      [1412, 96.5],
      [1415, 110.5],
      [1418, 115.5],
      [1421, 103.5],
      [1424, 102.5],
      [1427, 97.5],
      [1430, 130.5],
      [1433, 119.5],
      [1436, 120.5],
      [1439, 102.5],
      [1442, 105.5],
      [1445, 108.5],
      [1448, 112.5],
      [1451, 113.5],
      [1454, 118.5],
      [1457, 111.5],
      [1460, 121.5],
      [1463, 116.5],
      [1466, 107.5],
      [1469, 100.5],
      [1472, 102.5],
      [1475, 122.5],
      [1478, 125.5],
      [1481, 110.5],
      [1484, 114.5],
      [1487, 109.5],
      [1490, 102.5],
      [1493, 132.5],
      [1496, 104.5],
      [1499, 98.5],
      [1502, 96.5],
      [1505, 133.5],
      [1508, 109.5],
      [1511, 116.5],
      [1514, 114.5],
      [1517, 98.5],
      [1520, 105.5],
      [1523, 93.5],
      [1526, 90.5],
      [1529, 86.5],
      [1532, 87.5],
      [1535, 78.5],
      [1538, 76.5],
      [1541, 75.5],
      [1544, 75.5],
      [1547, 75.5],
      [1550, 75.5],
    ],
    bottom: [
      [1548, 75.5],
      [1545, 75.5],
      [1542, 75.5],
      [1539, 74.5],
      [1536, 73.5],
      [1533, 65.5],
      [1530, 59.5],
      [1527, 61.5],
      [1524, 54.5],
      [1521, 39.5],
      [1518, 38.5],
      [1515, 27.5],
      [1512, 41.5],
      [1509, 44.5],
      [1506, 27.5],
      [1503, 35.5],
      [1500, 37.5],
      [1497, 46.5],
      [1494, 43.5],
      [1491, 34.5],
      [1488, 34.5],
      [1485, 36.5],
      [1482, 46.5],
      [1479, 27.5],
      [1476, 43.5],
      [1473, 35.5],
      [1470, 34.5],
      [1467, 41.5],
      [1464, 45.5],
      [1461, 43.5],
      [1458, 34.5],
      [1455, 24.5],
      [1452, 28.5],
      [1449, 46.5],
      [1446, 50.5],
      [1443, 36.5],
      [1440, 37.5],
      [1437, 48.5],
      [1434, 28.5],
      [1431, 36.5],
      [1428, 37.5],
      [1425, 37.5],
      [1422, 52.5],
      [1419, 41.5],
      [1416, 51.5],
      [1413, 20.5],
      [1410, 47.5],
      [1407, 43.5],
      [1404, 51.5],
      [1401, 47.5],
      [1398, 33.5],
      [1395, 22.5],
      [1392, 49.5],
      [1389, 47.5],
      [1386, 47.5],
      [1383, 36.5],
      [1380, 23.5],
      [1377, 49.5],
      [1374, 46.5],
      [1371, 44.5],
      [1368, 48.5],
      [1365, 38.5],
      [1362, 42.5],
      [1359, 42.5],
      [1356, 29.5],
      [1353, 22.5],
      [1350, 45.5],
      [1347, 55.5],
      [1344, 44.5],
      [1341, 46.5],
      [1338, 35.5],
      [1335, 23.5],
      [1332, 49.5],
      [1329, 11.5],
      [1326, 50.5],
      [1323, 36.5],
      [1320, 32.5],
      [1317, 53.5],
      [1314, 41.5],
      [1311, 46.5],
      [1308, 38.5],
      [1305, 19.5],
      [1302, 45.5],
      [1299, 50.5],
      [1296, 45.5],
      [1293, 19.5],
      [1290, 49.5],
      [1287, 59.5],
      [1284, 43.5],
      [1281, 35.5],
      [1278, 15.5],
      [1275, 25.5],
      [1272, 44.5],
      [1269, 36.5],
      [1266, 49.5],
      [1263, 34.5],
      [1260, 36.5],
      [1257, 47.5],
      [1254, 31.5],
      [1251, 53.5],
      [1248, 34.5],
      [1245, 32.5],
      [1242, 31.5],
      [1239, 44.5],
      [1236, 43.5],
      [1233, 42.5],
      [1230, 21.5],
      [1227, 50.5],
      [1224, 36.5],
      [1221, 50.5],
      [1218, 33.5],
      [1215, 20.5],
      [1212, 57.5],
      [1209, 36.5],
      [1206, 50.5],
      [1203, 41.5],
      [1200, 39.5],
      [1197, 47.5],
      [1194, 45.5],
      [1191, 51.5],
      [1188, 49.5],
      [1185, 32.5],
      [1182, 42.5],
      [1179, 40.5],
      [1176, 45.5],
      [1173, 27.5],
      [1170, 50.5],
      [1167, 52.5],
      [1164, 37.5],
      [1161, 38.5],
      [1158, 37.5],
      [1155, 21.5],
      [1152, 51.5],
      [1149, 42.5],
      [1146, 37.5],
      [1143, 37.5],
      [1140, 36.5],
      [1137, 54.5],
      [1134, 37.5],
      [1131, 54.5],
      [1128, 26.5],
      [1125, 35.5],
      [1122, 49.5],
      [1119, 42.5],
      [1116, 41.5],
      [1113, 33.5],
      [1110, 35.5],
      [1107, 56.5],
      [1104, 29.5],
      [1101, 44.5],
      [1098, 30.5],
      [1095, 15.5],
      [1092, 56.5],
      [1089, 35.5],
      [1086, 42.5],
      [1083, 38.5],
      [1080, 20.5],
      [1077, 43.5],
      [1074, 42.5],
      [1071, 57.5],
      [1068, 30.5],
      [1065, 32.5],
      [1062, 41.5],
      [1059, 39.5],
      [1056, 34.5],
      [1053, 15.5],
      [1050, 51.5],
      [1047, 61.5],
      [1044, 48.5],
      [1041, 49.5],
      [1038, 30.5],
      [1035, 34.5],
      [1032, 40.5],
      [1029, 24.5],
      [1026, 41.5],
      [1023, 33.5],
      [1020, 29.5],
      [1017, 37.5],
      [1014, 16.5],
      [1011, 33.5],
      [1008, 42.5],
      [1005, 22.5],
      [1002, 37.5],
      [999, 50.5],
      [996, 38.5],
      [993, 46.5],
      [990, 33.5],
      [987, 41.5],
      [984, 27.5],
      [981, 45.5],
      [978, 31.5],
      [975, 22.5],
      [972, 41.5],
      [969, 31.5],
      [966, 41.5],
      [963, 44.5],
      [960, 23.5],
      [957, 38.5],
      [954, 22.5],
      [951, 44.5],
      [948, 40.5],
      [945, 36.5],
      [942, 47.5],
      [939, 36.5],
      [936, 27.5],
      [933, 37.5],
      [930, 25.5],
      [927, 31.5],
      [924, 38.5],
      [921, 32.5],
      [918, 45.5],
      [915, 33.5],
      [912, 37.5],
      [909, 44.5],
      [906, 40.5],
      [903, 19.5],
      [900, 32.5],
      [897, 36.5],
      [894, 31.5],
      [891, 43.5],
      [888, 45.5],
      [885, 36.5],
      [882, 33.5],
      [879, 38.5],
      [876, 19.5],
      [873, 39.5],
      [870, 29.5],
      [867, 41.5],
      [864, 30.5],
      [861, 45.5],
      [858, 40.5],
      [855, 9.5],
      [852, 35.5],
      [849, 33.5],
      [846, 42.5],
      [843, 39.5],
      [840, 28.5],
      [837, 49.5],
      [834, 43.5],
      [831, 54.5],
      [828, 21.5],
      [825, 36.5],
      [822, 39.5],
      [819, 47.5],
      [816, 26.5],
      [813, 26.5],
      [810, 48.5],
      [807, 52.5],
      [804, 33.5],
      [801, 49.5],
      [798, 28.5],
      [795, 34.5],
      [792, 60.5],
      [789, 43.5],
      [786, 37.5],
      [783, 31.5],
      [780, 28.5],
      [777, 36.5],
      [774, 32.5],
      [771, 55.5],
      [768, 54.5],
      [765, 29.5],
      [762, 44.5],
      [759, 37.5],
      [756, 36.5],
      [753, 24.5],
      [750, 29.5],
      [747, 44.5],
      [744, 41.5],
      [741, 36.5],
      [738, 50.5],
      [735, 38.5],
      [732, 39.5],
      [729, 47.5],
      [726, 23.5],
      [723, 30.5],
      [720, 42.5],
      [717, 53.5],
      [714, 44.5],
      [711, 55.5],
      [708, 42.5],
      [705, 46.5],
      [702, 30.5],
      [699, 37.5],
      [696, 29.5],
      [693, 34.5],
      [690, 31.5],
      [687, 40.5],
      [684, 38.5],
      [681, 38.5],
      [678, 36.5],
      [675, 36.5],
      [672, 44.5],
      [669, 44.5],
      [666, 31.5],
      [663, 40.5],
      [660, 38.5],
      [657, 33.5],
      [654, 38.5],
      [651, 38.5],
      [648, 31.5],
      [645, 42.5],
      [642, 52.5],
      [639, 31.5],
      [636, 35.5],
      [633, 35.5],
      [630, 38.5],
      [627, 43.5],
      [624, 41.5],
      [621, 44.5],
      [618, 18.5],
      [615, 20.5],
      [612, 59.5],
      [609, 32.5],
      [606, 48.5],
      [603, 26.5],
      [600, 31.5],
      [597, 44.5],
      [594, 47.5],
      [591, 54.5],
      [588, 36.5],
      [585, 33.5],
      [582, 35.5],
      [579, 32.5],
      [576, 33.5],
      [573, 34.5],
      [570, 41.5],
      [567, 50.5],
      [564, 44.5],
      [561, 38.5],
      [558, 21.5],
      [555, 26.5],
      [552, 54.5],
      [549, 30.5],
      [546, 43.5],
      [543, 28.5],
      [540, 35.5],
      [537, 38.5],
      [534, 54.5],
      [531, 55.5],
      [528, 24.5],
      [525, 23.5],
      [522, 40.5],
      [519, 40.5],
      [516, 41.5],
      [513, 21.5],
      [510, 35.5],
      [507, 49.5],
      [504, 38.5],
      [501, 28.5],
      [498, 10.5],
      [495, 29.5],
      [492, 54.5],
      [489, 19.5],
      [486, 45.5],
      [483, 35.5],
      [480, 30.5],
      [477, 23.5],
      [474, 43.5],
      [471, 38.5],
      [468, 24.5],
      [465, 30.5],
      [462, 37.5],
      [459, 26.5],
      [456, 28.5],
      [453, 23.5],
      [450, 9.5],
      [447, 24.5],
      [444, 44.5],
      [441, 38.5],
      [438, 21.5],
      [435, 27.5],
      [432, 26.5],
      [429, 37.5],
      [426, 8.5],
      [423, 39.5],
      [420, 21.5],
      [417, 30.5],
      [414, 35.5],
      [411, 31.5],
      [408, 40.5],
      [405, 29.5],
      [402, 40.5],
      [399, 24.5],
      [396, 29.5],
      [393, 23.5],
      [390, 19.5],
      [387, 29.5],
      [384, 29.5],
      [381, 37.5],
      [378, 6.502399999999994],
      [375, 17.5],
      [372, 31.5],
      [369, 46.5],
      [366, 41.5],
      [363, 51.5],
      [360, 16.5],
      [357, 35.5],
      [354, 28.5],
      [351, 31.5],
      [348, 14.5],
      [345, 19.5],
      [342, 33.5],
      [339, 25.5],
      [336, 25.5],
      [333, 22.5],
      [330, 17.5],
      [327, 32.5],
      [324, 45.5],
      [321, 33.5],
      [318, 13.5],
      [315, 20.5],
      [312, 52.5],
      [309, 22.5],
      [306, 36.5],
      [303, 17.5],
      [300, 7.5],
      [297, 47.5],
      [294, 35.5],
      [291, 40.5],
      [288, 13.5],
      [285, 31.5],
      [282, 35.5],
      [279, 36.5],
      [276, 33.5],
      [273, 35.5],
      [270, 19.5],
      [267, 45.5],
      [264, 36.5],
      [261, 39.5],
      [258, 5.5],
      [255, 24.5],
      [252, 42.5],
      [249, 17.5],
      [246, 32.5],
      [243, 33.5],
      [240, 14.5],
      [237, 27.5],
      [234, 33.5],
      [231, 44.5],
      [228, 22.5],
      [225, 10.5],
      [222, 25.5],
      [219, 28.5],
      [216, 41.5],
      [213, 11.5],
      [210, 36.5],
      [207, 51.5],
      [204, 24.5],
      [201, 24.5],
      [198, 11.5],
      [195, 18.5],
      [192, 32.5],
      [189, 44.5],
      [186, 41.5],
      [183, 18.5],
      [180, 6.894599999999997],
      [177, 45.5],
      [174, 29.5],
      [171, 45.5],
      [168, 26.5],
      [165, 20.5],
      [162, 38.5],
      [159, 26.5],
      [156, 21.5],
      [153, 31.5],
      [150, 7.301600000000008],
      [147, 30.5],
      [144, 23.5],
      [141, 32.5],
      [138, 26.5],
      [135, 14.5],
      [132, 57.5],
      [129, 26.5],
      [126, 7.723399999999998],
      [123, 35.5],
      [120, 22.5],
      [117, 45.5],
      [114, 39.5],
      [111, 46.5],
      [108, 56.5],
      [105, 30.5],
      [102, 24.5],
      [99, 25.5],
      [96, 36.5],
      [93, 24.5],
      [90, 23.5],
      [87, 35.5],
      [84, 38.5],
      [81, 20.5],
      [78, 25.5],
      [75, 7.5],
      [72, 57.5],
      [69, 23.5],
      [66, 21.5],
      [63, 34.5],
      [60, 7.723399999999998],
      [57, 32.5],
      [54, 31.5],
      [51, 41.5],
      [48, 60.5],
      [45, 24.5],
      [42, 25.5],
      [39, 25.5],
      [36, 24.5],
      [33, 20.5],
      [30, 19.5],
      [27, 38.5],
      [24, 16.5],
      [21, 22.5],
      [18, 11.5],
      [15, 7.5],
      [12, 43.5],
      [9, 1.9735999999999905],
      [6, 12.5],
      [3, 16.5],
      [0, 39.5],
    ],
  },
  {
    top: [
      [2, 129.5],
      [5, 144.1054],
      [8, 107.5],
      [11, 108.5],
      [14, 131.5],
      [17, 112.5],
      [20, 144.1054],
      [23, 122.5],
      [26, 139.5],
      [29, 144.5],
      [32, 105.5],
      [35, 132.5],
      [38, 145.2376],
      [41, 119.5],
      [44, 144.875],
      [47, 109.5],
      [50, 142.5],
      [53, 137.5],
      [56, 137.5],
      [59, 135.5],
      [62, 134.5],
      [65, 131.5],
      [68, 109.5],
      [71, 116.5],
      [74, 130.5],
      [77, 129.5],
      [80, 136.5],
      [83, 120.5],
      [86, 135.5],
      [89, 139.5],
      [92, 106.5],
      [95, 131.5],
      [98, 134.5],
      [101, 130.5],
      [104, 123.5],
      [107, 114.5],
      [110, 120.5],
      [113, 142.5],
      [116, 122.5],
      [119, 140.5],
      [122, 123.5],
      [125, 136.5],
      [128, 102.5],
      [131, 105.5],
      [134, 120.5],
      [137, 106.5],
      [140, 145.2376],
      [143, 122.5],
      [146, 123.5],
      [149, 142.5],
      [152, 111.5],
      [155, 126.5],
      [158, 138.5],
      [161, 117.5],
      [164, 128.5],
      [167, 99.5],
      [170, 125.5],
      [173, 133.5],
      [176, 122.5],
      [179, 142.5],
      [182, 112.5],
      [185, 123.5],
      [188, 139.5],
      [191, 108.5],
      [194, 110.5],
      [197, 99.5],
      [200, 135.5],
      [203, 118.5],
      [206, 115.5],
      [209, 143.5],
      [212, 103.5],
      [215, 129.5],
      [218, 144.4976],
      [221, 115.5],
      [224, 130.5],
      [227, 124.5],
      [230, 128.5],
      [233, 133.5],
      [236, 111.5],
      [239, 118.5],
      [242, 132.5],
      [245, 126.5],
      [248, 138.5],
      [251, 121.5],
      [254, 106.5],
      [257, 108.5],
      [260, 141.5],
      [263, 129.5],
      [266, 110.5],
      [269, 114.5],
      [272, 106.5],
      [275, 143.5],
      [278, 135.5],
      [281, 115.5],
      [284, 111.5],
      [287, 113.5],
      [290, 108.5],
      [293, 129.5],
      [296, 112.5],
      [299, 113.5],
      [302, 128.5],
      [305, 125.5],
      [308, 128.5],
      [311, 103.5],
      [314, 119.5],
      [317, 110.5],
      [320, 120.5],
      [323, 110.5],
      [326, 125.5],
      [329, 117.5],
      [332, 111.5],
      [335, 133.5],
      [338, 135.5],
      [341, 116.5],
      [344, 107.5],
      [347, 102.5],
      [350, 144.5],
      [353, 123.5],
      [356, 108.5],
      [359, 111.5],
      [362, 111.5],
      [365, 130.5],
      [368, 89.5],
      [371, 110.5],
      [374, 120.5],
      [377, 128.5],
      [380, 129.5],
      [383, 113.5],
      [386, 115.5],
      [389, 118.5],
      [392, 108.5],
      [395, 123.5],
      [398, 124.5],
      [401, 107.5],
      [404, 98.5],
      [407, 106.5],
      [410, 120.5],
      [413, 118.5],
      [416, 119.5],
      [419, 111.5],
      [422, 113.5],
      [425, 129.5],
      [428, 127.5],
      [431, 114.5],
      [434, 117.5],
      [437, 116.5],
      [440, 119.5],
      [443, 114.5],
      [446, 125.5],
      [449, 111.5],
      [452, 108.5],
      [455, 127.5],
      [458, 141.5],
      [461, 110.5],
      [464, 98.5],
      [467, 103.5],
      [470, 119.5],
      [473, 125.5],
      [476, 113.5],
      [479, 125.5],
      [482, 104.5],
      [485, 117.5],
      [488, 124.5],
      [491, 103.5],
      [494, 109.5],
      [497, 110.5],
      [500, 132.5],
      [503, 127.5],
      [506, 107.5],
      [509, 107.5],
      [512, 94.5],
      [515, 123.5],
      [518, 121.5],
      [521, 102.5],
      [524, 105.5],
      [527, 111.5],
      [530, 109.5],
      [533, 121.5],
      [536, 122.5],
      [539, 121.5],
      [542, 111.5],
      [545, 110.5],
      [548, 108.5],
      [551, 112.5],
      [554, 103.5],
      [557, 117.5],
      [560, 115.5],
      [563, 121.5],
      [566, 113.5],
      [569, 121.5],
      [572, 95.5],
      [575, 130.5],
      [578, 143.5],
      [581, 114.5],
      [584, 102.5],
      [587, 105.5],
      [590, 117.5],
      [593, 110.5],
      [596, 117.5],
      [599, 110.5],
      [602, 117.5],
      [605, 120.5],
      [608, 111.5],
      [611, 96.5],
      [614, 112.5],
      [617, 107.5],
      [620, 122.5],
      [623, 120.5],
      [626, 115.5],
      [629, 126.5],
      [632, 95.5],
      [635, 116.5],
      [638, 120.5],
      [641, 108.5],
      [644, 109.5],
      [647, 107.5],
      [650, 120.5],
      [653, 127.5],
      [656, 112.5],
      [659, 106.5],
      [662, 115.5],
      [665, 106.5],
      [668, 113.5],
      [671, 114.5],
      [674, 104.5],
      [677, 123.5],
      [680, 118.5],
      [683, 108.5],
      [686, 114.5],
      [689, 116.5],
      [692, 112.5],
      [695, 122.5],
      [698, 120.5],
      [701, 126.5],
      [704, 118.5],
      [707, 90.5],
      [710, 103.5],
      [713, 107.5],
      [716, 98.5],
      [719, 111.5],
      [722, 102.5],
      [725, 111.5],
      [728, 129.5],
      [731, 109.5],
      [734, 105.5],
      [737, 119.5],
      [740, 111.5],
      [743, 114.5],
      [746, 115.5],
      [749, 109.5],
      [752, 128.5],
      [755, 113.5],
      [758, 114.5],
      [761, 110.5],
      [764, 103.5],
      [767, 93.5],
      [770, 115.5],
      [773, 112.5],
      [776, 115.5],
      [779, 116.5],
      [782, 109.5],
      [785, 106.5],
      [788, 96.5],
      [791, 97.5],
      [794, 111.5],
      [797, 105.5],
      [800, 112.5],
      [803, 122.5],
      [806, 106.5],
      [809, 117.5],
      [812, 92.5],
      [815, 124.5],
      [818, 127.5],
      [821, 102.5],
      [824, 111.5],
      [827, 112.5],
      [830, 119.5],
      [833, 113.5],
      [836, 110.5],
      [839, 99.5],
      [842, 114.5],
      [845, 113.5],
      [848, 110.5],
      [851, 117.5],
      [854, 111.5],
      [857, 104.5],
      [860, 116.5],
      [863, 122.5],
      [866, 114.5],
      [869, 109.5],
      [872, 96.5],
      [875, 121.5],
      [878, 125.5],
      [881, 118.5],
      [884, 106.5],
      [887, 110.5],
      [890, 118.5],
      [893, 105.5],
      [896, 123.5],
      [899, 109.5],
      [902, 125.5],
      [905, 115.5],
      [908, 108.5],
      [911, 106.5],
      [914, 106.5],
      [917, 115.5],
      [920, 116.5],
      [923, 107.5],
      [926, 122.5],
      [929, 127.5],
      [932, 105.5],
      [935, 127.5],
      [938, 103.5],
      [941, 112.5],
      [944, 109.5],
      [947, 101.5],
      [950, 118.5],
      [953, 123.5],
      [956, 113.5],
      [959, 105.5],
      [962, 102.5],
      [965, 107.5],
      [968, 103.5],
      [971, 102.5],
      [974, 124.5],
      [977, 105.5],
      [980, 123.5],
      [983, 111.5],
      [986, 99.5],
      [989, 103.5],
      [992, 106.5],
      [995, 102.5],
      [998, 105.5],
      [1001, 110.5],
      [1004, 114.5],
      [1007, 103.5],
      [1010, 117.5],
      [1013, 122.5],
      [1016, 132.5],
      [1019, 119.5],
      [1022, 106.5],
      [1025, 115.5],
      [1028, 120.5],
      [1031, 103.5],
      [1034, 100.5],
      [1037, 103.5],
      [1040, 119.5],
      [1043, 105.5],
      [1046, 101.5],
      [1049, 120.5],
      [1052, 103.5],
      [1055, 138.5],
      [1058, 117.5],
      [1061, 98.5],
      [1064, 111.5],
      [1067, 98.5],
      [1070, 119.5],
      [1073, 117.5],
      [1076, 105.5],
      [1079, 122.5],
      [1082, 109.5],
      [1085, 115.5],
      [1088, 109.5],
      [1091, 96.5],
      [1094, 116.5],
      [1097, 97.5],
      [1100, 111.5],
      [1103, 133.5],
      [1106, 109.5],
      [1109, 110.5],
      [1112, 97.5],
      [1115, 123.5],
      [1118, 117.5],
      [1121, 101.5],
      [1124, 102.5],
      [1127, 103.5],
      [1130, 118.5],
      [1133, 132.5],
      [1136, 121.5],
      [1139, 102.5],
      [1142, 110.5],
      [1145, 114.5],
      [1148, 117.5],
      [1151, 99.5],
      [1154, 118.5],
      [1157, 110.5],
      [1160, 119.5],
      [1163, 109.5],
      [1166, 108.5],
      [1169, 111.5],
      [1172, 96.5],
      [1175, 135.5],
      [1178, 130.5],
      [1181, 102.5],
      [1184, 109.5],
      [1187, 90.5],
      [1190, 103.5],
      [1193, 116.5],
      [1196, 125.5],
      [1199, 111.5],
      [1202, 99.5],
      [1205, 125.5],
      [1208, 107.5],
      [1211, 93.5],
      [1214, 118.5],
      [1217, 98.5],
      [1220, 102.5],
      [1223, 107.5],
      [1226, 106.5],
      [1229, 106.5],
      [1232, 108.5],
      [1235, 121.5],
      [1238, 113.5],
      [1241, 105.5],
      [1244, 116.5],
      [1247, 94.5],
      [1250, 101.5],
      [1253, 138.5],
      [1256, 104.5],
      [1259, 99.5],
      [1262, 108.5],
      [1265, 111.5],
      [1268, 109.5],
      [1271, 111.5],
      [1274, 117.5],
      [1277, 115.5],
      [1280, 131.5],
      [1283, 115.5],
      [1286, 111.5],
      [1289, 114.5],
      [1292, 97.5],
      [1295, 121.5],
      [1298, 113.5],
      [1301, 99.5],
      [1304, 129.5],
      [1307, 103.5],
      [1310, 112.5],
      [1313, 116.5],
      [1316, 118.5],
      [1319, 98.5],
      [1322, 108.5],
      [1325, 117.5],
      [1328, 128.5],
      [1331, 101.5],
      [1334, 114.5],
      [1337, 95.5],
      [1340, 111.5],
      [1343, 117.5],
      [1346, 98.5],
      [1349, 117.5],
      [1352, 98.5],
      [1355, 136.5],
      [1358, 119.5],
      [1361, 113.5],
      [1364, 108.5],
      [1367, 102.5],
      [1370, 102.5],
      [1373, 136.5],
      [1376, 101.5],
      [1379, 104.5],
      [1382, 113.5],
      [1385, 113.5],
      [1388, 113.5],
      [1391, 107.5],
      [1394, 115.5],
      [1397, 102.5],
      [1400, 113.5],
      [1403, 114.5],
      [1406, 109.5],
      [1409, 120.5],
      [1412, 95.5],
      [1415, 110.5],
      [1418, 114.5],
      [1421, 103.5],
      [1424, 108.5],
      [1427, 96.5],
      [1430, 130.5],
      [1433, 122.5],
      [1436, 120.5],
      [1439, 103.5],
      [1442, 104.5],
      [1445, 108.5],
      [1448, 115.5],
      [1451, 111.5],
      [1454, 117.5],
      [1457, 111.5],
      [1460, 119.5],
      [1463, 115.5],
      [1466, 103.5],
      [1469, 99.5],
      [1472, 105.5],
      [1475, 123.5],
      [1478, 124.5],
      [1481, 109.5],
      [1484, 114.5],
      [1487, 109.5],
      [1490, 102.5],
      [1493, 132.5],
      [1496, 104.5],
      [1499, 97.5],
      [1502, 97.5],
      [1505, 133.5],
      [1508, 110.5],
      [1511, 113.5],
      [1514, 113.5],
      [1517, 97.5],
      [1520, 104.5],
      [1523, 92.5],
      [1526, 90.5],
      [1529, 86.5],
      [1532, 87.5],
      [1535, 78.5],
      [1538, 76.5],
      [1541, 75.5],
      [1544, 75.5],
      [1547, 75.5],
      [1550, 75.5],
    ],
    bottom: [
      [1548, 75.5],
      [1545, 75.5],
      [1542, 75.5],
      [1539, 74.5],
      [1536, 73.5],
      [1533, 65.5],
      [1530, 59.5],
      [1527, 62.5],
      [1524, 54.5],
      [1521, 42.5],
      [1518, 37.5],
      [1515, 28.5],
      [1512, 46.5],
      [1509, 41.5],
      [1506, 27.5],
      [1503, 36.5],
      [1500, 38.5],
      [1497, 45.5],
      [1494, 43.5],
      [1491, 35.5],
      [1488, 34.5],
      [1485, 36.5],
      [1482, 46.5],
      [1479, 27.5],
      [1476, 42.5],
      [1473, 34.5],
      [1470, 31.5],
      [1467, 43.5],
      [1464, 46.5],
      [1461, 45.5],
      [1458, 36.5],
      [1455, 24.5],
      [1452, 28.5],
      [1449, 47.5],
      [1446, 47.5],
      [1443, 39.5],
      [1440, 34.5],
      [1437, 51.5],
      [1434, 28.5],
      [1431, 36.5],
      [1428, 37.5],
      [1425, 33.5],
      [1422, 50.5],
      [1419, 43.5],
      [1416, 48.5],
      [1413, 21.5],
      [1410, 47.5],
      [1407, 44.5],
      [1404, 50.5],
      [1401, 51.5],
      [1398, 33.5],
      [1395, 22.5],
      [1392, 49.5],
      [1389, 45.5],
      [1386, 46.5],
      [1383, 36.5],
      [1380, 23.5],
      [1377, 50.5],
      [1374, 46.5],
      [1371, 47.5],
      [1368, 47.5],
      [1365, 37.5],
      [1362, 42.5],
      [1359, 43.5],
      [1356, 28.5],
      [1353, 21.5],
      [1350, 43.5],
      [1347, 55.5],
      [1344, 44.5],
      [1341, 46.5],
      [1338, 31.5],
      [1335, 23.5],
      [1332, 48.5],
      [1329, 11.5],
      [1326, 51.5],
      [1323, 37.5],
      [1320, 36.5],
      [1317, 54.5],
      [1314, 41.5],
      [1311, 48.5],
      [1308, 38.5],
      [1305, 19.5],
      [1302, 45.5],
      [1299, 52.5],
      [1296, 45.5],
      [1293, 19.5],
      [1290, 48.5],
      [1287, 58.5],
      [1284, 46.5],
      [1281, 35.5],
      [1278, 14.5],
      [1275, 26.5],
      [1272, 46.5],
      [1269, 38.5],
      [1266, 51.5],
      [1263, 37.5],
      [1260, 39.5],
      [1257, 48.5],
      [1254, 30.5],
      [1251, 52.5],
      [1248, 35.5],
      [1245, 34.5],
      [1242, 36.5],
      [1239, 46.5],
      [1236, 43.5],
      [1233, 45.5],
      [1230, 21.5],
      [1227, 52.5],
      [1224, 40.5],
      [1221, 52.5],
      [1218, 31.5],
      [1215, 20.5],
      [1212, 57.5],
      [1209, 39.5],
      [1206, 50.5],
      [1203, 43.5],
      [1200, 42.5],
      [1197, 47.5],
      [1194, 46.5],
      [1191, 53.5],
      [1188, 51.5],
      [1185, 37.5],
      [1182, 44.5],
      [1179, 40.5],
      [1176, 45.5],
      [1173, 28.5],
      [1170, 51.5],
      [1167, 53.5],
      [1164, 41.5],
      [1161, 40.5],
      [1158, 34.5],
      [1155, 21.5],
      [1152, 51.5],
      [1149, 45.5],
      [1146, 41.5],
      [1143, 38.5],
      [1140, 38.5],
      [1137, 55.5],
      [1134, 37.5],
      [1131, 55.5],
      [1128, 26.5],
      [1125, 38.5],
      [1122, 52.5],
      [1119, 45.5],
      [1116, 40.5],
      [1113, 32.5],
      [1110, 35.5],
      [1107, 57.5],
      [1104, 29.5],
      [1101, 47.5],
      [1098, 33.5],
      [1095, 15.5],
      [1092, 58.5],
      [1089, 38.5],
      [1086, 46.5],
      [1083, 35.5],
      [1080, 20.5],
      [1077, 43.5],
      [1074, 46.5],
      [1071, 56.5],
      [1068, 34.5],
      [1065, 34.5],
      [1062, 44.5],
      [1059, 41.5],
      [1056, 34.5],
      [1053, 14.5],
      [1050, 53.5],
      [1047, 62.5],
      [1044, 51.5],
      [1041, 51.5],
      [1038, 33.5],
      [1035, 37.5],
      [1032, 44.5],
      [1029, 23.5],
      [1026, 43.5],
      [1023, 35.5],
      [1020, 33.5],
      [1017, 39.5],
      [1014, 16.5],
      [1011, 36.5],
      [1008, 43.5],
      [1005, 24.5],
      [1002, 40.5],
      [999, 51.5],
      [996, 38.5],
      [993, 46.5],
      [990, 39.5],
      [987, 45.5],
      [984, 31.5],
      [981, 46.5],
      [978, 31.5],
      [975, 22.5],
      [972, 45.5],
      [969, 32.5],
      [966, 44.5],
      [963, 48.5],
      [960, 30.5],
      [957, 38.5],
      [954, 22.5],
      [951, 45.5],
      [948, 43.5],
      [945, 39.5],
      [942, 48.5],
      [939, 38.5],
      [936, 27.5],
      [933, 38.5],
      [930, 26.5],
      [927, 31.5],
      [924, 41.5],
      [921, 35.5],
      [918, 46.5],
      [915, 37.5],
      [912, 40.5],
      [909, 47.5],
      [906, 42.5],
      [903, 19.5],
      [900, 32.5],
      [897, 36.5],
      [894, 32.5],
      [891, 44.5],
      [888, 47.5],
      [885, 36.5],
      [882, 35.5],
      [879, 38.5],
      [876, 22.5],
      [873, 42.5],
      [870, 35.5],
      [867, 43.5],
      [864, 35.5],
      [861, 46.5],
      [858, 41.5],
      [855, 9.5],
      [852, 35.5],
      [849, 35.5],
      [846, 46.5],
      [843, 41.5],
      [840, 33.5],
      [837, 51.5],
      [834, 47.5],
      [831, 56.5],
      [828, 21.5],
      [825, 38.5],
      [822, 41.5],
      [819, 50.5],
      [816, 25.5],
      [813, 32.5],
      [810, 50.5],
      [807, 54.5],
      [804, 34.5],
      [801, 50.5],
      [798, 30.5],
      [795, 38.5],
      [792, 61.5],
      [789, 45.5],
      [786, 38.5],
      [783, 34.5],
      [780, 34.5],
      [777, 36.5],
      [774, 35.5],
      [771, 56.5],
      [768, 56.5],
      [765, 34.5],
      [762, 47.5],
      [759, 39.5],
      [756, 34.5],
      [753, 24.5],
      [750, 32.5],
      [747, 47.5],
      [744, 41.5],
      [741, 37.5],
      [738, 51.5],
      [735, 39.5],
      [732, 41.5],
      [729, 46.5],
      [726, 23.5],
      [723, 34.5],
      [720, 42.5],
      [717, 54.5],
      [714, 46.5],
      [711, 57.5],
      [708, 44.5],
      [705, 46.5],
      [702, 30.5],
      [699, 41.5],
      [696, 29.5],
      [693, 34.5],
      [690, 35.5],
      [687, 43.5],
      [684, 41.5],
      [681, 42.5],
      [678, 37.5],
      [675, 36.5],
      [672, 42.5],
      [669, 42.5],
      [666, 36.5],
      [663, 39.5],
      [660, 40.5],
      [657, 33.5],
      [654, 39.5],
      [651, 38.5],
      [648, 34.5],
      [645, 45.5],
      [642, 52.5],
      [639, 33.5],
      [636, 37.5],
      [633, 39.5],
      [630, 39.5],
      [627, 43.5],
      [624, 40.5],
      [621, 46.5],
      [618, 18.5],
      [615, 21.5],
      [612, 59.5],
      [609, 31.5],
      [606, 48.5],
      [603, 30.5],
      [600, 32.5],
      [597, 47.5],
      [594, 48.5],
      [591, 56.5],
      [588, 39.5],
      [585, 36.5],
      [582, 36.5],
      [579, 33.5],
      [576, 34.5],
      [573, 35.5],
      [570, 44.5],
      [567, 53.5],
      [564, 46.5],
      [561, 42.5],
      [558, 27.5],
      [555, 29.5],
      [552, 54.5],
      [549, 31.5],
      [546, 45.5],
      [543, 31.5],
      [540, 32.5],
      [537, 38.5],
      [534, 54.5],
      [531, 55.5],
      [528, 24.5],
      [525, 23.5],
      [522, 42.5],
      [519, 38.5],
      [516, 40.5],
      [513, 25.5],
      [510, 38.5],
      [507, 51.5],
      [504, 38.5],
      [501, 28.5],
      [498, 9.5],
      [495, 30.5],
      [492, 55.5],
      [489, 21.5],
      [486, 47.5],
      [483, 39.5],
      [480, 30.5],
      [477, 23.5],
      [474, 44.5],
      [471, 37.5],
      [468, 27.5],
      [465, 34.5],
      [462, 40.5],
      [459, 25.5],
      [456, 28.5],
      [453, 24.5],
      [450, 9.5],
      [447, 24.5],
      [444, 45.5],
      [441, 42.5],
      [438, 23.5],
      [435, 27.5],
      [432, 25.5],
      [429, 40.5],
      [426, 6.5],
      [423, 40.5],
      [420, 20.5],
      [417, 30.5],
      [414, 34.5],
      [411, 32.5],
      [408, 42.5],
      [405, 30.5],
      [402, 40.5],
      [399, 24.5],
      [396, 33.5],
      [393, 24.5],
      [390, 20.5],
      [387, 30.5],
      [384, 31.5],
      [381, 39.5],
      [378, 6.894599999999997],
      [375, 16.5],
      [372, 33.5],
      [369, 48.5],
      [366, 43.5],
      [363, 51.5],
      [360, 17.5],
      [357, 38.5],
      [354, 30.5],
      [351, 31.5],
      [348, 16.5],
      [345, 21.5],
      [342, 35.5],
      [339, 25.5],
      [336, 26.5],
      [333, 23.5],
      [330, 21.5],
      [327, 32.5],
      [324, 45.5],
      [321, 36.5],
      [318, 16.5],
      [315, 21.5],
      [312, 53.5],
      [309, 27.5],
      [306, 39.5],
      [303, 19.5],
      [300, 7.5],
      [297, 47.5],
      [294, 37.5],
      [291, 42.5],
      [288, 14.5],
      [285, 34.5],
      [282, 37.5],
      [279, 39.5],
      [276, 32.5],
      [273, 35.5],
      [270, 17.5],
      [267, 46.5],
      [264, 39.5],
      [261, 38.5],
      [258, 7.723399999999998],
      [255, 24.5],
      [252, 42.5],
      [249, 17.5],
      [246, 33.5],
      [243, 31.5],
      [240, 16.5],
      [237, 29.5],
      [234, 35.5],
      [231, 41.5],
      [228, 23.5],
      [225, 10.5],
      [222, 26.5],
      [219, 27.5],
      [216, 39.5],
      [213, 11.5],
      [210, 36.5],
      [207, 52.5],
      [204, 24.5],
      [201, 27.5],
      [198, 11.5],
      [195, 19.5],
      [192, 31.5],
      [189, 43.5],
      [186, 39.5],
      [183, 18.5],
      [180, 6.894599999999997],
      [177, 45.5],
      [174, 29.5],
      [171, 46.5],
      [168, 26.5],
      [165, 19.5],
      [162, 37.5],
      [159, 26.5],
      [156, 23.5],
      [153, 31.5],
      [150, 6.894599999999997],
      [147, 32.5],
      [144, 22.5],
      [141, 32.5],
      [138, 26.5],
      [135, 13.5],
      [132, 58.5],
      [129, 27.5],
      [126, 7.723399999999998],
      [123, 35.5],
      [120, 22.5],
      [117, 45.5],
      [114, 40.5],
      [111, 46.5],
      [108, 56.5],
      [105, 29.5],
      [102, 22.5],
      [99, 24.5],
      [96, 37.5],
      [93, 25.5],
      [90, 26.5],
      [87, 35.5],
      [84, 38.5],
      [81, 22.5],
      [78, 27.5],
      [75, 6.5],
      [72, 58.5],
      [69, 22.5],
      [66, 23.5],
      [63, 37.5],
      [60, 5.5],
      [57, 31.5],
      [54, 31.5],
      [51, 41.5],
      [48, 60.5],
      [45, 25.5],
      [42, 25.5],
      [39, 26.5],
      [36, 24.5],
      [33, 19.5],
      [30, 19.5],
      [27, 37.5],
      [24, 18.5],
      [21, 22.5],
      [18, 12.5],
      [15, 6.5],
      [12, 43.5],
      [9, 1.9735999999999905],
      [6, 14.5],
      [3, 16.5],
      [0, 40.5],
    ],
  },
  {
    top: [
      [2, 127.5],
      [5, 143.6984],
      [8, 106.5],
      [11, 106.5],
      [14, 131.5],
      [17, 111.5],
      [20, 144.1054],
      [23, 121.5],
      [26, 139.5],
      [29, 145.5],
      [32, 104.5],
      [35, 131.5],
      [38, 145.2376],
      [41, 120.5],
      [44, 144.875],
      [47, 109.5],
      [50, 142.5],
      [53, 136.5],
      [56, 136.5],
      [59, 134.5],
      [62, 133.5],
      [65, 129.5],
      [68, 108.5],
      [71, 117.5],
      [74, 130.5],
      [77, 130.5],
      [80, 136.5],
      [83, 120.5],
      [86, 136.5],
      [89, 135.5],
      [92, 106.5],
      [95, 129.5],
      [98, 134.5],
      [101, 127.5],
      [104, 124.5],
      [107, 114.5],
      [110, 120.5],
      [113, 142.5],
      [116, 118.5],
      [119, 139.5],
      [122, 121.5],
      [125, 136.5],
      [128, 101.5],
      [131, 106.5],
      [134, 120.5],
      [137, 106.5],
      [140, 145.2376],
      [143, 121.5],
      [146, 121.5],
      [149, 141.5],
      [152, 111.5],
      [155, 125.5],
      [158, 138.5],
      [161, 116.5],
      [164, 130.5],
      [167, 99.5],
      [170, 125.5],
      [173, 129.5],
      [176, 124.5],
      [179, 141.5],
      [182, 111.5],
      [185, 121.5],
      [188, 137.5],
      [191, 107.5],
      [194, 108.5],
      [197, 98.5],
      [200, 135.5],
      [203, 118.5],
      [206, 114.5],
      [209, 141.5],
      [212, 102.5],
      [215, 127.5],
      [218, 144.4976],
      [221, 114.5],
      [224, 130.5],
      [227, 125.5],
      [230, 129.5],
      [233, 130.5],
      [236, 112.5],
      [239, 117.5],
      [242, 131.5],
      [245, 127.5],
      [248, 136.5],
      [251, 121.5],
      [254, 105.5],
      [257, 108.5],
      [260, 142.5],
      [263, 132.5],
      [266, 112.5],
      [269, 113.5],
      [272, 106.5],
      [275, 143.5],
      [278, 135.5],
      [281, 115.5],
      [284, 108.5],
      [287, 113.5],
      [290, 108.5],
      [293, 127.5],
      [296, 112.5],
      [299, 113.5],
      [302, 128.5],
      [305, 125.5],
      [308, 128.5],
      [311, 103.5],
      [314, 118.5],
      [317, 110.5],
      [320, 119.5],
      [323, 108.5],
      [326, 124.5],
      [329, 116.5],
      [332, 112.5],
      [335, 132.5],
      [338, 135.5],
      [341, 114.5],
      [344, 107.5],
      [347, 103.5],
      [350, 144.5],
      [353, 123.5],
      [356, 107.5],
      [359, 110.5],
      [362, 109.5],
      [365, 130.5],
      [368, 88.5],
      [371, 109.5],
      [374, 120.5],
      [377, 128.5],
      [380, 129.5],
      [383, 115.5],
      [386, 115.5],
      [389, 117.5],
      [392, 108.5],
      [395, 123.5],
      [398, 125.5],
      [401, 106.5],
      [404, 96.5],
      [407, 104.5],
      [410, 120.5],
      [413, 116.5],
      [416, 120.5],
      [419, 111.5],
      [422, 112.5],
      [425, 130.5],
      [428, 126.5],
      [431, 113.5],
      [434, 113.5],
      [437, 115.5],
      [440, 122.5],
      [443, 114.5],
      [446, 124.5],
      [449, 112.5],
      [452, 108.5],
      [455, 128.5],
      [458, 141.5],
      [461, 112.5],
      [464, 98.5],
      [467, 103.5],
      [470, 117.5],
      [473, 127.5],
      [476, 113.5],
      [479, 127.5],
      [482, 104.5],
      [485, 119.5],
      [488, 123.5],
      [491, 100.5],
      [494, 109.5],
      [497, 110.5],
      [500, 132.5],
      [503, 126.5],
      [506, 107.5],
      [509, 107.5],
      [512, 94.5],
      [515, 121.5],
      [518, 120.5],
      [521, 104.5],
      [524, 105.5],
      [527, 111.5],
      [530, 111.5],
      [533, 121.5],
      [536, 122.5],
      [539, 121.5],
      [542, 109.5],
      [545, 111.5],
      [548, 108.5],
      [551, 112.5],
      [554, 104.5],
      [557, 117.5],
      [560, 114.5],
      [563, 118.5],
      [566, 112.5],
      [569, 122.5],
      [572, 94.5],
      [575, 128.5],
      [578, 142.5],
      [581, 115.5],
      [584, 100.5],
      [587, 105.5],
      [590, 120.5],
      [593, 112.5],
      [596, 115.5],
      [599, 110.5],
      [602, 115.5],
      [605, 117.5],
      [608, 110.5],
      [611, 95.5],
      [614, 111.5],
      [617, 107.5],
      [620, 120.5],
      [623, 115.5],
      [626, 115.5],
      [629, 124.5],
      [632, 94.5],
      [635, 115.5],
      [638, 120.5],
      [641, 106.5],
      [644, 109.5],
      [647, 106.5],
      [650, 119.5],
      [653, 127.5],
      [656, 112.5],
      [659, 106.5],
      [662, 112.5],
      [665, 104.5],
      [668, 113.5],
      [671, 113.5],
      [674, 105.5],
      [677, 123.5],
      [680, 117.5],
      [683, 105.5],
      [686, 111.5],
      [689, 114.5],
      [692, 109.5],
      [695, 122.5],
      [698, 120.5],
      [701, 126.5],
      [704, 120.5],
      [707, 90.5],
      [710, 101.5],
      [713, 104.5],
      [716, 97.5],
      [719, 108.5],
      [722, 100.5],
      [725, 111.5],
      [728, 128.5],
      [731, 109.5],
      [734, 104.5],
      [737, 119.5],
      [740, 110.5],
      [743, 112.5],
      [746, 112.5],
      [749, 106.5],
      [752, 128.5],
      [755, 112.5],
      [758, 113.5],
      [761, 106.5],
      [764, 100.5],
      [767, 92.5],
      [770, 111.5],
      [773, 109.5],
      [776, 115.5],
      [779, 116.5],
      [782, 106.5],
      [785, 104.5],
      [788, 94.5],
      [791, 95.5],
      [794, 109.5],
      [797, 105.5],
      [800, 113.5],
      [803, 121.5],
      [806, 103.5],
      [809, 112.5],
      [812, 90.5],
      [815, 124.5],
      [818, 127.5],
      [821, 100.5],
      [824, 111.5],
      [827, 112.5],
      [830, 119.5],
      [833, 111.5],
      [836, 107.5],
      [839, 98.5],
      [842, 109.5],
      [845, 109.5],
      [848, 106.5],
      [851, 118.5],
      [854, 111.5],
      [857, 104.5],
      [860, 114.5],
      [863, 117.5],
      [866, 110.5],
      [869, 105.5],
      [872, 96.5],
      [875, 119.5],
      [878, 125.5],
      [881, 114.5],
      [884, 103.5],
      [887, 107.5],
      [890, 114.5],
      [893, 103.5],
      [896, 124.5],
      [899, 108.5],
      [902, 125.5],
      [905, 115.5],
      [908, 106.5],
      [911, 105.5],
      [914, 105.5],
      [917, 115.5],
      [920, 115.5],
      [923, 103.5],
      [926, 122.5],
      [929, 127.5],
      [932, 103.5],
      [935, 127.5],
      [938, 102.5],
      [941, 109.5],
      [944, 106.5],
      [947, 100.5],
      [950, 117.5],
      [953, 123.5],
      [956, 114.5],
      [959, 103.5],
      [962, 101.5],
      [965, 106.5],
      [968, 101.5],
      [971, 100.5],
      [974, 124.5],
      [977, 105.5],
      [980, 123.5],
      [983, 109.5],
      [986, 96.5],
      [989, 101.5],
      [992, 104.5],
      [995, 101.5],
      [998, 105.5],
      [1001, 110.5],
      [1004, 112.5],
      [1007, 103.5],
      [1010, 114.5],
      [1013, 121.5],
      [1016, 132.5],
      [1019, 116.5],
      [1022, 104.5],
      [1025, 116.5],
      [1028, 120.5],
      [1031, 103.5],
      [1034, 100.5],
      [1037, 103.5],
      [1040, 115.5],
      [1043, 104.5],
      [1046, 99.5],
      [1049, 118.5],
      [1052, 103.5],
      [1055, 138.5],
      [1058, 113.5],
      [1061, 98.5],
      [1064, 108.5],
      [1067, 97.5],
      [1070, 115.5],
      [1073, 115.5],
      [1076, 105.5],
      [1079, 122.5],
      [1082, 107.5],
      [1085, 113.5],
      [1088, 107.5],
      [1091, 93.5],
      [1094, 116.5],
      [1097, 96.5],
      [1100, 109.5],
      [1103, 133.5],
      [1106, 108.5],
      [1109, 108.5],
      [1112, 97.5],
      [1115, 121.5],
      [1118, 116.5],
      [1121, 101.5],
      [1124, 105.5],
      [1127, 103.5],
      [1130, 118.5],
      [1133, 132.5],
      [1136, 121.5],
      [1139, 101.5],
      [1142, 109.5],
      [1145, 109.5],
      [1148, 115.5],
      [1151, 98.5],
      [1154, 118.5],
      [1157, 110.5],
      [1160, 116.5],
      [1163, 105.5],
      [1166, 105.5],
      [1169, 109.5],
      [1172, 96.5],
      [1175, 135.5],
      [1178, 130.5],
      [1181, 102.5],
      [1184, 108.5],
      [1187, 90.5],
      [1190, 102.5],
      [1193, 115.5],
      [1196, 125.5],
      [1199, 112.5],
      [1202, 99.5],
      [1205, 127.5],
      [1208, 112.5],
      [1211, 91.5],
      [1214, 118.5],
      [1217, 97.5],
      [1220, 101.5],
      [1223, 104.5],
      [1226, 106.5],
      [1229, 107.5],
      [1232, 110.5],
      [1235, 121.5],
      [1238, 110.5],
      [1241, 103.5],
      [1244, 112.5],
      [1247, 92.5],
      [1250, 102.5],
      [1253, 138.5],
      [1256, 105.5],
      [1259, 97.5],
      [1262, 107.5],
      [1265, 109.5],
      [1268, 106.5],
      [1271, 112.5],
      [1274, 116.5],
      [1277, 115.5],
      [1280, 132.5],
      [1283, 114.5],
      [1286, 109.5],
      [1289, 112.5],
      [1292, 97.5],
      [1295, 120.5],
      [1298, 115.5],
      [1301, 99.5],
      [1304, 129.5],
      [1307, 103.5],
      [1310, 109.5],
      [1313, 114.5],
      [1316, 117.5],
      [1319, 96.5],
      [1322, 106.5],
      [1325, 115.5],
      [1328, 128.5],
      [1331, 102.5],
      [1334, 114.5],
      [1337, 94.5],
      [1340, 106.5],
      [1343, 114.5],
      [1346, 97.5],
      [1349, 115.5],
      [1352, 97.5],
      [1355, 134.5],
      [1358, 114.5],
      [1361, 110.5],
      [1364, 107.5],
      [1367, 102.5],
      [1370, 102.5],
      [1373, 136.5],
      [1376, 99.5],
      [1379, 104.5],
      [1382, 112.5],
      [1385, 111.5],
      [1388, 112.5],
      [1391, 105.5],
      [1394, 116.5],
      [1397, 101.5],
      [1400, 114.5],
      [1403, 113.5],
      [1406, 108.5],
      [1409, 116.5],
      [1412, 96.5],
      [1415, 110.5],
      [1418, 114.5],
      [1421, 103.5],
      [1424, 105.5],
      [1427, 96.5],
      [1430, 132.5],
      [1433, 121.5],
      [1436, 120.5],
      [1439, 101.5],
      [1442, 102.5],
      [1445, 107.5],
      [1448, 114.5],
      [1451, 110.5],
      [1454, 118.5],
      [1457, 111.5],
      [1460, 114.5],
      [1463, 114.5],
      [1466, 104.5],
      [1469, 96.5],
      [1472, 103.5],
      [1475, 122.5],
      [1478, 125.5],
      [1481, 111.5],
      [1484, 114.5],
      [1487, 109.5],
      [1490, 101.5],
      [1493, 132.5],
      [1496, 103.5],
      [1499, 96.5],
      [1502, 95.5],
      [1505, 134.5],
      [1508, 108.5],
      [1511, 111.5],
      [1514, 113.5],
      [1517, 96.5],
      [1520, 102.5],
      [1523, 91.5],
      [1526, 89.5],
      [1529, 86.5],
      [1532, 87.5],
      [1535, 78.5],
      [1538, 76.5],
      [1541, 75.5],
      [1544, 75.5],
      [1547, 75.5],
      [1550, 75.5],
    ],
    bottom: [
      [1548, 75.5],
      [1545, 75.5],
      [1542, 75.5],
      [1539, 74.5],
      [1536, 73.5],
      [1533, 65.5],
      [1530, 59.5],
      [1527, 63.5],
      [1524, 55.5],
      [1521, 43.5],
      [1518, 39.5],
      [1515, 28.5],
      [1512, 46.5],
      [1509, 43.5],
      [1506, 26.5],
      [1503, 36.5],
      [1500, 41.5],
      [1497, 45.5],
      [1494, 43.5],
      [1491, 35.5],
      [1488, 34.5],
      [1485, 36.5],
      [1482, 45.5],
      [1479, 27.5],
      [1476, 43.5],
      [1473, 36.5],
      [1470, 33.5],
      [1467, 44.5],
      [1464, 47.5],
      [1461, 47.5],
      [1458, 34.5],
      [1455, 23.5],
      [1452, 28.5],
      [1449, 48.5],
      [1446, 50.5],
      [1443, 40.5],
      [1440, 38.5],
      [1437, 52.5],
      [1434, 28.5],
      [1431, 35.5],
      [1428, 38.5],
      [1425, 38.5],
      [1422, 52.5],
      [1419, 45.5],
      [1416, 50.5],
      [1413, 20.5],
      [1410, 49.5],
      [1407, 44.5],
      [1404, 51.5],
      [1401, 49.5],
      [1398, 36.5],
      [1395, 20.5],
      [1392, 50.5],
      [1389, 44.5],
      [1386, 48.5],
      [1383, 38.5],
      [1380, 24.5],
      [1377, 51.5],
      [1374, 46.5],
      [1371, 47.5],
      [1368, 48.5],
      [1365, 39.5],
      [1362, 45.5],
      [1359, 45.5],
      [1356, 28.5],
      [1353, 21.5],
      [1350, 43.5],
      [1347, 55.5],
      [1344, 47.5],
      [1341, 48.5],
      [1338, 33.5],
      [1335, 23.5],
      [1332, 49.5],
      [1329, 11.5],
      [1326, 53.5],
      [1323, 39.5],
      [1320, 40.5],
      [1317, 54.5],
      [1314, 41.5],
      [1311, 49.5],
      [1308, 40.5],
      [1305, 19.5],
      [1302, 45.5],
      [1299, 51.5],
      [1296, 47.5],
      [1293, 19.5],
      [1290, 50.5],
      [1287, 59.5],
      [1284, 47.5],
      [1281, 35.5],
      [1278, 14.5],
      [1275, 26.5],
      [1272, 47.5],
      [1269, 41.5],
      [1266, 52.5],
      [1263, 38.5],
      [1260, 43.5],
      [1257, 47.5],
      [1254, 30.5],
      [1251, 53.5],
      [1248, 39.5],
      [1245, 36.5],
      [1242, 38.5],
      [1239, 48.5],
      [1236, 43.5],
      [1233, 44.5],
      [1230, 19.5],
      [1227, 52.5],
      [1224, 42.5],
      [1221, 52.5],
      [1218, 33.5],
      [1215, 20.5],
      [1212, 57.5],
      [1209, 39.5],
      [1206, 49.5],
      [1203, 43.5],
      [1200, 42.5],
      [1197, 47.5],
      [1194, 47.5],
      [1191, 53.5],
      [1188, 51.5],
      [1185, 40.5],
      [1182, 45.5],
      [1179, 40.5],
      [1176, 45.5],
      [1173, 28.5],
      [1170, 54.5],
      [1167, 55.5],
      [1164, 44.5],
      [1161, 44.5],
      [1158, 36.5],
      [1155, 21.5],
      [1152, 51.5],
      [1149, 46.5],
      [1146, 44.5],
      [1143, 41.5],
      [1140, 38.5],
      [1137, 56.5],
      [1134, 37.5],
      [1131, 55.5],
      [1128, 26.5],
      [1125, 35.5],
      [1122, 52.5],
      [1119, 46.5],
      [1116, 41.5],
      [1113, 33.5],
      [1110, 37.5],
      [1107, 57.5],
      [1104, 29.5],
      [1101, 48.5],
      [1098, 34.5],
      [1095, 15.5],
      [1092, 59.5],
      [1089, 41.5],
      [1086, 48.5],
      [1083, 38.5],
      [1080, 19.5],
      [1077, 43.5],
      [1074, 49.5],
      [1071, 57.5],
      [1068, 37.5],
      [1065, 37.5],
      [1062, 47.5],
      [1059, 43.5],
      [1056, 34.5],
      [1053, 14.5],
      [1050, 54.5],
      [1047, 63.5],
      [1044, 51.5],
      [1041, 53.5],
      [1038, 32.5],
      [1035, 37.5],
      [1032, 43.5],
      [1029, 23.5],
      [1026, 43.5],
      [1023, 38.5],
      [1020, 37.5],
      [1017, 40.5],
      [1014, 17.5],
      [1011, 38.5],
      [1008, 43.5],
      [1005, 26.5],
      [1002, 40.5],
      [999, 51.5],
      [996, 38.5],
      [993, 46.5],
      [990, 40.5],
      [987, 46.5],
      [984, 34.5],
      [981, 45.5],
      [978, 31.5],
      [975, 22.5],
      [972, 49.5],
      [969, 35.5],
      [966, 47.5],
      [963, 50.5],
      [960, 34.5],
      [957, 38.5],
      [954, 22.5],
      [951, 45.5],
      [948, 44.5],
      [945, 40.5],
      [942, 50.5],
      [939, 39.5],
      [936, 27.5],
      [933, 39.5],
      [930, 25.5],
      [927, 31.5],
      [924, 45.5],
      [921, 37.5],
      [918, 46.5],
      [915, 40.5],
      [912, 43.5],
      [909, 48.5],
      [906, 43.5],
      [903, 18.5],
      [900, 34.5],
      [897, 36.5],
      [894, 32.5],
      [891, 46.5],
      [888, 49.5],
      [885, 40.5],
      [882, 38.5],
      [879, 38.5],
      [876, 23.5],
      [873, 42.5],
      [870, 37.5],
      [867, 46.5],
      [864, 39.5],
      [861, 48.5],
      [858, 42.5],
      [855, 9.5],
      [852, 35.5],
      [849, 39.5],
      [846, 48.5],
      [843, 44.5],
      [840, 35.5],
      [837, 52.5],
      [834, 48.5],
      [831, 57.5],
      [828, 21.5],
      [825, 39.5],
      [822, 44.5],
      [819, 49.5],
      [816, 25.5],
      [813, 37.5],
      [810, 52.5],
      [807, 56.5],
      [804, 35.5],
      [801, 50.5],
      [798, 30.5],
      [795, 38.5],
      [792, 62.5],
      [789, 47.5],
      [786, 41.5],
      [783, 37.5],
      [780, 37.5],
      [777, 37.5],
      [774, 36.5],
      [771, 58.5],
      [768, 57.5],
      [765, 37.5],
      [762, 48.5],
      [759, 39.5],
      [756, 36.5],
      [753, 24.5],
      [750, 34.5],
      [747, 50.5],
      [744, 43.5],
      [741, 37.5],
      [738, 51.5],
      [735, 38.5],
      [732, 42.5],
      [729, 47.5],
      [726, 23.5],
      [723, 36.5],
      [720, 44.5],
      [717, 55.5],
      [714, 47.5],
      [711, 58.5],
      [708, 46.5],
      [705, 46.5],
      [702, 30.5],
      [699, 42.5],
      [696, 29.5],
      [693, 37.5],
      [690, 37.5],
      [687, 45.5],
      [684, 44.5],
      [681, 42.5],
      [678, 37.5],
      [675, 36.5],
      [672, 40.5],
      [669, 42.5],
      [666, 39.5],
      [663, 43.5],
      [660, 41.5],
      [657, 33.5],
      [654, 39.5],
      [651, 38.5],
      [648, 37.5],
      [645, 45.5],
      [642, 52.5],
      [639, 34.5],
      [636, 39.5],
      [633, 42.5],
      [630, 41.5],
      [627, 44.5],
      [624, 43.5],
      [621, 46.5],
      [618, 18.5],
      [615, 21.5],
      [612, 59.5],
      [609, 30.5],
      [606, 50.5],
      [603, 31.5],
      [600, 31.5],
      [597, 49.5],
      [594, 47.5],
      [591, 56.5],
      [588, 38.5],
      [585, 40.5],
      [582, 36.5],
      [579, 34.5],
      [576, 36.5],
      [573, 35.5],
      [570, 45.5],
      [567, 53.5],
      [564, 47.5],
      [561, 44.5],
      [558, 27.5],
      [555, 28.5],
      [552, 54.5],
      [549, 30.5],
      [546, 46.5],
      [543, 31.5],
      [540, 31.5],
      [537, 38.5],
      [534, 54.5],
      [531, 55.5],
      [528, 24.5],
      [525, 23.5],
      [522, 41.5],
      [519, 40.5],
      [516, 40.5],
      [513, 28.5],
      [510, 38.5],
      [507, 52.5],
      [504, 39.5],
      [501, 28.5],
      [498, 9.5],
      [495, 30.5],
      [492, 57.5],
      [489, 21.5],
      [486, 47.5],
      [483, 40.5],
      [480, 29.5],
      [477, 22.5],
      [474, 42.5],
      [471, 39.5],
      [468, 30.5],
      [465, 35.5],
      [462, 40.5],
      [459, 26.5],
      [456, 28.5],
      [453, 24.5],
      [450, 10.5],
      [447, 25.5],
      [444, 42.5],
      [441, 40.5],
      [438, 23.5],
      [435, 30.5],
      [432, 25.5],
      [429, 39.5],
      [426, 6.5],
      [423, 39.5],
      [420, 21.5],
      [417, 30.5],
      [414, 35.5],
      [411, 32.5],
      [408, 44.5],
      [405, 33.5],
      [402, 41.5],
      [399, 25.5],
      [396, 33.5],
      [393, 23.5],
      [390, 19.5],
      [387, 30.5],
      [384, 31.5],
      [381, 39.5],
      [378, 7.301600000000008],
      [375, 16.5],
      [372, 35.5],
      [369, 48.5],
      [366, 43.5],
      [363, 51.5],
      [360, 17.5],
      [357, 40.5],
      [354, 32.5],
      [351, 31.5],
      [348, 17.5],
      [345, 19.5],
      [342, 37.5],
      [339, 25.5],
      [336, 29.5],
      [333, 21.5],
      [330, 24.5],
      [327, 33.5],
      [324, 46.5],
      [321, 35.5],
      [318, 15.5],
      [315, 22.5],
      [312, 53.5],
      [309, 29.5],
      [306, 39.5],
      [303, 17.5],
      [300, 7.5],
      [297, 47.5],
      [294, 38.5],
      [291, 42.5],
      [288, 17.5],
      [285, 36.5],
      [282, 37.5],
      [279, 39.5],
      [276, 33.5],
      [273, 34.5],
      [270, 19.5],
      [267, 46.5],
      [264, 36.5],
      [261, 37.5],
      [258, 5.5],
      [255, 24.5],
      [252, 42.5],
      [249, 17.5],
      [246, 33.5],
      [243, 31.5],
      [240, 18.5],
      [237, 29.5],
      [234, 37.5],
      [231, 40.5],
      [228, 21.5],
      [225, 10.5],
      [222, 25.5],
      [219, 27.5],
      [216, 40.5],
      [213, 11.5],
      [210, 37.5],
      [207, 51.5],
      [204, 23.5],
      [201, 28.5],
      [198, 14.5],
      [195, 20.5],
      [192, 32.5],
      [189, 45.5],
      [186, 40.5],
      [183, 22.5],
      [180, 7.301600000000008],
      [177, 44.5],
      [174, 28.5],
      [171, 45.5],
      [168, 28.5],
      [165, 18.5],
      [162, 36.5],
      [159, 26.5],
      [156, 21.5],
      [153, 32.5],
      [150, 7.301600000000008],
      [147, 32.5],
      [144, 24.5],
      [141, 32.5],
      [138, 26.5],
      [135, 15.5],
      [132, 58.5],
      [129, 28.5],
      [126, 7.723399999999998],
      [123, 36.5],
      [120, 23.5],
      [117, 47.5],
      [114, 40.5],
      [111, 46.5],
      [108, 56.5],
      [105, 28.5],
      [102, 24.5],
      [99, 24.5],
      [96, 39.5],
      [93, 26.5],
      [90, 29.5],
      [87, 34.5],
      [84, 38.5],
      [81, 22.5],
      [78, 28.5],
      [75, 6.5],
      [72, 57.5],
      [69, 21.5],
      [66, 26.5],
      [63, 37.5],
      [60, 6.5],
      [57, 32.5],
      [54, 32.5],
      [51, 41.5],
      [48, 60.5],
      [45, 25.5],
      [42, 25.5],
      [39, 25.5],
      [36, 25.5],
      [33, 22.5],
      [30, 19.5],
      [27, 36.5],
      [24, 19.5],
      [21, 22.5],
      [18, 12.5],
      [15, 5.5],
      [12, 44.5],
      [9, 2.239999999999995],
      [6, 13.5],
      [3, 17.5],
      [0, 41.5],
    ],
  },
  {
    top: [
      [2, 125.5],
      [5, 143.5],
      [8, 105.5],
      [11, 107.5],
      [14, 131.5],
      [17, 115.5],
      [20, 144.4976],
      [23, 123.5],
      [26, 137.5],
      [29, 143.6984],
      [32, 105.5],
      [35, 138.5],
      [38, 144.4976],
      [41, 128.5],
      [44, 145.2376],
      [47, 112.5],
      [50, 142.5],
      [53, 142.5],
      [56, 139.5],
      [59, 134.5],
      [62, 133.5],
      [65, 132.5],
      [68, 109.5],
      [71, 118.5],
      [74, 129.5],
      [77, 129.5],
      [80, 136.5],
      [83, 122.5],
      [86, 141.5],
      [89, 138.5],
      [92, 108.5],
      [95, 130.5],
      [98, 135.5],
      [101, 130.5],
      [104, 125.5],
      [107, 115.5],
      [110, 122.5],
      [113, 143.5],
      [116, 126.5],
      [119, 139.5],
      [122, 122.5],
      [125, 136.5],
      [128, 103.5],
      [131, 111.5],
      [134, 120.5],
      [137, 108.5],
      [140, 145.2376],
      [143, 123.5],
      [146, 131.5],
      [149, 142.5],
      [152, 112.5],
      [155, 125.5],
      [158, 140.5],
      [161, 124.5],
      [164, 134.5],
      [167, 100.5],
      [170, 128.5],
      [173, 142.5],
      [176, 126.5],
      [179, 140.5],
      [182, 114.5],
      [185, 126.5],
      [188, 140.5],
      [191, 108.5],
      [194, 109.5],
      [197, 102.5],
      [200, 137.5],
      [203, 118.5],
      [206, 116.5],
      [209, 141.5],
      [212, 103.5],
      [215, 130.5],
      [218, 144.1054],
      [221, 117.5],
      [224, 130.5],
      [227, 126.5],
      [230, 127.5],
      [233, 134.5],
      [236, 112.5],
      [239, 120.5],
      [242, 135.5],
      [245, 128.5],
      [248, 135.5],
      [251, 121.5],
      [254, 108.5],
      [257, 110.5],
      [260, 139.5],
      [263, 138.5],
      [266, 114.5],
      [269, 116.5],
      [272, 110.5],
      [275, 143.5],
      [278, 139.5],
      [281, 116.5],
      [284, 114.5],
      [287, 115.5],
      [290, 111.5],
      [293, 132.5],
      [296, 112.5],
      [299, 113.5],
      [302, 129.5],
      [305, 134.5],
      [308, 138.5],
      [311, 106.5],
      [314, 125.5],
      [317, 109.5],
      [320, 125.5],
      [323, 115.5],
      [326, 123.5],
      [329, 117.5],
      [332, 114.5],
      [335, 135.5],
      [338, 135.5],
      [341, 116.5],
      [344, 108.5],
      [347, 105.5],
      [350, 143.2766],
      [353, 130.5],
      [356, 111.5],
      [359, 112.5],
      [362, 111.5],
      [365, 137.5],
      [368, 91.5],
      [371, 109.5],
      [374, 120.5],
      [377, 128.5],
      [380, 135.5],
      [383, 118.5],
      [386, 120.5],
      [389, 123.5],
      [392, 114.5],
      [395, 134.5],
      [398, 135.5],
      [401, 112.5],
      [404, 106.5],
      [407, 114.5],
      [410, 133.5],
      [413, 124.5],
      [416, 122.5],
      [419, 110.5],
      [422, 113.5],
      [425, 130.5],
      [428, 130.5],
      [431, 114.5],
      [434, 115.5],
      [437, 119.5],
      [440, 130.5],
      [443, 118.5],
      [446, 125.5],
      [449, 115.5],
      [452, 107.5],
      [455, 130.5],
      [458, 141.5],
      [461, 115.5],
      [464, 104.5],
      [467, 111.5],
      [470, 128.5],
      [473, 141.5],
      [476, 113.5],
      [479, 138.5],
      [482, 118.5],
      [485, 132.5],
      [488, 128.5],
      [491, 106.5],
      [494, 117.5],
      [497, 111.5],
      [500, 135.5],
      [503, 130.5],
      [506, 113.5],
      [509, 117.5],
      [512, 96.5],
      [515, 129.5],
      [518, 128.5],
      [521, 103.5],
      [524, 112.5],
      [527, 111.5],
      [530, 114.5],
      [533, 132.5],
      [536, 121.5],
      [539, 121.5],
      [542, 117.5],
      [545, 117.5],
      [548, 113.5],
      [551, 113.5],
      [554, 112.5],
      [557, 123.5],
      [560, 122.5],
      [563, 130.5],
      [566, 114.5],
      [569, 128.5],
      [572, 97.5],
      [575, 129.5],
      [578, 143.5],
      [581, 120.5],
      [584, 112.5],
      [587, 112.5],
      [590, 134.5],
      [593, 128.5],
      [596, 124.5],
      [599, 115.5],
      [602, 118.5],
      [605, 128.5],
      [608, 117.5],
      [611, 101.5],
      [614, 117.5],
      [617, 106.5],
      [620, 130.5],
      [623, 127.5],
      [626, 113.5],
      [629, 130.5],
      [632, 102.5],
      [635, 124.5],
      [638, 127.5],
      [641, 112.5],
      [644, 115.5],
      [647, 108.5],
      [650, 123.5],
      [653, 127.5],
      [656, 112.5],
      [659, 107.5],
      [662, 121.5],
      [665, 109.5],
      [668, 121.5],
      [671, 119.5],
      [674, 113.5],
      [677, 123.5],
      [680, 130.5],
      [683, 108.5],
      [686, 116.5],
      [689, 124.5],
      [692, 116.5],
      [695, 125.5],
      [698, 121.5],
      [701, 127.5],
      [704, 120.5],
      [707, 93.5],
      [710, 110.5],
      [713, 113.5],
      [716, 100.5],
      [719, 114.5],
      [722, 113.5],
      [725, 120.5],
      [728, 128.5],
      [731, 110.5],
      [734, 106.5],
      [737, 119.5],
      [740, 117.5],
      [743, 122.5],
      [746, 123.5],
      [749, 116.5],
      [752, 128.5],
      [755, 122.5],
      [758, 119.5],
      [761, 124.5],
      [764, 109.5],
      [767, 98.5],
      [770, 122.5],
      [773, 117.5],
      [776, 115.5],
      [779, 119.5],
      [782, 115.5],
      [785, 113.5],
      [788, 101.5],
      [791, 100.5],
      [794, 121.5],
      [797, 112.5],
      [800, 126.5],
      [803, 124.5],
      [806, 110.5],
      [809, 125.5],
      [812, 95.5],
      [815, 125.5],
      [818, 133.5],
      [821, 108.5],
      [824, 120.5],
      [827, 112.5],
      [830, 127.5],
      [833, 122.5],
      [836, 112.5],
      [839, 101.5],
      [842, 125.5],
      [845, 125.5],
      [848, 117.5],
      [851, 118.5],
      [854, 111.5],
      [857, 104.5],
      [860, 127.5],
      [863, 132.5],
      [866, 118.5],
      [869, 117.5],
      [872, 103.5],
      [875, 135.5],
      [878, 126.5],
      [881, 128.5],
      [884, 115.5],
      [887, 114.5],
      [890, 120.5],
      [893, 110.5],
      [896, 123.5],
      [899, 112.5],
      [902, 124.5],
      [905, 122.5],
      [908, 109.5],
      [911, 114.5],
      [914, 110.5],
      [917, 117.5],
      [920, 119.5],
      [923, 112.5],
      [926, 128.5],
      [929, 126.5],
      [932, 110.5],
      [935, 127.5],
      [938, 110.5],
      [941, 123.5],
      [944, 117.5],
      [947, 109.5],
      [950, 120.5],
      [953, 123.5],
      [956, 117.5],
      [959, 111.5],
      [962, 111.5],
      [965, 116.5],
      [968, 106.5],
      [971, 110.5],
      [974, 125.5],
      [977, 105.5],
      [980, 130.5],
      [983, 116.5],
      [986, 98.5],
      [989, 102.5],
      [992, 110.5],
      [995, 102.5],
      [998, 107.5],
      [1001, 116.5],
      [1004, 117.5],
      [1007, 110.5],
      [1010, 126.5],
      [1013, 125.5],
      [1016, 134.5],
      [1019, 124.5],
      [1022, 112.5],
      [1025, 126.5],
      [1028, 121.5],
      [1031, 108.5],
      [1034, 107.5],
      [1037, 107.5],
      [1040, 122.5],
      [1043, 108.5],
      [1046, 100.5],
      [1049, 121.5],
      [1052, 103.5],
      [1055, 138.5],
      [1058, 118.5],
      [1061, 103.5],
      [1064, 113.5],
      [1067, 99.5],
      [1070, 121.5],
      [1073, 123.5],
      [1076, 106.5],
      [1079, 122.5],
      [1082, 117.5],
      [1085, 121.5],
      [1088, 117.5],
      [1091, 101.5],
      [1094, 115.5],
      [1097, 100.5],
      [1100, 118.5],
      [1103, 133.5],
      [1106, 109.5],
      [1109, 118.5],
      [1112, 98.5],
      [1115, 128.5],
      [1118, 127.5],
      [1121, 104.5],
      [1124, 105.5],
      [1127, 102.5],
      [1130, 119.5],
      [1133, 132.5],
      [1136, 124.5],
      [1139, 109.5],
      [1142, 117.5],
      [1145, 124.5],
      [1148, 134.5],
      [1151, 105.5],
      [1154, 116.5],
      [1157, 111.5],
      [1160, 124.5],
      [1163, 112.5],
      [1166, 117.5],
      [1169, 118.5],
      [1172, 99.5],
      [1175, 135.5],
      [1178, 131.5],
      [1181, 107.5],
      [1184, 119.5],
      [1187, 98.5],
      [1190, 114.5],
      [1193, 127.5],
      [1196, 126.5],
      [1199, 116.5],
      [1202, 102.5],
      [1205, 125.5],
      [1208, 114.5],
      [1211, 96.5],
      [1214, 118.5],
      [1217, 100.5],
      [1220, 108.5],
      [1223, 109.5],
      [1226, 109.5],
      [1229, 107.5],
      [1232, 111.5],
      [1235, 120.5],
      [1238, 119.5],
      [1241, 112.5],
      [1244, 127.5],
      [1247, 99.5],
      [1250, 108.5],
      [1253, 138.5],
      [1256, 106.5],
      [1259, 103.5],
      [1262, 109.5],
      [1265, 121.5],
      [1268, 116.5],
      [1271, 117.5],
      [1274, 125.5],
      [1277, 120.5],
      [1280, 130.5],
      [1283, 121.5],
      [1286, 110.5],
      [1289, 118.5],
      [1292, 97.5],
      [1295, 121.5],
      [1298, 119.5],
      [1301, 99.5],
      [1304, 128.5],
      [1307, 104.5],
      [1310, 118.5],
      [1313, 115.5],
      [1316, 118.5],
      [1319, 103.5],
      [1322, 117.5],
      [1325, 128.5],
      [1328, 128.5],
      [1331, 103.5],
      [1334, 114.5],
      [1337, 95.5],
      [1340, 114.5],
      [1343, 119.5],
      [1346, 98.5],
      [1349, 118.5],
      [1352, 96.5],
      [1355, 135.5],
      [1358, 115.5],
      [1361, 113.5],
      [1364, 109.5],
      [1367, 105.5],
      [1370, 106.5],
      [1373, 135.5],
      [1376, 104.5],
      [1379, 105.5],
      [1382, 114.5],
      [1385, 110.5],
      [1388, 114.5],
      [1391, 103.5],
      [1394, 117.5],
      [1397, 106.5],
      [1400, 112.5],
      [1403, 118.5],
      [1406, 109.5],
      [1409, 123.5],
      [1412, 96.5],
      [1415, 112.5],
      [1418, 120.5],
      [1421, 109.5],
      [1424, 106.5],
      [1427, 96.5],
      [1430, 130.5],
      [1433, 121.5],
      [1436, 122.5],
      [1439, 105.5],
      [1442, 103.5],
      [1445, 109.5],
      [1448, 113.5],
      [1451, 115.5],
      [1454, 118.5],
      [1457, 111.5],
      [1460, 117.5],
      [1463, 113.5],
      [1466, 103.5],
      [1469, 100.5],
      [1472, 105.5],
      [1475, 123.5],
      [1478, 124.5],
      [1481, 112.5],
      [1484, 117.5],
      [1487, 106.5],
      [1490, 104.5],
      [1493, 132.5],
      [1496, 104.5],
      [1499, 101.5],
      [1502, 97.5],
      [1505, 133.5],
      [1508, 110.5],
      [1511, 114.5],
      [1514, 113.5],
      [1517, 100.5],
      [1520, 103.5],
      [1523, 92.5],
      [1526, 90.5],
      [1529, 87.5],
      [1532, 86.5],
      [1535, 78.5],
      [1538, 76.5],
      [1541, 75.5],
      [1544, 75.5],
      [1547, 75.5],
      [1550, 75.5],
    ],
    bottom: [
      [1548, 75.5],
      [1545, 75.5],
      [1542, 75.5],
      [1539, 74.5],
      [1536, 73.5],
      [1533, 66.5],
      [1530, 59.5],
      [1527, 62.5],
      [1524, 54.5],
      [1521, 44.5],
      [1518, 33.5],
      [1515, 28.5],
      [1512, 42.5],
      [1509, 42.5],
      [1506, 26.5],
      [1503, 35.5],
      [1500, 35.5],
      [1497, 44.5],
      [1494, 43.5],
      [1491, 34.5],
      [1488, 32.5],
      [1485, 34.5],
      [1482, 44.5],
      [1479, 28.5],
      [1476, 39.5],
      [1473, 35.5],
      [1470, 32.5],
      [1467, 44.5],
      [1464, 48.5],
      [1461, 43.5],
      [1458, 31.5],
      [1455, 24.5],
      [1452, 29.5],
      [1449, 45.5],
      [1446, 47.5],
      [1443, 37.5],
      [1440, 32.5],
      [1437, 49.5],
      [1434, 29.5],
      [1431, 35.5],
      [1428, 38.5],
      [1425, 37.5],
      [1422, 49.5],
      [1419, 38.5],
      [1416, 46.5],
      [1413, 20.5],
      [1410, 45.5],
      [1407, 42.5],
      [1404, 48.5],
      [1401, 49.5],
      [1398, 28.5],
      [1395, 21.5],
      [1392, 52.5],
      [1389, 43.5],
      [1386, 48.5],
      [1383, 36.5],
      [1380, 22.5],
      [1377, 47.5],
      [1374, 46.5],
      [1371, 41.5],
      [1368, 45.5],
      [1365, 36.5],
      [1362, 43.5],
      [1359, 41.5],
      [1356, 27.5],
      [1353, 21.5],
      [1350, 40.5],
      [1347, 54.5],
      [1344, 43.5],
      [1341, 44.5],
      [1338, 32.5],
      [1335, 24.5],
      [1332, 48.5],
      [1329, 13.5],
      [1326, 44.5],
      [1323, 28.5],
      [1320, 29.5],
      [1317, 53.5],
      [1314, 41.5],
      [1311, 47.5],
      [1308, 33.5],
      [1305, 19.5],
      [1302, 43.5],
      [1299, 45.5],
      [1296, 42.5],
      [1293, 19.5],
      [1290, 46.5],
      [1287, 59.5],
      [1284, 41.5],
      [1281, 37.5],
      [1278, 13.5],
      [1275, 23.5],
      [1272, 42.5],
      [1269, 30.5],
      [1266, 43.5],
      [1263, 32.5],
      [1260, 33.5],
      [1257, 45.5],
      [1254, 30.5],
      [1251, 49.5],
      [1248, 25.5],
      [1245, 20.5],
      [1242, 26.5],
      [1239, 40.5],
      [1236, 43.5],
      [1233, 38.5],
      [1230, 18.5],
      [1227, 53.5],
      [1224, 34.5],
      [1221, 48.5],
      [1218, 27.5],
      [1215, 20.5],
      [1212, 55.5],
      [1209, 34.5],
      [1206, 49.5],
      [1203, 39.5],
      [1200, 36.5],
      [1197, 47.5],
      [1194, 39.5],
      [1191, 46.5],
      [1188, 41.5],
      [1185, 21.5],
      [1182, 38.5],
      [1179, 39.5],
      [1176, 43.5],
      [1173, 28.5],
      [1170, 48.5],
      [1167, 49.5],
      [1164, 32.5],
      [1161, 38.5],
      [1158, 28.5],
      [1155, 21.5],
      [1152, 49.5],
      [1149, 34.5],
      [1146, 32.5],
      [1143, 32.5],
      [1140, 24.5],
      [1137, 50.5],
      [1134, 38.5],
      [1131, 54.5],
      [1128, 26.5],
      [1125, 28.5],
      [1122, 49.5],
      [1119, 37.5],
      [1116, 40.5],
      [1113, 32.5],
      [1110, 25.5],
      [1107, 54.5],
      [1104, 29.5],
      [1101, 42.5],
      [1098, 27.5],
      [1095, 16.5],
      [1092, 53.5],
      [1089, 30.5],
      [1086, 41.5],
      [1083, 24.5],
      [1080, 18.5],
      [1077, 43.5],
      [1074, 42.5],
      [1071, 55.5],
      [1068, 35.5],
      [1065, 34.5],
      [1062, 40.5],
      [1059, 39.5],
      [1056, 35.5],
      [1053, 15.5],
      [1050, 53.5],
      [1047, 61.5],
      [1044, 50.5],
      [1041, 48.5],
      [1038, 22.5],
      [1035, 27.5],
      [1032, 34.5],
      [1029, 22.5],
      [1026, 36.5],
      [1023, 25.5],
      [1020, 29.5],
      [1017, 34.5],
      [1014, 16.5],
      [1011, 27.5],
      [1008, 34.5],
      [1005, 20.5],
      [1002, 32.5],
      [999, 48.5],
      [996, 40.5],
      [993, 43.5],
      [990, 36.5],
      [987, 47.5],
      [984, 30.5],
      [981, 39.5],
      [978, 30.5],
      [975, 23.5],
      [972, 38.5],
      [969, 27.5],
      [966, 40.5],
      [963, 38.5],
      [960, 21.5],
      [957, 38.5],
      [954, 20.5],
      [951, 46.5],
      [948, 34.5],
      [945, 29.5],
      [942, 40.5],
      [939, 29.5],
      [936, 27.5],
      [933, 30.5],
      [930, 22.5],
      [927, 30.5],
      [924, 34.5],
      [921, 32.5],
      [918, 45.5],
      [915, 31.5],
      [912, 31.5],
      [909, 40.5],
      [906, 35.5],
      [903, 19.5],
      [900, 31.5],
      [897, 36.5],
      [894, 31.5],
      [891, 45.5],
      [888, 42.5],
      [885, 31.5],
      [882, 29.5],
      [879, 36.5],
      [876, 15.5],
      [873, 32.5],
      [870, 28.5],
      [867, 37.5],
      [864, 29.5],
      [861, 38.5],
      [858, 35.5],
      [855, 8.5],
      [852, 35.5],
      [849, 29.5],
      [846, 37.5],
      [843, 31.5],
      [840, 25.5],
      [837, 51.5],
      [834, 44.5],
      [831, 52.5],
      [828, 23.5],
      [825, 31.5],
      [822, 31.5],
      [819, 41.5],
      [816, 25.5],
      [813, 27.5],
      [810, 45.5],
      [807, 50.5],
      [804, 34.5],
      [801, 44.5],
      [798, 21.5],
      [795, 25.5],
      [792, 57.5],
      [789, 38.5],
      [786, 30.5],
      [783, 26.5],
      [780, 28.5],
      [777, 36.5],
      [774, 35.5],
      [771, 53.5],
      [768, 50.5],
      [765, 22.5],
      [762, 35.5],
      [759, 30.5],
      [756, 27.5],
      [753, 23.5],
      [750, 23.5],
      [747, 41.5],
      [744, 34.5],
      [741, 29.5],
      [738, 50.5],
      [735, 38.5],
      [732, 38.5],
      [729, 45.5],
      [726, 22.5],
      [723, 21.5],
      [720, 33.5],
      [717, 52.5],
      [714, 42.5],
      [711, 52.5],
      [708, 39.5],
      [705, 41.5],
      [702, 30.5],
      [699, 35.5],
      [696, 29.5],
      [693, 28.5],
      [690, 29.5],
      [687, 37.5],
      [684, 36.5],
      [681, 33.5],
      [678, 36.5],
      [675, 31.5],
      [672, 34.5],
      [669, 37.5],
      [666, 29.5],
      [663, 35.5],
      [660, 36.5],
      [657, 34.5],
      [654, 38.5],
      [651, 37.5],
      [648, 32.5],
      [645, 37.5],
      [642, 49.5],
      [639, 28.5],
      [636, 28.5],
      [633, 28.5],
      [630, 33.5],
      [627, 44.5],
      [624, 35.5],
      [621, 39.5],
      [618, 19.5],
      [615, 15.5],
      [612, 54.5],
      [609, 24.5],
      [606, 45.5],
      [603, 28.5],
      [600, 27.5],
      [597, 43.5],
      [594, 37.5],
      [591, 47.5],
      [588, 29.5],
      [585, 23.5],
      [582, 29.5],
      [579, 31.5],
      [576, 35.5],
      [573, 31.5],
      [570, 43.5],
      [567, 53.5],
      [564, 39.5],
      [561, 35.5],
      [558, 21.5],
      [555, 15.5],
      [552, 54.5],
      [549, 19.5],
      [546, 39.5],
      [543, 21.5],
      [540, 33.5],
      [537, 39.5],
      [534, 48.5],
      [531, 53.5],
      [528, 22.5],
      [525, 23.5],
      [522, 37.5],
      [519, 39.5],
      [516, 34.5],
      [513, 21.5],
      [510, 30.5],
      [507, 48.5],
      [504, 28.5],
      [501, 26.5],
      [498, 9.5],
      [495, 24.5],
      [492, 53.5],
      [489, 17.5],
      [486, 39.5],
      [483, 19.5],
      [480, 13.5],
      [477, 23.5],
      [474, 34.5],
      [471, 29.5],
      [468, 17.5],
      [465, 21.5],
      [462, 36.5],
      [459, 25.5],
      [456, 29.5],
      [453, 23.5],
      [450, 9.5],
      [447, 25.5],
      [444, 38.5],
      [441, 34.5],
      [438, 20.5],
      [435, 29.5],
      [432, 26.5],
      [429, 38.5],
      [426, 8.5],
      [423, 37.5],
      [420, 22.5],
      [417, 30.5],
      [414, 31.5],
      [411, 21.5],
      [408, 33.5],
      [405, 18.5],
      [402, 33.5],
      [399, 12.5],
      [396, 23.5],
      [393, 13.5],
      [390, 11.5],
      [387, 29.5],
      [384, 26.5],
      [381, 33.5],
      [378, 6.894599999999997],
      [375, 17.5],
      [372, 35.5],
      [369, 43.5],
      [366, 36.5],
      [363, 50.5],
      [360, 18.5],
      [357, 36.5],
      [354, 21.5],
      [351, 30.5],
      [348, 11.5],
      [345, 19.5],
      [342, 36.5],
      [339, 24.5],
      [336, 23.5],
      [333, 19.5],
      [330, 19.5],
      [327, 33.5],
      [324, 43.5],
      [321, 29.5],
      [318, 14.5],
      [315, 17.5],
      [312, 50.5],
      [309, 19.5],
      [306, 35.5],
      [303, 13.5],
      [300, 7.5],
      [297, 48.5],
      [294, 34.5],
      [291, 40.5],
      [288, 13.5],
      [285, 31.5],
      [282, 36.5],
      [279, 36.5],
      [276, 34.5],
      [273, 29.5],
      [270, 10.5],
      [267, 44.5],
      [264, 31.5],
      [261, 32.5],
      [258, 5.5],
      [255, 18.5],
      [252, 42.5],
      [249, 19.5],
      [246, 33.5],
      [243, 27.5],
      [240, 13.5],
      [237, 26.5],
      [234, 35.5],
      [231, 41.5],
      [228, 23.5],
      [225, 10.5],
      [222, 22.5],
      [219, 27.5],
      [216, 38.5],
      [213, 9.5],
      [210, 36.5],
      [207, 51.5],
      [204, 21.5],
      [201, 25.5],
      [198, 9.5],
      [195, 15.5],
      [192, 30.5],
      [189, 43.5],
      [186, 41.5],
      [183, 17.5],
      [180, 7.723399999999998],
      [177, 42.5],
      [174, 25.5],
      [171, 40.5],
      [168, 26.5],
      [165, 12.5],
      [162, 33.5],
      [159, 25.5],
      [156, 21.5],
      [153, 29.5],
      [150, 6.894599999999997],
      [147, 28.5],
      [144, 21.5],
      [141, 31.5],
      [138, 25.5],
      [135, 14.5],
      [132, 56.5],
      [129, 25.5],
      [126, 7.723399999999998],
      [123, 33.5],
      [120, 23.5],
      [117, 44.5],
      [114, 39.5],
      [111, 47.5],
      [108, 56.5],
      [105, 28.5],
      [102, 19.5],
      [99, 23.5],
      [96, 36.5],
      [93, 22.5],
      [90, 27.5],
      [87, 32.5],
      [84, 34.5],
      [81, 21.5],
      [78, 28.5],
      [75, 7.5],
      [72, 57.5],
      [69, 20.5],
      [66, 24.5],
      [63, 34.5],
      [60, 7.5],
      [57, 30.5],
      [54, 30.5],
      [51, 41.5],
      [48, 58.5],
      [45, 23.5],
      [42, 21.5],
      [39, 25.5],
      [36, 21.5],
      [33, 18.5],
      [30, 18.5],
      [27, 36.5],
      [24, 20.5],
      [21, 21.5],
      [18, 7.5],
      [15, 7.723399999999998],
      [12, 45.5],
      [9, 2.950400000000002],
      [6, 16.5],
      [3, 20.5],
      [0, 43.5],
    ],
  },
  {
    top: [
      [2, 132.5],
      [5, 145.5],
      [8, 105.5],
      [11, 108.5],
      [14, 133.5],
      [17, 118.5],
      [20, 144.4976],
      [23, 124.5],
      [26, 135.5],
      [29, 143.6984],
      [32, 105.5],
      [35, 139.5],
      [38, 144.4976],
      [41, 130.5],
      [44, 145.5854],
      [47, 112.5],
      [50, 141.5],
      [53, 145.5],
      [56, 138.5],
      [59, 133.5],
      [62, 138.5],
      [65, 136.5],
      [68, 110.5],
      [71, 123.5],
      [74, 127.5],
      [77, 132.5],
      [80, 136.5],
      [83, 123.5],
      [86, 145.5],
      [89, 139.5],
      [92, 108.5],
      [95, 135.5],
      [98, 135.5],
      [101, 129.5],
      [104, 125.5],
      [107, 116.5],
      [110, 125.5],
      [113, 142.5],
      [116, 129.5],
      [119, 138.5],
      [122, 121.5],
      [125, 134.5],
      [128, 107.5],
      [131, 112.5],
      [134, 120.5],
      [137, 109.5],
      [140, 144.4976],
      [143, 125.5],
      [146, 131.5],
      [149, 143.5],
      [152, 113.5],
      [155, 129.5],
      [158, 143.2766],
      [161, 125.5],
      [164, 133.5],
      [167, 99.5],
      [170, 129.5],
      [173, 143.5],
      [176, 126.5],
      [179, 138.5],
      [182, 118.5],
      [185, 128.5],
      [188, 144.5],
      [191, 109.5],
      [194, 109.5],
      [197, 103.5],
      [200, 137.5],
      [203, 120.5],
      [206, 117.5],
      [209, 142.5],
      [212, 105.5],
      [215, 133.5],
      [218, 143.6984],
      [221, 120.5],
      [224, 130.5],
      [227, 127.5],
      [230, 127.5],
      [233, 138.5],
      [236, 112.5],
      [239, 121.5],
      [242, 139.5],
      [245, 132.5],
      [248, 134.5],
      [251, 119.5],
      [254, 111.5],
      [257, 108.5],
      [260, 143.5],
      [263, 140.5],
      [266, 114.5],
      [269, 117.5],
      [272, 111.5],
      [275, 140.5],
      [278, 143.5],
      [281, 121.5],
      [284, 116.5],
      [287, 115.5],
      [290, 112.5],
      [293, 138.5],
      [296, 114.5],
      [299, 111.5],
      [302, 129.5],
      [305, 138.5],
      [308, 142.5],
      [311, 107.5],
      [314, 126.5],
      [317, 114.5],
      [320, 128.5],
      [323, 117.5],
      [326, 120.5],
      [329, 121.5],
      [332, 116.5],
      [335, 138.5],
      [338, 134.5],
      [341, 124.5],
      [344, 109.5],
      [347, 105.5],
      [350, 145.5],
      [353, 133.5],
      [356, 113.5],
      [359, 111.5],
      [362, 112.5],
      [365, 140.5],
      [368, 93.5],
      [371, 112.5],
      [374, 120.5],
      [377, 126.5],
      [380, 138.5],
      [383, 120.5],
      [386, 120.5],
      [389, 124.5],
      [392, 115.5],
      [395, 136.5],
      [398, 137.5],
      [401, 113.5],
      [404, 106.5],
      [407, 115.5],
      [410, 136.5],
      [413, 125.5],
      [416, 125.5],
      [419, 109.5],
      [422, 119.5],
      [425, 131.5],
      [428, 131.5],
      [431, 115.5],
      [434, 123.5],
      [437, 120.5],
      [440, 131.5],
      [443, 121.5],
      [446, 127.5],
      [449, 117.5],
      [452, 106.5],
      [455, 140.5],
      [458, 138.5],
      [461, 123.5],
      [464, 109.5],
      [467, 113.5],
      [470, 129.5],
      [473, 143.5],
      [476, 112.5],
      [479, 141.5],
      [482, 120.5],
      [485, 135.5],
      [488, 128.5],
      [491, 106.5],
      [494, 118.5],
      [497, 109.5],
      [500, 138.5],
      [503, 132.5],
      [506, 116.5],
      [509, 122.5],
      [512, 99.5],
      [515, 134.5],
      [518, 130.5],
      [521, 109.5],
      [524, 114.5],
      [527, 110.5],
      [530, 117.5],
      [533, 142.5],
      [536, 123.5],
      [539, 123.5],
      [542, 126.5],
      [545, 120.5],
      [548, 115.5],
      [551, 111.5],
      [554, 115.5],
      [557, 126.5],
      [560, 124.5],
      [563, 137.5],
      [566, 120.5],
      [569, 137.5],
      [572, 101.5],
      [575, 135.5],
      [578, 142.5],
      [581, 122.5],
      [584, 116.5],
      [587, 113.5],
      [590, 136.5],
      [593, 130.5],
      [596, 126.5],
      [599, 120.5],
      [602, 121.5],
      [605, 132.5],
      [608, 120.5],
      [611, 104.5],
      [614, 120.5],
      [617, 105.5],
      [620, 136.5],
      [623, 138.5],
      [626, 113.5],
      [629, 135.5],
      [632, 106.5],
      [635, 128.5],
      [638, 132.5],
      [641, 116.5],
      [644, 121.5],
      [647, 111.5],
      [650, 129.5],
      [653, 127.5],
      [656, 111.5],
      [659, 115.5],
      [662, 129.5],
      [665, 117.5],
      [668, 124.5],
      [671, 124.5],
      [674, 115.5],
      [677, 121.5],
      [680, 133.5],
      [683, 122.5],
      [686, 122.5],
      [689, 133.5],
      [692, 122.5],
      [695, 128.5],
      [698, 122.5],
      [701, 124.5],
      [704, 123.5],
      [707, 96.5],
      [710, 116.5],
      [713, 121.5],
      [716, 103.5],
      [719, 118.5],
      [722, 116.5],
      [725, 122.5],
      [728, 125.5],
      [731, 114.5],
      [734, 110.5],
      [737, 120.5],
      [740, 126.5],
      [743, 124.5],
      [746, 127.5],
      [749, 120.5],
      [752, 126.5],
      [755, 122.5],
      [758, 122.5],
      [761, 132.5],
      [764, 112.5],
      [767, 102.5],
      [770, 127.5],
      [773, 121.5],
      [776, 113.5],
      [779, 119.5],
      [782, 118.5],
      [785, 117.5],
      [788, 104.5],
      [791, 102.5],
      [794, 126.5],
      [797, 114.5],
      [800, 128.5],
      [803, 133.5],
      [806, 115.5],
      [809, 131.5],
      [812, 99.5],
      [815, 125.5],
      [818, 139.5],
      [821, 111.5],
      [824, 125.5],
      [827, 111.5],
      [830, 129.5],
      [833, 125.5],
      [836, 112.5],
      [839, 105.5],
      [842, 130.5],
      [845, 130.5],
      [848, 120.5],
      [851, 119.5],
      [854, 113.5],
      [857, 106.5],
      [860, 133.5],
      [863, 138.5],
      [866, 125.5],
      [869, 122.5],
      [872, 102.5],
      [875, 139.5],
      [878, 126.5],
      [881, 132.5],
      [884, 121.5],
      [887, 116.5],
      [890, 132.5],
      [893, 114.5],
      [896, 120.5],
      [899, 115.5],
      [902, 123.5],
      [905, 125.5],
      [908, 119.5],
      [911, 118.5],
      [914, 114.5],
      [917, 120.5],
      [920, 134.5],
      [923, 116.5],
      [926, 130.5],
      [929, 124.5],
      [932, 115.5],
      [935, 125.5],
      [938, 111.5],
      [941, 128.5],
      [944, 123.5],
      [947, 111.5],
      [950, 131.5],
      [953, 122.5],
      [956, 121.5],
      [959, 118.5],
      [962, 114.5],
      [965, 126.5],
      [968, 113.5],
      [971, 115.5],
      [974, 125.5],
      [977, 107.5],
      [980, 135.5],
      [983, 121.5],
      [986, 105.5],
      [989, 109.5],
      [992, 118.5],
      [995, 112.5],
      [998, 111.5],
      [1001, 123.5],
      [1004, 121.5],
      [1007, 111.5],
      [1010, 130.5],
      [1013, 128.5],
      [1016, 133.5],
      [1019, 136.5],
      [1022, 116.5],
      [1025, 132.5],
      [1028, 120.5],
      [1031, 110.5],
      [1034, 111.5],
      [1037, 109.5],
      [1040, 129.5],
      [1043, 114.5],
      [1046, 103.5],
      [1049, 128.5],
      [1052, 103.5],
      [1055, 136.5],
      [1058, 124.5],
      [1061, 105.5],
      [1064, 121.5],
      [1067, 104.5],
      [1070, 134.5],
      [1073, 127.5],
      [1076, 107.5],
      [1079, 120.5],
      [1082, 120.5],
      [1085, 126.5],
      [1088, 123.5],
      [1091, 103.5],
      [1094, 114.5],
      [1097, 104.5],
      [1100, 126.5],
      [1103, 130.5],
      [1106, 112.5],
      [1109, 122.5],
      [1112, 102.5],
      [1115, 137.5],
      [1118, 137.5],
      [1121, 108.5],
      [1124, 113.5],
      [1127, 103.5],
      [1130, 119.5],
      [1133, 133.5],
      [1136, 122.5],
      [1139, 110.5],
      [1142, 122.5],
      [1145, 128.5],
      [1148, 137.5],
      [1151, 106.5],
      [1154, 114.5],
      [1157, 112.5],
      [1160, 130.5],
      [1163, 118.5],
      [1166, 122.5],
      [1169, 120.5],
      [1172, 100.5],
      [1175, 133.5],
      [1178, 129.5],
      [1181, 111.5],
      [1184, 123.5],
      [1187, 99.5],
      [1190, 117.5],
      [1193, 133.5],
      [1196, 127.5],
      [1199, 121.5],
      [1202, 106.5],
      [1205, 128.5],
      [1208, 119.5],
      [1211, 99.5],
      [1214, 115.5],
      [1217, 103.5],
      [1220, 112.5],
      [1223, 117.5],
      [1226, 113.5],
      [1229, 108.5],
      [1232, 111.5],
      [1235, 122.5],
      [1238, 127.5],
      [1241, 117.5],
      [1244, 131.5],
      [1247, 100.5],
      [1250, 110.5],
      [1253, 135.5],
      [1256, 105.5],
      [1259, 106.5],
      [1262, 116.5],
      [1265, 126.5],
      [1268, 122.5],
      [1271, 119.5],
      [1274, 130.5],
      [1277, 121.5],
      [1280, 128.5],
      [1283, 128.5],
      [1286, 112.5],
      [1289, 126.5],
      [1292, 99.5],
      [1295, 122.5],
      [1298, 124.5],
      [1301, 105.5],
      [1304, 126.5],
      [1307, 106.5],
      [1310, 126.5],
      [1313, 120.5],
      [1316, 118.5],
      [1319, 108.5],
      [1322, 120.5],
      [1325, 135.5],
      [1328, 127.5],
      [1331, 103.5],
      [1334, 111.5],
      [1337, 97.5],
      [1340, 120.5],
      [1343, 126.5],
      [1346, 103.5],
      [1349, 121.5],
      [1352, 100.5],
      [1355, 134.5],
      [1358, 123.5],
      [1361, 114.5],
      [1364, 111.5],
      [1367, 110.5],
      [1370, 109.5],
      [1373, 132.5],
      [1376, 107.5],
      [1379, 104.5],
      [1382, 120.5],
      [1385, 121.5],
      [1388, 125.5],
      [1391, 109.5],
      [1394, 116.5],
      [1397, 107.5],
      [1400, 122.5],
      [1403, 120.5],
      [1406, 108.5],
      [1409, 123.5],
      [1412, 95.5],
      [1415, 114.5],
      [1418, 124.5],
      [1421, 112.5],
      [1424, 113.5],
      [1427, 101.5],
      [1430, 130.5],
      [1433, 125.5],
      [1436, 121.5],
      [1439, 109.5],
      [1442, 105.5],
      [1445, 119.5],
      [1448, 121.5],
      [1451, 118.5],
      [1454, 116.5],
      [1457, 110.5],
      [1460, 123.5],
      [1463, 119.5],
      [1466, 110.5],
      [1469, 104.5],
      [1472, 108.5],
      [1475, 121.5],
      [1478, 123.5],
      [1481, 110.5],
      [1484, 121.5],
      [1487, 110.5],
      [1490, 107.5],
      [1493, 128.5],
      [1496, 107.5],
      [1499, 105.5],
      [1502, 100.5],
      [1505, 129.5],
      [1508, 115.5],
      [1511, 120.5],
      [1514, 112.5],
      [1517, 103.5],
      [1520, 107.5],
      [1523, 95.5],
      [1526, 92.5],
      [1529, 86.5],
      [1532, 86.5],
      [1535, 79.5],
      [1538, 76.5],
      [1541, 75.5],
      [1544, 76.5],
      [1547, 75.5],
      [1550, 75.5],
    ],
    bottom: [
      [1548, 75.5],
      [1545, 74.5],
      [1542, 75.5],
      [1539, 74.5],
      [1536, 73.5],
      [1533, 66.5],
      [1530, 60.5],
      [1527, 60.5],
      [1524, 51.5],
      [1521, 40.5],
      [1518, 29.5],
      [1515, 28.5],
      [1512, 38.5],
      [1509, 35.5],
      [1506, 29.5],
      [1503, 34.5],
      [1500, 29.5],
      [1497, 42.5],
      [1494, 43.5],
      [1491, 32.5],
      [1488, 30.5],
      [1485, 31.5],
      [1482, 44.5],
      [1479, 30.5],
      [1476, 40.5],
      [1473, 33.5],
      [1470, 28.5],
      [1467, 38.5],
      [1464, 44.5],
      [1461, 41.5],
      [1458, 26.5],
      [1455, 26.5],
      [1452, 27.5],
      [1449, 42.5],
      [1446, 41.5],
      [1443, 34.5],
      [1440, 29.5],
      [1437, 45.5],
      [1434, 31.5],
      [1431, 36.5],
      [1428, 36.5],
      [1425, 27.5],
      [1422, 48.5],
      [1419, 36.5],
      [1416, 43.5],
      [1413, 23.5],
      [1410, 45.5],
      [1407, 42.5],
      [1404, 45.5],
      [1401, 44.5],
      [1398, 26.5],
      [1395, 23.5],
      [1392, 45.5],
      [1389, 36.5],
      [1386, 40.5],
      [1383, 28.5],
      [1380, 23.5],
      [1377, 46.5],
      [1374, 48.5],
      [1371, 39.5],
      [1368, 42.5],
      [1365, 30.5],
      [1362, 41.5],
      [1359, 37.5],
      [1356, 25.5],
      [1353, 22.5],
      [1350, 38.5],
      [1347, 50.5],
      [1344, 36.5],
      [1341, 39.5],
      [1338, 23.5],
      [1335, 23.5],
      [1332, 49.5],
      [1329, 16.5],
      [1326, 42.5],
      [1323, 24.5],
      [1320, 23.5],
      [1317, 49.5],
      [1314, 40.5],
      [1311, 43.5],
      [1308, 26.5],
      [1305, 20.5],
      [1302, 40.5],
      [1299, 39.5],
      [1296, 37.5],
      [1293, 21.5],
      [1290, 39.5],
      [1287, 58.5],
      [1284, 35.5],
      [1281, 37.5],
      [1278, 14.5],
      [1275, 20.5],
      [1272, 39.5],
      [1269, 28.5],
      [1266, 39.5],
      [1263, 25.5],
      [1260, 28.5],
      [1257, 44.5],
      [1254, 32.5],
      [1251, 48.5],
      [1248, 21.5],
      [1245, 17.5],
      [1242, 21.5],
      [1239, 34.5],
      [1236, 41.5],
      [1233, 38.5],
      [1230, 16.5],
      [1227, 51.5],
      [1224, 26.5],
      [1221, 43.5],
      [1218, 21.5],
      [1215, 23.5],
      [1212, 55.5],
      [1209, 27.5],
      [1206, 49.5],
      [1203, 31.5],
      [1200, 32.5],
      [1197, 44.5],
      [1194, 35.5],
      [1191, 44.5],
      [1188, 39.5],
      [1185, 15.5],
      [1182, 34.5],
      [1179, 40.5],
      [1176, 42.5],
      [1173, 29.5],
      [1170, 46.5],
      [1167, 45.5],
      [1164, 26.5],
      [1161, 30.5],
      [1158, 25.5],
      [1155, 23.5],
      [1152, 49.5],
      [1149, 31.5],
      [1146, 29.5],
      [1143, 29.5],
      [1140, 22.5],
      [1137, 50.5],
      [1134, 39.5],
      [1131, 52.5],
      [1128, 27.5],
      [1125, 22.5],
      [1122, 45.5],
      [1119, 30.5],
      [1116, 35.5],
      [1113, 22.5],
      [1110, 17.5],
      [1107, 53.5],
      [1104, 32.5],
      [1101, 37.5],
      [1098, 18.5],
      [1095, 18.5],
      [1092, 51.5],
      [1089, 25.5],
      [1086, 36.5],
      [1083, 23.5],
      [1080, 17.5],
      [1077, 43.5],
      [1074, 38.5],
      [1071, 51.5],
      [1068, 24.5],
      [1065, 27.5],
      [1062, 35.5],
      [1059, 36.5],
      [1056, 37.5],
      [1053, 15.5],
      [1050, 48.5],
      [1047, 59.5],
      [1044, 46.5],
      [1041, 44.5],
      [1038, 17.5],
      [1035, 21.5],
      [1032, 29.5],
      [1029, 22.5],
      [1026, 32.5],
      [1023, 21.5],
      [1020, 19.5],
      [1017, 30.5],
      [1014, 18.5],
      [1011, 22.5],
      [1008, 34.5],
      [1005, 18.5],
      [1002, 26.5],
      [999, 45.5],
      [996, 36.5],
      [993, 37.5],
      [990, 31.5],
      [987, 35.5],
      [984, 24.5],
      [981, 36.5],
      [978, 31.5],
      [975, 26.5],
      [972, 32.5],
      [969, 19.5],
      [966, 29.5],
      [963, 34.5],
      [960, 15.5],
      [957, 31.5],
      [954, 20.5],
      [951, 40.5],
      [948, 31.5],
      [945, 22.5],
      [942, 38.5],
      [939, 27.5],
      [936, 28.5],
      [933, 26.5],
      [930, 20.5],
      [927, 30.5],
      [924, 31.5],
      [921, 21.5],
      [918, 41.5],
      [915, 27.5],
      [912, 29.5],
      [909, 34.5],
      [906, 31.5],
      [903, 20.5],
      [900, 24.5],
      [897, 38.5],
      [894, 29.5],
      [891, 37.5],
      [888, 37.5],
      [885, 23.5],
      [882, 21.5],
      [879, 36.5],
      [876, 9.5],
      [873, 31.5],
      [870, 22.5],
      [867, 32.5],
      [864, 24.5],
      [861, 36.5],
      [858, 30.5],
      [855, 10.5],
      [852, 37.5],
      [849, 25.5],
      [846, 36.5],
      [843, 26.5],
      [840, 17.5],
      [837, 49.5],
      [834, 41.5],
      [831, 50.5],
      [828, 23.5],
      [825, 29.5],
      [822, 27.5],
      [819, 36.5],
      [816, 27.5],
      [813, 16.5],
      [810, 41.5],
      [807, 48.5],
      [804, 27.5],
      [801, 42.5],
      [798, 20.5],
      [795, 22.5],
      [792, 55.5],
      [789, 33.5],
      [786, 25.5],
      [783, 20.5],
      [780, 21.5],
      [777, 37.5],
      [774, 30.5],
      [771, 50.5],
      [768, 47.5],
      [765, 19.5],
      [762, 28.5],
      [759, 26.5],
      [756, 25.5],
      [753, 25.5],
      [750, 21.5],
      [747, 38.5],
      [744, 30.5],
      [741, 23.5],
      [738, 48.5],
      [735, 39.5],
      [732, 32.5],
      [729, 45.5],
      [726, 23.5],
      [723, 16.5],
      [720, 29.5],
      [717, 49.5],
      [714, 37.5],
      [711, 48.5],
      [708, 28.5],
      [705, 35.5],
      [702, 32.5],
      [699, 33.5],
      [696, 30.5],
      [693, 23.5],
      [690, 23.5],
      [687, 32.5],
      [684, 28.5],
      [681, 27.5],
      [678, 37.5],
      [675, 30.5],
      [672, 32.5],
      [669, 34.5],
      [666, 24.5],
      [663, 25.5],
      [660, 23.5],
      [657, 36.5],
      [654, 32.5],
      [651, 38.5],
      [648, 29.5],
      [645, 32.5],
      [642, 45.5],
      [639, 25.5],
      [636, 25.5],
      [633, 21.5],
      [630, 29.5],
      [627, 43.5],
      [624, 26.5],
      [621, 33.5],
      [618, 21.5],
      [615, 12.5],
      [612, 52.5],
      [609, 22.5],
      [606, 42.5],
      [603, 26.5],
      [600, 22.5],
      [597, 43.5],
      [594, 35.5],
      [591, 46.5],
      [588, 27.5],
      [585, 17.5],
      [582, 25.5],
      [579, 28.5],
      [576, 35.5],
      [573, 25.5],
      [570, 35.5],
      [567, 48.5],
      [564, 34.5],
      [561, 31.5],
      [558, 18.5],
      [555, 9.5],
      [552, 55.5],
      [549, 13.5],
      [546, 36.5],
      [543, 10.5],
      [540, 25.5],
      [537, 40.5],
      [534, 44.5],
      [531, 50.5],
      [528, 22.5],
      [525, 25.5],
      [522, 32.5],
      [519, 34.5],
      [516, 29.5],
      [513, 16.5],
      [510, 27.5],
      [507, 45.5],
      [504, 25.5],
      [501, 27.5],
      [498, 11.5],
      [495, 23.5],
      [492, 53.5],
      [489, 14.5],
      [486, 38.5],
      [483, 16.5],
      [480, 11.5],
      [477, 24.5],
      [474, 33.5],
      [471, 26.5],
      [468, 14.5],
      [465, 16.5],
      [462, 27.5],
      [459, 24.5],
      [456, 23.5],
      [453, 22.5],
      [450, 11.5],
      [447, 23.5],
      [444, 36.5],
      [441, 31.5],
      [438, 17.5],
      [435, 22.5],
      [432, 22.5],
      [429, 35.5],
      [426, 10.5],
      [423, 34.5],
      [420, 16.5],
      [417, 31.5],
      [414, 31.5],
      [411, 20.5],
      [408, 32.5],
      [405, 16.5],
      [402, 31.5],
      [399, 9.5],
      [396, 22.5],
      [393, 12.5],
      [390, 9.5],
      [387, 29.5],
      [384, 24.5],
      [381, 33.5],
      [378, 7.723399999999998],
      [375, 16.5],
      [372, 28.5],
      [369, 41.5],
      [366, 33.5],
      [363, 48.5],
      [360, 19.5],
      [357, 31.5],
      [354, 18.5],
      [351, 31.5],
      [348, 6.5],
      [345, 18.5],
      [342, 29.5],
      [339, 24.5],
      [336, 20.5],
      [333, 17.5],
      [330, 15.5],
      [327, 34.5],
      [324, 43.5],
      [321, 28.5],
      [318, 13.5],
      [315, 15.5],
      [312, 49.5],
      [309, 17.5],
      [306, 32.5],
      [303, 8.5],
      [300, 10.5],
      [297, 49.5],
      [294, 29.5],
      [291, 39.5],
      [288, 12.5],
      [285, 27.5],
      [282, 33.5],
      [279, 32.5],
      [276, 36.5],
      [273, 28.5],
      [270, 7.5],
      [267, 44.5],
      [264, 30.5],
      [261, 29.5],
      [258, 9.5],
      [255, 12.5],
      [252, 42.5],
      [249, 20.5],
      [246, 30.5],
      [243, 27.5],
      [240, 13.5],
      [237, 25.5],
      [234, 31.5],
      [231, 40.5],
      [228, 20.5],
      [225, 12.5],
      [222, 19.5],
      [219, 28.5],
      [216, 38.5],
      [213, 8.5],
      [210, 36.5],
      [207, 50.5],
      [204, 21.5],
      [201, 25.5],
      [198, 8.5],
      [195, 15.5],
      [192, 28.5],
      [189, 41.5],
      [186, 39.5],
      [183, 15.5],
      [180, 7.301600000000008],
      [177, 41.5],
      [174, 22.5],
      [171, 39.5],
      [168, 25.5],
      [165, 12.5],
      [162, 31.5],
      [159, 24.5],
      [156, 19.5],
      [153, 24.5],
      [150, 7.301600000000008],
      [147, 28.5],
      [144, 18.5],
      [141, 30.5],
      [138, 27.5],
      [135, 14.5],
      [132, 55.5],
      [129, 21.5],
      [126, 7.723399999999998],
      [123, 34.5],
      [120, 24.5],
      [117, 41.5],
      [114, 39.5],
      [111, 46.5],
      [108, 55.5],
      [105, 28.5],
      [102, 17.5],
      [99, 24.5],
      [96, 33.5],
      [93, 19.5],
      [90, 26.5],
      [87, 31.5],
      [84, 33.5],
      [81, 22.5],
      [78, 24.5],
      [75, 8.5],
      [72, 55.5],
      [69, 19.5],
      [66, 24.5],
      [63, 32.5],
      [60, 7.5],
      [57, 30.5],
      [54, 28.5],
      [51, 41.5],
      [48, 58.5],
      [45, 23.5],
      [42, 19.5],
      [39, 25.5],
      [36, 22.5],
      [33, 16.5],
      [30, 18.5],
      [27, 36.5],
      [24, 20.5],
      [21, 20.5],
      [18, 6.894599999999997],
      [15, 7.723399999999998],
      [12, 44.5],
      [9, 2.950400000000002],
      [6, 10.5],
      [3, 18.5],
      [0, 38.5],
    ],
  },
  {
    top: [
      [2, 133.5],
      [5, 144.5],
      [8, 107.5],
      [11, 108.5],
      [14, 133.5],
      [17, 116.5],
      [20, 144.1054],
      [23, 123.5],
      [26, 139.5],
      [29, 143.6984],
      [32, 106.5],
      [35, 136.5],
      [38, 144.4976],
      [41, 131.5],
      [44, 144.875],
      [47, 113.5],
      [50, 139.5],
      [53, 143.5],
      [56, 144.5],
      [59, 131.5],
      [62, 139.5],
      [65, 135.5],
      [68, 110.5],
      [71, 123.5],
      [74, 128.5],
      [77, 132.5],
      [80, 134.5],
      [83, 122.5],
      [86, 142.5],
      [89, 136.5],
      [92, 108.5],
      [95, 132.5],
      [98, 130.5],
      [101, 130.5],
      [104, 124.5],
      [107, 116.5],
      [110, 123.5],
      [113, 141.5],
      [116, 127.5],
      [119, 137.5],
      [122, 121.5],
      [125, 132.5],
      [128, 107.5],
      [131, 111.5],
      [134, 118.5],
      [137, 109.5],
      [140, 145.2376],
      [143, 122.5],
      [146, 128.5],
      [149, 140.5],
      [152, 115.5],
      [155, 127.5],
      [158, 143.5],
      [161, 122.5],
      [164, 130.5],
      [167, 99.5],
      [170, 125.5],
      [173, 140.5],
      [176, 123.5],
      [179, 137.5],
      [182, 120.5],
      [185, 126.5],
      [188, 142.5],
      [191, 108.5],
      [194, 106.5],
      [197, 100.5],
      [200, 132.5],
      [203, 119.5],
      [206, 116.5],
      [209, 142.5],
      [212, 103.5],
      [215, 130.5],
      [218, 144.5],
      [221, 121.5],
      [224, 127.5],
      [227, 126.5],
      [230, 134.5],
      [233, 141.5],
      [236, 111.5],
      [239, 119.5],
      [242, 135.5],
      [245, 129.5],
      [248, 138.5],
      [251, 119.5],
      [254, 111.5],
      [257, 108.5],
      [260, 142.5],
      [263, 137.5],
      [266, 111.5],
      [269, 115.5],
      [272, 109.5],
      [275, 139.5],
      [278, 143.2766],
      [281, 121.5],
      [284, 115.5],
      [287, 114.5],
      [290, 109.5],
      [293, 135.5],
      [296, 113.5],
      [299, 110.5],
      [302, 127.5],
      [305, 138.5],
      [308, 141.5],
      [311, 106.5],
      [314, 122.5],
      [317, 112.5],
      [320, 126.5],
      [323, 115.5],
      [326, 117.5],
      [329, 124.5],
      [332, 115.5],
      [335, 136.5],
      [338, 132.5],
      [341, 125.5],
      [344, 109.5],
      [347, 105.5],
      [350, 143.5],
      [353, 131.5],
      [356, 113.5],
      [359, 113.5],
      [362, 112.5],
      [365, 138.5],
      [368, 92.5],
      [371, 113.5],
      [374, 123.5],
      [377, 123.5],
      [380, 138.5],
      [383, 119.5],
      [386, 119.5],
      [389, 122.5],
      [392, 114.5],
      [395, 131.5],
      [398, 137.5],
      [401, 111.5],
      [404, 104.5],
      [407, 113.5],
      [410, 130.5],
      [413, 125.5],
      [416, 122.5],
      [419, 109.5],
      [422, 118.5],
      [425, 129.5],
      [428, 131.5],
      [431, 114.5],
      [434, 119.5],
      [437, 122.5],
      [440, 126.5],
      [443, 121.5],
      [446, 134.5],
      [449, 120.5],
      [452, 106.5],
      [455, 139.5],
      [458, 138.5],
      [461, 123.5],
      [464, 109.5],
      [467, 111.5],
      [470, 127.5],
      [473, 138.5],
      [476, 109.5],
      [479, 139.5],
      [482, 116.5],
      [485, 135.5],
      [488, 130.5],
      [491, 106.5],
      [494, 116.5],
      [497, 109.5],
      [500, 138.5],
      [503, 130.5],
      [506, 116.5],
      [509, 120.5],
      [512, 100.5],
      [515, 130.5],
      [518, 135.5],
      [521, 111.5],
      [524, 114.5],
      [527, 109.5],
      [530, 116.5],
      [533, 142.5],
      [536, 124.5],
      [539, 125.5],
      [542, 125.5],
      [545, 124.5],
      [548, 116.5],
      [551, 110.5],
      [554, 114.5],
      [557, 130.5],
      [560, 128.5],
      [563, 142.5],
      [566, 121.5],
      [569, 134.5],
      [572, 102.5],
      [575, 138.5],
      [578, 140.5],
      [581, 127.5],
      [584, 118.5],
      [587, 113.5],
      [590, 135.5],
      [593, 126.5],
      [596, 124.5],
      [599, 120.5],
      [602, 125.5],
      [605, 132.5],
      [608, 121.5],
      [611, 106.5],
      [614, 120.5],
      [617, 106.5],
      [620, 136.5],
      [623, 139.5],
      [626, 112.5],
      [629, 136.5],
      [632, 107.5],
      [635, 134.5],
      [638, 135.5],
      [641, 116.5],
      [644, 123.5],
      [647, 110.5],
      [650, 128.5],
      [653, 124.5],
      [656, 111.5],
      [659, 113.5],
      [662, 132.5],
      [665, 119.5],
      [668, 124.5],
      [671, 128.5],
      [674, 115.5],
      [677, 118.5],
      [680, 135.5],
      [683, 123.5],
      [686, 128.5],
      [689, 134.5],
      [692, 122.5],
      [695, 126.5],
      [698, 123.5],
      [701, 125.5],
      [704, 123.5],
      [707, 96.5],
      [710, 114.5],
      [713, 122.5],
      [716, 104.5],
      [719, 123.5],
      [722, 115.5],
      [725, 121.5],
      [728, 124.5],
      [731, 121.5],
      [734, 113.5],
      [737, 117.5],
      [740, 127.5],
      [743, 127.5],
      [746, 126.5],
      [749, 117.5],
      [752, 122.5],
      [755, 125.5],
      [758, 119.5],
      [761, 128.5],
      [764, 113.5],
      [767, 102.5],
      [770, 129.5],
      [773, 128.5],
      [776, 112.5],
      [779, 120.5],
      [782, 120.5],
      [785, 118.5],
      [788, 106.5],
      [791, 103.5],
      [794, 122.5],
      [797, 113.5],
      [800, 128.5],
      [803, 137.5],
      [806, 113.5],
      [809, 128.5],
      [812, 98.5],
      [815, 124.5],
      [818, 140.5],
      [821, 112.5],
      [824, 126.5],
      [827, 108.5],
      [830, 130.5],
      [833, 122.5],
      [836, 114.5],
      [839, 106.5],
      [842, 129.5],
      [845, 128.5],
      [848, 118.5],
      [851, 120.5],
      [854, 112.5],
      [857, 104.5],
      [860, 133.5],
      [863, 140.5],
      [866, 123.5],
      [869, 120.5],
      [872, 104.5],
      [875, 136.5],
      [878, 124.5],
      [881, 131.5],
      [884, 122.5],
      [887, 121.5],
      [890, 131.5],
      [893, 114.5],
      [896, 119.5],
      [899, 120.5],
      [902, 124.5],
      [905, 125.5],
      [908, 124.5],
      [911, 118.5],
      [914, 112.5],
      [917, 121.5],
      [920, 134.5],
      [923, 114.5],
      [926, 129.5],
      [929, 125.5],
      [932, 114.5],
      [935, 123.5],
      [938, 114.5],
      [941, 127.5],
      [944, 121.5],
      [947, 110.5],
      [950, 131.5],
      [953, 118.5],
      [956, 119.5],
      [959, 116.5],
      [962, 115.5],
      [965, 126.5],
      [968, 112.5],
      [971, 113.5],
      [974, 122.5],
      [977, 106.5],
      [980, 133.5],
      [983, 123.5],
      [986, 108.5],
      [989, 112.5],
      [992, 117.5],
      [995, 110.5],
      [998, 111.5],
      [1001, 120.5],
      [1004, 117.5],
      [1007, 112.5],
      [1010, 132.5],
      [1013, 126.5],
      [1016, 129.5],
      [1019, 131.5],
      [1022, 117.5],
      [1025, 132.5],
      [1028, 118.5],
      [1031, 110.5],
      [1034, 108.5],
      [1037, 106.5],
      [1040, 129.5],
      [1043, 111.5],
      [1046, 106.5],
      [1049, 126.5],
      [1052, 101.5],
      [1055, 130.5],
      [1058, 125.5],
      [1061, 105.5],
      [1064, 122.5],
      [1067, 107.5],
      [1070, 133.5],
      [1073, 127.5],
      [1076, 106.5],
      [1079, 119.5],
      [1082, 121.5],
      [1085, 126.5],
      [1088, 122.5],
      [1091, 105.5],
      [1094, 112.5],
      [1097, 106.5],
      [1100, 126.5],
      [1103, 128.5],
      [1106, 114.5],
      [1109, 126.5],
      [1112, 104.5],
      [1115, 135.5],
      [1118, 138.5],
      [1121, 108.5],
      [1124, 111.5],
      [1127, 102.5],
      [1130, 117.5],
      [1133, 132.5],
      [1136, 122.5],
      [1139, 110.5],
      [1142, 119.5],
      [1145, 124.5],
      [1148, 132.5],
      [1151, 104.5],
      [1154, 112.5],
      [1157, 110.5],
      [1160, 129.5],
      [1163, 118.5],
      [1166, 119.5],
      [1169, 121.5],
      [1172, 103.5],
      [1175, 130.5],
      [1178, 128.5],
      [1181, 109.5],
      [1184, 120.5],
      [1187, 99.5],
      [1190, 117.5],
      [1193, 130.5],
      [1196, 127.5],
      [1199, 119.5],
      [1202, 105.5],
      [1205, 127.5],
      [1208, 119.5],
      [1211, 98.5],
      [1214, 113.5],
      [1217, 103.5],
      [1220, 116.5],
      [1223, 117.5],
      [1226, 117.5],
      [1229, 105.5],
      [1232, 112.5],
      [1235, 121.5],
      [1238, 125.5],
      [1241, 114.5],
      [1244, 126.5],
      [1247, 99.5],
      [1250, 109.5],
      [1253, 129.5],
      [1256, 105.5],
      [1259, 108.5],
      [1262, 120.5],
      [1265, 125.5],
      [1268, 123.5],
      [1271, 120.5],
      [1274, 126.5],
      [1277, 119.5],
      [1280, 126.5],
      [1283, 126.5],
      [1286, 118.5],
      [1289, 125.5],
      [1292, 98.5],
      [1295, 121.5],
      [1298, 122.5],
      [1301, 108.5],
      [1304, 123.5],
      [1307, 106.5],
      [1310, 128.5],
      [1313, 121.5],
      [1316, 118.5],
      [1319, 110.5],
      [1322, 119.5],
      [1325, 132.5],
      [1328, 124.5],
      [1331, 102.5],
      [1334, 110.5],
      [1337, 99.5],
      [1340, 119.5],
      [1343, 126.5],
      [1346, 103.5],
      [1349, 121.5],
      [1352, 99.5],
      [1355, 133.5],
      [1358, 126.5],
      [1361, 113.5],
      [1364, 114.5],
      [1367, 108.5],
      [1370, 107.5],
      [1373, 128.5],
      [1376, 105.5],
      [1379, 103.5],
      [1382, 119.5],
      [1385, 123.5],
      [1388, 125.5],
      [1391, 109.5],
      [1394, 116.5],
      [1397, 106.5],
      [1400, 121.5],
      [1403, 120.5],
      [1406, 106.5],
      [1409, 125.5],
      [1412, 94.5],
      [1415, 114.5],
      [1418, 124.5],
      [1421, 112.5],
      [1424, 115.5],
      [1427, 100.5],
      [1430, 127.5],
      [1433, 126.5],
      [1436, 121.5],
      [1439, 106.5],
      [1442, 108.5],
      [1445, 116.5],
      [1448, 120.5],
      [1451, 116.5],
      [1454, 115.5],
      [1457, 113.5],
      [1460, 128.5],
      [1463, 124.5],
      [1466, 110.5],
      [1469, 103.5],
      [1472, 109.5],
      [1475, 119.5],
      [1478, 122.5],
      [1481, 109.5],
      [1484, 122.5],
      [1487, 109.5],
      [1490, 108.5],
      [1493, 125.5],
      [1496, 110.5],
      [1499, 106.5],
      [1502, 103.5],
      [1505, 124.5],
      [1508, 116.5],
      [1511, 122.5],
      [1514, 113.5],
      [1517, 103.5],
      [1520, 106.5],
      [1523, 96.5],
      [1526, 92.5],
      [1529, 86.5],
      [1532, 86.5],
      [1535, 79.5],
      [1538, 76.5],
      [1541, 76.5],
      [1544, 76.5],
      [1547, 75.5],
      [1550, 75.5],
    ],
    bottom: [
      [1548, 75.5],
      [1545, 74.5],
      [1542, 74.5],
      [1539, 74.5],
      [1536, 73.5],
      [1533, 66.5],
      [1530, 61.5],
      [1527, 59.5],
      [1524, 52.5],
      [1521, 40.5],
      [1518, 28.5],
      [1515, 30.5],
      [1512, 36.5],
      [1509, 33.5],
      [1506, 31.5],
      [1503, 33.5],
      [1500, 26.5],
      [1497, 39.5],
      [1494, 43.5],
      [1491, 33.5],
      [1488, 30.5],
      [1485, 28.5],
      [1482, 44.5],
      [1479, 33.5],
      [1476, 40.5],
      [1473, 32.5],
      [1470, 26.5],
      [1467, 39.5],
      [1464, 38.5],
      [1461, 39.5],
      [1458, 21.5],
      [1455, 27.5],
      [1452, 30.5],
      [1449, 44.5],
      [1446, 40.5],
      [1443, 32.5],
      [1440, 29.5],
      [1437, 46.5],
      [1434, 28.5],
      [1431, 39.5],
      [1428, 33.5],
      [1425, 25.5],
      [1422, 46.5],
      [1419, 38.5],
      [1416, 45.5],
      [1413, 28.5],
      [1410, 45.5],
      [1407, 43.5],
      [1404, 47.5],
      [1401, 46.5],
      [1398, 24.5],
      [1395, 23.5],
      [1392, 45.5],
      [1389, 36.5],
      [1386, 40.5],
      [1383, 28.5],
      [1380, 23.5],
      [1377, 46.5],
      [1374, 48.5],
      [1371, 41.5],
      [1368, 42.5],
      [1365, 29.5],
      [1362, 41.5],
      [1359, 35.5],
      [1356, 26.5],
      [1353, 22.5],
      [1350, 39.5],
      [1347, 50.5],
      [1344, 36.5],
      [1341, 41.5],
      [1338, 21.5],
      [1335, 24.5],
      [1332, 50.5],
      [1329, 17.5],
      [1326, 44.5],
      [1323, 25.5],
      [1320, 24.5],
      [1317, 49.5],
      [1314, 39.5],
      [1311, 43.5],
      [1308, 27.5],
      [1305, 23.5],
      [1302, 39.5],
      [1299, 39.5],
      [1296, 36.5],
      [1293, 24.5],
      [1290, 42.5],
      [1287, 57.5],
      [1284, 37.5],
      [1281, 36.5],
      [1278, 19.5],
      [1275, 24.5],
      [1272, 41.5],
      [1269, 23.5],
      [1266, 41.5],
      [1263, 25.5],
      [1260, 26.5],
      [1257, 43.5],
      [1254, 36.5],
      [1251, 47.5],
      [1248, 23.5],
      [1245, 22.5],
      [1242, 25.5],
      [1239, 36.5],
      [1236, 44.5],
      [1233, 40.5],
      [1230, 19.5],
      [1227, 49.5],
      [1224, 26.5],
      [1221, 40.5],
      [1218, 19.5],
      [1215, 24.5],
      [1212, 55.5],
      [1209, 26.5],
      [1206, 49.5],
      [1203, 33.5],
      [1200, 32.5],
      [1197, 45.5],
      [1194, 37.5],
      [1191, 44.5],
      [1188, 39.5],
      [1185, 17.5],
      [1182, 36.5],
      [1179, 41.5],
      [1176, 42.5],
      [1173, 30.5],
      [1170, 45.5],
      [1167, 46.5],
      [1164, 27.5],
      [1161, 30.5],
      [1158, 26.5],
      [1155, 24.5],
      [1152, 51.5],
      [1149, 34.5],
      [1146, 33.5],
      [1143, 30.5],
      [1140, 26.5],
      [1137, 50.5],
      [1134, 39.5],
      [1131, 52.5],
      [1128, 30.5],
      [1125, 23.5],
      [1122, 46.5],
      [1119, 31.5],
      [1116, 34.5],
      [1113, 22.5],
      [1110, 16.5],
      [1107, 50.5],
      [1104, 33.5],
      [1101, 38.5],
      [1098, 18.5],
      [1095, 20.5],
      [1092, 51.5],
      [1089, 26.5],
      [1086, 35.5],
      [1083, 22.5],
      [1080, 18.5],
      [1077, 45.5],
      [1074, 39.5],
      [1071, 51.5],
      [1068, 20.5],
      [1065, 24.5],
      [1062, 34.5],
      [1059, 34.5],
      [1056, 40.5],
      [1053, 18.5],
      [1050, 48.5],
      [1047, 58.5],
      [1044, 48.5],
      [1041, 46.5],
      [1038, 22.5],
      [1035, 24.5],
      [1032, 32.5],
      [1029, 24.5],
      [1026, 31.5],
      [1023, 18.5],
      [1020, 21.5],
      [1017, 33.5],
      [1014, 22.5],
      [1011, 23.5],
      [1008, 35.5],
      [1005, 21.5],
      [1002, 29.5],
      [999, 46.5],
      [996, 34.5],
      [993, 40.5],
      [990, 29.5],
      [987, 29.5],
      [984, 21.5],
      [981, 35.5],
      [978, 34.5],
      [975, 28.5],
      [972, 35.5],
      [969, 21.5],
      [966, 30.5],
      [963, 31.5],
      [960, 14.5],
      [957, 34.5],
      [954, 24.5],
      [951, 40.5],
      [948, 34.5],
      [945, 22.5],
      [942, 38.5],
      [939, 25.5],
      [936, 30.5],
      [933, 23.5],
      [930, 19.5],
      [927, 32.5],
      [924, 33.5],
      [921, 20.5],
      [918, 39.5],
      [915, 30.5],
      [912, 26.5],
      [909, 32.5],
      [906, 31.5],
      [903, 23.5],
      [900, 17.5],
      [897, 36.5],
      [894, 30.5],
      [891, 37.5],
      [888, 37.5],
      [885, 23.5],
      [882, 21.5],
      [879, 39.5],
      [876, 13.5],
      [873, 34.5],
      [870, 21.5],
      [867, 34.5],
      [864, 23.5],
      [861, 35.5],
      [858, 29.5],
      [855, 11.5],
      [852, 38.5],
      [849, 26.5],
      [846, 36.5],
      [843, 29.5],
      [840, 19.5],
      [837, 47.5],
      [834, 42.5],
      [831, 50.5],
      [828, 26.5],
      [825, 27.5],
      [822, 25.5],
      [819, 36.5],
      [816, 29.5],
      [813, 15.5],
      [810, 42.5],
      [807, 50.5],
      [804, 23.5],
      [801, 42.5],
      [798, 19.5],
      [795, 26.5],
      [792, 56.5],
      [789, 32.5],
      [786, 26.5],
      [783, 21.5],
      [780, 22.5],
      [777, 38.5],
      [774, 27.5],
      [771, 50.5],
      [768, 47.5],
      [765, 14.5],
      [762, 31.5],
      [759, 29.5],
      [756, 24.5],
      [753, 29.5],
      [750, 25.5],
      [747, 41.5],
      [744, 29.5],
      [741, 24.5],
      [738, 49.5],
      [735, 37.5],
      [732, 30.5],
      [729, 45.5],
      [726, 23.5],
      [723, 18.5],
      [720, 26.5],
      [717, 46.5],
      [714, 35.5],
      [711, 49.5],
      [708, 28.5],
      [705, 35.5],
      [702, 33.5],
      [699, 28.5],
      [696, 31.5],
      [693, 23.5],
      [690, 23.5],
      [687, 30.5],
      [684, 27.5],
      [681, 26.5],
      [678, 39.5],
      [675, 32.5],
      [672, 27.5],
      [669, 34.5],
      [666, 22.5],
      [663, 23.5],
      [660, 27.5],
      [657, 35.5],
      [654, 33.5],
      [651, 39.5],
      [648, 26.5],
      [645, 34.5],
      [642, 44.5],
      [639, 21.5],
      [636, 22.5],
      [633, 18.5],
      [630, 28.5],
      [627, 44.5],
      [624, 24.5],
      [621, 35.5],
      [618, 16.5],
      [615, 11.5],
      [612, 51.5],
      [609, 20.5],
      [606, 42.5],
      [603, 22.5],
      [600, 21.5],
      [597, 44.5],
      [594, 37.5],
      [591, 47.5],
      [588, 30.5],
      [585, 15.5],
      [582, 22.5],
      [579, 26.5],
      [576, 36.5],
      [573, 24.5],
      [570, 35.5],
      [567, 48.5],
      [564, 30.5],
      [561, 29.5],
      [558, 16.5],
      [555, 9.5],
      [552, 55.5],
      [549, 13.5],
      [546, 36.5],
      [543, 10.5],
      [540, 21.5],
      [537, 40.5],
      [534, 44.5],
      [531, 50.5],
      [528, 23.5],
      [525, 22.5],
      [522, 30.5],
      [519, 31.5],
      [516, 30.5],
      [513, 18.5],
      [510, 25.5],
      [507, 46.5],
      [504, 27.5],
      [501, 30.5],
      [498, 14.5],
      [495, 23.5],
      [492, 54.5],
      [489, 17.5],
      [486, 38.5],
      [483, 22.5],
      [480, 15.5],
      [477, 26.5],
      [474, 35.5],
      [471, 30.5],
      [468, 16.5],
      [465, 16.5],
      [462, 27.5],
      [459, 25.5],
      [456, 24.5],
      [453, 24.5],
      [450, 12.5],
      [447, 19.5],
      [444, 37.5],
      [441, 34.5],
      [438, 16.5],
      [435, 23.5],
      [432, 22.5],
      [429, 34.5],
      [426, 8.5],
      [423, 33.5],
      [420, 15.5],
      [417, 33.5],
      [414, 29.5],
      [411, 23.5],
      [408, 34.5],
      [405, 20.5],
      [402, 34.5],
      [399, 11.5],
      [396, 24.5],
      [393, 15.5],
      [390, 10.5],
      [387, 29.5],
      [384, 27.5],
      [381, 32.5],
      [378, 7.5],
      [375, 16.5],
      [372, 27.5],
      [369, 41.5],
      [366, 35.5],
      [363, 50.5],
      [360, 13.5],
      [357, 33.5],
      [354, 19.5],
      [351, 34.5],
      [348, 10.5],
      [345, 17.5],
      [342, 27.5],
      [339, 26.5],
      [336, 23.5],
      [333, 18.5],
      [330, 14.5],
      [327, 35.5],
      [324, 43.5],
      [321, 30.5],
      [318, 16.5],
      [315, 19.5],
      [312, 51.5],
      [309, 19.5],
      [306, 33.5],
      [303, 9.5],
      [300, 10.5],
      [297, 48.5],
      [294, 31.5],
      [291, 42.5],
      [288, 17.5],
      [285, 28.5],
      [282, 31.5],
      [279, 31.5],
      [276, 35.5],
      [273, 30.5],
      [270, 13.5],
      [267, 45.5],
      [264, 33.5],
      [261, 29.5],
      [258, 10.5],
      [255, 12.5],
      [252, 42.5],
      [249, 18.5],
      [246, 31.5],
      [243, 28.5],
      [240, 15.5],
      [237, 26.5],
      [234, 30.5],
      [231, 36.5],
      [228, 20.5],
      [225, 17.5],
      [222, 21.5],
      [219, 30.5],
      [216, 41.5],
      [213, 10.5],
      [210, 35.5],
      [207, 50.5],
      [204, 23.5],
      [201, 29.5],
      [198, 14.5],
      [195, 19.5],
      [192, 30.5],
      [189, 43.5],
      [186, 40.5],
      [183, 14.5],
      [180, 7.301600000000008],
      [177, 43.5],
      [174, 26.5],
      [171, 41.5],
      [168, 28.5],
      [165, 15.5],
      [162, 34.5],
      [159, 26.5],
      [156, 24.5],
      [153, 22.5],
      [150, 6.5],
      [147, 30.5],
      [144, 22.5],
      [141, 27.5],
      [138, 27.5],
      [135, 16.5],
      [132, 56.5],
      [129, 23.5],
      [126, 6.5],
      [123, 35.5],
      [120, 25.5],
      [117, 43.5],
      [114, 41.5],
      [111, 47.5],
      [108, 55.5],
      [105, 28.5],
      [102, 15.5],
      [99, 28.5],
      [96, 35.5],
      [93, 18.5],
      [90, 28.5],
      [87, 32.5],
      [84, 34.5],
      [81, 24.5],
      [78, 23.5],
      [75, 10.5],
      [72, 55.5],
      [69, 21.5],
      [66, 24.5],
      [63, 31.5],
      [60, 8.5],
      [57, 28.5],
      [54, 30.5],
      [51, 41.5],
      [48, 57.5],
      [45, 24.5],
      [42, 19.5],
      [39, 25.5],
      [36, 25.5],
      [33, 14.5],
      [30, 17.5],
      [27, 34.5],
      [24, 20.5],
      [21, 21.5],
      [18, 6.5],
      [15, 7.301600000000008],
      [12, 45.5],
      [9, 3.164999999999992],
      [6, 11.5],
      [3, 15.5],
      [0, 40.5],
    ],
  },
  {
    top: [
      [2, 134.5],
      [5, 144.5],
      [8, 107.5],
      [11, 108.5],
      [14, 133.5],
      [17, 115.5],
      [20, 144.1054],
      [23, 124.5],
      [26, 139.5],
      [29, 143.2766],
      [32, 107.5],
      [35, 137.5],
      [38, 144.4976],
      [41, 129.5],
      [44, 144.875],
      [47, 111.5],
      [50, 138.5],
      [53, 139.5],
      [56, 143.5],
      [59, 134.5],
      [62, 137.5],
      [65, 133.5],
      [68, 109.5],
      [71, 120.5],
      [74, 131.5],
      [77, 129.5],
      [80, 133.5],
      [83, 121.5],
      [86, 137.5],
      [89, 133.5],
      [92, 106.5],
      [95, 128.5],
      [98, 134.5],
      [101, 130.5],
      [104, 123.5],
      [107, 114.5],
      [110, 120.5],
      [113, 138.5],
      [116, 125.5],
      [119, 135.5],
      [122, 126.5],
      [125, 131.5],
      [128, 105.5],
      [131, 108.5],
      [134, 117.5],
      [137, 111.5],
      [140, 144.1054],
      [143, 121.5],
      [146, 128.5],
      [149, 143.5],
      [152, 112.5],
      [155, 124.5],
      [158, 138.5],
      [161, 119.5],
      [164, 129.5],
      [167, 98.5],
      [170, 124.5],
      [173, 144.5],
      [176, 123.5],
      [179, 135.5],
      [182, 116.5],
      [185, 124.5],
      [188, 142.5],
      [191, 109.5],
      [194, 106.5],
      [197, 99.5],
      [200, 127.5],
      [203, 119.5],
      [206, 113.5],
      [209, 137.5],
      [212, 102.5],
      [215, 131.5],
      [218, 143.2766],
      [221, 118.5],
      [224, 125.5],
      [227, 124.5],
      [230, 131.5],
      [233, 137.5],
      [236, 109.5],
      [239, 119.5],
      [242, 131.5],
      [245, 132.5],
      [248, 144.5],
      [251, 117.5],
      [254, 110.5],
      [257, 110.5],
      [260, 139.5],
      [263, 135.5],
      [266, 110.5],
      [269, 115.5],
      [272, 112.5],
      [275, 138.5],
      [278, 143.5],
      [281, 120.5],
      [284, 115.5],
      [287, 114.5],
      [290, 109.5],
      [293, 136.5],
      [296, 121.5],
      [299, 109.5],
      [302, 123.5],
      [305, 133.5],
      [308, 136.5],
      [311, 105.5],
      [314, 120.5],
      [317, 114.5],
      [320, 131.5],
      [323, 116.5],
      [326, 115.5],
      [329, 122.5],
      [332, 114.5],
      [335, 135.5],
      [338, 130.5],
      [341, 123.5],
      [344, 111.5],
      [347, 106.5],
      [350, 142.5],
      [353, 128.5],
      [356, 111.5],
      [359, 112.5],
      [362, 110.5],
      [365, 133.5],
      [368, 92.5],
      [371, 113.5],
      [374, 124.5],
      [377, 123.5],
      [380, 134.5],
      [383, 119.5],
      [386, 118.5],
      [389, 122.5],
      [392, 113.5],
      [395, 134.5],
      [398, 134.5],
      [401, 108.5],
      [404, 102.5],
      [407, 111.5],
      [410, 128.5],
      [413, 124.5],
      [416, 123.5],
      [419, 108.5],
      [422, 116.5],
      [425, 128.5],
      [428, 133.5],
      [431, 114.5],
      [434, 122.5],
      [437, 118.5],
      [440, 126.5],
      [443, 124.5],
      [446, 135.5],
      [449, 119.5],
      [452, 106.5],
      [455, 142.5],
      [458, 134.5],
      [461, 119.5],
      [464, 107.5],
      [467, 112.5],
      [470, 126.5],
      [473, 136.5],
      [476, 108.5],
      [479, 138.5],
      [482, 114.5],
      [485, 133.5],
      [488, 127.5],
      [491, 109.5],
      [494, 120.5],
      [497, 107.5],
      [500, 136.5],
      [503, 128.5],
      [506, 114.5],
      [509, 117.5],
      [512, 100.5],
      [515, 133.5],
      [518, 138.5],
      [521, 112.5],
      [524, 116.5],
      [527, 107.5],
      [530, 117.5],
      [533, 141.5],
      [536, 122.5],
      [539, 122.5],
      [542, 126.5],
      [545, 123.5],
      [548, 115.5],
      [551, 109.5],
      [554, 112.5],
      [557, 127.5],
      [560, 126.5],
      [563, 139.5],
      [566, 121.5],
      [569, 134.5],
      [572, 103.5],
      [575, 139.5],
      [578, 137.5],
      [581, 122.5],
      [584, 115.5],
      [587, 113.5],
      [590, 133.5],
      [593, 126.5],
      [596, 125.5],
      [599, 120.5],
      [602, 123.5],
      [605, 129.5],
      [608, 123.5],
      [611, 106.5],
      [614, 121.5],
      [617, 104.5],
      [620, 132.5],
      [623, 133.5],
      [626, 113.5],
      [629, 137.5],
      [632, 106.5],
      [635, 133.5],
      [638, 133.5],
      [641, 119.5],
      [644, 124.5],
      [647, 113.5],
      [650, 130.5],
      [653, 124.5],
      [656, 109.5],
      [659, 111.5],
      [662, 131.5],
      [665, 118.5],
      [668, 125.5],
      [671, 128.5],
      [674, 114.5],
      [677, 114.5],
      [680, 131.5],
      [683, 120.5],
      [686, 125.5],
      [689, 135.5],
      [692, 123.5],
      [695, 127.5],
      [698, 121.5],
      [701, 121.5],
      [704, 120.5],
      [707, 95.5],
      [710, 116.5],
      [713, 123.5],
      [716, 104.5],
      [719, 123.5],
      [722, 113.5],
      [725, 122.5],
      [728, 125.5],
      [731, 118.5],
      [734, 114.5],
      [737, 114.5],
      [740, 126.5],
      [743, 125.5],
      [746, 126.5],
      [749, 114.5],
      [752, 118.5],
      [755, 124.5],
      [758, 117.5],
      [761, 128.5],
      [764, 115.5],
      [767, 101.5],
      [770, 134.5],
      [773, 130.5],
      [776, 112.5],
      [779, 118.5],
      [782, 116.5],
      [785, 116.5],
      [788, 103.5],
      [791, 105.5],
      [794, 121.5],
      [797, 112.5],
      [800, 127.5],
      [803, 135.5],
      [806, 116.5],
      [809, 129.5],
      [812, 99.5],
      [815, 121.5],
      [818, 139.5],
      [821, 108.5],
      [824, 124.5],
      [827, 109.5],
      [830, 128.5],
      [833, 123.5],
      [836, 117.5],
      [839, 107.5],
      [842, 127.5],
      [845, 130.5],
      [848, 120.5],
      [851, 119.5],
      [854, 110.5],
      [857, 103.5],
      [860, 131.5],
      [863, 136.5],
      [866, 123.5],
      [869, 121.5],
      [872, 105.5],
      [875, 134.5],
      [878, 121.5],
      [881, 128.5],
      [884, 123.5],
      [887, 123.5],
      [890, 136.5],
      [893, 116.5],
      [896, 118.5],
      [899, 119.5],
      [902, 120.5],
      [905, 121.5],
      [908, 121.5],
      [911, 120.5],
      [914, 114.5],
      [917, 121.5],
      [920, 135.5],
      [923, 117.5],
      [926, 127.5],
      [929, 125.5],
      [932, 115.5],
      [935, 120.5],
      [938, 112.5],
      [941, 124.5],
      [944, 119.5],
      [947, 110.5],
      [950, 127.5],
      [953, 116.5],
      [956, 116.5],
      [959, 114.5],
      [962, 114.5],
      [965, 125.5],
      [968, 113.5],
      [971, 111.5],
      [974, 120.5],
      [977, 104.5],
      [980, 127.5],
      [983, 118.5],
      [986, 106.5],
      [989, 112.5],
      [992, 114.5],
      [995, 110.5],
      [998, 108.5],
      [1001, 119.5],
      [1004, 117.5],
      [1007, 114.5],
      [1010, 134.5],
      [1013, 126.5],
      [1016, 127.5],
      [1019, 130.5],
      [1022, 115.5],
      [1025, 127.5],
      [1028, 114.5],
      [1031, 109.5],
      [1034, 107.5],
      [1037, 106.5],
      [1040, 131.5],
      [1043, 112.5],
      [1046, 109.5],
      [1049, 128.5],
      [1052, 101.5],
      [1055, 127.5],
      [1058, 128.5],
      [1061, 105.5],
      [1064, 122.5],
      [1067, 106.5],
      [1070, 132.5],
      [1073, 127.5],
      [1076, 106.5],
      [1079, 117.5],
      [1082, 125.5],
      [1085, 128.5],
      [1088, 118.5],
      [1091, 105.5],
      [1094, 110.5],
      [1097, 105.5],
      [1100, 121.5],
      [1103, 124.5],
      [1106, 116.5],
      [1109, 124.5],
      [1112, 103.5],
      [1115, 130.5],
      [1118, 133.5],
      [1121, 108.5],
      [1124, 114.5],
      [1127, 102.5],
      [1130, 118.5],
      [1133, 133.5],
      [1136, 123.5],
      [1139, 110.5],
      [1142, 118.5],
      [1145, 122.5],
      [1148, 129.5],
      [1151, 103.5],
      [1154, 112.5],
      [1157, 112.5],
      [1160, 131.5],
      [1163, 118.5],
      [1166, 117.5],
      [1169, 122.5],
      [1172, 101.5],
      [1175, 126.5],
      [1178, 125.5],
      [1181, 106.5],
      [1184, 116.5],
      [1187, 97.5],
      [1190, 116.5],
      [1193, 125.5],
      [1196, 124.5],
      [1199, 127.5],
      [1202, 106.5],
      [1205, 130.5],
      [1208, 122.5],
      [1211, 99.5],
      [1214, 110.5],
      [1217, 102.5],
      [1220, 112.5],
      [1223, 115.5],
      [1226, 114.5],
      [1229, 105.5],
      [1232, 113.5],
      [1235, 120.5],
      [1238, 128.5],
      [1241, 111.5],
      [1244, 127.5],
      [1247, 99.5],
      [1250, 109.5],
      [1253, 129.5],
      [1256, 105.5],
      [1259, 108.5],
      [1262, 120.5],
      [1265, 124.5],
      [1268, 124.5],
      [1271, 118.5],
      [1274, 123.5],
      [1277, 117.5],
      [1280, 128.5],
      [1283, 131.5],
      [1286, 121.5],
      [1289, 127.5],
      [1292, 98.5],
      [1295, 119.5],
      [1298, 118.5],
      [1301, 107.5],
      [1304, 122.5],
      [1307, 105.5],
      [1310, 128.5],
      [1313, 123.5],
      [1316, 121.5],
      [1319, 108.5],
      [1322, 119.5],
      [1325, 128.5],
      [1328, 126.5],
      [1331, 102.5],
      [1334, 108.5],
      [1337, 99.5],
      [1340, 118.5],
      [1343, 122.5],
      [1346, 102.5],
      [1349, 122.5],
      [1352, 100.5],
      [1355, 132.5],
      [1358, 124.5],
      [1361, 113.5],
      [1364, 112.5],
      [1367, 108.5],
      [1370, 106.5],
      [1373, 123.5],
      [1376, 103.5],
      [1379, 100.5],
      [1382, 115.5],
      [1385, 118.5],
      [1388, 124.5],
      [1391, 109.5],
      [1394, 118.5],
      [1397, 107.5],
      [1400, 123.5],
      [1403, 120.5],
      [1406, 107.5],
      [1409, 125.5],
      [1412, 93.5],
      [1415, 111.5],
      [1418, 121.5],
      [1421, 112.5],
      [1424, 112.5],
      [1427, 99.5],
      [1430, 126.5],
      [1433, 126.5],
      [1436, 122.5],
      [1439, 111.5],
      [1442, 115.5],
      [1445, 120.5],
      [1448, 123.5],
      [1451, 117.5],
      [1454, 113.5],
      [1457, 111.5],
      [1460, 126.5],
      [1463, 124.5],
      [1466, 111.5],
      [1469, 104.5],
      [1472, 108.5],
      [1475, 121.5],
      [1478, 126.5],
      [1481, 109.5],
      [1484, 122.5],
      [1487, 109.5],
      [1490, 108.5],
      [1493, 123.5],
      [1496, 107.5],
      [1499, 106.5],
      [1502, 103.5],
      [1505, 124.5],
      [1508, 115.5],
      [1511, 120.5],
      [1514, 111.5],
      [1517, 105.5],
      [1520, 108.5],
      [1523, 95.5],
      [1526, 93.5],
      [1529, 85.5],
      [1532, 85.5],
      [1535, 79.5],
      [1538, 76.5],
      [1541, 76.5],
      [1544, 76.5],
      [1547, 75.5],
      [1550, 75.5],
    ],
    bottom: [
      [1548, 75.5],
      [1545, 74.5],
      [1542, 74.5],
      [1539, 74.5],
      [1536, 73.5],
      [1533, 66.5],
      [1530, 61.5],
      [1527, 59.5],
      [1524, 49.5],
      [1521, 40.5],
      [1518, 28.5],
      [1515, 31.5],
      [1512, 36.5],
      [1509, 36.5],
      [1506, 31.5],
      [1503, 33.5],
      [1500, 25.5],
      [1497, 39.5],
      [1494, 45.5],
      [1491, 33.5],
      [1488, 30.5],
      [1485, 27.5],
      [1482, 43.5],
      [1479, 33.5],
      [1476, 40.5],
      [1473, 30.5],
      [1470, 27.5],
      [1467, 36.5],
      [1464, 40.5],
      [1461, 39.5],
      [1458, 23.5],
      [1455, 28.5],
      [1452, 33.5],
      [1449, 42.5],
      [1446, 39.5],
      [1443, 25.5],
      [1440, 22.5],
      [1437, 46.5],
      [1434, 29.5],
      [1431, 37.5],
      [1428, 37.5],
      [1425, 26.5],
      [1422, 47.5],
      [1419, 38.5],
      [1416, 46.5],
      [1413, 31.5],
      [1410, 43.5],
      [1407, 41.5],
      [1404, 46.5],
      [1401, 44.5],
      [1398, 26.5],
      [1395, 20.5],
      [1392, 45.5],
      [1389, 37.5],
      [1386, 43.5],
      [1383, 33.5],
      [1380, 28.5],
      [1377, 48.5],
      [1374, 50.5],
      [1371, 42.5],
      [1368, 43.5],
      [1365, 34.5],
      [1362, 41.5],
      [1359, 37.5],
      [1356, 26.5],
      [1353, 22.5],
      [1350, 39.5],
      [1347, 51.5],
      [1344, 39.5],
      [1341, 42.5],
      [1338, 24.5],
      [1335, 23.5],
      [1332, 50.5],
      [1329, 18.5],
      [1326, 45.5],
      [1323, 27.5],
      [1320, 21.5],
      [1317, 48.5],
      [1314, 39.5],
      [1311, 42.5],
      [1308, 27.5],
      [1305, 24.5],
      [1302, 41.5],
      [1299, 41.5],
      [1296, 39.5],
      [1293, 26.5],
      [1290, 39.5],
      [1287, 57.5],
      [1284, 34.5],
      [1281, 33.5],
      [1278, 21.5],
      [1275, 27.5],
      [1272, 42.5],
      [1269, 24.5],
      [1266, 41.5],
      [1263, 27.5],
      [1260, 27.5],
      [1257, 45.5],
      [1254, 37.5],
      [1251, 48.5],
      [1248, 22.5],
      [1245, 20.5],
      [1242, 26.5],
      [1239, 37.5],
      [1236, 42.5],
      [1233, 39.5],
      [1230, 20.5],
      [1227, 49.5],
      [1224, 30.5],
      [1221, 43.5],
      [1218, 21.5],
      [1215, 27.5],
      [1212, 55.5],
      [1209, 25.5],
      [1206, 48.5],
      [1203, 31.5],
      [1200, 27.5],
      [1197, 45.5],
      [1194, 40.5],
      [1191, 44.5],
      [1188, 42.5],
      [1185, 22.5],
      [1182, 40.5],
      [1179, 44.5],
      [1176, 45.5],
      [1173, 32.5],
      [1170, 45.5],
      [1167, 48.5],
      [1164, 28.5],
      [1161, 30.5],
      [1158, 25.5],
      [1155, 22.5],
      [1152, 52.5],
      [1149, 37.5],
      [1146, 36.5],
      [1143, 30.5],
      [1140, 29.5],
      [1137, 51.5],
      [1134, 41.5],
      [1131, 50.5],
      [1128, 31.5],
      [1125, 22.5],
      [1122, 45.5],
      [1119, 31.5],
      [1116, 37.5],
      [1113, 25.5],
      [1110, 19.5],
      [1107, 49.5],
      [1104, 35.5],
      [1101, 40.5],
      [1098, 21.5],
      [1095, 23.5],
      [1092, 50.5],
      [1089, 27.5],
      [1086, 35.5],
      [1083, 16.5],
      [1080, 16.5],
      [1077, 47.5],
      [1074, 40.5],
      [1071, 52.5],
      [1068, 20.5],
      [1065, 24.5],
      [1062, 34.5],
      [1059, 31.5],
      [1056, 38.5],
      [1053, 23.5],
      [1050, 48.5],
      [1047, 57.5],
      [1044, 49.5],
      [1041, 43.5],
      [1038, 23.5],
      [1035, 25.5],
      [1032, 33.5],
      [1029, 28.5],
      [1026, 34.5],
      [1023, 21.5],
      [1020, 22.5],
      [1017, 35.5],
      [1014, 23.5],
      [1011, 24.5],
      [1008, 30.5],
      [1005, 20.5],
      [1002, 30.5],
      [999, 44.5],
      [996, 36.5],
      [993, 41.5],
      [990, 28.5],
      [987, 31.5],
      [984, 25.5],
      [981, 38.5],
      [978, 37.5],
      [975, 30.5],
      [972, 37.5],
      [969, 20.5],
      [966, 29.5],
      [963, 31.5],
      [960, 18.5],
      [957, 38.5],
      [954, 26.5],
      [951, 43.5],
      [948, 33.5],
      [945, 24.5],
      [942, 40.5],
      [939, 26.5],
      [936, 33.5],
      [933, 23.5],
      [930, 18.5],
      [927, 34.5],
      [924, 30.5],
      [921, 20.5],
      [918, 40.5],
      [915, 26.5],
      [912, 25.5],
      [909, 32.5],
      [906, 34.5],
      [903, 26.5],
      [900, 18.5],
      [897, 37.5],
      [894, 31.5],
      [891, 32.5],
      [888, 37.5],
      [885, 21.5],
      [882, 21.5],
      [879, 41.5],
      [876, 17.5],
      [873, 33.5],
      [870, 21.5],
      [867, 35.5],
      [864, 28.5],
      [861, 35.5],
      [858, 31.5],
      [855, 15.5],
      [852, 41.5],
      [849, 23.5],
      [846, 35.5],
      [843, 32.5],
      [840, 16.5],
      [837, 46.5],
      [834, 42.5],
      [831, 51.5],
      [828, 28.5],
      [825, 27.5],
      [822, 28.5],
      [819, 38.5],
      [816, 31.5],
      [813, 14.5],
      [810, 42.5],
      [807, 48.5],
      [804, 24.5],
      [801, 45.5],
      [798, 22.5],
      [795, 25.5],
      [792, 55.5],
      [789, 34.5],
      [786, 29.5],
      [783, 25.5],
      [780, 22.5],
      [777, 41.5],
      [774, 27.5],
      [771, 49.5],
      [768, 47.5],
      [765, 15.5],
      [762, 31.5],
      [759, 29.5],
      [756, 25.5],
      [753, 31.5],
      [750, 26.5],
      [747, 41.5],
      [744, 30.5],
      [741, 27.5],
      [738, 49.5],
      [735, 36.5],
      [732, 33.5],
      [729, 45.5],
      [726, 24.5],
      [723, 19.5],
      [720, 28.5],
      [717, 45.5],
      [714, 35.5],
      [711, 49.5],
      [708, 30.5],
      [705, 38.5],
      [702, 35.5],
      [699, 30.5],
      [696, 32.5],
      [693, 22.5],
      [690, 17.5],
      [687, 32.5],
      [684, 29.5],
      [681, 30.5],
      [678, 42.5],
      [675, 31.5],
      [672, 29.5],
      [669, 34.5],
      [666, 22.5],
      [663, 24.5],
      [660, 30.5],
      [657, 37.5],
      [654, 34.5],
      [651, 39.5],
      [648, 23.5],
      [645, 29.5],
      [642, 45.5],
      [639, 22.5],
      [636, 23.5],
      [633, 21.5],
      [630, 29.5],
      [627, 46.5],
      [624, 28.5],
      [621, 39.5],
      [618, 19.5],
      [615, 13.5],
      [612, 52.5],
      [609, 18.5],
      [606, 44.5],
      [603, 23.5],
      [600, 22.5],
      [597, 42.5],
      [594, 38.5],
      [591, 48.5],
      [588, 29.5],
      [585, 20.5],
      [582, 26.5],
      [579, 28.5],
      [576, 37.5],
      [573, 21.5],
      [570, 36.5],
      [567, 49.5],
      [564, 31.5],
      [561, 30.5],
      [558, 18.5],
      [555, 13.5],
      [552, 57.5],
      [549, 16.5],
      [546, 36.5],
      [543, 13.5],
      [540, 22.5],
      [537, 42.5],
      [534, 44.5],
      [531, 49.5],
      [528, 26.5],
      [525, 22.5],
      [522, 29.5],
      [519, 32.5],
      [516, 28.5],
      [513, 19.5],
      [510, 29.5],
      [507, 47.5],
      [504, 28.5],
      [501, 32.5],
      [498, 17.5],
      [495, 19.5],
      [492, 51.5],
      [489, 16.5],
      [486, 39.5],
      [483, 22.5],
      [480, 14.5],
      [477, 29.5],
      [474, 36.5],
      [471, 29.5],
      [468, 15.5],
      [465, 19.5],
      [462, 31.5],
      [459, 26.5],
      [456, 24.5],
      [453, 20.5],
      [450, 14.5],
      [447, 18.5],
      [444, 34.5],
      [441, 34.5],
      [438, 22.5],
      [435, 24.5],
      [432, 24.5],
      [429, 34.5],
      [426, 9.5],
      [423, 36.5],
      [420, 17.5],
      [417, 35.5],
      [414, 30.5],
      [411, 25.5],
      [408, 37.5],
      [405, 21.5],
      [402, 37.5],
      [399, 15.5],
      [396, 22.5],
      [393, 15.5],
      [390, 13.5],
      [387, 30.5],
      [384, 26.5],
      [381, 33.5],
      [378, 9.5],
      [375, 15.5],
      [372, 26.5],
      [369, 41.5],
      [366, 39.5],
      [363, 51.5],
      [360, 13.5],
      [357, 34.5],
      [354, 22.5],
      [351, 35.5],
      [348, 9.5],
      [345, 14.5],
      [342, 29.5],
      [339, 28.5],
      [336, 21.5],
      [333, 17.5],
      [330, 17.5],
      [327, 37.5],
      [324, 43.5],
      [321, 25.5],
      [318, 10.5],
      [315, 23.5],
      [312, 51.5],
      [309, 21.5],
      [306, 36.5],
      [303, 12.5],
      [300, 11.5],
      [297, 46.5],
      [294, 28.5],
      [291, 41.5],
      [288, 16.5],
      [285, 29.5],
      [282, 32.5],
      [279, 32.5],
      [276, 36.5],
      [273, 28.5],
      [270, 10.5],
      [267, 47.5],
      [264, 35.5],
      [261, 32.5],
      [258, 9.5],
      [255, 12.5],
      [252, 43.5],
      [249, 14.5],
      [246, 27.5],
      [243, 33.5],
      [240, 19.5],
      [237, 28.5],
      [234, 32.5],
      [231, 38.5],
      [228, 23.5],
      [225, 19.5],
      [222, 22.5],
      [219, 32.5],
      [216, 37.5],
      [213, 15.5],
      [210, 37.5],
      [207, 52.5],
      [204, 26.5],
      [201, 32.5],
      [198, 20.5],
      [195, 20.5],
      [192, 31.5],
      [189, 42.5],
      [186, 42.5],
      [183, 18.5],
      [180, 7.5],
      [177, 41.5],
      [174, 25.5],
      [171, 40.5],
      [168, 29.5],
      [165, 18.5],
      [162, 36.5],
      [159, 28.5],
      [156, 23.5],
      [153, 26.5],
      [150, 6.5],
      [147, 27.5],
      [144, 23.5],
      [141, 31.5],
      [138, 24.5],
      [135, 18.5],
      [132, 57.5],
      [129, 25.5],
      [126, 10.5],
      [123, 28.5],
      [120, 27.5],
      [117, 45.5],
      [114, 42.5],
      [111, 48.5],
      [108, 57.5],
      [105, 29.5],
      [102, 17.5],
      [99, 28.5],
      [96, 36.5],
      [93, 21.5],
      [90, 31.5],
      [87, 34.5],
      [84, 33.5],
      [81, 25.5],
      [78, 25.5],
      [75, 9.5],
      [72, 55.5],
      [69, 22.5],
      [66, 25.5],
      [63, 32.5],
      [60, 9.5],
      [57, 28.5],
      [54, 31.5],
      [51, 43.5],
      [48, 58.5],
      [45, 25.5],
      [42, 19.5],
      [39, 27.5],
      [36, 25.5],
      [33, 11.5],
      [30, 18.5],
      [27, 33.5],
      [24, 19.5],
      [21, 22.5],
      [18, 6.5],
      [15, 7.301600000000008],
      [12, 46.5],
      [9, 2.950400000000002],
      [6, 10.5],
      [3, 15.5],
      [0, 42.5],
    ],
  },
  {
    top: [
      [2, 133.5],
      [5, 144.5],
      [8, 107.5],
      [11, 108.5],
      [14, 133.5],
      [17, 113.5],
      [20, 143.6984],
      [23, 121.5],
      [26, 137.5],
      [29, 143.5],
      [32, 106.5],
      [35, 133.5],
      [38, 144.4976],
      [41, 126.5],
      [44, 144.875],
      [47, 110.5],
      [50, 139.5],
      [53, 136.5],
      [56, 137.5],
      [59, 133.5],
      [62, 134.5],
      [65, 130.5],
      [68, 108.5],
      [71, 118.5],
      [74, 131.5],
      [77, 129.5],
      [80, 132.5],
      [83, 118.5],
      [86, 134.5],
      [89, 132.5],
      [92, 104.5],
      [95, 126.5],
      [98, 135.5],
      [101, 128.5],
      [104, 123.5],
      [107, 113.5],
      [110, 118.5],
      [113, 136.5],
      [116, 123.5],
      [119, 134.5],
      [122, 127.5],
      [125, 132.5],
      [128, 104.5],
      [131, 108.5],
      [134, 117.5],
      [137, 111.5],
      [140, 143.6984],
      [143, 119.5],
      [146, 126.5],
      [149, 143.5],
      [152, 111.5],
      [155, 122.5],
      [158, 136.5],
      [161, 119.5],
      [164, 127.5],
      [167, 98.5],
      [170, 123.5],
      [173, 144.5],
      [176, 123.5],
      [179, 135.5],
      [182, 114.5],
      [185, 122.5],
      [188, 139.5],
      [191, 107.5],
      [194, 105.5],
      [197, 98.5],
      [200, 125.5],
      [203, 116.5],
      [206, 111.5],
      [209, 135.5],
      [212, 101.5],
      [215, 129.5],
      [218, 143.2766],
      [221, 117.5],
      [224, 128.5],
      [227, 122.5],
      [230, 128.5],
      [233, 132.5],
      [236, 109.5],
      [239, 120.5],
      [242, 129.5],
      [245, 130.5],
      [248, 145.5],
      [251, 117.5],
      [254, 108.5],
      [257, 111.5],
      [260, 138.5],
      [263, 133.5],
      [266, 110.5],
      [269, 113.5],
      [272, 112.5],
      [275, 139.5],
      [278, 139.5],
      [281, 118.5],
      [284, 113.5],
      [287, 112.5],
      [290, 108.5],
      [293, 136.5],
      [296, 121.5],
      [299, 109.5],
      [302, 122.5],
      [305, 131.5],
      [308, 132.5],
      [311, 105.5],
      [314, 118.5],
      [317, 112.5],
      [320, 129.5],
      [323, 118.5],
      [326, 116.5],
      [329, 120.5],
      [332, 113.5],
      [335, 137.5],
      [338, 129.5],
      [341, 121.5],
      [344, 110.5],
      [347, 106.5],
      [350, 141.5],
      [353, 125.5],
      [356, 110.5],
      [359, 110.5],
      [362, 110.5],
      [365, 129.5],
      [368, 92.5],
      [371, 112.5],
      [374, 123.5],
      [377, 126.5],
      [380, 132.5],
      [383, 118.5],
      [386, 120.5],
      [389, 121.5],
      [392, 111.5],
      [395, 131.5],
      [398, 132.5],
      [401, 107.5],
      [404, 103.5],
      [407, 109.5],
      [410, 126.5],
      [413, 122.5],
      [416, 125.5],
      [419, 108.5],
      [422, 114.5],
      [425, 128.5],
      [428, 130.5],
      [431, 115.5],
      [434, 121.5],
      [437, 116.5],
      [440, 123.5],
      [443, 121.5],
      [446, 134.5],
      [449, 119.5],
      [452, 105.5],
      [455, 141.5],
      [458, 134.5],
      [461, 116.5],
      [464, 105.5],
      [467, 111.5],
      [470, 128.5],
      [473, 137.5],
      [476, 108.5],
      [479, 135.5],
      [482, 111.5],
      [485, 130.5],
      [488, 129.5],
      [491, 108.5],
      [494, 117.5],
      [497, 108.5],
      [500, 134.5],
      [503, 127.5],
      [506, 112.5],
      [509, 115.5],
      [512, 99.5],
      [515, 129.5],
      [518, 137.5],
      [521, 112.5],
      [524, 116.5],
      [527, 106.5],
      [530, 115.5],
      [533, 140.5],
      [536, 122.5],
      [539, 120.5],
      [542, 124.5],
      [545, 123.5],
      [548, 115.5],
      [551, 108.5],
      [554, 110.5],
      [557, 125.5],
      [560, 123.5],
      [563, 135.5],
      [566, 118.5],
      [569, 133.5],
      [572, 104.5],
      [575, 139.5],
      [578, 136.5],
      [581, 119.5],
      [584, 113.5],
      [587, 112.5],
      [590, 131.5],
      [593, 124.5],
      [596, 123.5],
      [599, 119.5],
      [602, 121.5],
      [605, 127.5],
      [608, 120.5],
      [611, 104.5],
      [614, 121.5],
      [617, 103.5],
      [620, 132.5],
      [623, 131.5],
      [626, 113.5],
      [629, 137.5],
      [632, 104.5],
      [635, 129.5],
      [638, 130.5],
      [641, 118.5],
      [644, 124.5],
      [647, 113.5],
      [650, 128.5],
      [653, 126.5],
      [656, 109.5],
      [659, 112.5],
      [662, 129.5],
      [665, 117.5],
      [668, 123.5],
      [671, 128.5],
      [674, 115.5],
      [677, 115.5],
      [680, 130.5],
      [683, 118.5],
      [686, 122.5],
      [689, 131.5],
      [692, 123.5],
      [695, 126.5],
      [698, 121.5],
      [701, 121.5],
      [704, 119.5],
      [707, 94.5],
      [710, 113.5],
      [713, 120.5],
      [716, 105.5],
      [719, 123.5],
      [722, 114.5],
      [725, 120.5],
      [728, 125.5],
      [731, 119.5],
      [734, 115.5],
      [737, 115.5],
      [740, 124.5],
      [743, 124.5],
      [746, 124.5],
      [749, 114.5],
      [752, 117.5],
      [755, 124.5],
      [758, 117.5],
      [761, 124.5],
      [764, 114.5],
      [767, 99.5],
      [770, 132.5],
      [773, 129.5],
      [776, 110.5],
      [779, 118.5],
      [782, 116.5],
      [785, 115.5],
      [788, 101.5],
      [791, 103.5],
      [794, 119.5],
      [797, 110.5],
      [800, 125.5],
      [803, 133.5],
      [806, 113.5],
      [809, 128.5],
      [812, 99.5],
      [815, 119.5],
      [818, 135.5],
      [821, 108.5],
      [824, 122.5],
      [827, 108.5],
      [830, 125.5],
      [833, 121.5],
      [836, 116.5],
      [839, 106.5],
      [842, 127.5],
      [845, 127.5],
      [848, 122.5],
      [851, 119.5],
      [854, 110.5],
      [857, 102.5],
      [860, 129.5],
      [863, 133.5],
      [866, 122.5],
      [869, 120.5],
      [872, 104.5],
      [875, 133.5],
      [878, 119.5],
      [881, 128.5],
      [884, 122.5],
      [887, 124.5],
      [890, 134.5],
      [893, 116.5],
      [896, 119.5],
      [899, 121.5],
      [902, 120.5],
      [905, 120.5],
      [908, 120.5],
      [911, 119.5],
      [914, 112.5],
      [917, 122.5],
      [920, 133.5],
      [923, 117.5],
      [926, 128.5],
      [929, 125.5],
      [932, 113.5],
      [935, 119.5],
      [938, 111.5],
      [941, 121.5],
      [944, 118.5],
      [947, 110.5],
      [950, 129.5],
      [953, 116.5],
      [956, 117.5],
      [959, 111.5],
      [962, 113.5],
      [965, 124.5],
      [968, 114.5],
      [971, 112.5],
      [974, 122.5],
      [977, 104.5],
      [980, 121.5],
      [983, 117.5],
      [986, 104.5],
      [989, 113.5],
      [992, 111.5],
      [995, 108.5],
      [998, 107.5],
      [1001, 117.5],
      [1004, 116.5],
      [1007, 113.5],
      [1010, 134.5],
      [1013, 125.5],
      [1016, 126.5],
      [1019, 130.5],
      [1022, 114.5],
      [1025, 123.5],
      [1028, 114.5],
      [1031, 108.5],
      [1034, 105.5],
      [1037, 106.5],
      [1040, 129.5],
      [1043, 114.5],
      [1046, 107.5],
      [1049, 130.5],
      [1052, 103.5],
      [1055, 128.5],
      [1058, 129.5],
      [1061, 104.5],
      [1064, 120.5],
      [1067, 107.5],
      [1070, 131.5],
      [1073, 126.5],
      [1076, 106.5],
      [1079, 116.5],
      [1082, 123.5],
      [1085, 127.5],
      [1088, 120.5],
      [1091, 106.5],
      [1094, 111.5],
      [1097, 105.5],
      [1100, 122.5],
      [1103, 123.5],
      [1106, 115.5],
      [1109, 122.5],
      [1112, 103.5],
      [1115, 130.5],
      [1118, 132.5],
      [1121, 108.5],
      [1124, 113.5],
      [1127, 103.5],
      [1130, 118.5],
      [1133, 134.5],
      [1136, 121.5],
      [1139, 110.5],
      [1142, 119.5],
      [1145, 119.5],
      [1148, 129.5],
      [1151, 102.5],
      [1154, 111.5],
      [1157, 111.5],
      [1160, 129.5],
      [1163, 118.5],
      [1166, 119.5],
      [1169, 121.5],
      [1172, 100.5],
      [1175, 126.5],
      [1178, 124.5],
      [1181, 103.5],
      [1184, 113.5],
      [1187, 97.5],
      [1190, 114.5],
      [1193, 121.5],
      [1196, 121.5],
      [1199, 125.5],
      [1202, 106.5],
      [1205, 129.5],
      [1208, 124.5],
      [1211, 100.5],
      [1214, 111.5],
      [1217, 102.5],
      [1220, 112.5],
      [1223, 111.5],
      [1226, 116.5],
      [1229, 104.5],
      [1232, 113.5],
      [1235, 120.5],
      [1238, 127.5],
      [1241, 111.5],
      [1244, 126.5],
      [1247, 99.5],
      [1250, 108.5],
      [1253, 128.5],
      [1256, 104.5],
      [1259, 107.5],
      [1262, 120.5],
      [1265, 126.5],
      [1268, 124.5],
      [1271, 120.5],
      [1274, 120.5],
      [1277, 117.5],
      [1280, 126.5],
      [1283, 129.5],
      [1286, 122.5],
      [1289, 125.5],
      [1292, 98.5],
      [1295, 118.5],
      [1298, 118.5],
      [1301, 108.5],
      [1304, 121.5],
      [1307, 107.5],
      [1310, 127.5],
      [1313, 123.5],
      [1316, 120.5],
      [1319, 106.5],
      [1322, 120.5],
      [1325, 124.5],
      [1328, 125.5],
      [1331, 102.5],
      [1334, 107.5],
      [1337, 98.5],
      [1340, 117.5],
      [1343, 123.5],
      [1346, 100.5],
      [1349, 122.5],
      [1352, 100.5],
      [1355, 130.5],
      [1358, 122.5],
      [1361, 114.5],
      [1364, 113.5],
      [1367, 108.5],
      [1370, 106.5],
      [1373, 123.5],
      [1376, 103.5],
      [1379, 100.5],
      [1382, 112.5],
      [1385, 116.5],
      [1388, 122.5],
      [1391, 107.5],
      [1394, 117.5],
      [1397, 108.5],
      [1400, 125.5],
      [1403, 122.5],
      [1406, 109.5],
      [1409, 124.5],
      [1412, 93.5],
      [1415, 111.5],
      [1418, 120.5],
      [1421, 109.5],
      [1424, 109.5],
      [1427, 98.5],
      [1430, 124.5],
      [1433, 124.5],
      [1436, 123.5],
      [1439, 109.5],
      [1442, 111.5],
      [1445, 122.5],
      [1448, 122.5],
      [1451, 116.5],
      [1454, 113.5],
      [1457, 112.5],
      [1460, 129.5],
      [1463, 125.5],
      [1466, 114.5],
      [1469, 103.5],
      [1472, 107.5],
      [1475, 121.5],
      [1478, 128.5],
      [1481, 109.5],
      [1484, 120.5],
      [1487, 115.5],
      [1490, 107.5],
      [1493, 122.5],
      [1496, 107.5],
      [1499, 105.5],
      [1502, 102.5],
      [1505, 124.5],
      [1508, 115.5],
      [1511, 122.5],
      [1514, 112.5],
      [1517, 104.5],
      [1520, 107.5],
      [1523, 97.5],
      [1526, 95.5],
      [1529, 85.5],
      [1532, 85.5],
      [1535, 79.5],
      [1538, 76.5],
      [1541, 75.5],
      [1544, 75.5],
      [1547, 75.5],
      [1550, 75.5],
    ],
    bottom: [
      [1548, 75.5],
      [1545, 74.5],
      [1542, 75.5],
      [1539, 74.5],
      [1536, 73.5],
      [1533, 67.5],
      [1530, 62.5],
      [1527, 58.5],
      [1524, 49.5],
      [1521, 41.5],
      [1518, 28.5],
      [1515, 29.5],
      [1512, 36.5],
      [1509, 36.5],
      [1506, 31.5],
      [1503, 33.5],
      [1500, 26.5],
      [1497, 40.5],
      [1494, 46.5],
      [1491, 34.5],
      [1488, 25.5],
      [1485, 26.5],
      [1482, 43.5],
      [1479, 30.5],
      [1476, 37.5],
      [1473, 30.5],
      [1470, 28.5],
      [1467, 37.5],
      [1464, 37.5],
      [1461, 38.5],
      [1458, 24.5],
      [1455, 31.5],
      [1452, 33.5],
      [1449, 42.5],
      [1446, 38.5],
      [1443, 26.5],
      [1440, 25.5],
      [1437, 46.5],
      [1434, 29.5],
      [1431, 37.5],
      [1428, 39.5],
      [1425, 29.5],
      [1422, 49.5],
      [1419, 38.5],
      [1416, 47.5],
      [1413, 30.5],
      [1410, 42.5],
      [1407, 41.5],
      [1404, 45.5],
      [1401, 43.5],
      [1398, 26.5],
      [1395, 22.5],
      [1392, 47.5],
      [1389, 40.5],
      [1386, 45.5],
      [1383, 35.5],
      [1380, 29.5],
      [1377, 49.5],
      [1374, 52.5],
      [1371, 42.5],
      [1368, 43.5],
      [1365, 31.5],
      [1362, 41.5],
      [1359, 38.5],
      [1356, 27.5],
      [1353, 24.5],
      [1350, 38.5],
      [1347, 52.5],
      [1344, 40.5],
      [1341, 42.5],
      [1338, 25.5],
      [1335, 24.5],
      [1332, 49.5],
      [1329, 19.5],
      [1326, 46.5],
      [1323, 28.5],
      [1320, 24.5],
      [1317, 48.5],
      [1314, 37.5],
      [1311, 41.5],
      [1308, 28.5],
      [1305, 24.5],
      [1302, 41.5],
      [1299, 44.5],
      [1296, 37.5],
      [1293, 26.5],
      [1290, 39.5],
      [1287, 54.5],
      [1284, 34.5],
      [1281, 33.5],
      [1278, 23.5],
      [1275, 30.5],
      [1272, 42.5],
      [1269, 25.5],
      [1266, 39.5],
      [1263, 26.5],
      [1260, 27.5],
      [1257, 44.5],
      [1254, 38.5],
      [1251, 48.5],
      [1248, 22.5],
      [1245, 20.5],
      [1242, 27.5],
      [1239, 37.5],
      [1236, 42.5],
      [1233, 38.5],
      [1230, 22.5],
      [1227, 49.5],
      [1224, 33.5],
      [1221, 44.5],
      [1218, 23.5],
      [1215, 25.5],
      [1212, 55.5],
      [1209, 24.5],
      [1206, 47.5],
      [1203, 33.5],
      [1200, 29.5],
      [1197, 47.5],
      [1194, 42.5],
      [1191, 46.5],
      [1188, 43.5],
      [1185, 25.5],
      [1182, 42.5],
      [1179, 45.5],
      [1176, 46.5],
      [1173, 33.5],
      [1170, 46.5],
      [1167, 47.5],
      [1164, 29.5],
      [1161, 32.5],
      [1158, 26.5],
      [1155, 24.5],
      [1152, 52.5],
      [1149, 39.5],
      [1146, 37.5],
      [1143, 30.5],
      [1140, 26.5],
      [1137, 51.5],
      [1134, 42.5],
      [1131, 50.5],
      [1128, 31.5],
      [1125, 21.5],
      [1122, 44.5],
      [1119, 32.5],
      [1116, 38.5],
      [1113, 26.5],
      [1110, 22.5],
      [1107, 50.5],
      [1104, 35.5],
      [1101, 39.5],
      [1098, 22.5],
      [1095, 21.5],
      [1092, 49.5],
      [1089, 26.5],
      [1086, 36.5],
      [1083, 18.5],
      [1080, 18.5],
      [1077, 46.5],
      [1074, 40.5],
      [1071, 52.5],
      [1068, 20.5],
      [1065, 24.5],
      [1062, 36.5],
      [1059, 32.5],
      [1056, 38.5],
      [1053, 20.5],
      [1050, 47.5],
      [1047, 57.5],
      [1044, 46.5],
      [1041, 44.5],
      [1038, 22.5],
      [1035, 28.5],
      [1032, 34.5],
      [1029, 30.5],
      [1026, 35.5],
      [1023, 22.5],
      [1020, 21.5],
      [1017, 36.5],
      [1014, 24.5],
      [1011, 24.5],
      [1008, 30.5],
      [1005, 22.5],
      [1002, 32.5],
      [999, 45.5],
      [996, 38.5],
      [993, 44.5],
      [990, 29.5],
      [987, 33.5],
      [984, 27.5],
      [981, 40.5],
      [978, 37.5],
      [975, 29.5],
      [972, 37.5],
      [969, 19.5],
      [966, 31.5],
      [963, 33.5],
      [960, 21.5],
      [957, 38.5],
      [954, 27.5],
      [951, 42.5],
      [948, 33.5],
      [945, 26.5],
      [942, 41.5],
      [939, 29.5],
      [936, 34.5],
      [933, 24.5],
      [930, 15.5],
      [927, 35.5],
      [924, 31.5],
      [921, 21.5],
      [918, 40.5],
      [915, 28.5],
      [912, 26.5],
      [909, 34.5],
      [906, 35.5],
      [903, 26.5],
      [900, 17.5],
      [897, 38.5],
      [894, 29.5],
      [891, 35.5],
      [888, 36.5],
      [885, 21.5],
      [882, 21.5],
      [879, 41.5],
      [876, 19.5],
      [873, 33.5],
      [870, 24.5],
      [867, 34.5],
      [864, 29.5],
      [861, 37.5],
      [858, 34.5],
      [855, 15.5],
      [852, 41.5],
      [849, 22.5],
      [846, 36.5],
      [843, 31.5],
      [840, 18.5],
      [837, 47.5],
      [834, 42.5],
      [831, 52.5],
      [828, 29.5],
      [825, 28.5],
      [822, 28.5],
      [819, 39.5],
      [816, 32.5],
      [813, 15.5],
      [810, 42.5],
      [807, 48.5],
      [804, 26.5],
      [801, 46.5],
      [798, 24.5],
      [795, 27.5],
      [792, 56.5],
      [789, 37.5],
      [786, 30.5],
      [783, 26.5],
      [780, 24.5],
      [777, 42.5],
      [774, 27.5],
      [771, 49.5],
      [768, 49.5],
      [765, 15.5],
      [762, 32.5],
      [759, 32.5],
      [756, 25.5],
      [753, 33.5],
      [750, 27.5],
      [747, 42.5],
      [744, 31.5],
      [741, 28.5],
      [738, 49.5],
      [735, 37.5],
      [732, 33.5],
      [729, 45.5],
      [726, 24.5],
      [723, 19.5],
      [720, 27.5],
      [717, 45.5],
      [714, 36.5],
      [711, 51.5],
      [708, 32.5],
      [705, 39.5],
      [702, 36.5],
      [699, 31.5],
      [696, 34.5],
      [693, 22.5],
      [690, 20.5],
      [687, 35.5],
      [684, 32.5],
      [681, 31.5],
      [678, 42.5],
      [675, 30.5],
      [672, 28.5],
      [669, 35.5],
      [666, 22.5],
      [663, 27.5],
      [660, 30.5],
      [657, 38.5],
      [654, 34.5],
      [651, 38.5],
      [648, 25.5],
      [645, 29.5],
      [642, 45.5],
      [639, 23.5],
      [636, 26.5],
      [633, 23.5],
      [630, 30.5],
      [627, 47.5],
      [624, 30.5],
      [621, 40.5],
      [618, 22.5],
      [615, 13.5],
      [612, 52.5],
      [609, 19.5],
      [606, 45.5],
      [603, 24.5],
      [600, 22.5],
      [597, 42.5],
      [594, 39.5],
      [591, 48.5],
      [588, 30.5],
      [585, 23.5],
      [582, 29.5],
      [579, 31.5],
      [576, 37.5],
      [573, 21.5],
      [570, 35.5],
      [567, 51.5],
      [564, 34.5],
      [561, 32.5],
      [558, 21.5],
      [555, 15.5],
      [552, 57.5],
      [549, 16.5],
      [546, 36.5],
      [543, 12.5],
      [540, 25.5],
      [537, 43.5],
      [534, 44.5],
      [531, 50.5],
      [528, 26.5],
      [525, 21.5],
      [522, 28.5],
      [519, 30.5],
      [516, 30.5],
      [513, 20.5],
      [510, 31.5],
      [507, 48.5],
      [504, 30.5],
      [501, 33.5],
      [498, 14.5],
      [495, 23.5],
      [492, 51.5],
      [489, 18.5],
      [486, 40.5],
      [483, 26.5],
      [480, 16.5],
      [477, 30.5],
      [474, 35.5],
      [471, 29.5],
      [468, 15.5],
      [465, 21.5],
      [462, 33.5],
      [459, 26.5],
      [456, 25.5],
      [453, 20.5],
      [450, 13.5],
      [447, 20.5],
      [444, 35.5],
      [441, 34.5],
      [438, 25.5],
      [435, 26.5],
      [432, 24.5],
      [429, 35.5],
      [426, 10.5],
      [423, 38.5],
      [420, 16.5],
      [417, 33.5],
      [414, 31.5],
      [411, 29.5],
      [408, 39.5],
      [405, 21.5],
      [402, 39.5],
      [399, 16.5],
      [396, 25.5],
      [393, 18.5],
      [390, 16.5],
      [387, 29.5],
      [384, 28.5],
      [381, 35.5],
      [378, 8.5],
      [375, 14.5],
      [372, 26.5],
      [369, 42.5],
      [366, 40.5],
      [363, 51.5],
      [360, 15.5],
      [357, 35.5],
      [354, 25.5],
      [351, 36.5],
      [348, 8.5],
      [345, 16.5],
      [342, 31.5],
      [339, 29.5],
      [336, 19.5],
      [333, 19.5],
      [330, 20.5],
      [327, 37.5],
      [324, 41.5],
      [321, 25.5],
      [318, 11.5],
      [315, 25.5],
      [312, 51.5],
      [309, 24.5],
      [306, 37.5],
      [303, 15.5],
      [300, 13.5],
      [297, 45.5],
      [294, 29.5],
      [291, 41.5],
      [288, 21.5],
      [285, 32.5],
      [282, 34.5],
      [279, 35.5],
      [276, 36.5],
      [273, 27.5],
      [270, 14.5],
      [267, 46.5],
      [264, 35.5],
      [261, 34.5],
      [258, 9.5],
      [255, 15.5],
      [252, 44.5],
      [249, 12.5],
      [246, 28.5],
      [243, 35.5],
      [240, 18.5],
      [237, 29.5],
      [234, 35.5],
      [231, 40.5],
      [228, 26.5],
      [225, 17.5],
      [222, 21.5],
      [219, 31.5],
      [216, 38.5],
      [213, 16.5],
      [210, 38.5],
      [207, 53.5],
      [204, 28.5],
      [201, 33.5],
      [198, 21.5],
      [195, 22.5],
      [192, 34.5],
      [189, 44.5],
      [186, 42.5],
      [183, 20.5],
      [180, 8.5],
      [177, 41.5],
      [174, 23.5],
      [171, 40.5],
      [168, 29.5],
      [165, 21.5],
      [162, 36.5],
      [159, 29.5],
      [156, 25.5],
      [153, 28.5],
      [150, 6.5],
      [147, 27.5],
      [144, 27.5],
      [141, 33.5],
      [138, 23.5],
      [135, 18.5],
      [132, 57.5],
      [129, 27.5],
      [126, 10.5],
      [123, 28.5],
      [120, 27.5],
      [117, 45.5],
      [114, 43.5],
      [111, 49.5],
      [108, 57.5],
      [105, 30.5],
      [102, 19.5],
      [99, 25.5],
      [96, 37.5],
      [93, 25.5],
      [90, 33.5],
      [87, 35.5],
      [84, 36.5],
      [81, 26.5],
      [78, 28.5],
      [75, 10.5],
      [72, 56.5],
      [69, 22.5],
      [66, 28.5],
      [63, 35.5],
      [60, 9.5],
      [57, 31.5],
      [54, 33.5],
      [51, 43.5],
      [48, 58.5],
      [45, 25.5],
      [42, 22.5],
      [39, 26.5],
      [36, 25.5],
      [33, 15.5],
      [30, 20.5],
      [27, 35.5],
      [24, 20.5],
      [21, 23.5],
      [18, 9.5],
      [15, 7.301600000000008],
      [12, 46.5],
      [9, 3.164999999999992],
      [6, 11.5],
      [3, 15.5],
      [0, 43.5],
    ],
  },
  {
    top: [
      [2, 131.5],
      [5, 141.5],
      [8, 105.5],
      [11, 108.5],
      [14, 131.5],
      [17, 111.5],
      [20, 143.2766],
      [23, 118.5],
      [26, 135.5],
      [29, 141.5],
      [32, 104.5],
      [35, 130.5],
      [38, 144.1054],
      [41, 124.5],
      [44, 144.875],
      [47, 109.5],
      [50, 138.5],
      [53, 139.5],
      [56, 135.5],
      [59, 130.5],
      [62, 133.5],
      [65, 129.5],
      [68, 107.5],
      [71, 118.5],
      [74, 126.5],
      [77, 132.5],
      [80, 131.5],
      [83, 118.5],
      [86, 132.5],
      [89, 129.5],
      [92, 103.5],
      [95, 124.5],
      [98, 132.5],
      [101, 130.5],
      [104, 123.5],
      [107, 110.5],
      [110, 118.5],
      [113, 131.5],
      [116, 120.5],
      [119, 134.5],
      [122, 122.5],
      [125, 129.5],
      [128, 106.5],
      [131, 107.5],
      [134, 116.5],
      [137, 109.5],
      [140, 144.4976],
      [143, 120.5],
      [146, 123.5],
      [149, 140.5],
      [152, 113.5],
      [155, 124.5],
      [158, 134.5],
      [161, 116.5],
      [164, 128.5],
      [167, 97.5],
      [170, 121.5],
      [173, 139.5],
      [176, 122.5],
      [179, 135.5],
      [182, 119.5],
      [185, 120.5],
      [188, 134.5],
      [191, 106.5],
      [194, 106.5],
      [197, 97.5],
      [200, 124.5],
      [203, 114.5],
      [206, 109.5],
      [209, 137.5],
      [212, 102.5],
      [215, 126.5],
      [218, 142.5],
      [221, 121.5],
      [224, 125.5],
      [227, 122.5],
      [230, 131.5],
      [233, 130.5],
      [236, 107.5],
      [239, 119.5],
      [242, 130.5],
      [245, 125.5],
      [248, 140.5],
      [251, 115.5],
      [254, 111.5],
      [257, 109.5],
      [260, 139.5],
      [263, 135.5],
      [266, 110.5],
      [269, 113.5],
      [272, 109.5],
      [275, 136.5],
      [278, 142.5],
      [281, 122.5],
      [284, 113.5],
      [287, 110.5],
      [290, 107.5],
      [293, 132.5],
      [296, 118.5],
      [299, 109.5],
      [302, 124.5],
      [305, 137.5],
      [308, 135.5],
      [311, 103.5],
      [314, 117.5],
      [317, 110.5],
      [320, 124.5],
      [323, 114.5],
      [326, 116.5],
      [329, 123.5],
      [332, 116.5],
      [335, 133.5],
      [338, 127.5],
      [341, 124.5],
      [344, 108.5],
      [347, 104.5],
      [350, 136.5],
      [353, 125.5],
      [356, 112.5],
      [359, 112.5],
      [362, 109.5],
      [365, 127.5],
      [368, 91.5],
      [371, 109.5],
      [374, 120.5],
      [377, 124.5],
      [380, 132.5],
      [383, 118.5],
      [386, 117.5],
      [389, 119.5],
      [392, 109.5],
      [395, 128.5],
      [398, 128.5],
      [401, 105.5],
      [404, 101.5],
      [407, 107.5],
      [410, 124.5],
      [413, 121.5],
      [416, 121.5],
      [419, 108.5],
      [422, 118.5],
      [425, 126.5],
      [428, 128.5],
      [431, 114.5],
      [434, 122.5],
      [437, 116.5],
      [440, 123.5],
      [443, 117.5],
      [446, 129.5],
      [449, 115.5],
      [452, 104.5],
      [455, 139.5],
      [458, 132.5],
      [461, 119.5],
      [464, 106.5],
      [467, 107.5],
      [470, 124.5],
      [473, 132.5],
      [476, 107.5],
      [479, 136.5],
      [482, 115.5],
      [485, 134.5],
      [488, 129.5],
      [491, 105.5],
      [494, 114.5],
      [497, 106.5],
      [500, 132.5],
      [503, 127.5],
      [506, 114.5],
      [509, 119.5],
      [512, 100.5],
      [515, 125.5],
      [518, 132.5],
      [521, 108.5],
      [524, 113.5],
      [527, 106.5],
      [530, 114.5],
      [533, 139.5],
      [536, 123.5],
      [539, 120.5],
      [542, 125.5],
      [545, 121.5],
      [548, 111.5],
      [551, 106.5],
      [554, 109.5],
      [557, 126.5],
      [560, 126.5],
      [563, 134.5],
      [566, 116.5],
      [569, 127.5],
      [572, 101.5],
      [575, 133.5],
      [578, 134.5],
      [581, 122.5],
      [584, 117.5],
      [587, 111.5],
      [590, 127.5],
      [593, 118.5],
      [596, 117.5],
      [599, 115.5],
      [602, 117.5],
      [605, 123.5],
      [608, 116.5],
      [611, 101.5],
      [614, 117.5],
      [617, 102.5],
      [620, 134.5],
      [623, 136.5],
      [626, 112.5],
      [629, 132.5],
      [632, 102.5],
      [635, 127.5],
      [638, 129.5],
      [641, 114.5],
      [644, 119.5],
      [647, 109.5],
      [650, 123.5],
      [653, 122.5],
      [656, 108.5],
      [659, 112.5],
      [662, 127.5],
      [665, 117.5],
      [668, 119.5],
      [671, 123.5],
      [674, 112.5],
      [677, 114.5],
      [680, 129.5],
      [683, 117.5],
      [686, 124.5],
      [689, 132.5],
      [692, 119.5],
      [695, 122.5],
      [698, 119.5],
      [701, 121.5],
      [704, 122.5],
      [707, 95.5],
      [710, 113.5],
      [713, 118.5],
      [716, 105.5],
      [719, 119.5],
      [722, 110.5],
      [725, 116.5],
      [728, 121.5],
      [731, 117.5],
      [734, 114.5],
      [737, 116.5],
      [740, 124.5],
      [743, 123.5],
      [746, 125.5],
      [749, 112.5],
      [752, 115.5],
      [755, 122.5],
      [758, 119.5],
      [761, 125.5],
      [764, 112.5],
      [767, 99.5],
      [770, 127.5],
      [773, 124.5],
      [776, 108.5],
      [779, 118.5],
      [782, 119.5],
      [785, 116.5],
      [788, 103.5],
      [791, 101.5],
      [794, 116.5],
      [797, 107.5],
      [800, 121.5],
      [803, 127.5],
      [806, 109.5],
      [809, 121.5],
      [812, 96.5],
      [815, 117.5],
      [818, 134.5],
      [821, 109.5],
      [824, 123.5],
      [827, 108.5],
      [830, 122.5],
      [833, 120.5],
      [836, 115.5],
      [839, 105.5],
      [842, 125.5],
      [845, 122.5],
      [848, 117.5],
      [851, 116.5],
      [854, 109.5],
      [857, 102.5],
      [860, 129.5],
      [863, 136.5],
      [866, 125.5],
      [869, 120.5],
      [872, 102.5],
      [875, 129.5],
      [878, 117.5],
      [881, 127.5],
      [884, 119.5],
      [887, 122.5],
      [890, 133.5],
      [893, 116.5],
      [896, 119.5],
      [899, 121.5],
      [902, 120.5],
      [905, 121.5],
      [908, 123.5],
      [911, 119.5],
      [914, 111.5],
      [917, 120.5],
      [920, 132.5],
      [923, 114.5],
      [926, 123.5],
      [929, 121.5],
      [932, 111.5],
      [935, 119.5],
      [938, 112.5],
      [941, 124.5],
      [944, 117.5],
      [947, 110.5],
      [950, 126.5],
      [953, 113.5],
      [956, 117.5],
      [959, 110.5],
      [962, 113.5],
      [965, 122.5],
      [968, 110.5],
      [971, 112.5],
      [974, 119.5],
      [977, 104.5],
      [980, 126.5],
      [983, 122.5],
      [986, 108.5],
      [989, 113.5],
      [992, 114.5],
      [995, 107.5],
      [998, 107.5],
      [1001, 113.5],
      [1004, 113.5],
      [1007, 110.5],
      [1010, 128.5],
      [1013, 122.5],
      [1016, 125.5],
      [1019, 129.5],
      [1022, 114.5],
      [1025, 128.5],
      [1028, 117.5],
      [1031, 107.5],
      [1034, 103.5],
      [1037, 103.5],
      [1040, 126.5],
      [1043, 111.5],
      [1046, 106.5],
      [1049, 127.5],
      [1052, 101.5],
      [1055, 126.5],
      [1058, 128.5],
      [1061, 105.5],
      [1064, 121.5],
      [1067, 106.5],
      [1070, 130.5],
      [1073, 126.5],
      [1076, 106.5],
      [1079, 113.5],
      [1082, 120.5],
      [1085, 125.5],
      [1088, 120.5],
      [1091, 104.5],
      [1094, 111.5],
      [1097, 104.5],
      [1100, 123.5],
      [1103, 125.5],
      [1106, 115.5],
      [1109, 124.5],
      [1112, 102.5],
      [1115, 130.5],
      [1118, 130.5],
      [1121, 108.5],
      [1124, 113.5],
      [1127, 102.5],
      [1130, 115.5],
      [1133, 130.5],
      [1136, 118.5],
      [1139, 110.5],
      [1142, 120.5],
      [1145, 123.5],
      [1148, 130.5],
      [1151, 102.5],
      [1154, 108.5],
      [1157, 110.5],
      [1160, 125.5],
      [1163, 115.5],
      [1166, 118.5],
      [1169, 118.5],
      [1172, 99.5],
      [1175, 128.5],
      [1178, 125.5],
      [1181, 105.5],
      [1184, 118.5],
      [1187, 99.5],
      [1190, 115.5],
      [1193, 118.5],
      [1196, 121.5],
      [1199, 120.5],
      [1202, 103.5],
      [1205, 124.5],
      [1208, 119.5],
      [1211, 98.5],
      [1214, 109.5],
      [1217, 102.5],
      [1220, 114.5],
      [1223, 113.5],
      [1226, 114.5],
      [1229, 104.5],
      [1232, 112.5],
      [1235, 115.5],
      [1238, 123.5],
      [1241, 108.5],
      [1244, 124.5],
      [1247, 98.5],
      [1250, 106.5],
      [1253, 124.5],
      [1256, 103.5],
      [1259, 107.5],
      [1262, 120.5],
      [1265, 127.5],
      [1268, 125.5],
      [1271, 119.5],
      [1274, 120.5],
      [1277, 117.5],
      [1280, 125.5],
      [1283, 127.5],
      [1286, 119.5],
      [1289, 123.5],
      [1292, 97.5],
      [1295, 119.5],
      [1298, 125.5],
      [1301, 106.5],
      [1304, 122.5],
      [1307, 108.5],
      [1310, 129.5],
      [1313, 123.5],
      [1316, 117.5],
      [1319, 107.5],
      [1322, 117.5],
      [1325, 126.5],
      [1328, 123.5],
      [1331, 103.5],
      [1334, 106.5],
      [1337, 95.5],
      [1340, 114.5],
      [1343, 120.5],
      [1346, 101.5],
      [1349, 126.5],
      [1352, 99.5],
      [1355, 128.5],
      [1358, 121.5],
      [1361, 113.5],
      [1364, 111.5],
      [1367, 107.5],
      [1370, 104.5],
      [1373, 122.5],
      [1376, 105.5],
      [1379, 101.5],
      [1382, 116.5],
      [1385, 120.5],
      [1388, 127.5],
      [1391, 110.5],
      [1394, 114.5],
      [1397, 106.5],
      [1400, 121.5],
      [1403, 119.5],
      [1406, 105.5],
      [1409, 119.5],
      [1412, 92.5],
      [1415, 111.5],
      [1418, 123.5],
      [1421, 111.5],
      [1424, 112.5],
      [1427, 100.5],
      [1430, 126.5],
      [1433, 125.5],
      [1436, 121.5],
      [1439, 106.5],
      [1442, 108.5],
      [1445, 118.5],
      [1448, 120.5],
      [1451, 114.5],
      [1454, 111.5],
      [1457, 110.5],
      [1460, 128.5],
      [1463, 126.5],
      [1466, 113.5],
      [1469, 105.5],
      [1472, 108.5],
      [1475, 119.5],
      [1478, 126.5],
      [1481, 108.5],
      [1484, 121.5],
      [1487, 114.5],
      [1490, 106.5],
      [1493, 120.5],
      [1496, 109.5],
      [1499, 103.5],
      [1502, 102.5],
      [1505, 124.5],
      [1508, 116.5],
      [1511, 123.5],
      [1514, 111.5],
      [1517, 102.5],
      [1520, 106.5],
      [1523, 96.5],
      [1526, 93.5],
      [1529, 85.5],
      [1532, 85.5],
      [1535, 78.5],
      [1538, 76.5],
      [1541, 75.5],
      [1544, 76.5],
      [1547, 75.5],
      [1550, 75.5],
    ],
    bottom: [
      [1548, 75.5],
      [1545, 74.5],
      [1542, 75.5],
      [1539, 74.5],
      [1536, 73.5],
      [1533, 67.5],
      [1530, 63.5],
      [1527, 58.5],
      [1524, 50.5],
      [1521, 38.5],
      [1518, 31.5],
      [1515, 30.5],
      [1512, 37.5],
      [1509, 34.5],
      [1506, 32.5],
      [1503, 33.5],
      [1500, 27.5],
      [1497, 38.5],
      [1494, 45.5],
      [1491, 35.5],
      [1488, 27.5],
      [1485, 26.5],
      [1482, 45.5],
      [1479, 33.5],
      [1476, 39.5],
      [1473, 32.5],
      [1470, 27.5],
      [1467, 37.5],
      [1464, 37.5],
      [1461, 38.5],
      [1458, 25.5],
      [1455, 33.5],
      [1452, 34.5],
      [1449, 43.5],
      [1446, 40.5],
      [1443, 31.5],
      [1440, 30.5],
      [1437, 47.5],
      [1434, 32.5],
      [1431, 38.5],
      [1428, 35.5],
      [1425, 26.5],
      [1422, 46.5],
      [1419, 37.5],
      [1416, 47.5],
      [1413, 32.5],
      [1410, 45.5],
      [1407, 44.5],
      [1404, 47.5],
      [1401, 46.5],
      [1398, 26.5],
      [1395, 24.5],
      [1392, 45.5],
      [1389, 35.5],
      [1386, 43.5],
      [1383, 29.5],
      [1380, 25.5],
      [1377, 47.5],
      [1374, 51.5],
      [1371, 42.5],
      [1368, 44.5],
      [1365, 34.5],
      [1362, 41.5],
      [1359, 39.5],
      [1356, 28.5],
      [1353, 24.5],
      [1350, 35.5],
      [1347, 52.5],
      [1344, 42.5],
      [1341, 45.5],
      [1338, 29.5],
      [1335, 27.5],
      [1332, 49.5],
      [1329, 19.5],
      [1326, 48.5],
      [1323, 29.5],
      [1320, 25.5],
      [1317, 50.5],
      [1314, 39.5],
      [1311, 42.5],
      [1308, 25.5],
      [1305, 26.5],
      [1302, 40.5],
      [1299, 40.5],
      [1296, 39.5],
      [1293, 26.5],
      [1290, 41.5],
      [1287, 55.5],
      [1284, 37.5],
      [1281, 35.5],
      [1278, 22.5],
      [1275, 29.5],
      [1272, 43.5],
      [1269, 20.5],
      [1266, 42.5],
      [1263, 23.5],
      [1260, 28.5],
      [1257, 45.5],
      [1254, 40.5],
      [1251, 49.5],
      [1248, 24.5],
      [1245, 25.5],
      [1242, 30.5],
      [1239, 40.5],
      [1236, 46.5],
      [1233, 41.5],
      [1230, 22.5],
      [1227, 49.5],
      [1224, 29.5],
      [1221, 43.5],
      [1218, 23.5],
      [1215, 27.5],
      [1212, 57.5],
      [1209, 30.5],
      [1206, 49.5],
      [1203, 38.5],
      [1200, 33.5],
      [1197, 48.5],
      [1194, 44.5],
      [1191, 45.5],
      [1188, 39.5],
      [1185, 22.5],
      [1182, 39.5],
      [1179, 44.5],
      [1176, 44.5],
      [1173, 35.5],
      [1170, 47.5],
      [1167, 48.5],
      [1164, 31.5],
      [1161, 35.5],
      [1158, 28.5],
      [1155, 26.5],
      [1152, 52.5],
      [1149, 37.5],
      [1146, 35.5],
      [1143, 27.5],
      [1140, 25.5],
      [1137, 53.5],
      [1134, 43.5],
      [1131, 51.5],
      [1128, 34.5],
      [1125, 21.5],
      [1122, 45.5],
      [1119, 33.5],
      [1116, 39.5],
      [1113, 26.5],
      [1110, 22.5],
      [1107, 49.5],
      [1104, 35.5],
      [1101, 39.5],
      [1098, 20.5],
      [1095, 23.5],
      [1092, 50.5],
      [1089, 29.5],
      [1086, 37.5],
      [1083, 22.5],
      [1080, 21.5],
      [1077, 48.5],
      [1074, 40.5],
      [1071, 52.5],
      [1068, 21.5],
      [1065, 25.5],
      [1062, 35.5],
      [1059, 32.5],
      [1056, 39.5],
      [1053, 24.5],
      [1050, 49.5],
      [1047, 58.5],
      [1044, 48.5],
      [1041, 46.5],
      [1038, 26.5],
      [1035, 31.5],
      [1032, 38.5],
      [1029, 27.5],
      [1026, 33.5],
      [1023, 20.5],
      [1020, 22.5],
      [1017, 36.5],
      [1014, 27.5],
      [1011, 29.5],
      [1008, 33.5],
      [1005, 27.5],
      [1002, 36.5],
      [999, 47.5],
      [996, 38.5],
      [993, 43.5],
      [990, 29.5],
      [987, 28.5],
      [984, 23.5],
      [981, 37.5],
      [978, 36.5],
      [975, 32.5],
      [972, 38.5],
      [969, 22.5],
      [966, 32.5],
      [963, 35.5],
      [960, 23.5],
      [957, 38.5],
      [954, 29.5],
      [951, 44.5],
      [948, 34.5],
      [945, 28.5],
      [942, 41.5],
      [939, 27.5],
      [936, 35.5],
      [933, 27.5],
      [930, 18.5],
      [927, 38.5],
      [924, 34.5],
      [921, 22.5],
      [918, 40.5],
      [915, 27.5],
      [912, 28.5],
      [909, 34.5],
      [906, 31.5],
      [903, 26.5],
      [900, 20.5],
      [897, 39.5],
      [894, 29.5],
      [891, 36.5],
      [888, 37.5],
      [885, 24.5],
      [882, 23.5],
      [879, 42.5],
      [876, 23.5],
      [873, 36.5],
      [870, 26.5],
      [867, 33.5],
      [864, 26.5],
      [861, 36.5],
      [858, 33.5],
      [855, 17.5],
      [852, 43.5],
      [849, 27.5],
      [846, 40.5],
      [843, 33.5],
      [840, 20.5],
      [837, 48.5],
      [834, 43.5],
      [831, 53.5],
      [828, 28.5],
      [825, 28.5],
      [822, 27.5],
      [819, 40.5],
      [816, 34.5],
      [813, 21.5],
      [810, 46.5],
      [807, 51.5],
      [804, 32.5],
      [801, 47.5],
      [798, 28.5],
      [795, 33.5],
      [792, 57.5],
      [789, 38.5],
      [786, 29.5],
      [783, 23.5],
      [780, 25.5],
      [777, 43.5],
      [774, 31.5],
      [771, 52.5],
      [768, 50.5],
      [765, 16.5],
      [762, 31.5],
      [759, 31.5],
      [756, 26.5],
      [753, 35.5],
      [750, 30.5],
      [747, 43.5],
      [744, 32.5],
      [741, 24.5],
      [738, 50.5],
      [735, 39.5],
      [732, 34.5],
      [729, 46.5],
      [726, 28.5],
      [723, 25.5],
      [720, 32.5],
      [717, 47.5],
      [714, 37.5],
      [711, 49.5],
      [708, 31.5],
      [705, 37.5],
      [702, 35.5],
      [699, 32.5],
      [696, 37.5],
      [693, 27.5],
      [690, 21.5],
      [687, 35.5],
      [684, 30.5],
      [681, 32.5],
      [678, 43.5],
      [675, 34.5],
      [672, 32.5],
      [669, 37.5],
      [666, 23.5],
      [663, 25.5],
      [660, 29.5],
      [657, 38.5],
      [654, 37.5],
      [651, 42.5],
      [648, 30.5],
      [645, 34.5],
      [642, 48.5],
      [639, 24.5],
      [636, 28.5],
      [633, 26.5],
      [630, 33.5],
      [627, 48.5],
      [624, 27.5],
      [621, 36.5],
      [618, 24.5],
      [615, 18.5],
      [612, 54.5],
      [609, 25.5],
      [606, 47.5],
      [603, 29.5],
      [600, 26.5],
      [597, 46.5],
      [594, 43.5],
      [591, 51.5],
      [588, 31.5],
      [585, 21.5],
      [582, 27.5],
      [579, 32.5],
      [576, 39.5],
      [573, 26.5],
      [570, 39.5],
      [567, 53.5],
      [564, 36.5],
      [561, 31.5],
      [558, 16.5],
      [555, 17.5],
      [552, 57.5],
      [549, 21.5],
      [546, 38.5],
      [543, 10.5],
      [540, 24.5],
      [537, 43.5],
      [534, 45.5],
      [531, 51.5],
      [528, 28.5],
      [525, 24.5],
      [522, 32.5],
      [519, 35.5],
      [516, 34.5],
      [513, 17.5],
      [510, 24.5],
      [507, 46.5],
      [504, 27.5],
      [501, 33.5],
      [498, 16.5],
      [495, 27.5],
      [492, 53.5],
      [489, 22.5],
      [486, 38.5],
      [483, 22.5],
      [480, 16.5],
      [477, 29.5],
      [474, 38.5],
      [471, 33.5],
      [468, 20.5],
      [465, 22.5],
      [462, 29.5],
      [459, 25.5],
      [456, 25.5],
      [453, 22.5],
      [450, 18.5],
      [447, 25.5],
      [444, 38.5],
      [441, 36.5],
      [438, 25.5],
      [435, 24.5],
      [432, 26.5],
      [429, 36.5],
      [426, 14.5],
      [423, 34.5],
      [420, 14.5],
      [417, 35.5],
      [414, 34.5],
      [411, 29.5],
      [408, 41.5],
      [405, 25.5],
      [402, 40.5],
      [399, 21.5],
      [396, 29.5],
      [393, 21.5],
      [390, 20.5],
      [387, 34.5],
      [384, 31.5],
      [381, 34.5],
      [378, 10.5],
      [375, 18.5],
      [372, 30.5],
      [369, 44.5],
      [366, 42.5],
      [363, 51.5],
      [360, 16.5],
      [357, 32.5],
      [354, 22.5],
      [351, 39.5],
      [348, 13.5],
      [345, 21.5],
      [342, 27.5],
      [339, 30.5],
      [336, 24.5],
      [333, 18.5],
      [330, 15.5],
      [327, 36.5],
      [324, 44.5],
      [321, 30.5],
      [318, 17.5],
      [315, 26.5],
      [312, 53.5],
      [309, 26.5],
      [306, 31.5],
      [303, 11.5],
      [300, 13.5],
      [297, 48.5],
      [294, 32.5],
      [291, 43.5],
      [288, 23.5],
      [285, 33.5],
      [282, 29.5],
      [279, 33.5],
      [276, 38.5],
      [273, 31.5],
      [270, 16.5],
      [267, 46.5],
      [264, 36.5],
      [261, 30.5],
      [258, 11.5],
      [255, 11.5],
      [252, 44.5],
      [249, 18.5],
      [246, 32.5],
      [243, 34.5],
      [240, 21.5],
      [237, 31.5],
      [234, 38.5],
      [231, 40.5],
      [228, 23.5],
      [225, 17.5],
      [222, 19.5],
      [219, 32.5],
      [216, 41.5],
      [213, 14.5],
      [210, 38.5],
      [207, 54.5],
      [204, 31.5],
      [201, 33.5],
      [198, 25.5],
      [195, 25.5],
      [192, 36.5],
      [189, 46.5],
      [186, 44.5],
      [183, 18.5],
      [180, 6.5],
      [177, 43.5],
      [174, 26.5],
      [171, 43.5],
      [168, 31.5],
      [165, 21.5],
      [162, 38.5],
      [159, 30.5],
      [156, 27.5],
      [153, 23.5],
      [150, 8.5],
      [147, 29.5],
      [144, 30.5],
      [141, 28.5],
      [138, 26.5],
      [135, 19.5],
      [132, 57.5],
      [129, 26.5],
      [126, 10.5],
      [123, 32.5],
      [120, 27.5],
      [117, 46.5],
      [114, 45.5],
      [111, 50.5],
      [108, 58.5],
      [105, 30.5],
      [102, 15.5],
      [99, 27.5],
      [96, 38.5],
      [93, 29.5],
      [90, 33.5],
      [87, 37.5],
      [84, 36.5],
      [81, 27.5],
      [78, 25.5],
      [75, 13.5],
      [72, 57.5],
      [69, 23.5],
      [66, 27.5],
      [63, 38.5],
      [60, 10.5],
      [57, 34.5],
      [54, 34.5],
      [51, 42.5],
      [48, 59.5],
      [45, 25.5],
      [42, 23.5],
      [39, 27.5],
      [36, 26.5],
      [33, 19.5],
      [30, 22.5],
      [27, 36.5],
      [24, 23.5],
      [21, 23.5],
      [18, 12.5],
      [15, 7.723399999999998],
      [12, 46.5],
      [9, 3.897599999999997],
      [6, 13.5],
      [3, 17.5],
      [0, 43.5],
    ],
  },
  {
    top: [
      [2, 131.5],
      [5, 143.5],
      [8, 106.5],
      [11, 111.5],
      [14, 134.5],
      [17, 115.5],
      [20, 145.5],
      [23, 121.5],
      [26, 133.5],
      [29, 143.5],
      [32, 108.5],
      [35, 141.5],
      [38, 143.2766],
      [41, 125.5],
      [44, 145.2376],
      [47, 112.5],
      [50, 138.5],
      [53, 145.5],
      [56, 141.5],
      [59, 130.5],
      [62, 140.5],
      [65, 136.5],
      [68, 108.5],
      [71, 119.5],
      [74, 124.5],
      [77, 131.5],
      [80, 131.5],
      [83, 119.5],
      [86, 138.5],
      [89, 131.5],
      [92, 105.5],
      [95, 129.5],
      [98, 135.5],
      [101, 131.5],
      [104, 122.5],
      [107, 109.5],
      [110, 123.5],
      [113, 134.5],
      [116, 125.5],
      [119, 135.5],
      [122, 124.5],
      [125, 130.5],
      [128, 107.5],
      [131, 109.5],
      [134, 117.5],
      [137, 109.5],
      [140, 144.875],
      [143, 122.5],
      [146, 125.5],
      [149, 140.5],
      [152, 113.5],
      [155, 124.5],
      [158, 139.5],
      [161, 123.5],
      [164, 131.5],
      [167, 99.5],
      [170, 124.5],
      [173, 139.5],
      [176, 123.5],
      [179, 135.5],
      [182, 120.5],
      [185, 126.5],
      [188, 139.5],
      [191, 111.5],
      [194, 110.5],
      [197, 102.5],
      [200, 135.5],
      [203, 120.5],
      [206, 116.5],
      [209, 141.5],
      [212, 104.5],
      [215, 131.5],
      [218, 143.2766],
      [221, 121.5],
      [224, 130.5],
      [227, 129.5],
      [230, 131.5],
      [233, 136.5],
      [236, 113.5],
      [239, 120.5],
      [242, 129.5],
      [245, 128.5],
      [248, 139.5],
      [251, 115.5],
      [254, 110.5],
      [257, 108.5],
      [260, 139.5],
      [263, 141.5],
      [266, 115.5],
      [269, 119.5],
      [272, 112.5],
      [275, 137.5],
      [278, 142.5],
      [281, 122.5],
      [284, 118.5],
      [287, 116.5],
      [290, 112.5],
      [293, 138.5],
      [296, 120.5],
      [299, 110.5],
      [302, 125.5],
      [305, 139.5],
      [308, 144.5],
      [311, 108.5],
      [314, 125.5],
      [317, 115.5],
      [320, 130.5],
      [323, 117.5],
      [326, 117.5],
      [329, 127.5],
      [332, 116.5],
      [335, 132.5],
      [338, 129.5],
      [341, 126.5],
      [344, 113.5],
      [347, 109.5],
      [350, 144.5],
      [353, 125.5],
      [356, 110.5],
      [359, 113.5],
      [362, 117.5],
      [365, 138.5],
      [368, 93.5],
      [371, 111.5],
      [374, 124.5],
      [377, 127.5],
      [380, 133.5],
      [383, 122.5],
      [386, 124.5],
      [389, 124.5],
      [392, 115.5],
      [395, 137.5],
      [398, 131.5],
      [401, 106.5],
      [404, 104.5],
      [407, 112.5],
      [410, 134.5],
      [413, 126.5],
      [416, 127.5],
      [419, 111.5],
      [422, 119.5],
      [425, 131.5],
      [428, 134.5],
      [431, 121.5],
      [434, 128.5],
      [437, 122.5],
      [440, 132.5],
      [443, 123.5],
      [446, 132.5],
      [449, 118.5],
      [452, 105.5],
      [455, 138.5],
      [458, 134.5],
      [461, 121.5],
      [464, 105.5],
      [467, 108.5],
      [470, 127.5],
      [473, 139.5],
      [476, 111.5],
      [479, 142.5],
      [482, 120.5],
      [485, 139.5],
      [488, 137.5],
      [491, 106.5],
      [494, 116.5],
      [497, 107.5],
      [500, 132.5],
      [503, 126.5],
      [506, 112.5],
      [509, 120.5],
      [512, 100.5],
      [515, 132.5],
      [518, 136.5],
      [521, 113.5],
      [524, 115.5],
      [527, 105.5],
      [530, 116.5],
      [533, 137.5],
      [536, 123.5],
      [539, 120.5],
      [542, 126.5],
      [545, 121.5],
      [548, 117.5],
      [551, 108.5],
      [554, 113.5],
      [557, 129.5],
      [560, 128.5],
      [563, 136.5],
      [566, 119.5],
      [569, 126.5],
      [572, 103.5],
      [575, 138.5],
      [578, 134.5],
      [581, 122.5],
      [584, 118.5],
      [587, 114.5],
      [590, 130.5],
      [593, 118.5],
      [596, 119.5],
      [599, 117.5],
      [602, 123.5],
      [605, 130.5],
      [608, 124.5],
      [611, 105.5],
      [614, 121.5],
      [617, 102.5],
      [620, 137.5],
      [623, 138.5],
      [626, 110.5],
      [629, 130.5],
      [632, 103.5],
      [635, 129.5],
      [638, 131.5],
      [641, 115.5],
      [644, 119.5],
      [647, 109.5],
      [650, 120.5],
      [653, 124.5],
      [656, 108.5],
      [659, 113.5],
      [662, 129.5],
      [665, 117.5],
      [668, 124.5],
      [671, 124.5],
      [674, 115.5],
      [677, 118.5],
      [680, 132.5],
      [683, 118.5],
      [686, 123.5],
      [689, 131.5],
      [692, 120.5],
      [695, 125.5],
      [698, 121.5],
      [701, 126.5],
      [704, 124.5],
      [707, 96.5],
      [710, 115.5],
      [713, 118.5],
      [716, 105.5],
      [719, 121.5],
      [722, 112.5],
      [725, 117.5],
      [728, 123.5],
      [731, 117.5],
      [734, 112.5],
      [737, 115.5],
      [740, 124.5],
      [743, 126.5],
      [746, 126.5],
      [749, 118.5],
      [752, 122.5],
      [755, 127.5],
      [758, 122.5],
      [761, 129.5],
      [764, 114.5],
      [767, 99.5],
      [770, 125.5],
      [773, 127.5],
      [776, 112.5],
      [779, 123.5],
      [782, 121.5],
      [785, 118.5],
      [788, 104.5],
      [791, 103.5],
      [794, 119.5],
      [797, 114.5],
      [800, 129.5],
      [803, 133.5],
      [806, 110.5],
      [809, 124.5],
      [812, 97.5],
      [815, 119.5],
      [818, 140.5],
      [821, 112.5],
      [824, 123.5],
      [827, 111.5],
      [830, 132.5],
      [833, 129.5],
      [836, 119.5],
      [839, 106.5],
      [842, 129.5],
      [845, 128.5],
      [848, 123.5],
      [851, 124.5],
      [854, 113.5],
      [857, 104.5],
      [860, 131.5],
      [863, 138.5],
      [866, 125.5],
      [869, 123.5],
      [872, 105.5],
      [875, 137.5],
      [878, 121.5],
      [881, 130.5],
      [884, 120.5],
      [887, 123.5],
      [890, 134.5],
      [893, 117.5],
      [896, 119.5],
      [899, 122.5],
      [902, 122.5],
      [905, 123.5],
      [908, 125.5],
      [911, 122.5],
      [914, 112.5],
      [917, 124.5],
      [920, 132.5],
      [923, 116.5],
      [926, 127.5],
      [929, 120.5],
      [932, 114.5],
      [935, 120.5],
      [938, 112.5],
      [941, 128.5],
      [944, 117.5],
      [947, 112.5],
      [950, 129.5],
      [953, 119.5],
      [956, 122.5],
      [959, 112.5],
      [962, 114.5],
      [965, 121.5],
      [968, 112.5],
      [971, 113.5],
      [974, 123.5],
      [977, 104.5],
      [980, 130.5],
      [983, 124.5],
      [986, 110.5],
      [989, 115.5],
      [992, 115.5],
      [995, 112.5],
      [998, 113.5],
      [1001, 118.5],
      [1004, 117.5],
      [1007, 111.5],
      [1010, 128.5],
      [1013, 129.5],
      [1016, 130.5],
      [1019, 131.5],
      [1022, 115.5],
      [1025, 129.5],
      [1028, 118.5],
      [1031, 106.5],
      [1034, 103.5],
      [1037, 106.5],
      [1040, 129.5],
      [1043, 111.5],
      [1046, 105.5],
      [1049, 126.5],
      [1052, 99.5],
      [1055, 124.5],
      [1058, 127.5],
      [1061, 103.5],
      [1064, 122.5],
      [1067, 106.5],
      [1070, 127.5],
      [1073, 125.5],
      [1076, 107.5],
      [1079, 114.5],
      [1082, 119.5],
      [1085, 128.5],
      [1088, 124.5],
      [1091, 105.5],
      [1094, 111.5],
      [1097, 103.5],
      [1100, 120.5],
      [1103, 125.5],
      [1106, 117.5],
      [1109, 125.5],
      [1112, 102.5],
      [1115, 129.5],
      [1118, 133.5],
      [1121, 107.5],
      [1124, 112.5],
      [1127, 102.5],
      [1130, 114.5],
      [1133, 135.5],
      [1136, 123.5],
      [1139, 111.5],
      [1142, 121.5],
      [1145, 125.5],
      [1148, 135.5],
      [1151, 106.5],
      [1154, 111.5],
      [1157, 113.5],
      [1160, 121.5],
      [1163, 117.5],
      [1166, 120.5],
      [1169, 121.5],
      [1172, 102.5],
      [1175, 131.5],
      [1178, 127.5],
      [1181, 107.5],
      [1184, 122.5],
      [1187, 99.5],
      [1190, 116.5],
      [1193, 128.5],
      [1196, 126.5],
      [1199, 119.5],
      [1202, 103.5],
      [1205, 124.5],
      [1208, 118.5],
      [1211, 98.5],
      [1214, 110.5],
      [1217, 101.5],
      [1220, 114.5],
      [1223, 118.5],
      [1226, 113.5],
      [1229, 106.5],
      [1232, 114.5],
      [1235, 117.5],
      [1238, 123.5],
      [1241, 115.5],
      [1244, 129.5],
      [1247, 100.5],
      [1250, 107.5],
      [1253, 121.5],
      [1256, 106.5],
      [1259, 109.5],
      [1262, 120.5],
      [1265, 131.5],
      [1268, 123.5],
      [1271, 119.5],
      [1274, 126.5],
      [1277, 119.5],
      [1280, 124.5],
      [1283, 125.5],
      [1286, 120.5],
      [1289, 127.5],
      [1292, 97.5],
      [1295, 117.5],
      [1298, 124.5],
      [1301, 106.5],
      [1304, 122.5],
      [1307, 108.5],
      [1310, 130.5],
      [1313, 124.5],
      [1316, 120.5],
      [1319, 108.5],
      [1322, 119.5],
      [1325, 130.5],
      [1328, 125.5],
      [1331, 103.5],
      [1334, 107.5],
      [1337, 97.5],
      [1340, 119.5],
      [1343, 128.5],
      [1346, 102.5],
      [1349, 125.5],
      [1352, 98.5],
      [1355, 126.5],
      [1358, 126.5],
      [1361, 115.5],
      [1364, 113.5],
      [1367, 110.5],
      [1370, 109.5],
      [1373, 125.5],
      [1376, 105.5],
      [1379, 102.5],
      [1382, 116.5],
      [1385, 123.5],
      [1388, 125.5],
      [1391, 110.5],
      [1394, 112.5],
      [1397, 106.5],
      [1400, 125.5],
      [1403, 121.5],
      [1406, 104.5],
      [1409, 123.5],
      [1412, 92.5],
      [1415, 111.5],
      [1418, 122.5],
      [1421, 111.5],
      [1424, 111.5],
      [1427, 101.5],
      [1430, 126.5],
      [1433, 125.5],
      [1436, 118.5],
      [1439, 109.5],
      [1442, 112.5],
      [1445, 119.5],
      [1448, 118.5],
      [1451, 116.5],
      [1454, 112.5],
      [1457, 111.5],
      [1460, 125.5],
      [1463, 127.5],
      [1466, 115.5],
      [1469, 105.5],
      [1472, 107.5],
      [1475, 120.5],
      [1478, 125.5],
      [1481, 108.5],
      [1484, 120.5],
      [1487, 115.5],
      [1490, 106.5],
      [1493, 128.5],
      [1496, 109.5],
      [1499, 102.5],
      [1502, 101.5],
      [1505, 122.5],
      [1508, 118.5],
      [1511, 121.5],
      [1514, 111.5],
      [1517, 104.5],
      [1520, 109.5],
      [1523, 95.5],
      [1526, 92.5],
      [1529, 85.5],
      [1532, 85.5],
      [1535, 79.5],
      [1538, 76.5],
      [1541, 76.5],
      [1544, 76.5],
      [1547, 75.5],
      [1550, 75.5],
    ],
    bottom: [
      [1548, 75.5],
      [1545, 74.5],
      [1542, 74.5],
      [1539, 74.5],
      [1536, 73.5],
      [1533, 66.5],
      [1530, 62.5],
      [1527, 59.5],
      [1524, 51.5],
      [1521, 36.5],
      [1518, 29.5],
      [1515, 29.5],
      [1512, 39.5],
      [1509, 34.5],
      [1506, 33.5],
      [1503, 37.5],
      [1500, 27.5],
      [1497, 39.5],
      [1494, 43.5],
      [1491, 32.5],
      [1488, 24.5],
      [1485, 28.5],
      [1482, 46.5],
      [1479, 34.5],
      [1476, 40.5],
      [1473, 31.5],
      [1470, 27.5],
      [1467, 36.5],
      [1464, 35.5],
      [1461, 39.5],
      [1458, 26.5],
      [1455, 30.5],
      [1452, 30.5],
      [1449, 43.5],
      [1446, 41.5],
      [1443, 27.5],
      [1440, 27.5],
      [1437, 48.5],
      [1434, 31.5],
      [1431, 38.5],
      [1428, 33.5],
      [1425, 30.5],
      [1422, 45.5],
      [1419, 37.5],
      [1416, 47.5],
      [1413, 32.5],
      [1410, 43.5],
      [1407, 45.5],
      [1404, 48.5],
      [1401, 43.5],
      [1398, 24.5],
      [1395, 25.5],
      [1392, 46.5],
      [1389, 36.5],
      [1386, 40.5],
      [1383, 29.5],
      [1380, 25.5],
      [1377, 47.5],
      [1374, 50.5],
      [1371, 39.5],
      [1368, 41.5],
      [1365, 30.5],
      [1362, 39.5],
      [1359, 36.5],
      [1356, 28.5],
      [1353, 25.5],
      [1350, 36.5],
      [1347, 51.5],
      [1344, 36.5],
      [1341, 41.5],
      [1338, 24.5],
      [1335, 27.5],
      [1332, 49.5],
      [1329, 20.5],
      [1326, 45.5],
      [1323, 28.5],
      [1320, 22.5],
      [1317, 48.5],
      [1314, 39.5],
      [1311, 42.5],
      [1308, 26.5],
      [1305, 25.5],
      [1302, 41.5],
      [1299, 42.5],
      [1296, 38.5],
      [1293, 24.5],
      [1290, 40.5],
      [1287, 54.5],
      [1284, 37.5],
      [1281, 37.5],
      [1278, 20.5],
      [1275, 23.5],
      [1272, 42.5],
      [1269, 23.5],
      [1266, 38.5],
      [1263, 21.5],
      [1260, 25.5],
      [1257, 41.5],
      [1254, 40.5],
      [1251, 48.5],
      [1248, 22.5],
      [1245, 19.5],
      [1242, 22.5],
      [1239, 37.5],
      [1236, 45.5],
      [1233, 40.5],
      [1230, 20.5],
      [1227, 50.5],
      [1224, 26.5],
      [1221, 41.5],
      [1218, 22.5],
      [1215, 26.5],
      [1212, 56.5],
      [1209, 31.5],
      [1206, 50.5],
      [1203, 39.5],
      [1200, 34.5],
      [1197, 48.5],
      [1194, 37.5],
      [1191, 45.5],
      [1188, 40.5],
      [1185, 18.5],
      [1182, 38.5],
      [1179, 43.5],
      [1176, 42.5],
      [1173, 30.5],
      [1170, 45.5],
      [1167, 46.5],
      [1164, 30.5],
      [1161, 36.5],
      [1158, 26.5],
      [1155, 21.5],
      [1152, 49.5],
      [1149, 33.5],
      [1146, 31.5],
      [1143, 28.5],
      [1140, 23.5],
      [1137, 50.5],
      [1134, 39.5],
      [1131, 51.5],
      [1128, 32.5],
      [1125, 24.5],
      [1122, 45.5],
      [1119, 31.5],
      [1116, 37.5],
      [1113, 26.5],
      [1110, 22.5],
      [1107, 49.5],
      [1104, 36.5],
      [1101, 40.5],
      [1098, 21.5],
      [1095, 21.5],
      [1092, 50.5],
      [1089, 24.5],
      [1086, 34.5],
      [1083, 22.5],
      [1080, 24.5],
      [1077, 45.5],
      [1074, 41.5],
      [1071, 52.5],
      [1068, 21.5],
      [1065, 21.5],
      [1062, 36.5],
      [1059, 33.5],
      [1056, 41.5],
      [1053, 25.5],
      [1050, 48.5],
      [1047, 58.5],
      [1044, 49.5],
      [1041, 45.5],
      [1038, 23.5],
      [1035, 30.5],
      [1032, 36.5],
      [1029, 27.5],
      [1026, 33.5],
      [1023, 20.5],
      [1020, 26.5],
      [1017, 31.5],
      [1014, 23.5],
      [1011, 25.5],
      [1008, 32.5],
      [1005, 22.5],
      [1002, 33.5],
      [999, 41.5],
      [996, 32.5],
      [993, 40.5],
      [990, 23.5],
      [987, 26.5],
      [984, 21.5],
      [981, 37.5],
      [978, 34.5],
      [975, 30.5],
      [972, 35.5],
      [969, 23.5],
      [966, 31.5],
      [963, 33.5],
      [960, 19.5],
      [957, 34.5],
      [954, 24.5],
      [951, 41.5],
      [948, 31.5],
      [945, 27.5],
      [942, 37.5],
      [939, 25.5],
      [936, 34.5],
      [933, 25.5],
      [930, 19.5],
      [927, 34.5],
      [924, 31.5],
      [921, 20.5],
      [918, 37.5],
      [915, 30.5],
      [912, 24.5],
      [909, 30.5],
      [906, 30.5],
      [903, 24.5],
      [900, 20.5],
      [897, 36.5],
      [894, 31.5],
      [891, 34.5],
      [888, 37.5],
      [885, 23.5],
      [882, 22.5],
      [879, 38.5],
      [876, 14.5],
      [873, 31.5],
      [870, 23.5],
      [867, 33.5],
      [864, 23.5],
      [861, 36.5],
      [858, 32.5],
      [855, 10.5],
      [852, 36.5],
      [849, 21.5],
      [846, 35.5],
      [843, 29.5],
      [840, 18.5],
      [837, 46.5],
      [834, 39.5],
      [831, 49.5],
      [828, 22.5],
      [825, 26.5],
      [822, 24.5],
      [819, 36.5],
      [816, 31.5],
      [813, 19.5],
      [810, 45.5],
      [807, 52.5],
      [804, 28.5],
      [801, 41.5],
      [798, 20.5],
      [795, 26.5],
      [792, 56.5],
      [789, 37.5],
      [786, 27.5],
      [783, 18.5],
      [780, 23.5],
      [777, 38.5],
      [774, 30.5],
      [771, 51.5],
      [768, 50.5],
      [765, 15.5],
      [762, 28.5],
      [759, 28.5],
      [756, 21.5],
      [753, 28.5],
      [750, 22.5],
      [747, 39.5],
      [744, 32.5],
      [741, 24.5],
      [738, 49.5],
      [735, 38.5],
      [732, 35.5],
      [729, 46.5],
      [726, 26.5],
      [723, 20.5],
      [720, 29.5],
      [717, 47.5],
      [714, 38.5],
      [711, 49.5],
      [708, 27.5],
      [705, 36.5],
      [702, 33.5],
      [699, 31.5],
      [696, 34.5],
      [693, 28.5],
      [690, 24.5],
      [687, 36.5],
      [684, 29.5],
      [681, 30.5],
      [678, 40.5],
      [675, 28.5],
      [672, 31.5],
      [669, 35.5],
      [666, 19.5],
      [663, 25.5],
      [660, 26.5],
      [657, 39.5],
      [654, 34.5],
      [651, 43.5],
      [648, 30.5],
      [645, 33.5],
      [642, 47.5],
      [639, 23.5],
      [636, 24.5],
      [633, 26.5],
      [630, 33.5],
      [627, 49.5],
      [624, 28.5],
      [621, 35.5],
      [618, 22.5],
      [615, 14.5],
      [612, 52.5],
      [609, 19.5],
      [606, 41.5],
      [603, 25.5],
      [600, 22.5],
      [597, 45.5],
      [594, 42.5],
      [591, 50.5],
      [588, 27.5],
      [585, 19.5],
      [582, 25.5],
      [579, 31.5],
      [576, 37.5],
      [573, 24.5],
      [570, 39.5],
      [567, 51.5],
      [564, 34.5],
      [561, 30.5],
      [558, 14.5],
      [555, 11.5],
      [552, 57.5],
      [549, 12.5],
      [546, 35.5],
      [543, 10.5],
      [540, 25.5],
      [537, 43.5],
      [534, 46.5],
      [531, 50.5],
      [528, 27.5],
      [525, 22.5],
      [522, 27.5],
      [519, 29.5],
      [516, 33.5],
      [513, 15.5],
      [510, 24.5],
      [507, 47.5],
      [504, 28.5],
      [501, 31.5],
      [498, 14.5],
      [495, 25.5],
      [492, 53.5],
      [489, 12.5],
      [486, 35.5],
      [483, 14.5],
      [480, 9.5],
      [477, 24.5],
      [474, 34.5],
      [471, 30.5],
      [468, 20.5],
      [465, 21.5],
      [462, 29.5],
      [459, 26.5],
      [456, 26.5],
      [453, 23.5],
      [450, 11.5],
      [447, 23.5],
      [444, 35.5],
      [441, 30.5],
      [438, 16.5],
      [435, 18.5],
      [432, 17.5],
      [429, 31.5],
      [426, 10.5],
      [423, 33.5],
      [420, 9.5],
      [417, 31.5],
      [414, 29.5],
      [411, 19.5],
      [408, 34.5],
      [405, 20.5],
      [402, 37.5],
      [399, 20.5],
      [396, 20.5],
      [393, 12.5],
      [390, 10.5],
      [387, 26.5],
      [384, 24.5],
      [381, 31.5],
      [378, 11.5],
      [375, 14.5],
      [372, 28.5],
      [369, 40.5],
      [366, 34.5],
      [363, 46.5],
      [360, 12.5],
      [357, 32.5],
      [354, 22.5],
      [351, 36.5],
      [348, 5.5],
      [345, 10.5],
      [342, 25.5],
      [339, 30.5],
      [336, 24.5],
      [333, 17.5],
      [330, 10.5],
      [327, 35.5],
      [324, 42.5],
      [321, 26.5],
      [318, 9.5],
      [315, 15.5],
      [312, 50.5],
      [309, 15.5],
      [306, 31.5],
      [303, 8.5],
      [300, 15.5],
      [297, 45.5],
      [294, 28.5],
      [291, 39.5],
      [288, 12.5],
      [285, 26.5],
      [282, 29.5],
      [279, 33.5],
      [276, 38.5],
      [273, 28.5],
      [270, 6.5],
      [267, 42.5],
      [264, 31.5],
      [261, 30.5],
      [258, 10.5],
      [255, 11.5],
      [252, 45.5],
      [249, 15.5],
      [246, 32.5],
      [243, 33.5],
      [240, 17.5],
      [237, 25.5],
      [234, 33.5],
      [231, 41.5],
      [228, 16.5],
      [225, 11.5],
      [222, 19.5],
      [219, 31.5],
      [216, 39.5],
      [213, 10.5],
      [210, 34.5],
      [207, 50.5],
      [204, 21.5],
      [201, 27.5],
      [198, 11.5],
      [195, 14.5],
      [192, 31.5],
      [189, 42.5],
      [186, 38.5],
      [183, 14.5],
      [180, 5.5],
      [177, 42.5],
      [174, 27.5],
      [171, 42.5],
      [168, 29.5],
      [165, 15.5],
      [162, 33.5],
      [159, 28.5],
      [156, 24.5],
      [153, 24.5],
      [150, 7.5],
      [147, 31.5],
      [144, 24.5],
      [141, 27.5],
      [138, 27.5],
      [135, 17.5],
      [132, 56.5],
      [129, 26.5],
      [126, 8.5],
      [123, 31.5],
      [120, 26.5],
      [117, 45.5],
      [114, 42.5],
      [111, 47.5],
      [108, 58.5],
      [105, 31.5],
      [102, 15.5],
      [99, 28.5],
      [96, 34.5],
      [93, 22.5],
      [90, 32.5],
      [87, 35.5],
      [84, 37.5],
      [81, 22.5],
      [78, 25.5],
      [75, 14.5],
      [72, 55.5],
      [69, 22.5],
      [66, 24.5],
      [63, 32.5],
      [60, 11.5],
      [57, 28.5],
      [54, 28.5],
      [51, 42.5],
      [48, 59.5],
      [45, 25.5],
      [42, 23.5],
      [39, 29.5],
      [36, 21.5],
      [33, 12.5],
      [30, 21.5],
      [27, 35.5],
      [24, 22.5],
      [21, 24.5],
      [18, 9.5],
      [15, 7.301600000000008],
      [12, 43.5],
      [9, 2.239999999999995],
      [6, 6.5],
      [3, 18.5],
      [0, 41.5],
    ],
  },
  {
    top: [
      [2, 137.5],
      [5, 143.6984],
      [8, 105.5],
      [11, 109.5],
      [14, 132.5],
      [17, 115.5],
      [20, 143.5],
      [23, 118.5],
      [26, 133.5],
      [29, 140.5],
      [32, 106.5],
      [35, 138.5],
      [38, 144.1054],
      [41, 125.5],
      [44, 144.4976],
      [47, 111.5],
      [50, 137.5],
      [53, 143.5],
      [56, 142.5],
      [59, 131.5],
      [62, 136.5],
      [65, 133.5],
      [68, 108.5],
      [71, 118.5],
      [74, 128.5],
      [77, 126.5],
      [80, 130.5],
      [83, 118.5],
      [86, 136.5],
      [89, 131.5],
      [92, 107.5],
      [95, 128.5],
      [98, 139.5],
      [101, 128.5],
      [104, 120.5],
      [107, 109.5],
      [110, 121.5],
      [113, 133.5],
      [116, 122.5],
      [119, 135.5],
      [122, 125.5],
      [125, 128.5],
      [128, 104.5],
      [131, 108.5],
      [134, 117.5],
      [137, 110.5],
      [140, 145.5],
      [143, 120.5],
      [146, 128.5],
      [149, 139.5],
      [152, 111.5],
      [155, 120.5],
      [158, 134.5],
      [161, 120.5],
      [164, 128.5],
      [167, 98.5],
      [170, 119.5],
      [173, 140.5],
      [176, 122.5],
      [179, 132.5],
      [182, 115.5],
      [185, 122.5],
      [188, 135.5],
      [191, 109.5],
      [194, 107.5],
      [197, 100.5],
      [200, 131.5],
      [203, 116.5],
      [206, 113.5],
      [209, 136.5],
      [212, 102.5],
      [215, 128.5],
      [218, 144.5],
      [221, 117.5],
      [224, 127.5],
      [227, 125.5],
      [230, 127.5],
      [233, 132.5],
      [236, 110.5],
      [239, 115.5],
      [242, 127.5],
      [245, 129.5],
      [248, 140.5],
      [251, 114.5],
      [254, 109.5],
      [257, 110.5],
      [260, 134.5],
      [263, 135.5],
      [266, 111.5],
      [269, 117.5],
      [272, 112.5],
      [275, 135.5],
      [278, 139.5],
      [281, 119.5],
      [284, 114.5],
      [287, 113.5],
      [290, 111.5],
      [293, 136.5],
      [296, 121.5],
      [299, 108.5],
      [302, 122.5],
      [305, 135.5],
      [308, 139.5],
      [311, 105.5],
      [314, 120.5],
      [317, 112.5],
      [320, 130.5],
      [323, 116.5],
      [326, 114.5],
      [329, 122.5],
      [332, 114.5],
      [335, 138.5],
      [338, 126.5],
      [341, 122.5],
      [344, 112.5],
      [347, 107.5],
      [350, 140.5],
      [353, 123.5],
      [356, 107.5],
      [359, 110.5],
      [362, 114.5],
      [365, 131.5],
      [368, 92.5],
      [371, 112.5],
      [374, 126.5],
      [377, 124.5],
      [380, 129.5],
      [383, 117.5],
      [386, 120.5],
      [389, 120.5],
      [392, 111.5],
      [395, 132.5],
      [398, 126.5],
      [401, 105.5],
      [404, 102.5],
      [407, 109.5],
      [410, 128.5],
      [413, 125.5],
      [416, 125.5],
      [419, 109.5],
      [422, 116.5],
      [425, 127.5],
      [428, 128.5],
      [431, 118.5],
      [434, 123.5],
      [437, 117.5],
      [440, 129.5],
      [443, 122.5],
      [446, 133.5],
      [449, 116.5],
      [452, 105.5],
      [455, 136.5],
      [458, 131.5],
      [461, 117.5],
      [464, 105.5],
      [467, 110.5],
      [470, 126.5],
      [473, 136.5],
      [476, 109.5],
      [479, 136.5],
      [482, 116.5],
      [485, 133.5],
      [488, 132.5],
      [491, 109.5],
      [494, 116.5],
      [497, 106.5],
      [500, 129.5],
      [503, 122.5],
      [506, 110.5],
      [509, 115.5],
      [512, 97.5],
      [515, 131.5],
      [518, 137.5],
      [521, 112.5],
      [524, 112.5],
      [527, 102.5],
      [530, 116.5],
      [533, 136.5],
      [536, 120.5],
      [539, 118.5],
      [542, 125.5],
      [545, 120.5],
      [548, 113.5],
      [551, 106.5],
      [554, 109.5],
      [557, 124.5],
      [560, 124.5],
      [563, 131.5],
      [566, 118.5],
      [569, 128.5],
      [572, 104.5],
      [575, 135.5],
      [578, 129.5],
      [581, 117.5],
      [584, 114.5],
      [587, 110.5],
      [590, 124.5],
      [593, 116.5],
      [596, 114.5],
      [599, 114.5],
      [602, 117.5],
      [605, 124.5],
      [608, 123.5],
      [611, 104.5],
      [614, 119.5],
      [617, 101.5],
      [620, 131.5],
      [623, 134.5],
      [626, 108.5],
      [629, 126.5],
      [632, 101.5],
      [635, 125.5],
      [638, 130.5],
      [641, 116.5],
      [644, 120.5],
      [647, 110.5],
      [650, 126.5],
      [653, 123.5],
      [656, 105.5],
      [659, 110.5],
      [662, 126.5],
      [665, 117.5],
      [668, 124.5],
      [671, 123.5],
      [674, 112.5],
      [677, 115.5],
      [680, 127.5],
      [683, 115.5],
      [686, 123.5],
      [689, 134.5],
      [692, 119.5],
      [695, 123.5],
      [698, 119.5],
      [701, 122.5],
      [704, 119.5],
      [707, 94.5],
      [710, 112.5],
      [713, 119.5],
      [716, 103.5],
      [719, 120.5],
      [722, 111.5],
      [725, 117.5],
      [728, 123.5],
      [731, 118.5],
      [734, 111.5],
      [737, 113.5],
      [740, 121.5],
      [743, 122.5],
      [746, 123.5],
      [749, 117.5],
      [752, 119.5],
      [755, 123.5],
      [758, 117.5],
      [761, 125.5],
      [764, 113.5],
      [767, 99.5],
      [770, 127.5],
      [773, 127.5],
      [776, 109.5],
      [779, 119.5],
      [782, 116.5],
      [785, 115.5],
      [788, 102.5],
      [791, 100.5],
      [794, 116.5],
      [797, 110.5],
      [800, 124.5],
      [803, 129.5],
      [806, 113.5],
      [809, 127.5],
      [812, 96.5],
      [815, 115.5],
      [818, 135.5],
      [821, 109.5],
      [824, 120.5],
      [827, 108.5],
      [830, 127.5],
      [833, 124.5],
      [836, 118.5],
      [839, 105.5],
      [842, 125.5],
      [845, 128.5],
      [848, 121.5],
      [851, 121.5],
      [854, 110.5],
      [857, 102.5],
      [860, 129.5],
      [863, 134.5],
      [866, 123.5],
      [869, 121.5],
      [872, 103.5],
      [875, 134.5],
      [878, 118.5],
      [881, 127.5],
      [884, 121.5],
      [887, 121.5],
      [890, 130.5],
      [893, 116.5],
      [896, 116.5],
      [899, 117.5],
      [902, 119.5],
      [905, 119.5],
      [908, 122.5],
      [911, 120.5],
      [914, 112.5],
      [917, 123.5],
      [920, 127.5],
      [923, 117.5],
      [926, 125.5],
      [929, 118.5],
      [932, 113.5],
      [935, 118.5],
      [938, 109.5],
      [941, 123.5],
      [944, 115.5],
      [947, 108.5],
      [950, 127.5],
      [953, 116.5],
      [956, 119.5],
      [959, 112.5],
      [962, 113.5],
      [965, 120.5],
      [968, 110.5],
      [971, 111.5],
      [974, 119.5],
      [977, 102.5],
      [980, 126.5],
      [983, 121.5],
      [986, 107.5],
      [989, 113.5],
      [992, 113.5],
      [995, 108.5],
      [998, 110.5],
      [1001, 120.5],
      [1004, 117.5],
      [1007, 111.5],
      [1010, 128.5],
      [1013, 126.5],
      [1016, 126.5],
      [1019, 130.5],
      [1022, 112.5],
      [1025, 125.5],
      [1028, 115.5],
      [1031, 106.5],
      [1034, 105.5],
      [1037, 106.5],
      [1040, 128.5],
      [1043, 114.5],
      [1046, 107.5],
      [1049, 128.5],
      [1052, 100.5],
      [1055, 124.5],
      [1058, 127.5],
      [1061, 104.5],
      [1064, 120.5],
      [1067, 105.5],
      [1070, 125.5],
      [1073, 121.5],
      [1076, 105.5],
      [1079, 114.5],
      [1082, 122.5],
      [1085, 126.5],
      [1088, 121.5],
      [1091, 104.5],
      [1094, 110.5],
      [1097, 101.5],
      [1100, 117.5],
      [1103, 122.5],
      [1106, 115.5],
      [1109, 122.5],
      [1112, 101.5],
      [1115, 127.5],
      [1118, 129.5],
      [1121, 108.5],
      [1124, 111.5],
      [1127, 101.5],
      [1130, 116.5],
      [1133, 132.5],
      [1136, 121.5],
      [1139, 108.5],
      [1142, 117.5],
      [1145, 125.5],
      [1148, 130.5],
      [1151, 103.5],
      [1154, 109.5],
      [1157, 112.5],
      [1160, 125.5],
      [1163, 116.5],
      [1166, 118.5],
      [1169, 119.5],
      [1172, 100.5],
      [1175, 127.5],
      [1178, 123.5],
      [1181, 105.5],
      [1184, 118.5],
      [1187, 96.5],
      [1190, 112.5],
      [1193, 123.5],
      [1196, 124.5],
      [1199, 124.5],
      [1202, 103.5],
      [1205, 125.5],
      [1208, 119.5],
      [1211, 98.5],
      [1214, 107.5],
      [1217, 99.5],
      [1220, 110.5],
      [1223, 114.5],
      [1226, 112.5],
      [1229, 104.5],
      [1232, 113.5],
      [1235, 120.5],
      [1238, 126.5],
      [1241, 113.5],
      [1244, 125.5],
      [1247, 98.5],
      [1250, 108.5],
      [1253, 125.5],
      [1256, 104.5],
      [1259, 108.5],
      [1262, 119.5],
      [1265, 126.5],
      [1268, 121.5],
      [1271, 116.5],
      [1274, 125.5],
      [1277, 120.5],
      [1280, 122.5],
      [1283, 126.5],
      [1286, 120.5],
      [1289, 125.5],
      [1292, 97.5],
      [1295, 114.5],
      [1298, 121.5],
      [1301, 105.5],
      [1304, 120.5],
      [1307, 107.5],
      [1310, 126.5],
      [1313, 123.5],
      [1316, 119.5],
      [1319, 105.5],
      [1322, 118.5],
      [1325, 128.5],
      [1328, 123.5],
      [1331, 101.5],
      [1334, 106.5],
      [1337, 97.5],
      [1340, 115.5],
      [1343, 125.5],
      [1346, 100.5],
      [1349, 121.5],
      [1352, 98.5],
      [1355, 127.5],
      [1358, 122.5],
      [1361, 113.5],
      [1364, 111.5],
      [1367, 109.5],
      [1370, 107.5],
      [1373, 121.5],
      [1376, 103.5],
      [1379, 99.5],
      [1382, 114.5],
      [1385, 118.5],
      [1388, 121.5],
      [1391, 107.5],
      [1394, 114.5],
      [1397, 106.5],
      [1400, 125.5],
      [1403, 120.5],
      [1406, 105.5],
      [1409, 123.5],
      [1412, 92.5],
      [1415, 109.5],
      [1418, 116.5],
      [1421, 109.5],
      [1424, 110.5],
      [1427, 100.5],
      [1430, 123.5],
      [1433, 121.5],
      [1436, 122.5],
      [1439, 110.5],
      [1442, 109.5],
      [1445, 116.5],
      [1448, 120.5],
      [1451, 115.5],
      [1454, 109.5],
      [1457, 109.5],
      [1460, 124.5],
      [1463, 123.5],
      [1466, 112.5],
      [1469, 102.5],
      [1472, 106.5],
      [1475, 120.5],
      [1478, 122.5],
      [1481, 107.5],
      [1484, 120.5],
      [1487, 113.5],
      [1490, 105.5],
      [1493, 123.5],
      [1496, 107.5],
      [1499, 101.5],
      [1502, 99.5],
      [1505, 122.5],
      [1508, 115.5],
      [1511, 118.5],
      [1514, 112.5],
      [1517, 103.5],
      [1520, 108.5],
      [1523, 95.5],
      [1526, 91.5],
      [1529, 84.5],
      [1532, 84.5],
      [1535, 78.5],
      [1538, 76.5],
      [1541, 75.5],
      [1544, 75.5],
      [1547, 75.5],
      [1550, 75.5],
    ],
    bottom: [
      [1548, 75.5],
      [1545, 74.5],
      [1542, 74.5],
      [1539, 74.5],
      [1536, 73.5],
      [1533, 67.5],
      [1530, 62.5],
      [1527, 61.5],
      [1524, 51.5],
      [1521, 37.5],
      [1518, 31.5],
      [1515, 30.5],
      [1512, 41.5],
      [1509, 36.5],
      [1506, 33.5],
      [1503, 38.5],
      [1500, 30.5],
      [1497, 42.5],
      [1494, 46.5],
      [1491, 35.5],
      [1488, 27.5],
      [1485, 27.5],
      [1482, 47.5],
      [1479, 37.5],
      [1476, 41.5],
      [1473, 31.5],
      [1470, 30.5],
      [1467, 39.5],
      [1464, 38.5],
      [1461, 39.5],
      [1458, 28.5],
      [1455, 31.5],
      [1452, 31.5],
      [1449, 42.5],
      [1446, 42.5],
      [1443, 29.5],
      [1440, 26.5],
      [1437, 48.5],
      [1434, 32.5],
      [1431, 37.5],
      [1428, 36.5],
      [1425, 30.5],
      [1422, 47.5],
      [1419, 41.5],
      [1416, 48.5],
      [1413, 33.5],
      [1410, 44.5],
      [1407, 46.5],
      [1404, 47.5],
      [1401, 44.5],
      [1398, 26.5],
      [1395, 24.5],
      [1392, 48.5],
      [1389, 40.5],
      [1386, 44.5],
      [1383, 32.5],
      [1380, 30.5],
      [1377, 49.5],
      [1374, 52.5],
      [1371, 42.5],
      [1368, 42.5],
      [1365, 31.5],
      [1362, 41.5],
      [1359, 37.5],
      [1356, 29.5],
      [1353, 27.5],
      [1350, 39.5],
      [1347, 52.5],
      [1344, 39.5],
      [1341, 43.5],
      [1338, 25.5],
      [1335, 29.5],
      [1332, 49.5],
      [1329, 21.5],
      [1326, 46.5],
      [1323, 28.5],
      [1320, 24.5],
      [1317, 48.5],
      [1314, 40.5],
      [1311, 43.5],
      [1308, 28.5],
      [1305, 27.5],
      [1302, 42.5],
      [1299, 43.5],
      [1296, 41.5],
      [1293, 27.5],
      [1290, 42.5],
      [1287, 55.5],
      [1284, 36.5],
      [1281, 38.5],
      [1278, 19.5],
      [1275, 25.5],
      [1272, 44.5],
      [1269, 27.5],
      [1266, 41.5],
      [1263, 24.5],
      [1260, 28.5],
      [1257, 44.5],
      [1254, 39.5],
      [1251, 48.5],
      [1248, 25.5],
      [1245, 23.5],
      [1242, 27.5],
      [1239, 34.5],
      [1236, 46.5],
      [1233, 39.5],
      [1230, 22.5],
      [1227, 51.5],
      [1224, 31.5],
      [1221, 44.5],
      [1218, 26.5],
      [1215, 31.5],
      [1212, 56.5],
      [1209, 30.5],
      [1206, 49.5],
      [1203, 36.5],
      [1200, 31.5],
      [1197, 45.5],
      [1194, 41.5],
      [1191, 47.5],
      [1188, 44.5],
      [1185, 23.5],
      [1182, 41.5],
      [1179, 45.5],
      [1176, 45.5],
      [1173, 33.5],
      [1170, 47.5],
      [1167, 48.5],
      [1164, 31.5],
      [1161, 34.5],
      [1158, 26.5],
      [1155, 24.5],
      [1152, 51.5],
      [1149, 36.5],
      [1146, 32.5],
      [1143, 32.5],
      [1140, 26.5],
      [1137, 51.5],
      [1134, 42.5],
      [1131, 51.5],
      [1128, 34.5],
      [1125, 27.5],
      [1122, 44.5],
      [1119, 32.5],
      [1116, 39.5],
      [1113, 26.5],
      [1110, 24.5],
      [1107, 50.5],
      [1104, 37.5],
      [1101, 43.5],
      [1098, 26.5],
      [1095, 23.5],
      [1092, 52.5],
      [1089, 28.5],
      [1086, 35.5],
      [1083, 21.5],
      [1080, 21.5],
      [1077, 47.5],
      [1074, 43.5],
      [1071, 55.5],
      [1068, 22.5],
      [1065, 23.5],
      [1062, 36.5],
      [1059, 32.5],
      [1056, 40.5],
      [1053, 24.5],
      [1050, 48.5],
      [1047, 58.5],
      [1044, 49.5],
      [1041, 44.5],
      [1038, 23.5],
      [1035, 29.5],
      [1032, 34.5],
      [1029, 30.5],
      [1026, 36.5],
      [1023, 23.5],
      [1020, 26.5],
      [1017, 33.5],
      [1014, 26.5],
      [1011, 27.5],
      [1008, 31.5],
      [1005, 22.5],
      [1002, 32.5],
      [999, 44.5],
      [996, 36.5],
      [993, 43.5],
      [990, 26.5],
      [987, 31.5],
      [984, 24.5],
      [981, 40.5],
      [978, 37.5],
      [975, 35.5],
      [972, 37.5],
      [969, 25.5],
      [966, 32.5],
      [963, 34.5],
      [960, 19.5],
      [957, 34.5],
      [954, 29.5],
      [951, 42.5],
      [948, 35.5],
      [945, 31.5],
      [942, 41.5],
      [939, 30.5],
      [936, 35.5],
      [933, 28.5],
      [930, 21.5],
      [927, 34.5],
      [924, 30.5],
      [921, 26.5],
      [918, 39.5],
      [915, 30.5],
      [912, 27.5],
      [909, 32.5],
      [906, 34.5],
      [903, 27.5],
      [900, 26.5],
      [897, 39.5],
      [894, 30.5],
      [891, 35.5],
      [888, 39.5],
      [885, 21.5],
      [882, 23.5],
      [879, 40.5],
      [876, 16.5],
      [873, 33.5],
      [870, 26.5],
      [867, 34.5],
      [864, 26.5],
      [861, 36.5],
      [858, 36.5],
      [855, 15.5],
      [852, 39.5],
      [849, 23.5],
      [846, 36.5],
      [843, 32.5],
      [840, 18.5],
      [837, 47.5],
      [834, 41.5],
      [831, 51.5],
      [828, 28.5],
      [825, 30.5],
      [822, 29.5],
      [819, 40.5],
      [816, 34.5],
      [813, 22.5],
      [810, 44.5],
      [807, 49.5],
      [804, 30.5],
      [801, 44.5],
      [798, 26.5],
      [795, 30.5],
      [792, 57.5],
      [789, 39.5],
      [786, 30.5],
      [783, 23.5],
      [780, 25.5],
      [777, 41.5],
      [774, 30.5],
      [771, 51.5],
      [768, 49.5],
      [765, 17.5],
      [762, 31.5],
      [759, 33.5],
      [756, 26.5],
      [753, 31.5],
      [750, 24.5],
      [747, 41.5],
      [744, 35.5],
      [741, 28.5],
      [738, 50.5],
      [735, 40.5],
      [732, 34.5],
      [729, 47.5],
      [726, 26.5],
      [723, 23.5],
      [720, 30.5],
      [717, 49.5],
      [714, 38.5],
      [711, 51.5],
      [708, 32.5],
      [705, 40.5],
      [702, 37.5],
      [699, 34.5],
      [696, 35.5],
      [693, 29.5],
      [690, 22.5],
      [687, 33.5],
      [684, 33.5],
      [681, 34.5],
      [678, 44.5],
      [675, 31.5],
      [672, 31.5],
      [669, 35.5],
      [666, 20.5],
      [663, 27.5],
      [660, 30.5],
      [657, 42.5],
      [654, 36.5],
      [651, 44.5],
      [648, 28.5],
      [645, 34.5],
      [642, 47.5],
      [639, 24.5],
      [636, 27.5],
      [633, 31.5],
      [630, 36.5],
      [627, 51.5],
      [624, 32.5],
      [621, 38.5],
      [618, 26.5],
      [615, 16.5],
      [612, 52.5],
      [609, 19.5],
      [606, 44.5],
      [603, 30.5],
      [600, 27.5],
      [597, 48.5],
      [594, 45.5],
      [591, 53.5],
      [588, 33.5],
      [585, 24.5],
      [582, 31.5],
      [579, 35.5],
      [576, 38.5],
      [573, 24.5],
      [570, 38.5],
      [567, 50.5],
      [564, 37.5],
      [561, 35.5],
      [558, 19.5],
      [555, 17.5],
      [552, 59.5],
      [549, 17.5],
      [546, 37.5],
      [543, 14.5],
      [540, 26.5],
      [537, 45.5],
      [534, 46.5],
      [531, 50.5],
      [528, 30.5],
      [525, 27.5],
      [522, 29.5],
      [519, 30.5],
      [516, 30.5],
      [513, 21.5],
      [510, 30.5],
      [507, 50.5],
      [504, 33.5],
      [501, 35.5],
      [498, 17.5],
      [495, 25.5],
      [492, 51.5],
      [489, 14.5],
      [486, 39.5],
      [483, 20.5],
      [480, 15.5],
      [477, 29.5],
      [474, 37.5],
      [471, 30.5],
      [468, 16.5],
      [465, 21.5],
      [462, 33.5],
      [459, 30.5],
      [456, 28.5],
      [453, 21.5],
      [450, 14.5],
      [447, 21.5],
      [444, 35.5],
      [441, 32.5],
      [438, 21.5],
      [435, 22.5],
      [432, 22.5],
      [429, 34.5],
      [426, 16.5],
      [423, 36.5],
      [420, 15.5],
      [417, 34.5],
      [414, 29.5],
      [411, 23.5],
      [408, 38.5],
      [405, 24.5],
      [402, 40.5],
      [399, 24.5],
      [396, 24.5],
      [393, 18.5],
      [390, 16.5],
      [387, 31.5],
      [384, 29.5],
      [381, 35.5],
      [378, 15.5],
      [375, 16.5],
      [372, 28.5],
      [369, 41.5],
      [366, 38.5],
      [363, 48.5],
      [360, 17.5],
      [357, 36.5],
      [354, 26.5],
      [351, 38.5],
      [348, 9.5],
      [345, 12.5],
      [342, 29.5],
      [339, 34.5],
      [336, 22.5],
      [333, 19.5],
      [330, 16.5],
      [327, 39.5],
      [324, 44.5],
      [321, 26.5],
      [318, 13.5],
      [315, 20.5],
      [312, 52.5],
      [309, 20.5],
      [306, 34.5],
      [303, 13.5],
      [300, 16.5],
      [297, 46.5],
      [294, 28.5],
      [291, 41.5],
      [288, 17.5],
      [285, 29.5],
      [282, 33.5],
      [279, 36.5],
      [276, 40.5],
      [273, 29.5],
      [270, 7.5],
      [267, 44.5],
      [264, 35.5],
      [261, 34.5],
      [258, 12.5],
      [255, 12.5],
      [252, 47.5],
      [249, 15.5],
      [246, 29.5],
      [243, 35.5],
      [240, 22.5],
      [237, 29.5],
      [234, 36.5],
      [231, 43.5],
      [228, 20.5],
      [225, 14.5],
      [222, 22.5],
      [219, 34.5],
      [216, 39.5],
      [213, 15.5],
      [210, 38.5],
      [207, 52.5],
      [204, 25.5],
      [201, 32.5],
      [198, 16.5],
      [195, 19.5],
      [192, 33.5],
      [189, 44.5],
      [186, 41.5],
      [183, 21.5],
      [180, 11.5],
      [177, 42.5],
      [174, 29.5],
      [171, 44.5],
      [168, 30.5],
      [165, 18.5],
      [162, 36.5],
      [159, 32.5],
      [156, 27.5],
      [153, 28.5],
      [150, 9.5],
      [147, 27.5],
      [144, 28.5],
      [141, 31.5],
      [138, 25.5],
      [135, 19.5],
      [132, 57.5],
      [129, 30.5],
      [126, 11.5],
      [123, 29.5],
      [120, 27.5],
      [117, 46.5],
      [114, 43.5],
      [111, 48.5],
      [108, 58.5],
      [105, 33.5],
      [102, 18.5],
      [99, 25.5],
      [96, 36.5],
      [93, 20.5],
      [90, 31.5],
      [87, 37.5],
      [84, 37.5],
      [81, 22.5],
      [78, 28.5],
      [75, 14.5],
      [72, 55.5],
      [69, 23.5],
      [66, 25.5],
      [63, 33.5],
      [60, 11.5],
      [57, 29.5],
      [54, 30.5],
      [51, 43.5],
      [48, 59.5],
      [45, 25.5],
      [42, 22.5],
      [39, 28.5],
      [36, 23.5],
      [33, 15.5],
      [30, 23.5],
      [27, 37.5],
      [24, 22.5],
      [21, 26.5],
      [18, 11.5],
      [15, 6.5],
      [12, 45.5],
      [9, 2.7506000000000057],
      [6, 5.5],
      [3, 16.5],
      [0, 42.5],
    ],
  },
  {
    top: [
      [2, 138.5],
      [5, 143.6984],
      [8, 104.5],
      [11, 107.5],
      [14, 130.5],
      [17, 115.5],
      [20, 143.5],
      [23, 118.5],
      [26, 131.5],
      [29, 139.5],
      [32, 104.5],
      [35, 135.5],
      [38, 144.4976],
      [41, 124.5],
      [44, 144.1054],
      [47, 110.5],
      [50, 138.5],
      [53, 140.5],
      [56, 142.5],
      [59, 132.5],
      [62, 134.5],
      [65, 129.5],
      [68, 107.5],
      [71, 115.5],
      [74, 129.5],
      [77, 126.5],
      [80, 130.5],
      [83, 114.5],
      [86, 134.5],
      [89, 132.5],
      [92, 105.5],
      [95, 125.5],
      [98, 138.5],
      [101, 127.5],
      [104, 120.5],
      [107, 107.5],
      [110, 117.5],
      [113, 132.5],
      [116, 120.5],
      [119, 134.5],
      [122, 124.5],
      [125, 130.5],
      [128, 102.5],
      [131, 107.5],
      [134, 116.5],
      [137, 108.5],
      [140, 145.5],
      [143, 117.5],
      [146, 126.5],
      [149, 139.5],
      [152, 110.5],
      [155, 119.5],
      [158, 128.5],
      [161, 116.5],
      [164, 126.5],
      [167, 97.5],
      [170, 117.5],
      [173, 139.5],
      [176, 121.5],
      [179, 133.5],
      [182, 112.5],
      [185, 118.5],
      [188, 131.5],
      [191, 106.5],
      [194, 105.5],
      [197, 98.5],
      [200, 126.5],
      [203, 112.5],
      [206, 111.5],
      [209, 131.5],
      [212, 100.5],
      [215, 127.5],
      [218, 143.2766],
      [221, 114.5],
      [224, 127.5],
      [227, 122.5],
      [230, 124.5],
      [233, 127.5],
      [236, 107.5],
      [239, 113.5],
      [242, 126.5],
      [245, 128.5],
      [248, 142.5],
      [251, 113.5],
      [254, 108.5],
      [257, 111.5],
      [260, 133.5],
      [263, 129.5],
      [266, 109.5],
      [269, 115.5],
      [272, 111.5],
      [275, 136.5],
      [278, 137.5],
      [281, 116.5],
      [284, 113.5],
      [287, 111.5],
      [290, 108.5],
      [293, 133.5],
      [296, 120.5],
      [299, 108.5],
      [302, 122.5],
      [305, 132.5],
      [308, 134.5],
      [311, 103.5],
      [314, 116.5],
      [317, 109.5],
      [320, 128.5],
      [323, 117.5],
      [326, 117.5],
      [329, 120.5],
      [332, 111.5],
      [335, 138.5],
      [338, 128.5],
      [341, 119.5],
      [344, 110.5],
      [347, 106.5],
      [350, 139.5],
      [353, 122.5],
      [356, 105.5],
      [359, 109.5],
      [362, 111.5],
      [365, 127.5],
      [368, 91.5],
      [371, 110.5],
      [374, 126.5],
      [377, 125.5],
      [380, 129.5],
      [383, 114.5],
      [386, 116.5],
      [389, 116.5],
      [392, 108.5],
      [395, 126.5],
      [398, 123.5],
      [401, 103.5],
      [404, 100.5],
      [407, 106.5],
      [410, 124.5],
      [413, 124.5],
      [416, 124.5],
      [419, 108.5],
      [422, 114.5],
      [425, 126.5],
      [428, 126.5],
      [431, 114.5],
      [434, 119.5],
      [437, 114.5],
      [440, 125.5],
      [443, 121.5],
      [446, 132.5],
      [449, 118.5],
      [452, 104.5],
      [455, 137.5],
      [458, 130.5],
      [461, 116.5],
      [464, 103.5],
      [467, 109.5],
      [470, 126.5],
      [473, 137.5],
      [476, 108.5],
      [479, 133.5],
      [482, 113.5],
      [485, 128.5],
      [488, 127.5],
      [491, 107.5],
      [494, 118.5],
      [497, 104.5],
      [500, 130.5],
      [503, 121.5],
      [506, 109.5],
      [509, 112.5],
      [512, 96.5],
      [515, 129.5],
      [518, 134.5],
      [521, 111.5],
      [524, 113.5],
      [527, 103.5],
      [530, 114.5],
      [533, 137.5],
      [536, 119.5],
      [539, 117.5],
      [542, 123.5],
      [545, 120.5],
      [548, 114.5],
      [551, 106.5],
      [554, 109.5],
      [557, 121.5],
      [560, 119.5],
      [563, 126.5],
      [566, 116.5],
      [569, 126.5],
      [572, 104.5],
      [575, 135.5],
      [578, 130.5],
      [581, 115.5],
      [584, 110.5],
      [587, 107.5],
      [590, 120.5],
      [593, 112.5],
      [596, 110.5],
      [599, 110.5],
      [602, 113.5],
      [605, 120.5],
      [608, 120.5],
      [611, 104.5],
      [614, 120.5],
      [617, 101.5],
      [620, 131.5],
      [623, 132.5],
      [626, 107.5],
      [629, 125.5],
      [632, 99.5],
      [635, 121.5],
      [638, 126.5],
      [641, 115.5],
      [644, 120.5],
      [647, 111.5],
      [650, 127.5],
      [653, 124.5],
      [656, 105.5],
      [659, 108.5],
      [662, 123.5],
      [665, 115.5],
      [668, 123.5],
      [671, 124.5],
      [674, 114.5],
      [677, 114.5],
      [680, 126.5],
      [683, 113.5],
      [686, 120.5],
      [689, 132.5],
      [692, 119.5],
      [695, 122.5],
      [698, 120.5],
      [701, 121.5],
      [704, 118.5],
      [707, 93.5],
      [710, 109.5],
      [713, 116.5],
      [716, 102.5],
      [719, 120.5],
      [722, 111.5],
      [725, 117.5],
      [728, 122.5],
      [731, 119.5],
      [734, 112.5],
      [737, 112.5],
      [740, 120.5],
      [743, 122.5],
      [746, 123.5],
      [749, 115.5],
      [752, 117.5],
      [755, 120.5],
      [758, 115.5],
      [761, 122.5],
      [764, 111.5],
      [767, 97.5],
      [770, 129.5],
      [773, 128.5],
      [776, 109.5],
      [779, 117.5],
      [782, 113.5],
      [785, 111.5],
      [788, 100.5],
      [791, 98.5],
      [794, 112.5],
      [797, 107.5],
      [800, 119.5],
      [803, 124.5],
      [806, 111.5],
      [809, 126.5],
      [812, 97.5],
      [815, 118.5],
      [818, 133.5],
      [821, 107.5],
      [824, 118.5],
      [827, 106.5],
      [830, 124.5],
      [833, 119.5],
      [836, 116.5],
      [839, 104.5],
      [842, 123.5],
      [845, 127.5],
      [848, 121.5],
      [851, 119.5],
      [854, 109.5],
      [857, 101.5],
      [860, 127.5],
      [863, 132.5],
      [866, 121.5],
      [869, 120.5],
      [872, 103.5],
      [875, 131.5],
      [878, 116.5],
      [881, 126.5],
      [884, 119.5],
      [887, 121.5],
      [890, 130.5],
      [893, 116.5],
      [896, 117.5],
      [899, 120.5],
      [902, 117.5],
      [905, 118.5],
      [908, 120.5],
      [911, 118.5],
      [914, 111.5],
      [917, 121.5],
      [920, 129.5],
      [923, 116.5],
      [926, 124.5],
      [929, 119.5],
      [932, 113.5],
      [935, 118.5],
      [938, 110.5],
      [941, 120.5],
      [944, 115.5],
      [947, 108.5],
      [950, 126.5],
      [953, 114.5],
      [956, 117.5],
      [959, 110.5],
      [962, 110.5],
      [965, 119.5],
      [968, 111.5],
      [971, 111.5],
      [974, 118.5],
      [977, 101.5],
      [980, 126.5],
      [983, 117.5],
      [986, 104.5],
      [989, 110.5],
      [992, 110.5],
      [995, 105.5],
      [998, 106.5],
      [1001, 117.5],
      [1004, 115.5],
      [1007, 111.5],
      [1010, 129.5],
      [1013, 127.5],
      [1016, 125.5],
      [1019, 128.5],
      [1022, 111.5],
      [1025, 124.5],
      [1028, 111.5],
      [1031, 106.5],
      [1034, 104.5],
      [1037, 104.5],
      [1040, 127.5],
      [1043, 113.5],
      [1046, 107.5],
      [1049, 130.5],
      [1052, 101.5],
      [1055, 122.5],
      [1058, 125.5],
      [1061, 103.5],
      [1064, 118.5],
      [1067, 105.5],
      [1070, 127.5],
      [1073, 124.5],
      [1076, 106.5],
      [1079, 113.5],
      [1082, 121.5],
      [1085, 126.5],
      [1088, 119.5],
      [1091, 105.5],
      [1094, 110.5],
      [1097, 104.5],
      [1100, 118.5],
      [1103, 120.5],
      [1106, 113.5],
      [1109, 121.5],
      [1112, 100.5],
      [1115, 127.5],
      [1118, 128.5],
      [1121, 107.5],
      [1124, 111.5],
      [1127, 102.5],
      [1130, 113.5],
      [1133, 130.5],
      [1136, 121.5],
      [1139, 108.5],
      [1142, 117.5],
      [1145, 121.5],
      [1148, 128.5],
      [1151, 101.5],
      [1154, 108.5],
      [1157, 110.5],
      [1160, 123.5],
      [1163, 115.5],
      [1166, 117.5],
      [1169, 118.5],
      [1172, 99.5],
      [1175, 125.5],
      [1178, 122.5],
      [1181, 103.5],
      [1184, 115.5],
      [1187, 95.5],
      [1190, 108.5],
      [1193, 119.5],
      [1196, 121.5],
      [1199, 123.5],
      [1202, 103.5],
      [1205, 126.5],
      [1208, 120.5],
      [1211, 99.5],
      [1214, 109.5],
      [1217, 101.5],
      [1220, 111.5],
      [1223, 112.5],
      [1226, 112.5],
      [1229, 103.5],
      [1232, 111.5],
      [1235, 119.5],
      [1238, 126.5],
      [1241, 111.5],
      [1244, 122.5],
      [1247, 98.5],
      [1250, 110.5],
      [1253, 125.5],
      [1256, 104.5],
      [1259, 107.5],
      [1262, 118.5],
      [1265, 126.5],
      [1268, 122.5],
      [1271, 118.5],
      [1274, 123.5],
      [1277, 118.5],
      [1280, 122.5],
      [1283, 128.5],
      [1286, 116.5],
      [1289, 128.5],
      [1292, 96.5],
      [1295, 118.5],
      [1298, 121.5],
      [1301, 105.5],
      [1304, 118.5],
      [1307, 106.5],
      [1310, 125.5],
      [1313, 123.5],
      [1316, 118.5],
      [1319, 104.5],
      [1322, 119.5],
      [1325, 124.5],
      [1328, 123.5],
      [1331, 101.5],
      [1334, 106.5],
      [1337, 97.5],
      [1340, 116.5],
      [1343, 122.5],
      [1346, 99.5],
      [1349, 120.5],
      [1352, 97.5],
      [1355, 126.5],
      [1358, 121.5],
      [1361, 114.5],
      [1364, 112.5],
      [1367, 108.5],
      [1370, 105.5],
      [1373, 123.5],
      [1376, 102.5],
      [1379, 98.5],
      [1382, 112.5],
      [1385, 116.5],
      [1388, 118.5],
      [1391, 105.5],
      [1394, 111.5],
      [1397, 105.5],
      [1400, 123.5],
      [1403, 120.5],
      [1406, 106.5],
      [1409, 126.5],
      [1412, 92.5],
      [1415, 109.5],
      [1418, 118.5],
      [1421, 108.5],
      [1424, 110.5],
      [1427, 99.5],
      [1430, 123.5],
      [1433, 122.5],
      [1436, 123.5],
      [1439, 109.5],
      [1442, 109.5],
      [1445, 115.5],
      [1448, 121.5],
      [1451, 113.5],
      [1454, 109.5],
      [1457, 108.5],
      [1460, 125.5],
      [1463, 122.5],
      [1466, 112.5],
      [1469, 104.5],
      [1472, 105.5],
      [1475, 122.5],
      [1478, 123.5],
      [1481, 107.5],
      [1484, 119.5],
      [1487, 115.5],
      [1490, 104.5],
      [1493, 125.5],
      [1496, 108.5],
      [1499, 101.5],
      [1502, 98.5],
      [1505, 123.5],
      [1508, 115.5],
      [1511, 120.5],
      [1514, 112.5],
      [1517, 102.5],
      [1520, 109.5],
      [1523, 96.5],
      [1526, 91.5],
      [1529, 85.5],
      [1532, 85.5],
      [1535, 79.5],
      [1538, 76.5],
      [1541, 75.5],
      [1544, 75.5],
      [1547, 75.5],
      [1550, 75.5],
    ],
    bottom: [
      [1548, 75.5],
      [1545, 75.5],
      [1542, 75.5],
      [1539, 74.5],
      [1536, 73.5],
      [1533, 67.5],
      [1530, 61.5],
      [1527, 60.5],
      [1524, 51.5],
      [1521, 37.5],
      [1518, 30.5],
      [1515, 28.5],
      [1512, 42.5],
      [1509, 37.5],
      [1506, 33.5],
      [1503, 39.5],
      [1500, 30.5],
      [1497, 40.5],
      [1494, 45.5],
      [1491, 36.5],
      [1488, 25.5],
      [1485, 25.5],
      [1482, 48.5],
      [1479, 37.5],
      [1476, 39.5],
      [1473, 32.5],
      [1470, 28.5],
      [1467, 39.5],
      [1464, 39.5],
      [1461, 39.5],
      [1458, 26.5],
      [1455, 31.5],
      [1452, 36.5],
      [1449, 43.5],
      [1446, 43.5],
      [1443, 31.5],
      [1440, 26.5],
      [1437, 46.5],
      [1434, 33.5],
      [1431, 39.5],
      [1428, 39.5],
      [1425, 30.5],
      [1422, 48.5],
      [1419, 40.5],
      [1416, 48.5],
      [1413, 32.5],
      [1410, 44.5],
      [1407, 44.5],
      [1404, 46.5],
      [1401, 46.5],
      [1398, 27.5],
      [1395, 27.5],
      [1392, 49.5],
      [1389, 44.5],
      [1386, 45.5],
      [1383, 35.5],
      [1380, 32.5],
      [1377, 50.5],
      [1374, 51.5],
      [1371, 43.5],
      [1368, 44.5],
      [1365, 33.5],
      [1362, 41.5],
      [1359, 38.5],
      [1356, 30.5],
      [1353, 28.5],
      [1350, 39.5],
      [1347, 52.5],
      [1344, 41.5],
      [1341, 44.5],
      [1338, 25.5],
      [1335, 27.5],
      [1332, 50.5],
      [1329, 20.5],
      [1326, 46.5],
      [1323, 29.5],
      [1320, 24.5],
      [1317, 48.5],
      [1314, 41.5],
      [1311, 43.5],
      [1308, 27.5],
      [1305, 29.5],
      [1302, 43.5],
      [1299, 42.5],
      [1296, 39.5],
      [1293, 29.5],
      [1290, 39.5],
      [1287, 55.5],
      [1284, 36.5],
      [1281, 36.5],
      [1278, 21.5],
      [1275, 26.5],
      [1272, 43.5],
      [1269, 26.5],
      [1266, 41.5],
      [1263, 24.5],
      [1260, 30.5],
      [1257, 45.5],
      [1254, 39.5],
      [1251, 47.5],
      [1248, 24.5],
      [1245, 25.5],
      [1242, 29.5],
      [1239, 36.5],
      [1236, 47.5],
      [1233, 39.5],
      [1230, 25.5],
      [1227, 52.5],
      [1224, 33.5],
      [1221, 45.5],
      [1218, 25.5],
      [1215, 30.5],
      [1212, 56.5],
      [1209, 27.5],
      [1206, 48.5],
      [1203, 36.5],
      [1200, 32.5],
      [1197, 47.5],
      [1194, 43.5],
      [1191, 49.5],
      [1188, 47.5],
      [1185, 27.5],
      [1182, 43.5],
      [1179, 46.5],
      [1176, 45.5],
      [1173, 35.5],
      [1170, 48.5],
      [1167, 48.5],
      [1164, 32.5],
      [1161, 35.5],
      [1158, 28.5],
      [1155, 26.5],
      [1152, 53.5],
      [1149, 38.5],
      [1146, 35.5],
      [1143, 31.5],
      [1140, 27.5],
      [1137, 51.5],
      [1134, 42.5],
      [1131, 52.5],
      [1128, 33.5],
      [1125, 27.5],
      [1122, 45.5],
      [1119, 33.5],
      [1116, 40.5],
      [1113, 27.5],
      [1110, 26.5],
      [1107, 51.5],
      [1104, 38.5],
      [1101, 41.5],
      [1098, 23.5],
      [1095, 25.5],
      [1092, 50.5],
      [1089, 31.5],
      [1086, 35.5],
      [1083, 22.5],
      [1080, 20.5],
      [1077, 47.5],
      [1074, 42.5],
      [1071, 53.5],
      [1068, 23.5],
      [1065, 25.5],
      [1062, 37.5],
      [1059, 34.5],
      [1056, 40.5],
      [1053, 24.5],
      [1050, 48.5],
      [1047, 57.5],
      [1044, 48.5],
      [1041, 44.5],
      [1038, 24.5],
      [1035, 31.5],
      [1032, 36.5],
      [1029, 32.5],
      [1026, 38.5],
      [1023, 26.5],
      [1020, 27.5],
      [1017, 36.5],
      [1014, 25.5],
      [1011, 27.5],
      [1008, 30.5],
      [1005, 24.5],
      [1002, 35.5],
      [999, 47.5],
      [996, 40.5],
      [993, 46.5],
      [990, 31.5],
      [987, 36.5],
      [984, 28.5],
      [981, 41.5],
      [978, 39.5],
      [975, 35.5],
      [972, 37.5],
      [969, 22.5],
      [966, 33.5],
      [963, 36.5],
      [960, 22.5],
      [957, 37.5],
      [954, 30.5],
      [951, 43.5],
      [948, 35.5],
      [945, 31.5],
      [942, 42.5],
      [939, 31.5],
      [936, 34.5],
      [933, 28.5],
      [930, 20.5],
      [927, 35.5],
      [924, 30.5],
      [921, 24.5],
      [918, 40.5],
      [915, 31.5],
      [912, 30.5],
      [909, 35.5],
      [906, 35.5],
      [903, 29.5],
      [900, 24.5],
      [897, 40.5],
      [894, 30.5],
      [891, 37.5],
      [888, 37.5],
      [885, 24.5],
      [882, 25.5],
      [879, 42.5],
      [876, 19.5],
      [873, 33.5],
      [870, 25.5],
      [867, 35.5],
      [864, 28.5],
      [861, 38.5],
      [858, 36.5],
      [855, 16.5],
      [852, 41.5],
      [849, 23.5],
      [846, 38.5],
      [843, 33.5],
      [840, 20.5],
      [837, 48.5],
      [834, 44.5],
      [831, 52.5],
      [828, 31.5],
      [825, 32.5],
      [822, 31.5],
      [819, 42.5],
      [816, 34.5],
      [813, 21.5],
      [810, 44.5],
      [807, 50.5],
      [804, 33.5],
      [801, 47.5],
      [798, 30.5],
      [795, 34.5],
      [792, 59.5],
      [789, 42.5],
      [786, 35.5],
      [783, 28.5],
      [780, 28.5],
      [777, 42.5],
      [774, 28.5],
      [771, 49.5],
      [768, 50.5],
      [765, 21.5],
      [762, 35.5],
      [759, 36.5],
      [756, 29.5],
      [753, 34.5],
      [750, 26.5],
      [747, 43.5],
      [744, 35.5],
      [741, 30.5],
      [738, 51.5],
      [735, 41.5],
      [732, 34.5],
      [729, 47.5],
      [726, 26.5],
      [723, 23.5],
      [720, 30.5],
      [717, 49.5],
      [714, 40.5],
      [711, 52.5],
      [708, 35.5],
      [705, 41.5],
      [702, 38.5],
      [699, 35.5],
      [696, 34.5],
      [693, 29.5],
      [690, 21.5],
      [687, 35.5],
      [684, 35.5],
      [681, 35.5],
      [678, 44.5],
      [675, 31.5],
      [672, 30.5],
      [669, 35.5],
      [666, 23.5],
      [663, 30.5],
      [660, 31.5],
      [657, 41.5],
      [654, 34.5],
      [651, 42.5],
      [648, 29.5],
      [645, 35.5],
      [642, 47.5],
      [639, 27.5],
      [636, 31.5],
      [633, 35.5],
      [630, 37.5],
      [627, 51.5],
      [624, 33.5],
      [621, 39.5],
      [618, 26.5],
      [615, 15.5],
      [612, 52.5],
      [609, 22.5],
      [606, 47.5],
      [603, 32.5],
      [600, 32.5],
      [597, 51.5],
      [594, 49.5],
      [591, 54.5],
      [588, 37.5],
      [585, 28.5],
      [582, 33.5],
      [579, 36.5],
      [576, 38.5],
      [573, 24.5],
      [570, 38.5],
      [567, 51.5],
      [564, 40.5],
      [561, 38.5],
      [558, 23.5],
      [555, 19.5],
      [552, 59.5],
      [549, 17.5],
      [546, 37.5],
      [543, 15.5],
      [540, 28.5],
      [537, 44.5],
      [534, 46.5],
      [531, 51.5],
      [528, 30.5],
      [525, 25.5],
      [522, 30.5],
      [519, 31.5],
      [516, 32.5],
      [513, 25.5],
      [510, 33.5],
      [507, 51.5],
      [504, 33.5],
      [501, 35.5],
      [498, 17.5],
      [495, 23.5],
      [492, 51.5],
      [489, 18.5],
      [486, 42.5],
      [483, 24.5],
      [480, 19.5],
      [477, 30.5],
      [474, 36.5],
      [471, 30.5],
      [468, 19.5],
      [465, 23.5],
      [462, 36.5],
      [459, 32.5],
      [456, 26.5],
      [453, 22.5],
      [450, 14.5],
      [447, 21.5],
      [444, 36.5],
      [441, 36.5],
      [438, 27.5],
      [435, 28.5],
      [432, 26.5],
      [429, 38.5],
      [426, 17.5],
      [423, 37.5],
      [420, 18.5],
      [417, 34.5],
      [414, 30.5],
      [411, 26.5],
      [408, 40.5],
      [405, 28.5],
      [402, 42.5],
      [399, 27.5],
      [396, 29.5],
      [393, 23.5],
      [390, 22.5],
      [387, 34.5],
      [384, 33.5],
      [381, 36.5],
      [378, 12.5],
      [375, 15.5],
      [372, 30.5],
      [369, 43.5],
      [366, 41.5],
      [363, 50.5],
      [360, 20.5],
      [357, 39.5],
      [354, 26.5],
      [351, 38.5],
      [348, 11.5],
      [345, 16.5],
      [342, 32.5],
      [339, 33.5],
      [336, 21.5],
      [333, 21.5],
      [330, 21.5],
      [327, 39.5],
      [324, 42.5],
      [321, 27.5],
      [318, 16.5],
      [315, 25.5],
      [312, 54.5],
      [309, 24.5],
      [306, 38.5],
      [303, 15.5],
      [300, 15.5],
      [297, 46.5],
      [294, 30.5],
      [291, 44.5],
      [288, 21.5],
      [285, 32.5],
      [282, 35.5],
      [279, 38.5],
      [276, 40.5],
      [273, 28.5],
      [270, 10.5],
      [267, 46.5],
      [264, 38.5],
      [261, 36.5],
      [258, 10.5],
      [255, 15.5],
      [252, 47.5],
      [249, 14.5],
      [246, 31.5],
      [243, 35.5],
      [240, 25.5],
      [237, 33.5],
      [234, 38.5],
      [231, 45.5],
      [228, 24.5],
      [225, 15.5],
      [222, 24.5],
      [219, 32.5],
      [216, 39.5],
      [213, 18.5],
      [210, 40.5],
      [207, 53.5],
      [204, 29.5],
      [201, 36.5],
      [198, 20.5],
      [195, 24.5],
      [192, 36.5],
      [189, 47.5],
      [186, 43.5],
      [183, 23.5],
      [180, 10.5],
      [177, 42.5],
      [174, 28.5],
      [171, 46.5],
      [168, 33.5],
      [165, 21.5],
      [162, 37.5],
      [159, 36.5],
      [156, 30.5],
      [153, 29.5],
      [150, 9.5],
      [147, 27.5],
      [144, 29.5],
      [141, 33.5],
      [138, 26.5],
      [135, 21.5],
      [132, 58.5],
      [129, 31.5],
      [126, 11.5],
      [123, 30.5],
      [120, 28.5],
      [117, 47.5],
      [114, 45.5],
      [111, 50.5],
      [108, 58.5],
      [105, 33.5],
      [102, 20.5],
      [99, 25.5],
      [96, 37.5],
      [93, 25.5],
      [90, 31.5],
      [87, 38.5],
      [84, 39.5],
      [81, 24.5],
      [78, 30.5],
      [75, 12.5],
      [72, 56.5],
      [69, 26.5],
      [66, 27.5],
      [63, 36.5],
      [60, 10.5],
      [57, 30.5],
      [54, 33.5],
      [51, 43.5],
      [48, 59.5],
      [45, 26.5],
      [42, 25.5],
      [39, 27.5],
      [36, 24.5],
      [33, 15.5],
      [30, 25.5],
      [27, 38.5],
      [24, 22.5],
      [21, 26.5],
      [18, 10.5],
      [15, 8.5],
      [12, 46.5],
      [9, 3.3944000000000045],
      [6, 5.5],
      [3, 15.5],
      [0, 39.5],
    ],
  },
  {
    top: [
      [2, 139.5],
      [5, 144.1054],
      [8, 104.5],
      [11, 106.5],
      [14, 130.5],
      [17, 115.5],
      [20, 142.5],
      [23, 119.5],
      [26, 131.5],
      [29, 138.5],
      [32, 103.5],
      [35, 132.5],
      [38, 144.4976],
      [41, 121.5],
      [44, 144.1054],
      [47, 108.5],
      [50, 135.5],
      [53, 138.5],
      [56, 135.5],
      [59, 130.5],
      [62, 136.5],
      [65, 125.5],
      [68, 104.5],
      [71, 113.5],
      [74, 126.5],
      [77, 130.5],
      [80, 128.5],
      [83, 112.5],
      [86, 131.5],
      [89, 133.5],
      [92, 103.5],
      [95, 122.5],
      [98, 133.5],
      [101, 127.5],
      [104, 119.5],
      [107, 105.5],
      [110, 117.5],
      [113, 132.5],
      [116, 117.5],
      [119, 134.5],
      [122, 120.5],
      [125, 128.5],
      [128, 106.5],
      [131, 105.5],
      [134, 115.5],
      [137, 106.5],
      [140, 144.1054],
      [143, 119.5],
      [146, 124.5],
      [149, 134.5],
      [152, 112.5],
      [155, 122.5],
      [158, 123.5],
      [161, 113.5],
      [164, 122.5],
      [167, 95.5],
      [170, 115.5],
      [173, 133.5],
      [176, 119.5],
      [179, 134.5],
      [182, 117.5],
      [185, 117.5],
      [188, 126.5],
      [191, 103.5],
      [194, 103.5],
      [197, 96.5],
      [200, 121.5],
      [203, 111.5],
      [206, 108.5],
      [209, 130.5],
      [212, 98.5],
      [215, 123.5],
      [218, 142.5],
      [221, 119.5],
      [224, 124.5],
      [227, 121.5],
      [230, 129.5],
      [233, 125.5],
      [236, 105.5],
      [239, 111.5],
      [242, 125.5],
      [245, 124.5],
      [248, 135.5],
      [251, 111.5],
      [254, 109.5],
      [257, 109.5],
      [260, 136.5],
      [263, 133.5],
      [266, 105.5],
      [269, 112.5],
      [272, 108.5],
      [275, 131.5],
      [278, 140.5],
      [281, 120.5],
      [284, 113.5],
      [287, 107.5],
      [290, 105.5],
      [293, 130.5],
      [296, 116.5],
      [299, 107.5],
      [302, 123.5],
      [305, 135.5],
      [308, 137.5],
      [311, 101.5],
      [314, 112.5],
      [317, 107.5],
      [320, 124.5],
      [323, 113.5],
      [326, 116.5],
      [329, 121.5],
      [332, 115.5],
      [335, 132.5],
      [338, 124.5],
      [341, 122.5],
      [344, 109.5],
      [347, 103.5],
      [350, 134.5],
      [353, 124.5],
      [356, 110.5],
      [359, 111.5],
      [362, 107.5],
      [365, 121.5],
      [368, 89.5],
      [371, 107.5],
      [374, 121.5],
      [377, 121.5],
      [380, 134.5],
      [383, 120.5],
      [386, 113.5],
      [389, 112.5],
      [392, 104.5],
      [395, 120.5],
      [398, 119.5],
      [401, 101.5],
      [404, 97.5],
      [407, 103.5],
      [410, 123.5],
      [413, 118.5],
      [416, 120.5],
      [419, 107.5],
      [422, 117.5],
      [425, 125.5],
      [428, 124.5],
      [431, 114.5],
      [434, 120.5],
      [437, 114.5],
      [440, 122.5],
      [443, 116.5],
      [446, 126.5],
      [449, 114.5],
      [452, 103.5],
      [455, 136.5],
      [458, 132.5],
      [461, 118.5],
      [464, 105.5],
      [467, 106.5],
      [470, 120.5],
      [473, 132.5],
      [476, 105.5],
      [479, 132.5],
      [482, 115.5],
      [485, 132.5],
      [488, 126.5],
      [491, 104.5],
      [494, 113.5],
      [497, 103.5],
      [500, 129.5],
      [503, 126.5],
      [506, 112.5],
      [509, 118.5],
      [512, 99.5],
      [515, 125.5],
      [518, 127.5],
      [521, 107.5],
      [524, 110.5],
      [527, 102.5],
      [530, 113.5],
      [533, 137.5],
      [536, 120.5],
      [539, 118.5],
      [542, 124.5],
      [545, 119.5],
      [548, 109.5],
      [551, 104.5],
      [554, 108.5],
      [557, 122.5],
      [560, 123.5],
      [563, 130.5],
      [566, 114.5],
      [569, 123.5],
      [572, 101.5],
      [575, 130.5],
      [578, 128.5],
      [581, 120.5],
      [584, 114.5],
      [587, 108.5],
      [590, 122.5],
      [593, 111.5],
      [596, 108.5],
      [599, 108.5],
      [602, 111.5],
      [605, 115.5],
      [608, 115.5],
      [611, 101.5],
      [614, 115.5],
      [617, 99.5],
      [620, 131.5],
      [623, 135.5],
      [626, 109.5],
      [629, 124.5],
      [632, 99.5],
      [635, 122.5],
      [638, 127.5],
      [641, 111.5],
      [644, 115.5],
      [647, 107.5],
      [650, 122.5],
      [653, 120.5],
      [656, 103.5],
      [659, 111.5],
      [662, 127.5],
      [665, 115.5],
      [668, 119.5],
      [671, 119.5],
      [674, 110.5],
      [677, 112.5],
      [680, 125.5],
      [683, 115.5],
      [686, 122.5],
      [689, 131.5],
      [692, 117.5],
      [695, 118.5],
      [698, 117.5],
      [701, 121.5],
      [704, 122.5],
      [707, 94.5],
      [710, 111.5],
      [713, 116.5],
      [716, 103.5],
      [719, 117.5],
      [722, 108.5],
      [725, 113.5],
      [728, 118.5],
      [731, 115.5],
      [734, 112.5],
      [737, 114.5],
      [740, 123.5],
      [743, 121.5],
      [746, 124.5],
      [749, 111.5],
      [752, 114.5],
      [755, 118.5],
      [758, 115.5],
      [761, 122.5],
      [764, 110.5],
      [767, 97.5],
      [770, 125.5],
      [773, 123.5],
      [776, 107.5],
      [779, 117.5],
      [782, 116.5],
      [785, 115.5],
      [788, 101.5],
      [791, 99.5],
      [794, 113.5],
      [797, 103.5],
      [800, 116.5],
      [803, 119.5],
      [806, 107.5],
      [809, 120.5],
      [812, 95.5],
      [815, 115.5],
      [818, 130.5],
      [821, 108.5],
      [824, 120.5],
      [827, 107.5],
      [830, 121.5],
      [833, 117.5],
      [836, 114.5],
      [839, 103.5],
      [842, 122.5],
      [845, 122.5],
      [848, 116.5],
      [851, 114.5],
      [854, 107.5],
      [857, 101.5],
      [860, 128.5],
      [863, 134.5],
      [866, 123.5],
      [869, 119.5],
      [872, 101.5],
      [875, 125.5],
      [878, 113.5],
      [881, 125.5],
      [884, 117.5],
      [887, 120.5],
      [890, 130.5],
      [893, 116.5],
      [896, 116.5],
      [899, 119.5],
      [902, 118.5],
      [905, 120.5],
      [908, 122.5],
      [911, 117.5],
      [914, 110.5],
      [917, 118.5],
      [920, 131.5],
      [923, 113.5],
      [926, 120.5],
      [929, 116.5],
      [932, 111.5],
      [935, 117.5],
      [938, 110.5],
      [941, 120.5],
      [944, 118.5],
      [947, 111.5],
      [950, 124.5],
      [953, 111.5],
      [956, 115.5],
      [959, 109.5],
      [962, 110.5],
      [965, 119.5],
      [968, 109.5],
      [971, 111.5],
      [974, 117.5],
      [977, 101.5],
      [980, 128.5],
      [983, 119.5],
      [986, 108.5],
      [989, 113.5],
      [992, 109.5],
      [995, 107.5],
      [998, 107.5],
      [1001, 114.5],
      [1004, 111.5],
      [1007, 107.5],
      [1010, 123.5],
      [1013, 122.5],
      [1016, 122.5],
      [1019, 126.5],
      [1022, 111.5],
      [1025, 126.5],
      [1028, 116.5],
      [1031, 104.5],
      [1034, 103.5],
      [1037, 102.5],
      [1040, 125.5],
      [1043, 110.5],
      [1046, 105.5],
      [1049, 126.5],
      [1052, 99.5],
      [1055, 119.5],
      [1058, 122.5],
      [1061, 103.5],
      [1064, 120.5],
      [1067, 105.5],
      [1070, 124.5],
      [1073, 126.5],
      [1076, 105.5],
      [1079, 110.5],
      [1082, 118.5],
      [1085, 122.5],
      [1088, 117.5],
      [1091, 104.5],
      [1094, 110.5],
      [1097, 104.5],
      [1100, 122.5],
      [1103, 121.5],
      [1106, 112.5],
      [1109, 122.5],
      [1112, 100.5],
      [1115, 127.5],
      [1118, 127.5],
      [1121, 106.5],
      [1124, 112.5],
      [1127, 101.5],
      [1130, 111.5],
      [1133, 127.5],
      [1136, 118.5],
      [1139, 107.5],
      [1142, 114.5],
      [1145, 120.5],
      [1148, 125.5],
      [1151, 101.5],
      [1154, 107.5],
      [1157, 108.5],
      [1160, 123.5],
      [1163, 113.5],
      [1166, 117.5],
      [1169, 117.5],
      [1172, 99.5],
      [1175, 126.5],
      [1178, 123.5],
      [1181, 103.5],
      [1184, 116.5],
      [1187, 98.5],
      [1190, 113.5],
      [1193, 119.5],
      [1196, 120.5],
      [1199, 120.5],
      [1202, 103.5],
      [1205, 123.5],
      [1208, 117.5],
      [1211, 97.5],
      [1214, 106.5],
      [1217, 101.5],
      [1220, 112.5],
      [1223, 113.5],
      [1226, 112.5],
      [1229, 103.5],
      [1232, 111.5],
      [1235, 116.5],
      [1238, 122.5],
      [1241, 108.5],
      [1244, 118.5],
      [1247, 97.5],
      [1250, 108.5],
      [1253, 123.5],
      [1256, 103.5],
      [1259, 105.5],
      [1262, 115.5],
      [1265, 128.5],
      [1268, 123.5],
      [1271, 119.5],
      [1274, 120.5],
      [1277, 117.5],
      [1280, 122.5],
      [1283, 124.5],
      [1286, 114.5],
      [1289, 123.5],
      [1292, 95.5],
      [1295, 117.5],
      [1298, 123.5],
      [1301, 103.5],
      [1304, 119.5],
      [1307, 106.5],
      [1310, 126.5],
      [1313, 121.5],
      [1316, 116.5],
      [1319, 105.5],
      [1322, 118.5],
      [1325, 120.5],
      [1328, 124.5],
      [1331, 101.5],
      [1334, 105.5],
      [1337, 97.5],
      [1340, 113.5],
      [1343, 121.5],
      [1346, 99.5],
      [1349, 122.5],
      [1352, 99.5],
      [1355, 127.5],
      [1358, 122.5],
      [1361, 113.5],
      [1364, 110.5],
      [1367, 106.5],
      [1370, 104.5],
      [1373, 121.5],
      [1376, 103.5],
      [1379, 100.5],
      [1382, 116.5],
      [1385, 121.5],
      [1388, 124.5],
      [1391, 109.5],
      [1394, 109.5],
      [1397, 105.5],
      [1400, 119.5],
      [1403, 116.5],
      [1406, 104.5],
      [1409, 124.5],
      [1412, 92.5],
      [1415, 107.5],
      [1418, 120.5],
      [1421, 109.5],
      [1424, 112.5],
      [1427, 100.5],
      [1430, 124.5],
      [1433, 119.5],
      [1436, 118.5],
      [1439, 107.5],
      [1442, 108.5],
      [1445, 115.5],
      [1448, 120.5],
      [1451, 111.5],
      [1454, 107.5],
      [1457, 107.5],
      [1460, 126.5],
      [1463, 121.5],
      [1466, 112.5],
      [1469, 104.5],
      [1472, 107.5],
      [1475, 120.5],
      [1478, 123.5],
      [1481, 106.5],
      [1484, 119.5],
      [1487, 112.5],
      [1490, 104.5],
      [1493, 123.5],
      [1496, 105.5],
      [1499, 103.5],
      [1502, 99.5],
      [1505, 121.5],
      [1508, 116.5],
      [1511, 120.5],
      [1514, 110.5],
      [1517, 100.5],
      [1520, 107.5],
      [1523, 95.5],
      [1526, 92.5],
      [1529, 85.5],
      [1532, 85.5],
      [1535, 79.5],
      [1538, 76.5],
      [1541, 75.5],
      [1544, 75.5],
      [1547, 75.5],
      [1550, 75.5],
    ],
    bottom: [
      [1548, 75.5],
      [1545, 75.5],
      [1542, 75.5],
      [1539, 74.5],
      [1536, 73.5],
      [1533, 66.5],
      [1530, 62.5],
      [1527, 60.5],
      [1524, 53.5],
      [1521, 39.5],
      [1518, 32.5],
      [1515, 31.5],
      [1512, 41.5],
      [1509, 37.5],
      [1506, 32.5],
      [1503, 38.5],
      [1500, 30.5],
      [1497, 40.5],
      [1494, 47.5],
      [1491, 39.5],
      [1488, 27.5],
      [1485, 28.5],
      [1482, 48.5],
      [1479, 39.5],
      [1476, 42.5],
      [1473, 32.5],
      [1470, 28.5],
      [1467, 37.5],
      [1464, 41.5],
      [1461, 40.5],
      [1458, 26.5],
      [1455, 33.5],
      [1452, 36.5],
      [1449, 44.5],
      [1446, 42.5],
      [1443, 32.5],
      [1440, 28.5],
      [1437, 48.5],
      [1434, 36.5],
      [1431, 40.5],
      [1428, 41.5],
      [1425, 29.5],
      [1422, 46.5],
      [1419, 40.5],
      [1416, 49.5],
      [1413, 33.5],
      [1410, 45.5],
      [1407, 47.5],
      [1404, 49.5],
      [1401, 48.5],
      [1398, 30.5],
      [1395, 29.5],
      [1392, 46.5],
      [1389, 36.5],
      [1386, 41.5],
      [1383, 37.5],
      [1380, 29.5],
      [1377, 49.5],
      [1374, 51.5],
      [1371, 45.5],
      [1368, 45.5],
      [1365, 35.5],
      [1362, 41.5],
      [1359, 38.5],
      [1356, 29.5],
      [1353, 26.5],
      [1350, 38.5],
      [1347, 53.5],
      [1344, 42.5],
      [1341, 46.5],
      [1338, 27.5],
      [1335, 31.5],
      [1332, 51.5],
      [1329, 20.5],
      [1326, 47.5],
      [1323, 32.5],
      [1320, 25.5],
      [1317, 49.5],
      [1314, 40.5],
      [1311, 43.5],
      [1308, 27.5],
      [1305, 31.5],
      [1302, 41.5],
      [1299, 42.5],
      [1296, 39.5],
      [1293, 28.5],
      [1290, 42.5],
      [1287, 56.5],
      [1284, 38.5],
      [1281, 38.5],
      [1278, 24.5],
      [1275, 30.5],
      [1272, 43.5],
      [1269, 25.5],
      [1266, 40.5],
      [1263, 27.5],
      [1260, 33.5],
      [1257, 45.5],
      [1254, 40.5],
      [1251, 48.5],
      [1248, 27.5],
      [1245, 31.5],
      [1242, 30.5],
      [1239, 40.5],
      [1236, 49.5],
      [1233, 39.5],
      [1230, 24.5],
      [1227, 50.5],
      [1224, 32.5],
      [1221, 44.5],
      [1218, 26.5],
      [1215, 32.5],
      [1212, 58.5],
      [1209, 29.5],
      [1206, 50.5],
      [1203, 37.5],
      [1200, 33.5],
      [1197, 49.5],
      [1194, 43.5],
      [1191, 47.5],
      [1188, 41.5],
      [1185, 26.5],
      [1182, 41.5],
      [1179, 46.5],
      [1176, 43.5],
      [1173, 37.5],
      [1170, 48.5],
      [1167, 49.5],
      [1164, 35.5],
      [1161, 37.5],
      [1158, 32.5],
      [1155, 29.5],
      [1152, 53.5],
      [1149, 41.5],
      [1146, 36.5],
      [1143, 31.5],
      [1140, 31.5],
      [1137, 52.5],
      [1134, 44.5],
      [1131, 53.5],
      [1128, 36.5],
      [1125, 24.5],
      [1122, 46.5],
      [1119, 34.5],
      [1116, 41.5],
      [1113, 28.5],
      [1110, 23.5],
      [1107, 51.5],
      [1104, 37.5],
      [1101, 41.5],
      [1098, 22.5],
      [1095, 27.5],
      [1092, 51.5],
      [1089, 30.5],
      [1086, 38.5],
      [1083, 25.5],
      [1080, 25.5],
      [1077, 49.5],
      [1074, 41.5],
      [1071, 53.5],
      [1068, 26.5],
      [1065, 26.5],
      [1062, 37.5],
      [1059, 36.5],
      [1056, 43.5],
      [1053, 29.5],
      [1050, 50.5],
      [1047, 58.5],
      [1044, 50.5],
      [1041, 46.5],
      [1038, 27.5],
      [1035, 33.5],
      [1032, 39.5],
      [1029, 29.5],
      [1026, 33.5],
      [1023, 23.5],
      [1020, 27.5],
      [1017, 38.5],
      [1014, 29.5],
      [1011, 30.5],
      [1008, 34.5],
      [1005, 29.5],
      [1002, 38.5],
      [999, 46.5],
      [996, 38.5],
      [993, 47.5],
      [990, 27.5],
      [987, 31.5],
      [984, 25.5],
      [981, 39.5],
      [978, 39.5],
      [975, 36.5],
      [972, 38.5],
      [969, 23.5],
      [966, 33.5],
      [963, 38.5],
      [960, 24.5],
      [957, 39.5],
      [954, 32.5],
      [951, 45.5],
      [948, 32.5],
      [945, 25.5],
      [942, 41.5],
      [939, 33.5],
      [936, 34.5],
      [933, 32.5],
      [930, 24.5],
      [927, 38.5],
      [924, 34.5],
      [921, 23.5],
      [918, 41.5],
      [915, 29.5],
      [912, 31.5],
      [909, 35.5],
      [906, 33.5],
      [903, 28.5],
      [900, 24.5],
      [897, 40.5],
      [894, 31.5],
      [891, 37.5],
      [888, 38.5],
      [885, 27.5],
      [882, 27.5],
      [879, 44.5],
      [876, 25.5],
      [873, 37.5],
      [870, 27.5],
      [867, 35.5],
      [864, 26.5],
      [861, 38.5],
      [858, 35.5],
      [855, 20.5],
      [852, 45.5],
      [849, 29.5],
      [846, 41.5],
      [843, 34.5],
      [840, 25.5],
      [837, 50.5],
      [834, 46.5],
      [831, 54.5],
      [828, 30.5],
      [825, 30.5],
      [822, 29.5],
      [819, 42.5],
      [816, 37.5],
      [813, 25.5],
      [810, 47.5],
      [807, 53.5],
      [804, 38.5],
      [801, 50.5],
      [798, 35.5],
      [795, 35.5],
      [792, 58.5],
      [789, 41.5],
      [786, 30.5],
      [783, 26.5],
      [780, 28.5],
      [777, 43.5],
      [774, 31.5],
      [771, 52.5],
      [768, 51.5],
      [765, 19.5],
      [762, 34.5],
      [759, 35.5],
      [756, 31.5],
      [753, 36.5],
      [750, 31.5],
      [747, 43.5],
      [744, 33.5],
      [741, 27.5],
      [738, 51.5],
      [735, 41.5],
      [732, 36.5],
      [729, 48.5],
      [726, 31.5],
      [723, 28.5],
      [720, 34.5],
      [717, 49.5],
      [714, 38.5],
      [711, 50.5],
      [708, 34.5],
      [705, 38.5],
      [702, 38.5],
      [699, 36.5],
      [696, 37.5],
      [693, 31.5],
      [690, 23.5],
      [687, 36.5],
      [684, 32.5],
      [681, 36.5],
      [678, 45.5],
      [675, 35.5],
      [672, 35.5],
      [669, 38.5],
      [666, 25.5],
      [663, 28.5],
      [660, 27.5],
      [657, 42.5],
      [654, 37.5],
      [651, 45.5],
      [648, 33.5],
      [645, 39.5],
      [642, 51.5],
      [639, 28.5],
      [636, 32.5],
      [633, 32.5],
      [630, 38.5],
      [627, 50.5],
      [624, 29.5],
      [621, 37.5],
      [618, 28.5],
      [615, 21.5],
      [612, 55.5],
      [609, 28.5],
      [606, 50.5],
      [603, 35.5],
      [600, 36.5],
      [597, 52.5],
      [594, 49.5],
      [591, 55.5],
      [588, 35.5],
      [585, 24.5],
      [582, 29.5],
      [579, 34.5],
      [576, 42.5],
      [573, 30.5],
      [570, 42.5],
      [567, 53.5],
      [564, 40.5],
      [561, 34.5],
      [558, 18.5],
      [555, 21.5],
      [552, 59.5],
      [549, 22.5],
      [546, 39.5],
      [543, 13.5],
      [540, 27.5],
      [537, 44.5],
      [534, 47.5],
      [531, 51.5],
      [528, 31.5],
      [525, 28.5],
      [522, 35.5],
      [519, 37.5],
      [516, 37.5],
      [513, 21.5],
      [510, 26.5],
      [507, 47.5],
      [504, 31.5],
      [501, 36.5],
      [498, 21.5],
      [495, 28.5],
      [492, 54.5],
      [489, 22.5],
      [486, 39.5],
      [483, 23.5],
      [480, 18.5],
      [477, 33.5],
      [474, 39.5],
      [471, 35.5],
      [468, 25.5],
      [465, 24.5],
      [462, 30.5],
      [459, 27.5],
      [456, 26.5],
      [453, 25.5],
      [450, 19.5],
      [447, 26.5],
      [444, 40.5],
      [441, 39.5],
      [438, 31.5],
      [435, 27.5],
      [432, 28.5],
      [429, 39.5],
      [426, 21.5],
      [423, 35.5],
      [420, 17.5],
      [417, 36.5],
      [414, 34.5],
      [411, 30.5],
      [408, 42.5],
      [405, 33.5],
      [402, 46.5],
      [399, 30.5],
      [396, 35.5],
      [393, 29.5],
      [390, 27.5],
      [387, 38.5],
      [384, 27.5],
      [381, 32.5],
      [378, 13.5],
      [375, 20.5],
      [372, 34.5],
      [369, 47.5],
      [366, 45.5],
      [363, 53.5],
      [360, 20.5],
      [357, 35.5],
      [354, 24.5],
      [351, 40.5],
      [348, 17.5],
      [345, 20.5],
      [342, 28.5],
      [339, 32.5],
      [336, 26.5],
      [333, 20.5],
      [330, 18.5],
      [327, 40.5],
      [324, 45.5],
      [321, 31.5],
      [318, 19.5],
      [315, 29.5],
      [312, 55.5],
      [309, 24.5],
      [306, 33.5],
      [303, 12.5],
      [300, 14.5],
      [297, 49.5],
      [294, 34.5],
      [291, 45.5],
      [288, 25.5],
      [285, 34.5],
      [282, 31.5],
      [279, 34.5],
      [276, 41.5],
      [273, 32.5],
      [270, 14.5],
      [267, 49.5],
      [264, 37.5],
      [261, 32.5],
      [258, 13.5],
      [255, 15.5],
      [252, 46.5],
      [249, 19.5],
      [246, 34.5],
      [243, 38.5],
      [240, 27.5],
      [237, 36.5],
      [234, 41.5],
      [231, 41.5],
      [228, 25.5],
      [225, 18.5],
      [222, 22.5],
      [219, 34.5],
      [216, 41.5],
      [213, 22.5],
      [210, 43.5],
      [207, 54.5],
      [204, 33.5],
      [201, 39.5],
      [198, 25.5],
      [195, 28.5],
      [192, 39.5],
      [189, 49.5],
      [186, 45.5],
      [183, 18.5],
      [180, 9.5],
      [177, 44.5],
      [174, 31.5],
      [171, 48.5],
      [168, 35.5],
      [165, 26.5],
      [162, 40.5],
      [159, 40.5],
      [156, 29.5],
      [153, 23.5],
      [150, 12.5],
      [147, 30.5],
      [144, 30.5],
      [141, 28.5],
      [138, 29.5],
      [135, 21.5],
      [132, 58.5],
      [129, 26.5],
      [126, 11.5],
      [123, 33.5],
      [120, 27.5],
      [117, 46.5],
      [114, 46.5],
      [111, 51.5],
      [108, 60.5],
      [105, 34.5],
      [102, 17.5],
      [99, 28.5],
      [96, 37.5],
      [93, 28.5],
      [90, 31.5],
      [87, 38.5],
      [84, 42.5],
      [81, 28.5],
      [78, 26.5],
      [75, 14.5],
      [72, 57.5],
      [69, 27.5],
      [66, 31.5],
      [63, 38.5],
      [60, 10.5],
      [57, 32.5],
      [54, 35.5],
      [51, 43.5],
      [48, 60.5],
      [45, 25.5],
      [42, 28.5],
      [39, 27.5],
      [36, 25.5],
      [33, 18.5],
      [30, 25.5],
      [27, 38.5],
      [24, 22.5],
      [21, 25.5],
      [18, 12.5],
      [15, 7.5],
      [12, 46.5],
      [9, 3.897599999999997],
      [6, 5.5],
      [3, 15.5],
      [0, 39.5],
    ],
  },
  {
    top: [
      [2, 137.5],
      [5, 143.6984],
      [8, 103.5],
      [11, 107.5],
      [14, 129.5],
      [17, 113.5],
      [20, 143.5],
      [23, 118.5],
      [26, 134.5],
      [29, 138.5],
      [32, 101.5],
      [35, 128.5],
      [38, 144.4976],
      [41, 121.5],
      [44, 144.4976],
      [47, 107.5],
      [50, 137.5],
      [53, 135.5],
      [56, 131.5],
      [59, 128.5],
      [62, 133.5],
      [65, 124.5],
      [68, 103.5],
      [71, 112.5],
      [74, 125.5],
      [77, 129.5],
      [80, 127.5],
      [83, 112.5],
      [86, 129.5],
      [89, 132.5],
      [92, 101.5],
      [95, 123.5],
      [98, 131.5],
      [101, 128.5],
      [104, 119.5],
      [107, 104.5],
      [110, 115.5],
      [113, 131.5],
      [116, 114.5],
      [119, 133.5],
      [122, 120.5],
      [125, 128.5],
      [128, 105.5],
      [131, 104.5],
      [134, 114.5],
      [137, 107.5],
      [140, 144.1054],
      [143, 116.5],
      [146, 125.5],
      [149, 137.5],
      [152, 112.5],
      [155, 121.5],
      [158, 122.5],
      [161, 112.5],
      [164, 118.5],
      [167, 95.5],
      [170, 116.5],
      [173, 131.5],
      [176, 118.5],
      [179, 136.5],
      [182, 116.5],
      [185, 114.5],
      [188, 128.5],
      [191, 102.5],
      [194, 102.5],
      [197, 94.5],
      [200, 119.5],
      [203, 108.5],
      [206, 107.5],
      [209, 130.5],
      [212, 96.5],
      [215, 124.5],
      [218, 142.5],
      [221, 118.5],
      [224, 123.5],
      [227, 122.5],
      [230, 126.5],
      [233, 120.5],
      [236, 104.5],
      [239, 111.5],
      [242, 123.5],
      [245, 122.5],
      [248, 135.5],
      [251, 113.5],
      [254, 110.5],
      [257, 108.5],
      [260, 137.5],
      [263, 130.5],
      [266, 104.5],
      [269, 110.5],
      [272, 107.5],
      [275, 134.5],
      [278, 140.5],
      [281, 118.5],
      [284, 110.5],
      [287, 105.5],
      [290, 105.5],
      [293, 127.5],
      [296, 115.5],
      [299, 107.5],
      [302, 123.5],
      [305, 133.5],
      [308, 132.5],
      [311, 99.5],
      [314, 108.5],
      [317, 105.5],
      [320, 119.5],
      [323, 112.5],
      [326, 116.5],
      [329, 121.5],
      [332, 113.5],
      [335, 129.5],
      [338, 127.5],
      [341, 122.5],
      [344, 106.5],
      [347, 102.5],
      [350, 135.5],
      [353, 125.5],
      [356, 109.5],
      [359, 109.5],
      [362, 103.5],
      [365, 118.5],
      [368, 89.5],
      [371, 107.5],
      [374, 118.5],
      [377, 123.5],
      [380, 134.5],
      [383, 117.5],
      [386, 111.5],
      [389, 109.5],
      [392, 102.5],
      [395, 118.5],
      [398, 116.5],
      [401, 99.5],
      [404, 95.5],
      [407, 101.5],
      [410, 120.5],
      [413, 115.5],
      [416, 120.5],
      [419, 107.5],
      [422, 115.5],
      [425, 123.5],
      [428, 124.5],
      [431, 112.5],
      [434, 117.5],
      [437, 110.5],
      [440, 121.5],
      [443, 113.5],
      [446, 124.5],
      [449, 115.5],
      [452, 103.5],
      [455, 136.5],
      [458, 132.5],
      [461, 117.5],
      [464, 104.5],
      [467, 103.5],
      [470, 117.5],
      [473, 131.5],
      [476, 106.5],
      [479, 133.5],
      [482, 114.5],
      [485, 129.5],
      [488, 123.5],
      [491, 102.5],
      [494, 113.5],
      [497, 105.5],
      [500, 131.5],
      [503, 125.5],
      [506, 112.5],
      [509, 117.5],
      [512, 97.5],
      [515, 123.5],
      [518, 122.5],
      [521, 106.5],
      [524, 111.5],
      [527, 105.5],
      [530, 113.5],
      [533, 135.5],
      [536, 120.5],
      [539, 119.5],
      [542, 122.5],
      [545, 117.5],
      [548, 110.5],
      [551, 105.5],
      [554, 109.5],
      [557, 123.5],
      [560, 122.5],
      [563, 125.5],
      [566, 111.5],
      [569, 120.5],
      [572, 99.5],
      [575, 129.5],
      [578, 133.5],
      [581, 118.5],
      [584, 112.5],
      [587, 106.5],
      [590, 119.5],
      [593, 107.5],
      [596, 104.5],
      [599, 104.5],
      [602, 109.5],
      [605, 117.5],
      [608, 110.5],
      [611, 99.5],
      [614, 115.5],
      [617, 101.5],
      [620, 131.5],
      [623, 134.5],
      [626, 108.5],
      [629, 125.5],
      [632, 99.5],
      [635, 121.5],
      [638, 124.5],
      [641, 108.5],
      [644, 113.5],
      [647, 106.5],
      [650, 119.5],
      [653, 120.5],
      [656, 106.5],
      [659, 112.5],
      [662, 123.5],
      [665, 112.5],
      [668, 117.5],
      [671, 119.5],
      [674, 111.5],
      [677, 113.5],
      [680, 128.5],
      [683, 116.5],
      [686, 120.5],
      [689, 127.5],
      [692, 115.5],
      [695, 120.5],
      [698, 116.5],
      [701, 121.5],
      [704, 121.5],
      [707, 93.5],
      [710, 111.5],
      [713, 115.5],
      [716, 101.5],
      [719, 114.5],
      [722, 109.5],
      [725, 115.5],
      [728, 119.5],
      [731, 114.5],
      [734, 111.5],
      [737, 112.5],
      [740, 121.5],
      [743, 122.5],
      [746, 122.5],
      [749, 110.5],
      [752, 116.5],
      [755, 119.5],
      [758, 116.5],
      [761, 122.5],
      [764, 107.5],
      [767, 95.5],
      [770, 121.5],
      [773, 122.5],
      [776, 106.5],
      [779, 116.5],
      [782, 116.5],
      [785, 112.5],
      [788, 100.5],
      [791, 98.5],
      [794, 110.5],
      [797, 100.5],
      [800, 113.5],
      [803, 115.5],
      [806, 104.5],
      [809, 118.5],
      [812, 96.5],
      [815, 116.5],
      [818, 132.5],
      [821, 108.5],
      [824, 118.5],
      [827, 106.5],
      [830, 119.5],
      [833, 116.5],
      [836, 111.5],
      [839, 101.5],
      [842, 120.5],
      [845, 119.5],
      [848, 114.5],
      [851, 116.5],
      [854, 105.5],
      [857, 101.5],
      [860, 127.5],
      [863, 131.5],
      [866, 119.5],
      [869, 116.5],
      [872, 101.5],
      [875, 125.5],
      [878, 114.5],
      [881, 125.5],
      [884, 116.5],
      [887, 119.5],
      [890, 129.5],
      [893, 114.5],
      [896, 116.5],
      [899, 120.5],
      [902, 118.5],
      [905, 119.5],
      [908, 120.5],
      [911, 116.5],
      [914, 108.5],
      [917, 117.5],
      [920, 129.5],
      [923, 113.5],
      [926, 120.5],
      [929, 119.5],
      [932, 112.5],
      [935, 115.5],
      [938, 111.5],
      [941, 118.5],
      [944, 115.5],
      [947, 110.5],
      [950, 125.5],
      [953, 112.5],
      [956, 114.5],
      [959, 108.5],
      [962, 109.5],
      [965, 118.5],
      [968, 108.5],
      [971, 110.5],
      [974, 117.5],
      [977, 100.5],
      [980, 129.5],
      [983, 117.5],
      [986, 107.5],
      [989, 111.5],
      [992, 109.5],
      [995, 104.5],
      [998, 105.5],
      [1001, 111.5],
      [1004, 108.5],
      [1007, 106.5],
      [1010, 124.5],
      [1013, 123.5],
      [1016, 122.5],
      [1019, 126.5],
      [1022, 112.5],
      [1025, 125.5],
      [1028, 112.5],
      [1031, 103.5],
      [1034, 101.5],
      [1037, 100.5],
      [1040, 123.5],
      [1043, 107.5],
      [1046, 105.5],
      [1049, 125.5],
      [1052, 100.5],
      [1055, 119.5],
      [1058, 120.5],
      [1061, 103.5],
      [1064, 119.5],
      [1067, 104.5],
      [1070, 123.5],
      [1073, 125.5],
      [1076, 105.5],
      [1079, 111.5],
      [1082, 116.5],
      [1085, 123.5],
      [1088, 116.5],
      [1091, 102.5],
      [1094, 110.5],
      [1097, 103.5],
      [1100, 120.5],
      [1103, 122.5],
      [1106, 112.5],
      [1109, 120.5],
      [1112, 99.5],
      [1115, 125.5],
      [1118, 127.5],
      [1121, 106.5],
      [1124, 110.5],
      [1127, 101.5],
      [1130, 109.5],
      [1133, 129.5],
      [1136, 118.5],
      [1139, 104.5],
      [1142, 115.5],
      [1145, 119.5],
      [1148, 125.5],
      [1151, 100.5],
      [1154, 107.5],
      [1157, 107.5],
      [1160, 124.5],
      [1163, 112.5],
      [1166, 115.5],
      [1169, 118.5],
      [1172, 100.5],
      [1175, 125.5],
      [1178, 124.5],
      [1181, 103.5],
      [1184, 116.5],
      [1187, 96.5],
      [1190, 109.5],
      [1193, 116.5],
      [1196, 116.5],
      [1199, 115.5],
      [1202, 101.5],
      [1205, 120.5],
      [1208, 117.5],
      [1211, 98.5],
      [1214, 109.5],
      [1217, 100.5],
      [1220, 112.5],
      [1223, 113.5],
      [1226, 110.5],
      [1229, 101.5],
      [1232, 109.5],
      [1235, 113.5],
      [1238, 118.5],
      [1241, 106.5],
      [1244, 119.5],
      [1247, 97.5],
      [1250, 107.5],
      [1253, 120.5],
      [1256, 103.5],
      [1259, 105.5],
      [1262, 117.5],
      [1265, 123.5],
      [1268, 122.5],
      [1271, 117.5],
      [1274, 118.5],
      [1277, 115.5],
      [1280, 121.5],
      [1283, 123.5],
      [1286, 115.5],
      [1289, 125.5],
      [1292, 95.5],
      [1295, 117.5],
      [1298, 124.5],
      [1301, 104.5],
      [1304, 117.5],
      [1307, 105.5],
      [1310, 124.5],
      [1313, 120.5],
      [1316, 115.5],
      [1319, 106.5],
      [1322, 116.5],
      [1325, 123.5],
      [1328, 120.5],
      [1331, 100.5],
      [1334, 107.5],
      [1337, 98.5],
      [1340, 117.5],
      [1343, 123.5],
      [1346, 101.5],
      [1349, 121.5],
      [1352, 97.5],
      [1355, 126.5],
      [1358, 119.5],
      [1361, 111.5],
      [1364, 110.5],
      [1367, 106.5],
      [1370, 103.5],
      [1373, 120.5],
      [1376, 103.5],
      [1379, 100.5],
      [1382, 118.5],
      [1385, 118.5],
      [1388, 124.5],
      [1391, 108.5],
      [1394, 106.5],
      [1397, 103.5],
      [1400, 116.5],
      [1403, 114.5],
      [1406, 104.5],
      [1409, 123.5],
      [1412, 92.5],
      [1415, 109.5],
      [1418, 121.5],
      [1421, 109.5],
      [1424, 111.5],
      [1427, 99.5],
      [1430, 123.5],
      [1433, 119.5],
      [1436, 115.5],
      [1439, 105.5],
      [1442, 107.5],
      [1445, 116.5],
      [1448, 116.5],
      [1451, 111.5],
      [1454, 110.5],
      [1457, 107.5],
      [1460, 125.5],
      [1463, 121.5],
      [1466, 110.5],
      [1469, 103.5],
      [1472, 107.5],
      [1475, 118.5],
      [1478, 121.5],
      [1481, 105.5],
      [1484, 118.5],
      [1487, 114.5],
      [1490, 104.5],
      [1493, 123.5],
      [1496, 106.5],
      [1499, 101.5],
      [1502, 98.5],
      [1505, 123.5],
      [1508, 114.5],
      [1511, 120.5],
      [1514, 109.5],
      [1517, 100.5],
      [1520, 106.5],
      [1523, 95.5],
      [1526, 91.5],
      [1529, 84.5],
      [1532, 84.5],
      [1535, 79.5],
      [1538, 76.5],
      [1541, 75.5],
      [1544, 75.5],
      [1547, 75.5],
      [1550, 75.5],
    ],
    bottom: [
      [1548, 75.5],
      [1545, 75.5],
      [1542, 75.5],
      [1539, 74.5],
      [1536, 73.5],
      [1533, 67.5],
      [1530, 63.5],
      [1527, 61.5],
      [1524, 52.5],
      [1521, 40.5],
      [1518, 35.5],
      [1515, 33.5],
      [1512, 39.5],
      [1509, 38.5],
      [1506, 33.5],
      [1503, 39.5],
      [1500, 35.5],
      [1497, 39.5],
      [1494, 46.5],
      [1491, 36.5],
      [1488, 28.5],
      [1485, 31.5],
      [1482, 47.5],
      [1479, 37.5],
      [1476, 44.5],
      [1473, 34.5],
      [1470, 29.5],
      [1467, 39.5],
      [1464, 41.5],
      [1461, 39.5],
      [1458, 27.5],
      [1455, 32.5],
      [1452, 36.5],
      [1449, 46.5],
      [1446, 42.5],
      [1443, 32.5],
      [1440, 31.5],
      [1437, 48.5],
      [1434, 38.5],
      [1431, 41.5],
      [1428, 40.5],
      [1425, 30.5],
      [1422, 46.5],
      [1419, 38.5],
      [1416, 48.5],
      [1413, 31.5],
      [1410, 44.5],
      [1407, 45.5],
      [1404, 50.5],
      [1401, 50.5],
      [1398, 31.5],
      [1395, 35.5],
      [1392, 48.5],
      [1389, 37.5],
      [1386, 43.5],
      [1383, 34.5],
      [1380, 30.5],
      [1377, 48.5],
      [1374, 52.5],
      [1371, 45.5],
      [1368, 45.5],
      [1365, 35.5],
      [1362, 42.5],
      [1359, 40.5],
      [1356, 32.5],
      [1353, 28.5],
      [1350, 41.5],
      [1347, 52.5],
      [1344, 38.5],
      [1341, 43.5],
      [1338, 24.5],
      [1335, 26.5],
      [1332, 51.5],
      [1329, 25.5],
      [1326, 47.5],
      [1323, 31.5],
      [1320, 26.5],
      [1317, 50.5],
      [1314, 41.5],
      [1311, 44.5],
      [1308, 27.5],
      [1305, 30.5],
      [1302, 41.5],
      [1299, 42.5],
      [1296, 41.5],
      [1293, 26.5],
      [1290, 42.5],
      [1287, 55.5],
      [1284, 40.5],
      [1281, 38.5],
      [1278, 26.5],
      [1275, 30.5],
      [1272, 44.5],
      [1269, 24.5],
      [1266, 42.5],
      [1263, 28.5],
      [1260, 29.5],
      [1257, 45.5],
      [1254, 41.5],
      [1251, 49.5],
      [1248, 27.5],
      [1245, 29.5],
      [1242, 32.5],
      [1239, 43.5],
      [1236, 50.5],
      [1233, 41.5],
      [1230, 27.5],
      [1227, 51.5],
      [1224, 33.5],
      [1221, 44.5],
      [1218, 27.5],
      [1215, 30.5],
      [1212, 57.5],
      [1209, 28.5],
      [1206, 51.5],
      [1203, 40.5],
      [1200, 37.5],
      [1197, 51.5],
      [1194, 47.5],
      [1191, 49.5],
      [1188, 42.5],
      [1185, 26.5],
      [1182, 43.5],
      [1179, 44.5],
      [1176, 46.5],
      [1173, 35.5],
      [1170, 47.5],
      [1167, 50.5],
      [1164, 35.5],
      [1161, 38.5],
      [1158, 31.5],
      [1155, 30.5],
      [1152, 54.5],
      [1149, 41.5],
      [1146, 38.5],
      [1143, 32.5],
      [1140, 30.5],
      [1137, 53.5],
      [1134, 43.5],
      [1131, 53.5],
      [1128, 36.5],
      [1125, 26.5],
      [1122, 46.5],
      [1119, 36.5],
      [1116, 41.5],
      [1113, 31.5],
      [1110, 24.5],
      [1107, 52.5],
      [1104, 38.5],
      [1101, 42.5],
      [1098, 21.5],
      [1095, 25.5],
      [1092, 51.5],
      [1089, 29.5],
      [1086, 40.5],
      [1083, 27.5],
      [1080, 25.5],
      [1077, 48.5],
      [1074, 42.5],
      [1071, 53.5],
      [1068, 28.5],
      [1065, 27.5],
      [1062, 38.5],
      [1059, 37.5],
      [1056, 44.5],
      [1053, 30.5],
      [1050, 50.5],
      [1047, 58.5],
      [1044, 52.5],
      [1041, 48.5],
      [1038, 31.5],
      [1035, 35.5],
      [1032, 42.5],
      [1029, 31.5],
      [1026, 36.5],
      [1023, 23.5],
      [1020, 25.5],
      [1017, 38.5],
      [1014, 27.5],
      [1011, 28.5],
      [1008, 36.5],
      [1005, 31.5],
      [1002, 41.5],
      [999, 47.5],
      [996, 42.5],
      [993, 47.5],
      [990, 28.5],
      [987, 33.5],
      [984, 28.5],
      [981, 38.5],
      [978, 39.5],
      [975, 35.5],
      [972, 38.5],
      [969, 25.5],
      [966, 35.5],
      [963, 39.5],
      [960, 25.5],
      [957, 39.5],
      [954, 32.5],
      [951, 46.5],
      [948, 34.5],
      [945, 28.5],
      [942, 44.5],
      [939, 30.5],
      [936, 36.5],
      [933, 28.5],
      [930, 24.5],
      [927, 40.5],
      [924, 35.5],
      [921, 25.5],
      [918, 42.5],
      [915, 31.5],
      [912, 31.5],
      [909, 36.5],
      [906, 34.5],
      [903, 28.5],
      [900, 22.5],
      [897, 40.5],
      [894, 32.5],
      [891, 38.5],
      [888, 39.5],
      [885, 28.5],
      [882, 25.5],
      [879, 43.5],
      [876, 27.5],
      [873, 37.5],
      [870, 29.5],
      [867, 39.5],
      [864, 29.5],
      [861, 39.5],
      [858, 35.5],
      [855, 23.5],
      [852, 43.5],
      [849, 30.5],
      [846, 41.5],
      [843, 37.5],
      [840, 28.5],
      [837, 51.5],
      [834, 46.5],
      [831, 55.5],
      [828, 31.5],
      [825, 32.5],
      [822, 31.5],
      [819, 42.5],
      [816, 36.5],
      [813, 25.5],
      [810, 48.5],
      [807, 55.5],
      [804, 42.5],
      [801, 51.5],
      [798, 38.5],
      [795, 39.5],
      [792, 59.5],
      [789, 43.5],
      [786, 32.5],
      [783, 26.5],
      [780, 27.5],
      [777, 44.5],
      [774, 32.5],
      [771, 53.5],
      [768, 53.5],
      [765, 23.5],
      [762, 36.5],
      [759, 34.5],
      [756, 30.5],
      [753, 35.5],
      [750, 30.5],
      [747, 45.5],
      [744, 35.5],
      [741, 30.5],
      [738, 51.5],
      [735, 40.5],
      [732, 35.5],
      [729, 47.5],
      [726, 30.5],
      [723, 28.5],
      [720, 35.5],
      [717, 51.5],
      [714, 40.5],
      [711, 51.5],
      [708, 34.5],
      [705, 40.5],
      [702, 39.5],
      [699, 33.5],
      [696, 36.5],
      [693, 32.5],
      [690, 26.5],
      [687, 38.5],
      [684, 32.5],
      [681, 34.5],
      [678, 44.5],
      [675, 34.5],
      [672, 34.5],
      [669, 40.5],
      [666, 30.5],
      [663, 32.5],
      [660, 29.5],
      [657, 39.5],
      [654, 39.5],
      [651, 44.5],
      [648, 33.5],
      [645, 40.5],
      [642, 52.5],
      [639, 32.5],
      [636, 32.5],
      [633, 32.5],
      [630, 37.5],
      [627, 51.5],
      [624, 31.5],
      [621, 38.5],
      [618, 25.5],
      [615, 19.5],
      [612, 56.5],
      [609, 34.5],
      [606, 50.5],
      [603, 38.5],
      [600, 37.5],
      [597, 54.5],
      [594, 51.5],
      [591, 56.5],
      [588, 38.5],
      [585, 26.5],
      [582, 33.5],
      [579, 33.5],
      [576, 40.5],
      [573, 33.5],
      [570, 44.5],
      [567, 54.5],
      [564, 43.5],
      [561, 37.5],
      [558, 20.5],
      [555, 19.5],
      [552, 58.5],
      [549, 21.5],
      [546, 41.5],
      [543, 17.5],
      [540, 27.5],
      [537, 44.5],
      [534, 46.5],
      [531, 52.5],
      [528, 29.5],
      [525, 26.5],
      [522, 36.5],
      [519, 38.5],
      [516, 40.5],
      [513, 25.5],
      [510, 28.5],
      [507, 48.5],
      [504, 31.5],
      [501, 34.5],
      [498, 22.5],
      [495, 26.5],
      [492, 55.5],
      [489, 26.5],
      [486, 41.5],
      [483, 24.5],
      [480, 18.5],
      [477, 31.5],
      [474, 39.5],
      [471, 37.5],
      [468, 29.5],
      [465, 26.5],
      [462, 32.5],
      [459, 27.5],
      [456, 26.5],
      [453, 25.5],
      [450, 16.5],
      [447, 26.5],
      [444, 42.5],
      [441, 41.5],
      [438, 34.5],
      [435, 30.5],
      [432, 30.5],
      [429, 40.5],
      [426, 20.5],
      [423, 36.5],
      [420, 16.5],
      [417, 36.5],
      [414, 36.5],
      [411, 32.5],
      [408, 46.5],
      [405, 36.5],
      [402, 49.5],
      [399, 31.5],
      [396, 38.5],
      [393, 33.5],
      [390, 30.5],
      [387, 41.5],
      [384, 29.5],
      [381, 33.5],
      [378, 11.5],
      [375, 22.5],
      [372, 35.5],
      [369, 48.5],
      [366, 47.5],
      [363, 56.5],
      [360, 22.5],
      [357, 38.5],
      [354, 24.5],
      [351, 40.5],
      [348, 18.5],
      [345, 25.5],
      [342, 30.5],
      [339, 30.5],
      [336, 25.5],
      [333, 23.5],
      [330, 18.5],
      [327, 38.5],
      [324, 45.5],
      [321, 33.5],
      [318, 23.5],
      [315, 33.5],
      [312, 57.5],
      [309, 28.5],
      [306, 35.5],
      [303, 12.5],
      [300, 16.5],
      [297, 49.5],
      [294, 36.5],
      [291, 45.5],
      [288, 27.5],
      [285, 38.5],
      [282, 33.5],
      [279, 34.5],
      [276, 40.5],
      [273, 33.5],
      [270, 17.5],
      [267, 50.5],
      [264, 40.5],
      [261, 33.5],
      [258, 14.5],
      [255, 18.5],
      [252, 46.5],
      [249, 19.5],
      [246, 37.5],
      [243, 39.5],
      [240, 30.5],
      [237, 37.5],
      [234, 43.5],
      [231, 44.5],
      [228, 24.5],
      [225, 19.5],
      [222, 25.5],
      [219, 33.5],
      [216, 42.5],
      [213, 25.5],
      [210, 43.5],
      [207, 55.5],
      [204, 38.5],
      [201, 41.5],
      [198, 28.5],
      [195, 31.5],
      [192, 41.5],
      [189, 49.5],
      [186, 47.5],
      [183, 22.5],
      [180, 6.5],
      [177, 45.5],
      [174, 31.5],
      [171, 49.5],
      [168, 37.5],
      [165, 27.5],
      [162, 43.5],
      [159, 38.5],
      [156, 32.5],
      [153, 26.5],
      [150, 10.5],
      [147, 31.5],
      [144, 33.5],
      [141, 29.5],
      [138, 29.5],
      [135, 24.5],
      [132, 59.5],
      [129, 28.5],
      [126, 11.5],
      [123, 34.5],
      [120, 28.5],
      [117, 49.5],
      [114, 47.5],
      [111, 52.5],
      [108, 61.5],
      [105, 34.5],
      [102, 18.5],
      [99, 30.5],
      [96, 39.5],
      [93, 31.5],
      [90, 32.5],
      [87, 39.5],
      [84, 45.5],
      [81, 29.5],
      [78, 28.5],
      [75, 13.5],
      [72, 57.5],
      [69, 29.5],
      [66, 32.5],
      [63, 40.5],
      [60, 11.5],
      [57, 34.5],
      [54, 38.5],
      [51, 43.5],
      [48, 60.5],
      [45, 25.5],
      [42, 29.5],
      [39, 27.5],
      [36, 25.5],
      [33, 24.5],
      [30, 25.5],
      [27, 39.5],
      [24, 21.5],
      [21, 25.5],
      [18, 13.5],
      [15, 8.5],
      [12, 47.5],
      [9, 4.460000000000008],
      [6, 6.5],
      [3, 16.5],
      [0, 41.5],
    ],
  },
  {
    top: [
      [2, 136.5],
      [5, 144.5],
      [8, 103.5],
      [11, 107.5],
      [14, 130.5],
      [17, 113.5],
      [20, 141.5],
      [23, 122.5],
      [26, 136.5],
      [29, 139.5],
      [32, 106.5],
      [35, 141.5],
      [38, 144.1054],
      [41, 125.5],
      [44, 144.875],
      [47, 108.5],
      [50, 135.5],
      [53, 135.5],
      [56, 135.5],
      [59, 129.5],
      [62, 138.5],
      [65, 128.5],
      [68, 109.5],
      [71, 120.5],
      [74, 126.5],
      [77, 128.5],
      [80, 131.5],
      [83, 121.5],
      [86, 136.5],
      [89, 136.5],
      [92, 105.5],
      [95, 132.5],
      [98, 135.5],
      [101, 127.5],
      [104, 119.5],
      [107, 112.5],
      [110, 121.5],
      [113, 139.5],
      [116, 132.5],
      [119, 137.5],
      [122, 126.5],
      [125, 129.5],
      [128, 104.5],
      [131, 107.5],
      [134, 117.5],
      [137, 109.5],
      [140, 144.5],
      [143, 118.5],
      [146, 132.5],
      [149, 139.5],
      [152, 111.5],
      [155, 126.5],
      [158, 133.5],
      [161, 121.5],
      [164, 133.5],
      [167, 101.5],
      [170, 123.5],
      [173, 138.5],
      [176, 123.5],
      [179, 133.5],
      [182, 115.5],
      [185, 125.5],
      [188, 141.5],
      [191, 111.5],
      [194, 108.5],
      [197, 100.5],
      [200, 130.5],
      [203, 119.5],
      [206, 116.5],
      [209, 141.5],
      [212, 103.5],
      [215, 130.5],
      [218, 144.5],
      [221, 119.5],
      [224, 130.5],
      [227, 128.5],
      [230, 130.5],
      [233, 125.5],
      [236, 113.5],
      [239, 116.5],
      [242, 127.5],
      [245, 125.5],
      [248, 141.5],
      [251, 112.5],
      [254, 110.5],
      [257, 109.5],
      [260, 137.5],
      [263, 137.5],
      [266, 115.5],
      [269, 117.5],
      [272, 113.5],
      [275, 138.5],
      [278, 140.5],
      [281, 119.5],
      [284, 116.5],
      [287, 113.5],
      [290, 109.5],
      [293, 139.5],
      [296, 119.5],
      [299, 110.5],
      [302, 124.5],
      [305, 135.5],
      [308, 140.5],
      [311, 107.5],
      [314, 125.5],
      [317, 114.5],
      [320, 128.5],
      [323, 115.5],
      [326, 119.5],
      [329, 123.5],
      [332, 113.5],
      [335, 132.5],
      [338, 127.5],
      [341, 124.5],
      [344, 111.5],
      [347, 107.5],
      [350, 139.5],
      [353, 125.5],
      [356, 109.5],
      [359, 111.5],
      [362, 115.5],
      [365, 137.5],
      [368, 91.5],
      [371, 114.5],
      [374, 124.5],
      [377, 127.5],
      [380, 135.5],
      [383, 118.5],
      [386, 116.5],
      [389, 119.5],
      [392, 112.5],
      [395, 133.5],
      [398, 130.5],
      [401, 104.5],
      [404, 98.5],
      [407, 108.5],
      [410, 133.5],
      [413, 123.5],
      [416, 125.5],
      [419, 109.5],
      [422, 116.5],
      [425, 123.5],
      [428, 123.5],
      [431, 117.5],
      [434, 122.5],
      [437, 116.5],
      [440, 130.5],
      [443, 121.5],
      [446, 134.5],
      [449, 119.5],
      [452, 102.5],
      [455, 137.5],
      [458, 128.5],
      [461, 115.5],
      [464, 104.5],
      [467, 107.5],
      [470, 125.5],
      [473, 136.5],
      [476, 109.5],
      [479, 138.5],
      [482, 118.5],
      [485, 133.5],
      [488, 129.5],
      [491, 103.5],
      [494, 116.5],
      [497, 105.5],
      [500, 128.5],
      [503, 124.5],
      [506, 114.5],
      [509, 118.5],
      [512, 98.5],
      [515, 128.5],
      [518, 136.5],
      [521, 111.5],
      [524, 112.5],
      [527, 106.5],
      [530, 113.5],
      [533, 138.5],
      [536, 119.5],
      [539, 119.5],
      [542, 120.5],
      [545, 121.5],
      [548, 116.5],
      [551, 107.5],
      [554, 107.5],
      [557, 123.5],
      [560, 120.5],
      [563, 129.5],
      [566, 119.5],
      [569, 132.5],
      [572, 101.5],
      [575, 136.5],
      [578, 134.5],
      [581, 118.5],
      [584, 113.5],
      [587, 108.5],
      [590, 128.5],
      [593, 125.5],
      [596, 124.5],
      [599, 117.5],
      [602, 123.5],
      [605, 129.5],
      [608, 119.5],
      [611, 103.5],
      [614, 116.5],
      [617, 100.5],
      [620, 130.5],
      [623, 135.5],
      [626, 116.5],
      [629, 135.5],
      [632, 103.5],
      [635, 126.5],
      [638, 126.5],
      [641, 116.5],
      [644, 116.5],
      [647, 107.5],
      [650, 123.5],
      [653, 121.5],
      [656, 107.5],
      [659, 112.5],
      [662, 126.5],
      [665, 114.5],
      [668, 125.5],
      [671, 126.5],
      [674, 115.5],
      [677, 116.5],
      [680, 131.5],
      [683, 115.5],
      [686, 123.5],
      [689, 130.5],
      [692, 118.5],
      [695, 123.5],
      [698, 121.5],
      [701, 124.5],
      [704, 123.5],
      [707, 95.5],
      [710, 112.5],
      [713, 116.5],
      [716, 105.5],
      [719, 121.5],
      [722, 111.5],
      [725, 117.5],
      [728, 121.5],
      [731, 116.5],
      [734, 112.5],
      [737, 111.5],
      [740, 120.5],
      [743, 123.5],
      [746, 125.5],
      [749, 116.5],
      [752, 120.5],
      [755, 118.5],
      [758, 118.5],
      [761, 127.5],
      [764, 111.5],
      [767, 98.5],
      [770, 126.5],
      [773, 128.5],
      [776, 110.5],
      [779, 121.5],
      [782, 119.5],
      [785, 114.5],
      [788, 101.5],
      [791, 98.5],
      [794, 118.5],
      [797, 110.5],
      [800, 125.5],
      [803, 131.5],
      [806, 113.5],
      [809, 125.5],
      [812, 97.5],
      [815, 118.5],
      [818, 136.5],
      [821, 111.5],
      [824, 122.5],
      [827, 111.5],
      [830, 130.5],
      [833, 128.5],
      [836, 119.5],
      [839, 108.5],
      [842, 130.5],
      [845, 127.5],
      [848, 120.5],
      [851, 120.5],
      [854, 108.5],
      [857, 102.5],
      [860, 129.5],
      [863, 133.5],
      [866, 121.5],
      [869, 120.5],
      [872, 104.5],
      [875, 134.5],
      [878, 121.5],
      [881, 129.5],
      [884, 119.5],
      [887, 123.5],
      [890, 132.5],
      [893, 116.5],
      [896, 120.5],
      [899, 122.5],
      [902, 116.5],
      [905, 118.5],
      [908, 121.5],
      [911, 118.5],
      [914, 111.5],
      [917, 122.5],
      [920, 131.5],
      [923, 116.5],
      [926, 129.5],
      [929, 125.5],
      [932, 113.5],
      [935, 120.5],
      [938, 113.5],
      [941, 122.5],
      [944, 118.5],
      [947, 112.5],
      [950, 129.5],
      [953, 117.5],
      [956, 120.5],
      [959, 109.5],
      [962, 110.5],
      [965, 122.5],
      [968, 111.5],
      [971, 113.5],
      [974, 119.5],
      [977, 103.5],
      [980, 129.5],
      [983, 119.5],
      [986, 108.5],
      [989, 114.5],
      [992, 114.5],
      [995, 109.5],
      [998, 109.5],
      [1001, 117.5],
      [1004, 115.5],
      [1007, 113.5],
      [1010, 129.5],
      [1013, 131.5],
      [1016, 130.5],
      [1019, 130.5],
      [1022, 113.5],
      [1025, 128.5],
      [1028, 118.5],
      [1031, 107.5],
      [1034, 104.5],
      [1037, 104.5],
      [1040, 129.5],
      [1043, 110.5],
      [1046, 106.5],
      [1049, 127.5],
      [1052, 100.5],
      [1055, 126.5],
      [1058, 123.5],
      [1061, 103.5],
      [1064, 118.5],
      [1067, 103.5],
      [1070, 127.5],
      [1073, 129.5],
      [1076, 108.5],
      [1079, 115.5],
      [1082, 117.5],
      [1085, 127.5],
      [1088, 122.5],
      [1091, 103.5],
      [1094, 110.5],
      [1097, 101.5],
      [1100, 120.5],
      [1103, 124.5],
      [1106, 114.5],
      [1109, 121.5],
      [1112, 102.5],
      [1115, 131.5],
      [1118, 128.5],
      [1121, 107.5],
      [1124, 111.5],
      [1127, 102.5],
      [1130, 115.5],
      [1133, 128.5],
      [1136, 120.5],
      [1139, 109.5],
      [1142, 117.5],
      [1145, 124.5],
      [1148, 136.5],
      [1151, 105.5],
      [1154, 112.5],
      [1157, 107.5],
      [1160, 129.5],
      [1163, 115.5],
      [1166, 117.5],
      [1169, 121.5],
      [1172, 101.5],
      [1175, 127.5],
      [1178, 125.5],
      [1181, 105.5],
      [1184, 120.5],
      [1187, 99.5],
      [1190, 113.5],
      [1193, 125.5],
      [1196, 120.5],
      [1199, 125.5],
      [1202, 103.5],
      [1205, 125.5],
      [1208, 117.5],
      [1211, 98.5],
      [1214, 107.5],
      [1217, 100.5],
      [1220, 113.5],
      [1223, 115.5],
      [1226, 113.5],
      [1229, 105.5],
      [1232, 115.5],
      [1235, 120.5],
      [1238, 120.5],
      [1241, 113.5],
      [1244, 129.5],
      [1247, 100.5],
      [1250, 110.5],
      [1253, 129.5],
      [1256, 103.5],
      [1259, 106.5],
      [1262, 116.5],
      [1265, 126.5],
      [1268, 123.5],
      [1271, 121.5],
      [1274, 123.5],
      [1277, 121.5],
      [1280, 122.5],
      [1283, 127.5],
      [1286, 117.5],
      [1289, 125.5],
      [1292, 96.5],
      [1295, 118.5],
      [1298, 120.5],
      [1301, 105.5],
      [1304, 120.5],
      [1307, 105.5],
      [1310, 127.5],
      [1313, 124.5],
      [1316, 117.5],
      [1319, 106.5],
      [1322, 119.5],
      [1325, 128.5],
      [1328, 124.5],
      [1331, 101.5],
      [1334, 109.5],
      [1337, 99.5],
      [1340, 119.5],
      [1343, 125.5],
      [1346, 100.5],
      [1349, 121.5],
      [1352, 98.5],
      [1355, 127.5],
      [1358, 124.5],
      [1361, 114.5],
      [1364, 114.5],
      [1367, 111.5],
      [1370, 108.5],
      [1373, 127.5],
      [1376, 106.5],
      [1379, 102.5],
      [1382, 117.5],
      [1385, 118.5],
      [1388, 121.5],
      [1391, 105.5],
      [1394, 114.5],
      [1397, 105.5],
      [1400, 122.5],
      [1403, 119.5],
      [1406, 104.5],
      [1409, 123.5],
      [1412, 91.5],
      [1415, 108.5],
      [1418, 122.5],
      [1421, 108.5],
      [1424, 111.5],
      [1427, 100.5],
      [1430, 129.5],
      [1433, 120.5],
      [1436, 124.5],
      [1439, 110.5],
      [1442, 111.5],
      [1445, 117.5],
      [1448, 119.5],
      [1451, 112.5],
      [1454, 112.5],
      [1457, 107.5],
      [1460, 125.5],
      [1463, 123.5],
      [1466, 111.5],
      [1469, 103.5],
      [1472, 105.5],
      [1475, 119.5],
      [1478, 126.5],
      [1481, 108.5],
      [1484, 119.5],
      [1487, 112.5],
      [1490, 107.5],
      [1493, 125.5],
      [1496, 108.5],
      [1499, 105.5],
      [1502, 100.5],
      [1505, 124.5],
      [1508, 113.5],
      [1511, 117.5],
      [1514, 110.5],
      [1517, 102.5],
      [1520, 110.5],
      [1523, 96.5],
      [1526, 90.5],
      [1529, 84.5],
      [1532, 85.5],
      [1535, 78.5],
      [1538, 76.5],
      [1541, 75.5],
      [1544, 75.5],
      [1547, 75.5],
      [1550, 75.5],
    ],
    bottom: [
      [1548, 75.5],
      [1545, 75.5],
      [1542, 75.5],
      [1539, 74.5],
      [1536, 73.5],
      [1533, 67.5],
      [1530, 62.5],
      [1527, 62.5],
      [1524, 50.5],
      [1521, 37.5],
      [1518, 33.5],
      [1515, 29.5],
      [1512, 41.5],
      [1509, 39.5],
      [1506, 33.5],
      [1503, 37.5],
      [1500, 29.5],
      [1497, 37.5],
      [1494, 46.5],
      [1491, 33.5],
      [1488, 26.5],
      [1485, 32.5],
      [1482, 47.5],
      [1479, 34.5],
      [1476, 41.5],
      [1473, 36.5],
      [1470, 31.5],
      [1467, 40.5],
      [1464, 43.5],
      [1461, 39.5],
      [1458, 25.5],
      [1455, 32.5],
      [1452, 33.5],
      [1449, 46.5],
      [1446, 43.5],
      [1443, 27.5],
      [1440, 21.5],
      [1437, 44.5],
      [1434, 33.5],
      [1431, 39.5],
      [1428, 37.5],
      [1425, 27.5],
      [1422, 48.5],
      [1419, 39.5],
      [1416, 48.5],
      [1413, 32.5],
      [1410, 44.5],
      [1407, 46.5],
      [1404, 48.5],
      [1401, 46.5],
      [1398, 31.5],
      [1395, 28.5],
      [1392, 49.5],
      [1389, 40.5],
      [1386, 43.5],
      [1383, 35.5],
      [1380, 28.5],
      [1377, 47.5],
      [1374, 50.5],
      [1371, 40.5],
      [1368, 40.5],
      [1365, 30.5],
      [1362, 40.5],
      [1359, 38.5],
      [1356, 33.5],
      [1353, 26.5],
      [1350, 40.5],
      [1347, 52.5],
      [1344, 40.5],
      [1341, 41.5],
      [1338, 21.5],
      [1335, 23.5],
      [1332, 51.5],
      [1329, 19.5],
      [1326, 44.5],
      [1323, 29.5],
      [1320, 25.5],
      [1317, 50.5],
      [1314, 38.5],
      [1311, 42.5],
      [1308, 27.5],
      [1305, 26.5],
      [1302, 41.5],
      [1299, 43.5],
      [1296, 42.5],
      [1293, 26.5],
      [1290, 41.5],
      [1287, 55.5],
      [1284, 39.5],
      [1281, 38.5],
      [1278, 17.5],
      [1275, 27.5],
      [1272, 40.5],
      [1269, 24.5],
      [1266, 42.5],
      [1263, 27.5],
      [1260, 27.5],
      [1257, 43.5],
      [1254, 39.5],
      [1251, 47.5],
      [1248, 20.5],
      [1245, 19.5],
      [1242, 26.5],
      [1239, 38.5],
      [1236, 45.5],
      [1233, 38.5],
      [1230, 18.5],
      [1227, 50.5],
      [1224, 30.5],
      [1221, 43.5],
      [1218, 24.5],
      [1215, 29.5],
      [1212, 58.5],
      [1209, 30.5],
      [1206, 49.5],
      [1203, 36.5],
      [1200, 30.5],
      [1197, 47.5],
      [1194, 40.5],
      [1191, 47.5],
      [1188, 40.5],
      [1185, 21.5],
      [1182, 39.5],
      [1179, 45.5],
      [1176, 44.5],
      [1173, 32.5],
      [1170, 47.5],
      [1167, 47.5],
      [1164, 31.5],
      [1161, 35.5],
      [1158, 28.5],
      [1155, 24.5],
      [1152, 50.5],
      [1149, 33.5],
      [1146, 32.5],
      [1143, 30.5],
      [1140, 26.5],
      [1137, 50.5],
      [1134, 42.5],
      [1131, 53.5],
      [1128, 31.5],
      [1125, 24.5],
      [1122, 45.5],
      [1119, 35.5],
      [1116, 39.5],
      [1113, 28.5],
      [1110, 24.5],
      [1107, 51.5],
      [1104, 36.5],
      [1101, 40.5],
      [1098, 23.5],
      [1095, 24.5],
      [1092, 51.5],
      [1089, 27.5],
      [1086, 37.5],
      [1083, 25.5],
      [1080, 21.5],
      [1077, 46.5],
      [1074, 39.5],
      [1071, 51.5],
      [1068, 25.5],
      [1065, 28.5],
      [1062, 37.5],
      [1059, 36.5],
      [1056, 42.5],
      [1053, 26.5],
      [1050, 49.5],
      [1047, 57.5],
      [1044, 47.5],
      [1041, 44.5],
      [1038, 23.5],
      [1035, 29.5],
      [1032, 38.5],
      [1029, 24.5],
      [1026, 34.5],
      [1023, 24.5],
      [1020, 22.5],
      [1017, 33.5],
      [1014, 18.5],
      [1011, 21.5],
      [1008, 30.5],
      [1005, 20.5],
      [1002, 33.5],
      [999, 43.5],
      [996, 35.5],
      [993, 41.5],
      [990, 25.5],
      [987, 30.5],
      [984, 23.5],
      [981, 39.5],
      [978, 36.5],
      [975, 35.5],
      [972, 36.5],
      [969, 21.5],
      [966, 34.5],
      [963, 36.5],
      [960, 26.5],
      [957, 37.5],
      [954, 25.5],
      [951, 42.5],
      [948, 30.5],
      [945, 25.5],
      [942, 39.5],
      [939, 27.5],
      [936, 32.5],
      [933, 26.5],
      [930, 16.5],
      [927, 34.5],
      [924, 29.5],
      [921, 22.5],
      [918, 40.5],
      [915, 31.5],
      [912, 31.5],
      [909, 33.5],
      [906, 36.5],
      [903, 29.5],
      [900, 20.5],
      [897, 36.5],
      [894, 30.5],
      [891, 38.5],
      [888, 38.5],
      [885, 23.5],
      [882, 22.5],
      [879, 39.5],
      [876, 17.5],
      [873, 32.5],
      [870, 23.5],
      [867, 34.5],
      [864, 27.5],
      [861, 37.5],
      [858, 35.5],
      [855, 20.5],
      [852, 39.5],
      [849, 24.5],
      [846, 37.5],
      [843, 28.5],
      [840, 17.5],
      [837, 48.5],
      [834, 38.5],
      [831, 50.5],
      [828, 23.5],
      [825, 29.5],
      [822, 27.5],
      [819, 38.5],
      [816, 32.5],
      [813, 21.5],
      [810, 45.5],
      [807, 49.5],
      [804, 31.5],
      [801, 43.5],
      [798, 25.5],
      [795, 28.5],
      [792, 58.5],
      [789, 43.5],
      [786, 31.5],
      [783, 22.5],
      [780, 22.5],
      [777, 40.5],
      [774, 26.5],
      [771, 50.5],
      [768, 49.5],
      [765, 20.5],
      [762, 31.5],
      [759, 31.5],
      [756, 28.5],
      [753, 33.5],
      [750, 23.5],
      [747, 41.5],
      [744, 35.5],
      [741, 32.5],
      [738, 51.5],
      [735, 41.5],
      [732, 31.5],
      [729, 47.5],
      [726, 31.5],
      [723, 24.5],
      [720, 31.5],
      [717, 49.5],
      [714, 38.5],
      [711, 51.5],
      [708, 31.5],
      [705, 37.5],
      [702, 35.5],
      [699, 30.5],
      [696, 33.5],
      [693, 28.5],
      [690, 26.5],
      [687, 33.5],
      [684, 34.5],
      [681, 33.5],
      [678, 41.5],
      [675, 30.5],
      [672, 30.5],
      [669, 33.5],
      [666, 24.5],
      [663, 29.5],
      [660, 29.5],
      [657, 38.5],
      [654, 38.5],
      [651, 43.5],
      [648, 30.5],
      [645, 37.5],
      [642, 49.5],
      [639, 25.5],
      [636, 28.5],
      [633, 26.5],
      [630, 29.5],
      [627, 44.5],
      [624, 28.5],
      [621, 37.5],
      [618, 26.5],
      [615, 23.5],
      [612, 54.5],
      [609, 21.5],
      [606, 44.5],
      [603, 24.5],
      [600, 23.5],
      [597, 42.5],
      [594, 39.5],
      [591, 49.5],
      [588, 35.5],
      [585, 24.5],
      [582, 31.5],
      [579, 34.5],
      [576, 37.5],
      [573, 28.5],
      [570, 40.5],
      [567, 50.5],
      [564, 38.5],
      [561, 38.5],
      [558, 20.5],
      [555, 22.5],
      [552, 59.5],
      [549, 14.5],
      [546, 36.5],
      [543, 18.5],
      [540, 27.5],
      [537, 45.5],
      [534, 46.5],
      [531, 51.5],
      [528, 29.5],
      [525, 25.5],
      [522, 31.5],
      [519, 32.5],
      [516, 32.5],
      [513, 20.5],
      [510, 28.5],
      [507, 47.5],
      [504, 31.5],
      [501, 36.5],
      [498, 20.5],
      [495, 25.5],
      [492, 54.5],
      [489, 19.5],
      [486, 38.5],
      [483, 18.5],
      [480, 13.5],
      [477, 27.5],
      [474, 35.5],
      [471, 32.5],
      [468, 18.5],
      [465, 25.5],
      [462, 33.5],
      [459, 31.5],
      [456, 29.5],
      [453, 23.5],
      [450, 12.5],
      [447, 19.5],
      [444, 35.5],
      [441, 35.5],
      [438, 19.5],
      [435, 24.5],
      [432, 22.5],
      [429, 38.5],
      [426, 16.5],
      [423, 37.5],
      [420, 13.5],
      [417, 32.5],
      [414, 29.5],
      [411, 20.5],
      [408, 37.5],
      [405, 30.5],
      [402, 44.5],
      [399, 20.5],
      [396, 23.5],
      [393, 16.5],
      [390, 14.5],
      [387, 36.5],
      [384, 28.5],
      [381, 32.5],
      [378, 7.5],
      [375, 16.5],
      [372, 27.5],
      [369, 42.5],
      [366, 36.5],
      [363, 48.5],
      [360, 16.5],
      [357, 37.5],
      [354, 26.5],
      [351, 38.5],
      [348, 11.5],
      [345, 18.5],
      [342, 28.5],
      [339, 31.5],
      [336, 22.5],
      [333, 22.5],
      [330, 17.5],
      [327, 35.5],
      [324, 43.5],
      [321, 27.5],
      [318, 13.5],
      [315, 16.5],
      [312, 50.5],
      [309, 17.5],
      [306, 33.5],
      [303, 12.5],
      [300, 13.5],
      [297, 45.5],
      [294, 28.5],
      [291, 40.5],
      [288, 19.5],
      [285, 29.5],
      [282, 30.5],
      [279, 33.5],
      [276, 37.5],
      [273, 27.5],
      [270, 13.5],
      [267, 43.5],
      [264, 32.5],
      [261, 32.5],
      [258, 12.5],
      [255, 15.5],
      [252, 46.5],
      [249, 18.5],
      [246, 30.5],
      [243, 34.5],
      [240, 22.5],
      [237, 27.5],
      [234, 38.5],
      [231, 40.5],
      [228, 18.5],
      [225, 11.5],
      [222, 23.5],
      [219, 33.5],
      [216, 42.5],
      [213, 11.5],
      [210, 34.5],
      [207, 51.5],
      [204, 22.5],
      [201, 29.5],
      [198, 15.5],
      [195, 18.5],
      [192, 29.5],
      [189, 42.5],
      [186, 37.5],
      [183, 19.5],
      [180, 9.5],
      [177, 43.5],
      [174, 25.5],
      [171, 43.5],
      [168, 24.5],
      [165, 9.5],
      [162, 34.5],
      [159, 32.5],
      [156, 22.5],
      [153, 27.5],
      [150, 6.5],
      [147, 25.5],
      [144, 25.5],
      [141, 31.5],
      [138, 27.5],
      [135, 18.5],
      [132, 57.5],
      [129, 29.5],
      [126, 11.5],
      [123, 31.5],
      [120, 23.5],
      [117, 40.5],
      [114, 39.5],
      [111, 46.5],
      [108, 58.5],
      [105, 30.5],
      [102, 20.5],
      [99, 29.5],
      [96, 34.5],
      [93, 25.5],
      [90, 30.5],
      [87, 35.5],
      [84, 35.5],
      [81, 22.5],
      [78, 25.5],
      [75, 12.5],
      [72, 55.5],
      [69, 22.5],
      [66, 25.5],
      [63, 35.5],
      [60, 12.5],
      [57, 34.5],
      [54, 36.5],
      [51, 44.5],
      [48, 59.5],
      [45, 25.5],
      [42, 28.5],
      [39, 26.5],
      [36, 20.5],
      [33, 14.5],
      [30, 26.5],
      [27, 35.5],
      [24, 17.5],
      [21, 25.5],
      [18, 12.5],
      [15, 9.5],
      [12, 46.5],
      [9, 3.6385999999999967],
      [6, 7.5],
      [3, 17.5],
      [0, 40.5],
    ],
  },
  {
    top: [
      [2, 136.5],
      [5, 144.1054],
      [8, 106.5],
      [11, 109.5],
      [14, 131.5],
      [17, 113.5],
      [20, 142.5],
      [23, 124.5],
      [26, 140.5],
      [29, 142.5],
      [32, 107.5],
      [35, 144.5],
      [38, 144.4976],
      [41, 131.5],
      [44, 144.875],
      [47, 111.5],
      [50, 133.5],
      [53, 138.5],
      [56, 144.1054],
      [59, 132.5],
      [62, 136.5],
      [65, 131.5],
      [68, 109.5],
      [71, 121.5],
      [74, 128.5],
      [77, 129.5],
      [80, 133.5],
      [83, 122.5],
      [86, 139.5],
      [89, 142.5],
      [92, 108.5],
      [95, 135.5],
      [98, 135.5],
      [101, 127.5],
      [104, 123.5],
      [107, 118.5],
      [110, 125.5],
      [113, 143.2766],
      [116, 132.5],
      [119, 143.5],
      [122, 128.5],
      [125, 133.5],
      [128, 103.5],
      [131, 112.5],
      [134, 120.5],
      [137, 108.5],
      [140, 143.5],
      [143, 120.5],
      [146, 133.5],
      [149, 143.6984],
      [152, 110.5],
      [155, 126.5],
      [158, 135.5],
      [161, 123.5],
      [164, 136.5],
      [167, 102.5],
      [170, 129.5],
      [173, 142.5],
      [176, 128.5],
      [179, 138.5],
      [182, 113.5],
      [185, 128.5],
      [188, 144.4976],
      [191, 113.5],
      [194, 109.5],
      [197, 103.5],
      [200, 136.5],
      [203, 120.5],
      [206, 117.5],
      [209, 144.4976],
      [212, 104.5],
      [215, 130.5],
      [218, 143.5],
      [221, 118.5],
      [224, 132.5],
      [227, 131.5],
      [230, 130.5],
      [233, 134.5],
      [236, 114.5],
      [239, 118.5],
      [242, 134.5],
      [245, 130.5],
      [248, 140.5],
      [251, 110.5],
      [254, 109.5],
      [257, 109.5],
      [260, 139.5],
      [263, 137.5],
      [266, 115.5],
      [269, 120.5],
      [272, 111.5],
      [275, 142.5],
      [278, 139.5],
      [281, 120.5],
      [284, 120.5],
      [287, 116.5],
      [290, 112.5],
      [293, 139.5],
      [296, 118.5],
      [299, 112.5],
      [302, 123.5],
      [305, 136.5],
      [308, 143.5],
      [311, 107.5],
      [314, 126.5],
      [317, 114.5],
      [320, 129.5],
      [323, 116.5],
      [326, 124.5],
      [329, 126.5],
      [332, 113.5],
      [335, 131.5],
      [338, 123.5],
      [341, 122.5],
      [344, 112.5],
      [347, 107.5],
      [350, 142.5],
      [353, 125.5],
      [356, 110.5],
      [359, 117.5],
      [362, 116.5],
      [365, 137.5],
      [368, 92.5],
      [371, 115.5],
      [374, 124.5],
      [377, 130.5],
      [380, 134.5],
      [383, 118.5],
      [386, 122.5],
      [389, 125.5],
      [392, 114.5],
      [395, 135.5],
      [398, 132.5],
      [401, 106.5],
      [404, 101.5],
      [407, 111.5],
      [410, 133.5],
      [413, 126.5],
      [416, 124.5],
      [419, 111.5],
      [422, 117.5],
      [425, 134.5],
      [428, 132.5],
      [431, 119.5],
      [434, 125.5],
      [437, 123.5],
      [440, 132.5],
      [443, 122.5],
      [446, 135.5],
      [449, 119.5],
      [452, 103.5],
      [455, 134.5],
      [458, 127.5],
      [461, 115.5],
      [464, 105.5],
      [467, 107.5],
      [470, 127.5],
      [473, 136.5],
      [476, 112.5],
      [479, 138.5],
      [482, 118.5],
      [485, 132.5],
      [488, 133.5],
      [491, 104.5],
      [494, 116.5],
      [497, 103.5],
      [500, 127.5],
      [503, 122.5],
      [506, 114.5],
      [509, 117.5],
      [512, 98.5],
      [515, 131.5],
      [518, 135.5],
      [521, 111.5],
      [524, 111.5],
      [527, 110.5],
      [530, 113.5],
      [533, 135.5],
      [536, 124.5],
      [539, 118.5],
      [542, 119.5],
      [545, 121.5],
      [548, 116.5],
      [551, 109.5],
      [554, 104.5],
      [557, 123.5],
      [560, 123.5],
      [563, 136.5],
      [566, 126.5],
      [569, 131.5],
      [572, 102.5],
      [575, 136.5],
      [578, 140.5],
      [581, 118.5],
      [584, 114.5],
      [587, 111.5],
      [590, 130.5],
      [593, 126.5],
      [596, 131.5],
      [599, 118.5],
      [602, 128.5],
      [605, 130.5],
      [608, 123.5],
      [611, 103.5],
      [614, 115.5],
      [617, 100.5],
      [620, 134.5],
      [623, 132.5],
      [626, 120.5],
      [629, 134.5],
      [632, 102.5],
      [635, 128.5],
      [638, 128.5],
      [641, 119.5],
      [644, 118.5],
      [647, 108.5],
      [650, 123.5],
      [653, 123.5],
      [656, 112.5],
      [659, 111.5],
      [662, 127.5],
      [665, 117.5],
      [668, 125.5],
      [671, 124.5],
      [674, 115.5],
      [677, 121.5],
      [680, 131.5],
      [683, 116.5],
      [686, 126.5],
      [689, 130.5],
      [692, 118.5],
      [695, 121.5],
      [698, 122.5],
      [701, 123.5],
      [704, 123.5],
      [707, 95.5],
      [710, 110.5],
      [713, 117.5],
      [716, 104.5],
      [719, 119.5],
      [722, 110.5],
      [725, 116.5],
      [728, 126.5],
      [731, 121.5],
      [734, 112.5],
      [737, 110.5],
      [740, 118.5],
      [743, 122.5],
      [746, 127.5],
      [749, 119.5],
      [752, 122.5],
      [755, 121.5],
      [758, 119.5],
      [761, 125.5],
      [764, 111.5],
      [767, 99.5],
      [770, 126.5],
      [773, 127.5],
      [776, 114.5],
      [779, 123.5],
      [782, 119.5],
      [785, 115.5],
      [788, 103.5],
      [791, 99.5],
      [794, 121.5],
      [797, 112.5],
      [800, 126.5],
      [803, 132.5],
      [806, 118.5],
      [809, 129.5],
      [812, 97.5],
      [815, 120.5],
      [818, 136.5],
      [821, 111.5],
      [824, 122.5],
      [827, 115.5],
      [830, 130.5],
      [833, 130.5],
      [836, 124.5],
      [839, 107.5],
      [842, 130.5],
      [845, 129.5],
      [848, 123.5],
      [851, 120.5],
      [854, 110.5],
      [857, 103.5],
      [860, 127.5],
      [863, 136.5],
      [866, 127.5],
      [869, 122.5],
      [872, 103.5],
      [875, 137.5],
      [878, 126.5],
      [881, 131.5],
      [884, 117.5],
      [887, 122.5],
      [890, 132.5],
      [893, 116.5],
      [896, 121.5],
      [899, 123.5],
      [902, 118.5],
      [905, 119.5],
      [908, 120.5],
      [911, 118.5],
      [914, 111.5],
      [917, 123.5],
      [920, 132.5],
      [923, 118.5],
      [926, 127.5],
      [929, 128.5],
      [932, 111.5],
      [935, 118.5],
      [938, 114.5],
      [941, 125.5],
      [944, 117.5],
      [947, 112.5],
      [950, 131.5],
      [953, 119.5],
      [956, 122.5],
      [959, 115.5],
      [962, 111.5],
      [965, 120.5],
      [968, 111.5],
      [971, 113.5],
      [974, 121.5],
      [977, 107.5],
      [980, 129.5],
      [983, 124.5],
      [986, 109.5],
      [989, 115.5],
      [992, 115.5],
      [995, 108.5],
      [998, 112.5],
      [1001, 120.5],
      [1004, 121.5],
      [1007, 112.5],
      [1010, 129.5],
      [1013, 134.5],
      [1016, 129.5],
      [1019, 134.5],
      [1022, 112.5],
      [1025, 127.5],
      [1028, 123.5],
      [1031, 108.5],
      [1034, 105.5],
      [1037, 107.5],
      [1040, 127.5],
      [1043, 117.5],
      [1046, 108.5],
      [1049, 129.5],
      [1052, 101.5],
      [1055, 131.5],
      [1058, 127.5],
      [1061, 104.5],
      [1064, 123.5],
      [1067, 103.5],
      [1070, 129.5],
      [1073, 135.5],
      [1076, 109.5],
      [1079, 121.5],
      [1082, 116.5],
      [1085, 129.5],
      [1088, 123.5],
      [1091, 103.5],
      [1094, 109.5],
      [1097, 101.5],
      [1100, 124.5],
      [1103, 130.5],
      [1106, 111.5],
      [1109, 121.5],
      [1112, 102.5],
      [1115, 135.5],
      [1118, 129.5],
      [1121, 107.5],
      [1124, 110.5],
      [1127, 103.5],
      [1130, 118.5],
      [1133, 134.5],
      [1136, 119.5],
      [1139, 108.5],
      [1142, 117.5],
      [1145, 129.5],
      [1148, 136.5],
      [1151, 105.5],
      [1154, 111.5],
      [1157, 110.5],
      [1160, 130.5],
      [1163, 119.5],
      [1166, 119.5],
      [1169, 123.5],
      [1172, 100.5],
      [1175, 127.5],
      [1178, 133.5],
      [1181, 108.5],
      [1184, 121.5],
      [1187, 98.5],
      [1190, 113.5],
      [1193, 126.5],
      [1196, 127.5],
      [1199, 124.5],
      [1202, 103.5],
      [1205, 123.5],
      [1208, 116.5],
      [1211, 96.5],
      [1214, 107.5],
      [1217, 101.5],
      [1220, 112.5],
      [1223, 119.5],
      [1226, 113.5],
      [1229, 109.5],
      [1232, 116.5],
      [1235, 118.5],
      [1238, 122.5],
      [1241, 117.5],
      [1244, 130.5],
      [1247, 100.5],
      [1250, 108.5],
      [1253, 134.5],
      [1256, 104.5],
      [1259, 109.5],
      [1262, 119.5],
      [1265, 126.5],
      [1268, 120.5],
      [1271, 123.5],
      [1274, 128.5],
      [1277, 122.5],
      [1280, 128.5],
      [1283, 134.5],
      [1286, 117.5],
      [1289, 124.5],
      [1292, 96.5],
      [1295, 116.5],
      [1298, 120.5],
      [1301, 106.5],
      [1304, 118.5],
      [1307, 105.5],
      [1310, 126.5],
      [1313, 132.5],
      [1316, 117.5],
      [1319, 106.5],
      [1322, 117.5],
      [1325, 133.5],
      [1328, 126.5],
      [1331, 103.5],
      [1334, 108.5],
      [1337, 99.5],
      [1340, 117.5],
      [1343, 132.5],
      [1346, 98.5],
      [1349, 119.5],
      [1352, 99.5],
      [1355, 124.5],
      [1358, 124.5],
      [1361, 114.5],
      [1364, 112.5],
      [1367, 109.5],
      [1370, 110.5],
      [1373, 133.5],
      [1376, 105.5],
      [1379, 105.5],
      [1382, 116.5],
      [1385, 117.5],
      [1388, 123.5],
      [1391, 106.5],
      [1394, 115.5],
      [1397, 104.5],
      [1400, 121.5],
      [1403, 123.5],
      [1406, 103.5],
      [1409, 120.5],
      [1412, 90.5],
      [1415, 108.5],
      [1418, 121.5],
      [1421, 108.5],
      [1424, 111.5],
      [1427, 99.5],
      [1430, 133.5],
      [1433, 124.5],
      [1436, 124.5],
      [1439, 109.5],
      [1442, 109.5],
      [1445, 116.5],
      [1448, 116.5],
      [1451, 116.5],
      [1454, 111.5],
      [1457, 108.5],
      [1460, 125.5],
      [1463, 123.5],
      [1466, 113.5],
      [1469, 103.5],
      [1472, 101.5],
      [1475, 117.5],
      [1478, 127.5],
      [1481, 109.5],
      [1484, 116.5],
      [1487, 111.5],
      [1490, 108.5],
      [1493, 123.5],
      [1496, 111.5],
      [1499, 104.5],
      [1502, 100.5],
      [1505, 121.5],
      [1508, 109.5],
      [1511, 115.5],
      [1514, 110.5],
      [1517, 102.5],
      [1520, 112.5],
      [1523, 96.5],
      [1526, 92.5],
      [1529, 86.5],
      [1532, 85.5],
      [1535, 78.5],
      [1538, 76.5],
      [1541, 75.5],
      [1544, 75.5],
      [1547, 75.5],
      [1550, 75.5],
    ],
    bottom: [
      [1548, 75.5],
      [1545, 75.5],
      [1542, 75.5],
      [1539, 74.5],
      [1536, 73.5],
      [1533, 67.5],
      [1530, 60.5],
      [1527, 60.5],
      [1524, 51.5],
      [1521, 31.5],
      [1518, 30.5],
      [1515, 30.5],
      [1512, 42.5],
      [1509, 43.5],
      [1506, 35.5],
      [1503, 37.5],
      [1500, 31.5],
      [1497, 36.5],
      [1494, 47.5],
      [1491, 29.5],
      [1488, 29.5],
      [1485, 36.5],
      [1482, 47.5],
      [1479, 29.5],
      [1476, 42.5],
      [1473, 39.5],
      [1470, 34.5],
      [1467, 36.5],
      [1464, 43.5],
      [1461, 36.5],
      [1458, 26.5],
      [1455, 32.5],
      [1452, 31.5],
      [1449, 43.5],
      [1446, 45.5],
      [1443, 29.5],
      [1440, 25.5],
      [1437, 43.5],
      [1434, 30.5],
      [1431, 36.5],
      [1428, 35.5],
      [1425, 29.5],
      [1422, 48.5],
      [1419, 38.5],
      [1416, 47.5],
      [1413, 37.5],
      [1410, 46.5],
      [1407, 46.5],
      [1404, 47.5],
      [1401, 41.5],
      [1398, 32.5],
      [1395, 27.5],
      [1392, 47.5],
      [1389, 39.5],
      [1386, 41.5],
      [1383, 35.5],
      [1380, 20.5],
      [1377, 47.5],
      [1374, 50.5],
      [1371, 37.5],
      [1368, 41.5],
      [1365, 31.5],
      [1362, 41.5],
      [1359, 37.5],
      [1356, 30.5],
      [1353, 25.5],
      [1350, 40.5],
      [1347, 52.5],
      [1344, 38.5],
      [1341, 39.5],
      [1338, 24.5],
      [1335, 26.5],
      [1332, 50.5],
      [1329, 13.5],
      [1326, 43.5],
      [1323, 26.5],
      [1320, 26.5],
      [1317, 48.5],
      [1314, 36.5],
      [1311, 39.5],
      [1308, 30.5],
      [1305, 28.5],
      [1302, 43.5],
      [1299, 44.5],
      [1296, 41.5],
      [1293, 29.5],
      [1290, 42.5],
      [1287, 55.5],
      [1284, 36.5],
      [1281, 35.5],
      [1278, 14.5],
      [1275, 22.5],
      [1272, 40.5],
      [1269, 26.5],
      [1266, 43.5],
      [1263, 25.5],
      [1260, 24.5],
      [1257, 42.5],
      [1254, 38.5],
      [1251, 47.5],
      [1248, 21.5],
      [1245, 17.5],
      [1242, 21.5],
      [1239, 37.5],
      [1236, 46.5],
      [1233, 37.5],
      [1230, 16.5],
      [1227, 48.5],
      [1224, 27.5],
      [1221, 44.5],
      [1218, 26.5],
      [1215, 27.5],
      [1212, 58.5],
      [1209, 33.5],
      [1206, 50.5],
      [1203, 35.5],
      [1200, 33.5],
      [1197, 44.5],
      [1194, 39.5],
      [1191, 46.5],
      [1188, 41.5],
      [1185, 20.5],
      [1182, 37.5],
      [1179, 39.5],
      [1176, 45.5],
      [1173, 33.5],
      [1170, 46.5],
      [1167, 47.5],
      [1164, 27.5],
      [1161, 30.5],
      [1158, 27.5],
      [1155, 24.5],
      [1152, 50.5],
      [1149, 32.5],
      [1146, 29.5],
      [1143, 31.5],
      [1140, 28.5],
      [1137, 51.5],
      [1134, 40.5],
      [1131, 52.5],
      [1128, 27.5],
      [1125, 25.5],
      [1122, 44.5],
      [1119, 35.5],
      [1116, 36.5],
      [1113, 27.5],
      [1110, 22.5],
      [1107, 52.5],
      [1104, 31.5],
      [1101, 40.5],
      [1098, 22.5],
      [1095, 23.5],
      [1092, 52.5],
      [1089, 25.5],
      [1086, 34.5],
      [1083, 28.5],
      [1080, 20.5],
      [1077, 43.5],
      [1074, 33.5],
      [1071, 51.5],
      [1068, 26.5],
      [1065, 23.5],
      [1062, 34.5],
      [1059, 35.5],
      [1056, 39.5],
      [1053, 20.5],
      [1050, 48.5],
      [1047, 56.5],
      [1044, 42.5],
      [1041, 46.5],
      [1038, 21.5],
      [1035, 28.5],
      [1032, 34.5],
      [1029, 19.5],
      [1026, 35.5],
      [1023, 25.5],
      [1020, 20.5],
      [1017, 30.5],
      [1014, 13.5],
      [1011, 22.5],
      [1008, 32.5],
      [1005, 18.5],
      [1002, 29.5],
      [999, 41.5],
      [996, 33.5],
      [993, 40.5],
      [990, 25.5],
      [987, 31.5],
      [984, 20.5],
      [981, 38.5],
      [978, 29.5],
      [975, 32.5],
      [972, 34.5],
      [969, 20.5],
      [966, 33.5],
      [963, 35.5],
      [960, 18.5],
      [957, 32.5],
      [954, 24.5],
      [951, 40.5],
      [948, 30.5],
      [945, 27.5],
      [942, 40.5],
      [939, 26.5],
      [936, 31.5],
      [933, 27.5],
      [930, 16.5],
      [927, 30.5],
      [924, 26.5],
      [921, 22.5],
      [918, 39.5],
      [915, 32.5],
      [912, 28.5],
      [909, 32.5],
      [906, 35.5],
      [903, 28.5],
      [900, 20.5],
      [897, 36.5],
      [894, 26.5],
      [891, 38.5],
      [888, 38.5],
      [885, 26.5],
      [882, 22.5],
      [879, 37.5],
      [876, 11.5],
      [873, 32.5],
      [870, 22.5],
      [867, 33.5],
      [864, 21.5],
      [861, 38.5],
      [858, 35.5],
      [855, 14.5],
      [852, 39.5],
      [849, 23.5],
      [846, 34.5],
      [843, 27.5],
      [840, 15.5],
      [837, 47.5],
      [834, 35.5],
      [831, 49.5],
      [828, 17.5],
      [825, 28.5],
      [822, 26.5],
      [819, 38.5],
      [816, 32.5],
      [813, 20.5],
      [810, 42.5],
      [807, 48.5],
      [804, 25.5],
      [801, 42.5],
      [798, 23.5],
      [795, 26.5],
      [792, 57.5],
      [789, 40.5],
      [786, 31.5],
      [783, 19.5],
      [780, 21.5],
      [777, 36.5],
      [774, 25.5],
      [771, 49.5],
      [768, 49.5],
      [765, 18.5],
      [762, 32.5],
      [759, 29.5],
      [756, 27.5],
      [753, 29.5],
      [750, 19.5],
      [747, 39.5],
      [744, 35.5],
      [741, 31.5],
      [738, 52.5],
      [735, 42.5],
      [732, 30.5],
      [729, 46.5],
      [726, 26.5],
      [723, 25.5],
      [720, 30.5],
      [717, 49.5],
      [714, 37.5],
      [711, 51.5],
      [708, 31.5],
      [705, 37.5],
      [702, 35.5],
      [699, 30.5],
      [696, 33.5],
      [693, 29.5],
      [690, 25.5],
      [687, 33.5],
      [684, 33.5],
      [681, 31.5],
      [678, 37.5],
      [675, 30.5],
      [672, 31.5],
      [669, 34.5],
      [666, 20.5],
      [663, 30.5],
      [660, 31.5],
      [657, 36.5],
      [654, 36.5],
      [651, 43.5],
      [648, 29.5],
      [645, 36.5],
      [642, 46.5],
      [639, 26.5],
      [636, 26.5],
      [633, 29.5],
      [630, 29.5],
      [627, 41.5],
      [624, 30.5],
      [621, 36.5],
      [618, 26.5],
      [615, 21.5],
      [612, 54.5],
      [609, 20.5],
      [606, 42.5],
      [603, 22.5],
      [600, 22.5],
      [597, 38.5],
      [594, 38.5],
      [591, 49.5],
      [588, 31.5],
      [585, 23.5],
      [582, 30.5],
      [579, 34.5],
      [576, 33.5],
      [573, 28.5],
      [570, 38.5],
      [567, 45.5],
      [564, 34.5],
      [561, 37.5],
      [558, 18.5],
      [555, 22.5],
      [552, 58.5],
      [549, 14.5],
      [546, 36.5],
      [543, 20.5],
      [540, 28.5],
      [537, 40.5],
      [534, 47.5],
      [531, 52.5],
      [528, 24.5],
      [525, 23.5],
      [522, 30.5],
      [519, 31.5],
      [516, 33.5],
      [513, 18.5],
      [510, 30.5],
      [507, 45.5],
      [504, 32.5],
      [501, 38.5],
      [498, 23.5],
      [495, 26.5],
      [492, 53.5],
      [489, 15.5],
      [486, 38.5],
      [483, 19.5],
      [480, 13.5],
      [477, 24.5],
      [474, 36.5],
      [471, 32.5],
      [468, 21.5],
      [465, 22.5],
      [462, 36.5],
      [459, 33.5],
      [456, 32.5],
      [453, 26.5],
      [450, 12.5],
      [447, 17.5],
      [444, 35.5],
      [441, 32.5],
      [438, 15.5],
      [435, 21.5],
      [432, 19.5],
      [429, 33.5],
      [426, 6.894599999999997],
      [423, 36.5],
      [420, 13.5],
      [417, 30.5],
      [414, 28.5],
      [411, 21.5],
      [408, 34.5],
      [405, 27.5],
      [402, 37.5],
      [399, 20.5],
      [396, 20.5],
      [393, 12.5],
      [390, 10.5],
      [387, 24.5],
      [384, 26.5],
      [381, 33.5],
      [378, 9.5],
      [375, 10.5],
      [372, 26.5],
      [369, 40.5],
      [366, 34.5],
      [363, 47.5],
      [360, 13.5],
      [357, 31.5],
      [354, 26.5],
      [351, 36.5],
      [348, 9.5],
      [345, 15.5],
      [342, 28.5],
      [339, 34.5],
      [336, 25.5],
      [333, 22.5],
      [330, 17.5],
      [327, 32.5],
      [324, 42.5],
      [321, 27.5],
      [318, 9.5],
      [315, 14.5],
      [312, 50.5],
      [309, 15.5],
      [306, 32.5],
      [303, 12.5],
      [300, 12.5],
      [297, 46.5],
      [294, 29.5],
      [291, 39.5],
      [288, 11.5],
      [285, 25.5],
      [282, 27.5],
      [279, 33.5],
      [276, 34.5],
      [273, 27.5],
      [270, 9.5],
      [267, 41.5],
      [264, 32.5],
      [261, 32.5],
      [258, 14.5],
      [255, 19.5],
      [252, 46.5],
      [249, 18.5],
      [246, 30.5],
      [243, 27.5],
      [240, 20.5],
      [237, 22.5],
      [234, 32.5],
      [231, 38.5],
      [228, 16.5],
      [225, 7.723399999999998],
      [222, 24.5],
      [219, 33.5],
      [216, 42.5],
      [213, 11.5],
      [210, 30.5],
      [207, 51.5],
      [204, 20.5],
      [201, 25.5],
      [198, 10.5],
      [195, 17.5],
      [192, 27.5],
      [189, 40.5],
      [186, 35.5],
      [183, 18.5],
      [180, 6.5],
      [177, 42.5],
      [174, 23.5],
      [171, 40.5],
      [168, 20.5],
      [165, 6.5],
      [162, 34.5],
      [159, 29.5],
      [156, 18.5],
      [153, 29.5],
      [150, 7.301600000000008],
      [147, 26.5],
      [144, 23.5],
      [141, 33.5],
      [138, 28.5],
      [135, 15.5],
      [132, 55.5],
      [129, 29.5],
      [126, 7.5],
      [123, 31.5],
      [120, 19.5],
      [117, 41.5],
      [114, 37.5],
      [111, 45.5],
      [108, 56.5],
      [105, 27.5],
      [102, 22.5],
      [99, 30.5],
      [96, 32.5],
      [93, 17.5],
      [90, 23.5],
      [87, 35.5],
      [84, 31.5],
      [81, 21.5],
      [78, 21.5],
      [75, 9.5],
      [72, 56.5],
      [69, 23.5],
      [66, 22.5],
      [63, 33.5],
      [60, 9.5],
      [57, 26.5],
      [54, 30.5],
      [51, 45.5],
      [48, 59.5],
      [45, 27.5],
      [42, 20.5],
      [39, 27.5],
      [36, 20.5],
      [33, 14.5],
      [30, 24.5],
      [27, 36.5],
      [24, 15.5],
      [21, 25.5],
      [18, 8.5],
      [15, 5.5],
      [12, 45.5],
      [9, 2.239999999999995],
      [6, 5.5],
      [3, 16.5],
      [0, 40.5],
    ],
  },
  {
    top: [
      [2, 135.5],
      [5, 143.2766],
      [8, 105.5],
      [11, 107.5],
      [14, 130.5],
      [17, 113.5],
      [20, 141.5],
      [23, 122.5],
      [26, 142.5],
      [29, 143.5],
      [32, 107.5],
      [35, 142.5],
      [38, 144.875],
      [41, 131.5],
      [44, 144.4976],
      [47, 114.5],
      [50, 132.5],
      [53, 138.5],
      [56, 144.4976],
      [59, 133.5],
      [62, 136.5],
      [65, 131.5],
      [68, 107.5],
      [71, 119.5],
      [74, 129.5],
      [77, 129.5],
      [80, 131.5],
      [83, 122.5],
      [86, 136.5],
      [89, 143.5],
      [92, 107.5],
      [95, 132.5],
      [98, 131.5],
      [101, 125.5],
      [104, 124.5],
      [107, 117.5],
      [110, 122.5],
      [113, 143.2766],
      [116, 129.5],
      [119, 144.5],
      [122, 125.5],
      [125, 134.5],
      [128, 102.5],
      [131, 112.5],
      [134, 120.5],
      [137, 108.5],
      [140, 140.5],
      [143, 119.5],
      [146, 130.5],
      [149, 144.4976],
      [152, 109.5],
      [155, 123.5],
      [158, 137.5],
      [161, 122.5],
      [164, 133.5],
      [167, 101.5],
      [170, 129.5],
      [173, 140.5],
      [176, 128.5],
      [179, 141.5],
      [182, 113.5],
      [185, 127.5],
      [188, 144.875],
      [191, 111.5],
      [194, 110.5],
      [197, 101.5],
      [200, 138.5],
      [203, 119.5],
      [206, 116.5],
      [209, 144.4976],
      [212, 103.5],
      [215, 128.5],
      [218, 138.5],
      [221, 116.5],
      [224, 132.5],
      [227, 130.5],
      [230, 128.5],
      [233, 135.5],
      [236, 112.5],
      [239, 119.5],
      [242, 130.5],
      [245, 130.5],
      [248, 136.5],
      [251, 111.5],
      [254, 109.5],
      [257, 107.5],
      [260, 135.5],
      [263, 133.5],
      [266, 114.5],
      [269, 121.5],
      [272, 109.5],
      [275, 143.5],
      [278, 136.5],
      [281, 120.5],
      [284, 119.5],
      [287, 116.5],
      [290, 110.5],
      [293, 135.5],
      [296, 116.5],
      [299, 112.5],
      [302, 122.5],
      [305, 132.5],
      [308, 141.5],
      [311, 105.5],
      [314, 125.5],
      [317, 113.5],
      [320, 128.5],
      [323, 114.5],
      [326, 124.5],
      [329, 127.5],
      [332, 112.5],
      [335, 130.5],
      [338, 120.5],
      [341, 120.5],
      [344, 111.5],
      [347, 104.5],
      [350, 138.5],
      [353, 122.5],
      [356, 110.5],
      [359, 118.5],
      [362, 113.5],
      [365, 133.5],
      [368, 91.5],
      [371, 112.5],
      [374, 123.5],
      [377, 131.5],
      [380, 130.5],
      [383, 115.5],
      [386, 122.5],
      [389, 126.5],
      [392, 111.5],
      [395, 133.5],
      [398, 128.5],
      [401, 108.5],
      [404, 99.5],
      [407, 110.5],
      [410, 130.5],
      [413, 123.5],
      [416, 124.5],
      [419, 109.5],
      [422, 114.5],
      [425, 133.5],
      [428, 132.5],
      [431, 117.5],
      [434, 121.5],
      [437, 119.5],
      [440, 129.5],
      [443, 120.5],
      [446, 132.5],
      [449, 117.5],
      [452, 102.5],
      [455, 130.5],
      [458, 122.5],
      [461, 112.5],
      [464, 105.5],
      [467, 105.5],
      [470, 127.5],
      [473, 131.5],
      [476, 113.5],
      [479, 133.5],
      [482, 115.5],
      [485, 128.5],
      [488, 133.5],
      [491, 104.5],
      [494, 113.5],
      [497, 101.5],
      [500, 123.5],
      [503, 118.5],
      [506, 115.5],
      [509, 114.5],
      [512, 98.5],
      [515, 126.5],
      [518, 131.5],
      [521, 109.5],
      [524, 109.5],
      [527, 111.5],
      [530, 110.5],
      [533, 130.5],
      [536, 124.5],
      [539, 117.5],
      [542, 115.5],
      [545, 120.5],
      [548, 113.5],
      [551, 108.5],
      [554, 105.5],
      [557, 123.5],
      [560, 122.5],
      [563, 133.5],
      [566, 127.5],
      [569, 129.5],
      [572, 101.5],
      [575, 136.5],
      [578, 141.5],
      [581, 118.5],
      [584, 111.5],
      [587, 107.5],
      [590, 128.5],
      [593, 121.5],
      [596, 133.5],
      [599, 114.5],
      [602, 126.5],
      [605, 126.5],
      [608, 122.5],
      [611, 101.5],
      [614, 118.5],
      [617, 99.5],
      [620, 131.5],
      [623, 127.5],
      [626, 118.5],
      [629, 131.5],
      [632, 101.5],
      [635, 124.5],
      [638, 127.5],
      [641, 118.5],
      [644, 116.5],
      [647, 107.5],
      [650, 120.5],
      [653, 119.5],
      [656, 113.5],
      [659, 109.5],
      [662, 123.5],
      [665, 115.5],
      [668, 121.5],
      [671, 119.5],
      [674, 112.5],
      [677, 122.5],
      [680, 126.5],
      [683, 113.5],
      [686, 127.5],
      [689, 127.5],
      [692, 115.5],
      [695, 118.5],
      [698, 118.5],
      [701, 121.5],
      [704, 118.5],
      [707, 93.5],
      [710, 108.5],
      [713, 115.5],
      [716, 102.5],
      [719, 115.5],
      [722, 107.5],
      [725, 113.5],
      [728, 128.5],
      [731, 119.5],
      [734, 110.5],
      [737, 110.5],
      [740, 118.5],
      [743, 119.5],
      [746, 128.5],
      [749, 117.5],
      [752, 120.5],
      [755, 119.5],
      [758, 116.5],
      [761, 122.5],
      [764, 110.5],
      [767, 97.5],
      [770, 125.5],
      [773, 124.5],
      [776, 115.5],
      [779, 123.5],
      [782, 117.5],
      [785, 112.5],
      [788, 101.5],
      [791, 100.5],
      [794, 117.5],
      [797, 109.5],
      [800, 122.5],
      [803, 129.5],
      [806, 119.5],
      [809, 125.5],
      [812, 96.5],
      [815, 119.5],
      [818, 131.5],
      [821, 108.5],
      [824, 118.5],
      [827, 115.5],
      [830, 126.5],
      [833, 126.5],
      [836, 125.5],
      [839, 104.5],
      [842, 126.5],
      [845, 124.5],
      [848, 118.5],
      [851, 117.5],
      [854, 107.5],
      [857, 100.5],
      [860, 123.5],
      [863, 132.5],
      [866, 129.5],
      [869, 118.5],
      [872, 101.5],
      [875, 134.5],
      [878, 126.5],
      [881, 127.5],
      [884, 115.5],
      [887, 118.5],
      [890, 128.5],
      [893, 114.5],
      [896, 120.5],
      [899, 118.5],
      [902, 114.5],
      [905, 115.5],
      [908, 118.5],
      [911, 114.5],
      [914, 109.5],
      [917, 118.5],
      [920, 129.5],
      [923, 116.5],
      [926, 126.5],
      [929, 128.5],
      [932, 109.5],
      [935, 115.5],
      [938, 111.5],
      [941, 121.5],
      [944, 114.5],
      [947, 109.5],
      [950, 127.5],
      [953, 115.5],
      [956, 118.5],
      [959, 112.5],
      [962, 108.5],
      [965, 117.5],
      [968, 110.5],
      [971, 110.5],
      [974, 117.5],
      [977, 108.5],
      [980, 130.5],
      [983, 123.5],
      [986, 108.5],
      [989, 115.5],
      [992, 112.5],
      [995, 106.5],
      [998, 110.5],
      [1001, 117.5],
      [1004, 117.5],
      [1007, 108.5],
      [1010, 124.5],
      [1013, 133.5],
      [1016, 127.5],
      [1019, 131.5],
      [1022, 109.5],
      [1025, 123.5],
      [1028, 124.5],
      [1031, 105.5],
      [1034, 103.5],
      [1037, 104.5],
      [1040, 123.5],
      [1043, 117.5],
      [1046, 106.5],
      [1049, 127.5],
      [1052, 100.5],
      [1055, 126.5],
      [1058, 123.5],
      [1061, 101.5],
      [1064, 119.5],
      [1067, 102.5],
      [1070, 124.5],
      [1073, 136.5],
      [1076, 107.5],
      [1079, 122.5],
      [1082, 113.5],
      [1085, 124.5],
      [1088, 119.5],
      [1091, 100.5],
      [1094, 107.5],
      [1097, 99.5],
      [1100, 120.5],
      [1103, 132.5],
      [1106, 108.5],
      [1109, 121.5],
      [1112, 100.5],
      [1115, 130.5],
      [1118, 125.5],
      [1121, 104.5],
      [1124, 108.5],
      [1127, 103.5],
      [1130, 119.5],
      [1133, 137.5],
      [1136, 116.5],
      [1139, 106.5],
      [1142, 114.5],
      [1145, 125.5],
      [1148, 131.5],
      [1151, 102.5],
      [1154, 107.5],
      [1157, 108.5],
      [1160, 125.5],
      [1163, 120.5],
      [1166, 115.5],
      [1169, 120.5],
      [1172, 98.5],
      [1175, 122.5],
      [1178, 136.5],
      [1181, 107.5],
      [1184, 117.5],
      [1187, 97.5],
      [1190, 111.5],
      [1193, 122.5],
      [1196, 123.5],
      [1199, 122.5],
      [1202, 101.5],
      [1205, 119.5],
      [1208, 116.5],
      [1211, 95.5],
      [1214, 105.5],
      [1217, 99.5],
      [1220, 109.5],
      [1223, 120.5],
      [1226, 111.5],
      [1229, 110.5],
      [1232, 113.5],
      [1235, 115.5],
      [1238, 119.5],
      [1241, 114.5],
      [1244, 125.5],
      [1247, 97.5],
      [1250, 105.5],
      [1253, 135.5],
      [1256, 102.5],
      [1259, 107.5],
      [1262, 115.5],
      [1265, 121.5],
      [1268, 117.5],
      [1271, 118.5],
      [1274, 124.5],
      [1277, 119.5],
      [1280, 131.5],
      [1283, 136.5],
      [1286, 114.5],
      [1289, 123.5],
      [1292, 95.5],
      [1295, 111.5],
      [1298, 115.5],
      [1301, 103.5],
      [1304, 114.5],
      [1307, 103.5],
      [1310, 122.5],
      [1313, 134.5],
      [1316, 115.5],
      [1319, 103.5],
      [1322, 114.5],
      [1325, 128.5],
      [1328, 127.5],
      [1331, 104.5],
      [1334, 104.5],
      [1337, 97.5],
      [1340, 115.5],
      [1343, 133.5],
      [1346, 97.5],
      [1349, 116.5],
      [1352, 98.5],
      [1355, 119.5],
      [1358, 119.5],
      [1361, 110.5],
      [1364, 108.5],
      [1367, 108.5],
      [1370, 107.5],
      [1373, 132.5],
      [1376, 103.5],
      [1379, 107.5],
      [1382, 118.5],
      [1385, 113.5],
      [1388, 120.5],
      [1391, 103.5],
      [1394, 112.5],
      [1397, 104.5],
      [1400, 118.5],
      [1403, 122.5],
      [1406, 104.5],
      [1409, 117.5],
      [1412, 89.5],
      [1415, 106.5],
      [1418, 116.5],
      [1421, 106.5],
      [1424, 109.5],
      [1427, 99.5],
      [1430, 136.5],
      [1433, 122.5],
      [1436, 123.5],
      [1439, 106.5],
      [1442, 108.5],
      [1445, 114.5],
      [1448, 115.5],
      [1451, 112.5],
      [1454, 108.5],
      [1457, 105.5],
      [1460, 124.5],
      [1463, 123.5],
      [1466, 115.5],
      [1469, 101.5],
      [1472, 102.5],
      [1475, 114.5],
      [1478, 127.5],
      [1481, 110.5],
      [1484, 112.5],
      [1487, 111.5],
      [1490, 107.5],
      [1493, 121.5],
      [1496, 113.5],
      [1499, 103.5],
      [1502, 98.5],
      [1505, 116.5],
      [1508, 105.5],
      [1511, 112.5],
      [1514, 106.5],
      [1517, 100.5],
      [1520, 113.5],
      [1523, 95.5],
      [1526, 94.5],
      [1529, 86.5],
      [1532, 85.5],
      [1535, 78.5],
      [1538, 76.5],
      [1541, 75.5],
      [1544, 75.5],
      [1547, 75.5],
      [1550, 75.5],
    ],
    bottom: [
      [1548, 75.5],
      [1545, 75.5],
      [1542, 75.5],
      [1539, 74.5],
      [1536, 73.5],
      [1533, 67.5],
      [1530, 59.5],
      [1527, 59.5],
      [1524, 53.5],
      [1521, 29.5],
      [1518, 33.5],
      [1515, 35.5],
      [1512, 45.5],
      [1509, 46.5],
      [1506, 39.5],
      [1503, 41.5],
      [1500, 32.5],
      [1497, 35.5],
      [1494, 50.5],
      [1491, 29.5],
      [1488, 31.5],
      [1485, 39.5],
      [1482, 46.5],
      [1479, 27.5],
      [1476, 45.5],
      [1473, 40.5],
      [1470, 36.5],
      [1467, 34.5],
      [1464, 43.5],
      [1461, 35.5],
      [1458, 31.5],
      [1455, 37.5],
      [1452, 35.5],
      [1449, 46.5],
      [1446, 46.5],
      [1443, 31.5],
      [1440, 30.5],
      [1437, 44.5],
      [1434, 33.5],
      [1431, 33.5],
      [1428, 33.5],
      [1425, 32.5],
      [1422, 50.5],
      [1419, 42.5],
      [1416, 49.5],
      [1413, 40.5],
      [1410, 48.5],
      [1407, 44.5],
      [1404, 48.5],
      [1401, 42.5],
      [1398, 32.5],
      [1395, 31.5],
      [1392, 50.5],
      [1389, 43.5],
      [1386, 43.5],
      [1383, 36.5],
      [1380, 18.5],
      [1377, 48.5],
      [1374, 51.5],
      [1371, 38.5],
      [1368, 43.5],
      [1365, 35.5],
      [1362, 44.5],
      [1359, 41.5],
      [1356, 33.5],
      [1353, 28.5],
      [1350, 43.5],
      [1347, 52.5],
      [1344, 39.5],
      [1341, 38.5],
      [1338, 29.5],
      [1335, 30.5],
      [1332, 51.5],
      [1329, 12.5],
      [1326, 47.5],
      [1323, 29.5],
      [1320, 30.5],
      [1317, 49.5],
      [1314, 36.5],
      [1311, 39.5],
      [1308, 35.5],
      [1305, 32.5],
      [1302, 46.5],
      [1299, 47.5],
      [1296, 45.5],
      [1293, 32.5],
      [1290, 45.5],
      [1287, 55.5],
      [1284, 36.5],
      [1281, 34.5],
      [1278, 14.5],
      [1275, 26.5],
      [1272, 43.5],
      [1269, 31.5],
      [1266, 45.5],
      [1263, 29.5],
      [1260, 29.5],
      [1257, 43.5],
      [1254, 38.5],
      [1251, 48.5],
      [1248, 26.5],
      [1245, 23.5],
      [1242, 25.5],
      [1239, 40.5],
      [1236, 48.5],
      [1233, 39.5],
      [1230, 16.5],
      [1227, 48.5],
      [1224, 28.5],
      [1221, 45.5],
      [1218, 30.5],
      [1215, 30.5],
      [1212, 59.5],
      [1209, 35.5],
      [1206, 52.5],
      [1203, 38.5],
      [1200, 37.5],
      [1197, 45.5],
      [1194, 42.5],
      [1191, 48.5],
      [1188, 42.5],
      [1185, 25.5],
      [1182, 40.5],
      [1179, 37.5],
      [1176, 48.5],
      [1173, 37.5],
      [1170, 49.5],
      [1167, 49.5],
      [1164, 28.5],
      [1161, 34.5],
      [1158, 29.5],
      [1155, 30.5],
      [1152, 52.5],
      [1149, 36.5],
      [1146, 32.5],
      [1143, 33.5],
      [1140, 31.5],
      [1137, 53.5],
      [1134, 38.5],
      [1131, 52.5],
      [1128, 26.5],
      [1125, 29.5],
      [1122, 46.5],
      [1119, 38.5],
      [1116, 39.5],
      [1113, 31.5],
      [1110, 25.5],
      [1107, 53.5],
      [1104, 30.5],
      [1101, 42.5],
      [1098, 26.5],
      [1095, 27.5],
      [1092, 54.5],
      [1089, 29.5],
      [1086, 37.5],
      [1083, 32.5],
      [1080, 18.5],
      [1077, 43.5],
      [1074, 32.5],
      [1071, 53.5],
      [1068, 28.5],
      [1065, 26.5],
      [1062, 37.5],
      [1059, 37.5],
      [1056, 41.5],
      [1053, 24.5],
      [1050, 50.5],
      [1047, 58.5],
      [1044, 41.5],
      [1041, 48.5],
      [1038, 26.5],
      [1035, 31.5],
      [1032, 37.5],
      [1029, 18.5],
      [1026, 37.5],
      [1023, 28.5],
      [1020, 24.5],
      [1017, 34.5],
      [1014, 13.5],
      [1011, 27.5],
      [1008, 37.5],
      [1005, 22.5],
      [1002, 34.5],
      [999, 43.5],
      [996, 37.5],
      [993, 44.5],
      [990, 26.5],
      [987, 34.5],
      [984, 18.5],
      [981, 40.5],
      [978, 27.5],
      [975, 35.5],
      [972, 37.5],
      [969, 22.5],
      [966, 36.5],
      [963, 39.5],
      [960, 21.5],
      [957, 36.5],
      [954, 27.5],
      [951, 43.5],
      [948, 34.5],
      [945, 31.5],
      [942, 42.5],
      [939, 28.5],
      [936, 35.5],
      [933, 32.5],
      [930, 19.5],
      [927, 31.5],
      [924, 27.5],
      [921, 26.5],
      [918, 42.5],
      [915, 34.5],
      [912, 31.5],
      [909, 35.5],
      [906, 38.5],
      [903, 31.5],
      [900, 25.5],
      [897, 40.5],
      [894, 27.5],
      [891, 40.5],
      [888, 41.5],
      [885, 30.5],
      [882, 24.5],
      [879, 38.5],
      [876, 14.5],
      [873, 36.5],
      [870, 27.5],
      [867, 35.5],
      [864, 21.5],
      [861, 40.5],
      [858, 38.5],
      [855, 20.5],
      [852, 41.5],
      [849, 27.5],
      [846, 38.5],
      [843, 31.5],
      [840, 20.5],
      [837, 47.5],
      [834, 35.5],
      [831, 51.5],
      [828, 16.5],
      [825, 32.5],
      [822, 30.5],
      [819, 41.5],
      [816, 34.5],
      [813, 23.5],
      [810, 44.5],
      [807, 49.5],
      [804, 24.5],
      [801, 45.5],
      [798, 28.5],
      [795, 31.5],
      [792, 58.5],
      [789, 40.5],
      [786, 35.5],
      [783, 24.5],
      [780, 23.5],
      [777, 35.5],
      [774, 26.5],
      [771, 50.5],
      [768, 52.5],
      [765, 22.5],
      [762, 35.5],
      [759, 33.5],
      [756, 30.5],
      [753, 33.5],
      [750, 23.5],
      [747, 41.5],
      [744, 36.5],
      [741, 33.5],
      [738, 53.5],
      [735, 44.5],
      [732, 33.5],
      [729, 46.5],
      [726, 24.5],
      [723, 29.5],
      [720, 33.5],
      [717, 51.5],
      [714, 39.5],
      [711, 52.5],
      [708, 34.5],
      [705, 41.5],
      [702, 37.5],
      [699, 34.5],
      [696, 36.5],
      [693, 33.5],
      [690, 26.5],
      [687, 32.5],
      [684, 35.5],
      [681, 35.5],
      [678, 37.5],
      [675, 32.5],
      [672, 35.5],
      [669, 37.5],
      [666, 24.5],
      [663, 32.5],
      [660, 33.5],
      [657, 35.5],
      [654, 38.5],
      [651, 46.5],
      [648, 32.5],
      [645, 38.5],
      [642, 46.5],
      [639, 26.5],
      [636, 30.5],
      [633, 32.5],
      [630, 32.5],
      [627, 42.5],
      [624, 32.5],
      [621, 38.5],
      [618, 29.5],
      [615, 17.5],
      [612, 56.5],
      [609, 22.5],
      [606, 45.5],
      [603, 24.5],
      [600, 24.5],
      [597, 36.5],
      [594, 40.5],
      [591, 51.5],
      [588, 33.5],
      [585, 26.5],
      [582, 29.5],
      [579, 35.5],
      [576, 33.5],
      [573, 31.5],
      [570, 39.5],
      [567, 44.5],
      [564, 36.5],
      [561, 37.5],
      [558, 19.5],
      [555, 25.5],
      [552, 58.5],
      [549, 20.5],
      [546, 38.5],
      [543, 23.5],
      [540, 30.5],
      [537, 39.5],
      [534, 50.5],
      [531, 53.5],
      [528, 24.5],
      [525, 23.5],
      [522, 33.5],
      [519, 34.5],
      [516, 36.5],
      [513, 18.5],
      [510, 34.5],
      [507, 45.5],
      [504, 34.5],
      [501, 40.5],
      [498, 27.5],
      [495, 28.5],
      [492, 53.5],
      [489, 14.5],
      [486, 41.5],
      [483, 22.5],
      [480, 18.5],
      [477, 23.5],
      [474, 38.5],
      [471, 33.5],
      [468, 24.5],
      [465, 24.5],
      [462, 38.5],
      [459, 36.5],
      [456, 34.5],
      [453, 29.5],
      [450, 15.5],
      [447, 17.5],
      [444, 36.5],
      [441, 34.5],
      [438, 18.5],
      [435, 24.5],
      [432, 20.5],
      [429, 35.5],
      [426, 6.502399999999994],
      [423, 37.5],
      [420, 15.5],
      [417, 29.5],
      [414, 31.5],
      [411, 24.5],
      [408, 36.5],
      [405, 30.5],
      [402, 38.5],
      [399, 21.5],
      [396, 24.5],
      [393, 17.5],
      [390, 11.5],
      [387, 21.5],
      [384, 29.5],
      [381, 35.5],
      [378, 11.5],
      [375, 10.5],
      [372, 27.5],
      [369, 42.5],
      [366, 37.5],
      [363, 50.5],
      [360, 14.5],
      [357, 29.5],
      [354, 28.5],
      [351, 37.5],
      [348, 14.5],
      [345, 16.5],
      [342, 29.5],
      [339, 36.5],
      [336, 26.5],
      [333, 23.5],
      [330, 18.5],
      [327, 33.5],
      [324, 44.5],
      [321, 28.5],
      [318, 10.5],
      [315, 17.5],
      [312, 51.5],
      [309, 19.5],
      [306, 33.5],
      [303, 17.5],
      [300, 11.5],
      [297, 46.5],
      [294, 31.5],
      [291, 41.5],
      [288, 10.5],
      [285, 28.5],
      [282, 28.5],
      [279, 35.5],
      [276, 33.5],
      [273, 31.5],
      [270, 10.5],
      [267, 42.5],
      [264, 34.5],
      [261, 34.5],
      [258, 18.5],
      [255, 20.5],
      [252, 47.5],
      [249, 20.5],
      [246, 33.5],
      [243, 28.5],
      [240, 20.5],
      [237, 24.5],
      [234, 35.5],
      [231, 38.5],
      [228, 20.5],
      [225, 7.301600000000008],
      [222, 25.5],
      [219, 36.5],
      [216, 44.5],
      [213, 12.5],
      [210, 32.5],
      [207, 51.5],
      [204, 22.5],
      [201, 23.5],
      [198, 13.5],
      [195, 16.5],
      [192, 30.5],
      [189, 39.5],
      [186, 37.5],
      [183, 20.5],
      [180, 7.723399999999998],
      [177, 42.5],
      [174, 23.5],
      [171, 41.5],
      [168, 21.5],
      [165, 9.5],
      [162, 35.5],
      [159, 29.5],
      [156, 20.5],
      [153, 31.5],
      [150, 6.125],
      [147, 27.5],
      [144, 21.5],
      [141, 35.5],
      [138, 29.5],
      [135, 14.5],
      [132, 55.5],
      [129, 30.5],
      [126, 6.5],
      [123, 33.5],
      [120, 19.5],
      [117, 42.5],
      [114, 38.5],
      [111, 45.5],
      [108, 56.5],
      [105, 27.5],
      [102, 24.5],
      [99, 31.5],
      [96, 34.5],
      [93, 19.5],
      [90, 23.5],
      [87, 35.5],
      [84, 32.5],
      [81, 21.5],
      [78, 23.5],
      [75, 8.5],
      [72, 55.5],
      [69, 22.5],
      [66, 23.5],
      [63, 32.5],
      [60, 8.5],
      [57, 25.5],
      [54, 31.5],
      [51, 45.5],
      [48, 58.5],
      [45, 28.5],
      [42, 20.5],
      [39, 26.5],
      [36, 22.5],
      [33, 15.5],
      [30, 21.5],
      [27, 35.5],
      [24, 14.5],
      [21, 27.5],
      [18, 7.5],
      [15, 5.5],
      [12, 47.5],
      [9, 2.5656000000000034],
      [6, 5.5],
      [3, 17.5],
      [0, 39.5],
    ],
  },
  {
    top: [
      [2, 137.5],
      [5, 143.5],
      [8, 104.5],
      [11, 107.5],
      [14, 128.5],
      [17, 114.5],
      [20, 141.5],
      [23, 120.5],
      [26, 143.5],
      [29, 143.5],
      [32, 106.5],
      [35, 139.5],
      [38, 144.875],
      [41, 129.5],
      [44, 143.2766],
      [47, 112.5],
      [50, 132.5],
      [53, 141.5],
      [56, 144.875],
      [59, 135.5],
      [62, 136.5],
      [65, 133.5],
      [68, 108.5],
      [71, 118.5],
      [74, 129.5],
      [77, 129.5],
      [80, 130.5],
      [83, 122.5],
      [86, 134.5],
      [89, 144.5],
      [92, 105.5],
      [95, 132.5],
      [98, 130.5],
      [101, 124.5],
      [104, 126.5],
      [107, 117.5],
      [110, 120.5],
      [113, 143.6984],
      [116, 126.5],
      [119, 144.5],
      [122, 123.5],
      [125, 135.5],
      [128, 102.5],
      [131, 112.5],
      [134, 120.5],
      [137, 106.5],
      [140, 138.5],
      [143, 121.5],
      [146, 129.5],
      [149, 144.875],
      [152, 110.5],
      [155, 123.5],
      [158, 137.5],
      [161, 120.5],
      [164, 131.5],
      [167, 100.5],
      [170, 129.5],
      [173, 138.5],
      [176, 129.5],
      [179, 142.5],
      [182, 113.5],
      [185, 127.5],
      [188, 144.4976],
      [191, 112.5],
      [194, 108.5],
      [197, 101.5],
      [200, 140.5],
      [203, 120.5],
      [206, 115.5],
      [209, 144.1054],
      [212, 103.5],
      [215, 126.5],
      [218, 136.5],
      [221, 116.5],
      [224, 131.5],
      [227, 130.5],
      [230, 127.5],
      [233, 137.5],
      [236, 112.5],
      [239, 119.5],
      [242, 131.5],
      [245, 126.5],
      [248, 136.5],
      [251, 113.5],
      [254, 108.5],
      [257, 107.5],
      [260, 132.5],
      [263, 134.5],
      [266, 111.5],
      [269, 121.5],
      [272, 108.5],
      [275, 143.5],
      [278, 137.5],
      [281, 122.5],
      [284, 117.5],
      [287, 115.5],
      [290, 108.5],
      [293, 130.5],
      [296, 114.5],
      [299, 112.5],
      [302, 124.5],
      [305, 129.5],
      [308, 137.5],
      [311, 104.5],
      [314, 126.5],
      [317, 114.5],
      [320, 125.5],
      [323, 113.5],
      [326, 124.5],
      [329, 127.5],
      [332, 114.5],
      [335, 129.5],
      [338, 125.5],
      [341, 120.5],
      [344, 112.5],
      [347, 104.5],
      [350, 136.5],
      [353, 124.5],
      [356, 111.5],
      [359, 119.5],
      [362, 113.5],
      [365, 129.5],
      [368, 90.5],
      [371, 111.5],
      [374, 121.5],
      [377, 132.5],
      [380, 128.5],
      [383, 114.5],
      [386, 122.5],
      [389, 128.5],
      [392, 108.5],
      [395, 126.5],
      [398, 129.5],
      [401, 109.5],
      [404, 99.5],
      [407, 112.5],
      [410, 129.5],
      [413, 121.5],
      [416, 123.5],
      [419, 109.5],
      [422, 112.5],
      [425, 135.5],
      [428, 132.5],
      [431, 116.5],
      [434, 120.5],
      [437, 120.5],
      [440, 125.5],
      [443, 118.5],
      [446, 131.5],
      [449, 116.5],
      [452, 100.5],
      [455, 127.5],
      [458, 122.5],
      [461, 110.5],
      [464, 105.5],
      [467, 104.5],
      [470, 126.5],
      [473, 128.5],
      [476, 113.5],
      [479, 130.5],
      [482, 111.5],
      [485, 127.5],
      [488, 131.5],
      [491, 103.5],
      [494, 113.5],
      [497, 100.5],
      [500, 120.5],
      [503, 117.5],
      [506, 114.5],
      [509, 114.5],
      [512, 96.5],
      [515, 123.5],
      [518, 126.5],
      [521, 108.5],
      [524, 108.5],
      [527, 111.5],
      [530, 107.5],
      [533, 129.5],
      [536, 125.5],
      [539, 117.5],
      [542, 118.5],
      [545, 120.5],
      [548, 110.5],
      [551, 105.5],
      [554, 105.5],
      [557, 123.5],
      [560, 122.5],
      [563, 133.5],
      [566, 128.5],
      [569, 126.5],
      [572, 99.5],
      [575, 134.5],
      [578, 142.5],
      [581, 118.5],
      [584, 109.5],
      [587, 106.5],
      [590, 129.5],
      [593, 117.5],
      [596, 135.5],
      [599, 113.5],
      [602, 127.5],
      [605, 122.5],
      [608, 120.5],
      [611, 99.5],
      [614, 119.5],
      [617, 97.5],
      [620, 129.5],
      [623, 125.5],
      [626, 121.5],
      [629, 129.5],
      [632, 100.5],
      [635, 120.5],
      [638, 127.5],
      [641, 115.5],
      [644, 113.5],
      [647, 105.5],
      [650, 117.5],
      [653, 116.5],
      [656, 113.5],
      [659, 107.5],
      [662, 119.5],
      [665, 112.5],
      [668, 118.5],
      [671, 117.5],
      [674, 109.5],
      [677, 123.5],
      [680, 121.5],
      [683, 112.5],
      [686, 128.5],
      [689, 126.5],
      [692, 111.5],
      [695, 116.5],
      [698, 113.5],
      [701, 119.5],
      [704, 114.5],
      [707, 92.5],
      [710, 105.5],
      [713, 114.5],
      [716, 100.5],
      [719, 112.5],
      [722, 105.5],
      [725, 112.5],
      [728, 129.5],
      [731, 116.5],
      [734, 108.5],
      [737, 106.5],
      [740, 117.5],
      [743, 116.5],
      [746, 130.5],
      [749, 112.5],
      [752, 117.5],
      [755, 114.5],
      [758, 114.5],
      [761, 117.5],
      [764, 107.5],
      [767, 94.5],
      [770, 121.5],
      [773, 120.5],
      [776, 115.5],
      [779, 122.5],
      [782, 112.5],
      [785, 107.5],
      [788, 99.5],
      [791, 99.5],
      [794, 112.5],
      [797, 105.5],
      [800, 118.5],
      [803, 125.5],
      [806, 119.5],
      [809, 121.5],
      [812, 93.5],
      [815, 118.5],
      [818, 127.5],
      [821, 104.5],
      [824, 115.5],
      [827, 115.5],
      [830, 123.5],
      [833, 123.5],
      [836, 126.5],
      [839, 102.5],
      [842, 122.5],
      [845, 119.5],
      [848, 113.5],
      [851, 113.5],
      [854, 104.5],
      [857, 98.5],
      [860, 119.5],
      [863, 131.5],
      [866, 129.5],
      [869, 114.5],
      [872, 98.5],
      [875, 127.5],
      [878, 126.5],
      [881, 123.5],
      [884, 113.5],
      [887, 114.5],
      [890, 123.5],
      [893, 113.5],
      [896, 120.5],
      [899, 113.5],
      [902, 114.5],
      [905, 112.5],
      [908, 114.5],
      [911, 109.5],
      [914, 105.5],
      [917, 114.5],
      [920, 125.5],
      [923, 114.5],
      [926, 126.5],
      [929, 128.5],
      [932, 105.5],
      [935, 112.5],
      [938, 108.5],
      [941, 116.5],
      [944, 110.5],
      [947, 104.5],
      [950, 122.5],
      [953, 112.5],
      [956, 113.5],
      [959, 111.5],
      [962, 105.5],
      [965, 114.5],
      [968, 108.5],
      [971, 106.5],
      [974, 111.5],
      [977, 108.5],
      [980, 129.5],
      [983, 122.5],
      [986, 106.5],
      [989, 113.5],
      [992, 108.5],
      [995, 104.5],
      [998, 106.5],
      [1001, 112.5],
      [1004, 113.5],
      [1007, 106.5],
      [1010, 118.5],
      [1013, 133.5],
      [1016, 124.5],
      [1019, 129.5],
      [1022, 107.5],
      [1025, 121.5],
      [1028, 125.5],
      [1031, 104.5],
      [1034, 102.5],
      [1037, 100.5],
      [1040, 117.5],
      [1043, 118.5],
      [1046, 105.5],
      [1049, 126.5],
      [1052, 98.5],
      [1055, 120.5],
      [1058, 122.5],
      [1061, 98.5],
      [1064, 114.5],
      [1067, 99.5],
      [1070, 119.5],
      [1073, 136.5],
      [1076, 104.5],
      [1079, 121.5],
      [1082, 113.5],
      [1085, 118.5],
      [1088, 114.5],
      [1091, 97.5],
      [1094, 103.5],
      [1097, 97.5],
      [1100, 116.5],
      [1103, 133.5],
      [1106, 106.5],
      [1109, 119.5],
      [1112, 97.5],
      [1115, 123.5],
      [1118, 119.5],
      [1121, 102.5],
      [1124, 105.5],
      [1127, 103.5],
      [1130, 119.5],
      [1133, 139.5],
      [1136, 112.5],
      [1139, 103.5],
      [1142, 111.5],
      [1145, 119.5],
      [1148, 124.5],
      [1151, 99.5],
      [1154, 104.5],
      [1157, 105.5],
      [1160, 120.5],
      [1163, 121.5],
      [1166, 111.5],
      [1169, 116.5],
      [1172, 96.5],
      [1175, 117.5],
      [1178, 137.5],
      [1181, 106.5],
      [1184, 111.5],
      [1187, 94.5],
      [1190, 107.5],
      [1193, 120.5],
      [1196, 118.5],
      [1199, 122.5],
      [1202, 100.5],
      [1205, 114.5],
      [1208, 113.5],
      [1211, 93.5],
      [1214, 101.5],
      [1217, 97.5],
      [1220, 106.5],
      [1223, 120.5],
      [1226, 109.5],
      [1229, 110.5],
      [1232, 111.5],
      [1235, 111.5],
      [1238, 116.5],
      [1241, 109.5],
      [1244, 119.5],
      [1247, 95.5],
      [1250, 101.5],
      [1253, 136.5],
      [1256, 100.5],
      [1259, 105.5],
      [1262, 110.5],
      [1265, 115.5],
      [1268, 114.5],
      [1271, 113.5],
      [1274, 119.5],
      [1277, 117.5],
      [1280, 131.5],
      [1283, 137.5],
      [1286, 114.5],
      [1289, 123.5],
      [1292, 93.5],
      [1295, 107.5],
      [1298, 111.5],
      [1301, 99.5],
      [1304, 110.5],
      [1307, 102.5],
      [1310, 119.5],
      [1313, 134.5],
      [1316, 114.5],
      [1319, 103.5],
      [1322, 111.5],
      [1325, 123.5],
      [1328, 128.5],
      [1331, 103.5],
      [1334, 103.5],
      [1337, 96.5],
      [1340, 114.5],
      [1343, 133.5],
      [1346, 98.5],
      [1349, 115.5],
      [1352, 95.5],
      [1355, 114.5],
      [1358, 114.5],
      [1361, 107.5],
      [1364, 104.5],
      [1367, 106.5],
      [1370, 105.5],
      [1373, 132.5],
      [1376, 102.5],
      [1379, 107.5],
      [1382, 119.5],
      [1385, 112.5],
      [1388, 117.5],
      [1391, 102.5],
      [1394, 111.5],
      [1397, 103.5],
      [1400, 116.5],
      [1403, 121.5],
      [1406, 103.5],
      [1409, 116.5],
      [1412, 87.5],
      [1415, 102.5],
      [1418, 111.5],
      [1421, 105.5],
      [1424, 105.5],
      [1427, 100.5],
      [1430, 137.5],
      [1433, 121.5],
      [1436, 124.5],
      [1439, 104.5],
      [1442, 106.5],
      [1445, 112.5],
      [1448, 112.5],
      [1451, 107.5],
      [1454, 103.5],
      [1457, 103.5],
      [1460, 123.5],
      [1463, 121.5],
      [1466, 115.5],
      [1469, 99.5],
      [1472, 100.5],
      [1475, 113.5],
      [1478, 126.5],
      [1481, 111.5],
      [1484, 116.5],
      [1487, 108.5],
      [1490, 108.5],
      [1493, 123.5],
      [1496, 113.5],
      [1499, 99.5],
      [1502, 95.5],
      [1505, 112.5],
      [1508, 102.5],
      [1511, 112.5],
      [1514, 103.5],
      [1517, 98.5],
      [1520, 113.5],
      [1523, 94.5],
      [1526, 95.5],
      [1529, 87.5],
      [1532, 85.5],
      [1535, 78.5],
      [1538, 76.5],
      [1541, 75.5],
      [1544, 75.5],
      [1547, 75.5],
      [1550, 75.5],
    ],
    bottom: [
      [1548, 75.5],
      [1545, 75.5],
      [1542, 75.5],
      [1539, 74.5],
      [1536, 73.5],
      [1533, 67.5],
      [1530, 59.5],
      [1527, 58.5],
      [1524, 52.5],
      [1521, 28.5],
      [1518, 36.5],
      [1515, 41.5],
      [1512, 45.5],
      [1509, 47.5],
      [1506, 43.5],
      [1503, 45.5],
      [1500, 37.5],
      [1497, 35.5],
      [1494, 50.5],
      [1491, 28.5],
      [1488, 35.5],
      [1485, 33.5],
      [1482, 46.5],
      [1479, 27.5],
      [1476, 45.5],
      [1473, 40.5],
      [1470, 37.5],
      [1467, 33.5],
      [1464, 45.5],
      [1461, 35.5],
      [1458, 34.5],
      [1455, 41.5],
      [1452, 40.5],
      [1449, 49.5],
      [1446, 48.5],
      [1443, 33.5],
      [1440, 30.5],
      [1437, 43.5],
      [1434, 34.5],
      [1431, 33.5],
      [1428, 32.5],
      [1425, 35.5],
      [1422, 51.5],
      [1419, 44.5],
      [1416, 53.5],
      [1413, 45.5],
      [1410, 50.5],
      [1407, 45.5],
      [1404, 50.5],
      [1401, 42.5],
      [1398, 31.5],
      [1395, 32.5],
      [1392, 50.5],
      [1389, 44.5],
      [1386, 45.5],
      [1383, 36.5],
      [1380, 17.5],
      [1377, 49.5],
      [1374, 52.5],
      [1371, 38.5],
      [1368, 46.5],
      [1365, 40.5],
      [1362, 46.5],
      [1359, 46.5],
      [1356, 38.5],
      [1353, 32.5],
      [1350, 43.5],
      [1347, 52.5],
      [1344, 39.5],
      [1341, 37.5],
      [1338, 31.5],
      [1335, 32.5],
      [1332, 51.5],
      [1329, 10.5],
      [1326, 48.5],
      [1323, 35.5],
      [1320, 34.5],
      [1317, 49.5],
      [1314, 37.5],
      [1311, 38.5],
      [1308, 35.5],
      [1305, 36.5],
      [1302, 49.5],
      [1299, 51.5],
      [1296, 46.5],
      [1293, 37.5],
      [1290, 49.5],
      [1287, 54.5],
      [1284, 35.5],
      [1281, 34.5],
      [1278, 14.5],
      [1275, 31.5],
      [1272, 47.5],
      [1269, 34.5],
      [1266, 48.5],
      [1263, 34.5],
      [1260, 34.5],
      [1257, 43.5],
      [1254, 37.5],
      [1251, 48.5],
      [1248, 32.5],
      [1245, 30.5],
      [1242, 31.5],
      [1239, 43.5],
      [1236, 51.5],
      [1233, 40.5],
      [1230, 15.5],
      [1227, 48.5],
      [1224, 28.5],
      [1221, 45.5],
      [1218, 34.5],
      [1215, 35.5],
      [1212, 60.5],
      [1209, 36.5],
      [1206, 55.5],
      [1203, 41.5],
      [1200, 39.5],
      [1197, 46.5],
      [1194, 45.5],
      [1191, 50.5],
      [1188, 45.5],
      [1185, 31.5],
      [1182, 43.5],
      [1179, 36.5],
      [1176, 49.5],
      [1173, 39.5],
      [1170, 51.5],
      [1167, 51.5],
      [1164, 27.5],
      [1161, 37.5],
      [1158, 31.5],
      [1155, 36.5],
      [1152, 55.5],
      [1149, 41.5],
      [1146, 37.5],
      [1143, 36.5],
      [1140, 33.5],
      [1137, 55.5],
      [1134, 37.5],
      [1131, 52.5],
      [1128, 25.5],
      [1125, 33.5],
      [1122, 48.5],
      [1119, 42.5],
      [1116, 44.5],
      [1113, 34.5],
      [1110, 30.5],
      [1107, 56.5],
      [1104, 29.5],
      [1101, 45.5],
      [1098, 29.5],
      [1095, 34.5],
      [1092, 57.5],
      [1089, 34.5],
      [1086, 42.5],
      [1083, 34.5],
      [1080, 19.5],
      [1077, 43.5],
      [1074, 32.5],
      [1071, 56.5],
      [1068, 32.5],
      [1065, 32.5],
      [1062, 42.5],
      [1059, 38.5],
      [1056, 46.5],
      [1053, 30.5],
      [1050, 51.5],
      [1047, 60.5],
      [1044, 40.5],
      [1041, 51.5],
      [1038, 33.5],
      [1035, 32.5],
      [1032, 39.5],
      [1029, 17.5],
      [1026, 37.5],
      [1023, 33.5],
      [1020, 25.5],
      [1017, 39.5],
      [1014, 13.5],
      [1011, 32.5],
      [1008, 40.5],
      [1005, 28.5],
      [1002, 37.5],
      [999, 45.5],
      [996, 40.5],
      [993, 47.5],
      [990, 26.5],
      [987, 39.5],
      [984, 16.5],
      [981, 42.5],
      [978, 26.5],
      [975, 41.5],
      [972, 42.5],
      [969, 23.5],
      [966, 40.5],
      [963, 43.5],
      [960, 22.5],
      [957, 40.5],
      [954, 30.5],
      [951, 47.5],
      [948, 38.5],
      [945, 36.5],
      [942, 46.5],
      [939, 32.5],
      [936, 39.5],
      [933, 36.5],
      [930, 20.5],
      [927, 31.5],
      [924, 28.5],
      [921, 28.5],
      [918, 45.5],
      [915, 37.5],
      [912, 37.5],
      [909, 38.5],
      [906, 42.5],
      [903, 35.5],
      [900, 29.5],
      [897, 42.5],
      [894, 26.5],
      [891, 42.5],
      [888, 44.5],
      [885, 34.5],
      [882, 26.5],
      [879, 37.5],
      [876, 18.5],
      [873, 41.5],
      [870, 31.5],
      [867, 36.5],
      [864, 20.5],
      [861, 43.5],
      [858, 41.5],
      [855, 26.5],
      [852, 43.5],
      [849, 32.5],
      [846, 42.5],
      [843, 35.5],
      [840, 25.5],
      [837, 47.5],
      [834, 35.5],
      [831, 54.5],
      [828, 15.5],
      [825, 36.5],
      [822, 35.5],
      [819, 45.5],
      [816, 36.5],
      [813, 28.5],
      [810, 46.5],
      [807, 49.5],
      [804, 23.5],
      [801, 48.5],
      [798, 33.5],
      [795, 36.5],
      [792, 59.5],
      [789, 41.5],
      [786, 40.5],
      [783, 29.5],
      [780, 26.5],
      [777, 34.5],
      [774, 26.5],
      [771, 52.5],
      [768, 54.5],
      [765, 24.5],
      [762, 39.5],
      [759, 35.5],
      [756, 35.5],
      [753, 37.5],
      [750, 27.5],
      [747, 42.5],
      [744, 36.5],
      [741, 35.5],
      [738, 55.5],
      [735, 47.5],
      [732, 36.5],
      [729, 46.5],
      [726, 22.5],
      [723, 32.5],
      [720, 36.5],
      [717, 52.5],
      [714, 41.5],
      [711, 54.5],
      [708, 36.5],
      [705, 44.5],
      [702, 39.5],
      [699, 38.5],
      [696, 40.5],
      [693, 35.5],
      [690, 27.5],
      [687, 32.5],
      [684, 36.5],
      [681, 38.5],
      [678, 36.5],
      [675, 34.5],
      [672, 40.5],
      [669, 39.5],
      [666, 29.5],
      [663, 35.5],
      [660, 36.5],
      [657, 34.5],
      [654, 40.5],
      [651, 47.5],
      [648, 34.5],
      [645, 39.5],
      [642, 48.5],
      [639, 27.5],
      [636, 34.5],
      [633, 33.5],
      [630, 35.5],
      [627, 40.5],
      [624, 34.5],
      [621, 39.5],
      [618, 31.5],
      [615, 18.5],
      [612, 57.5],
      [609, 26.5],
      [606, 48.5],
      [603, 24.5],
      [600, 24.5],
      [597, 35.5],
      [594, 42.5],
      [591, 51.5],
      [588, 33.5],
      [585, 28.5],
      [582, 29.5],
      [579, 36.5],
      [576, 32.5],
      [573, 32.5],
      [570, 41.5],
      [567, 44.5],
      [564, 35.5],
      [561, 38.5],
      [558, 18.5],
      [555, 28.5],
      [552, 58.5],
      [549, 24.5],
      [546, 39.5],
      [543, 22.5],
      [540, 31.5],
      [537, 39.5],
      [534, 50.5],
      [531, 55.5],
      [528, 23.5],
      [525, 22.5],
      [522, 33.5],
      [519, 36.5],
      [516, 39.5],
      [513, 20.5],
      [510, 34.5],
      [507, 45.5],
      [504, 37.5],
      [501, 40.5],
      [498, 29.5],
      [495, 27.5],
      [492, 54.5],
      [489, 14.5],
      [486, 44.5],
      [483, 26.5],
      [480, 24.5],
      [477, 22.5],
      [474, 40.5],
      [471, 36.5],
      [468, 24.5],
      [465, 25.5],
      [462, 37.5],
      [459, 35.5],
      [456, 34.5],
      [453, 32.5],
      [450, 19.5],
      [447, 16.5],
      [444, 38.5],
      [441, 38.5],
      [438, 16.5],
      [435, 24.5],
      [432, 22.5],
      [429, 36.5],
      [426, 5.7623999999999995],
      [423, 40.5],
      [420, 16.5],
      [417, 29.5],
      [414, 33.5],
      [411, 27.5],
      [408, 35.5],
      [405, 33.5],
      [402, 38.5],
      [399, 21.5],
      [396, 29.5],
      [393, 22.5],
      [390, 13.5],
      [387, 20.5],
      [384, 30.5],
      [381, 36.5],
      [378, 11.5],
      [375, 9.5],
      [372, 29.5],
      [369, 43.5],
      [366, 40.5],
      [363, 49.5],
      [360, 13.5],
      [357, 28.5],
      [354, 23.5],
      [351, 38.5],
      [348, 16.5],
      [345, 16.5],
      [342, 30.5],
      [339, 34.5],
      [336, 28.5],
      [333, 22.5],
      [330, 19.5],
      [327, 32.5],
      [324, 45.5],
      [321, 31.5],
      [318, 13.5],
      [315, 18.5],
      [312, 51.5],
      [309, 22.5],
      [306, 35.5],
      [303, 18.5],
      [300, 7.5],
      [297, 46.5],
      [294, 32.5],
      [291, 43.5],
      [288, 10.5],
      [285, 29.5],
      [282, 25.5],
      [279, 36.5],
      [276, 33.5],
      [273, 32.5],
      [270, 11.5],
      [267, 42.5],
      [264, 35.5],
      [261, 36.5],
      [258, 18.5],
      [255, 23.5],
      [252, 47.5],
      [249, 20.5],
      [246, 34.5],
      [243, 30.5],
      [240, 18.5],
      [237, 25.5],
      [234, 36.5],
      [231, 38.5],
      [228, 23.5],
      [225, 7.723399999999998],
      [222, 26.5],
      [219, 37.5],
      [216, 45.5],
      [213, 13.5],
      [210, 33.5],
      [207, 50.5],
      [204, 22.5],
      [201, 23.5],
      [198, 12.5],
      [195, 18.5],
      [192, 29.5],
      [189, 39.5],
      [186, 38.5],
      [183, 19.5],
      [180, 7.301600000000008],
      [177, 41.5],
      [174, 23.5],
      [171, 43.5],
      [168, 22.5],
      [165, 12.5],
      [162, 35.5],
      [159, 29.5],
      [156, 21.5],
      [153, 30.5],
      [150, 6.125],
      [147, 26.5],
      [144, 21.5],
      [141, 35.5],
      [138, 32.5],
      [135, 14.5],
      [132, 55.5],
      [129, 31.5],
      [126, 5.5],
      [123, 33.5],
      [120, 19.5],
      [117, 42.5],
      [114, 38.5],
      [111, 46.5],
      [108, 56.5],
      [105, 26.5],
      [102, 26.5],
      [99, 32.5],
      [96, 35.5],
      [93, 20.5],
      [90, 22.5],
      [87, 36.5],
      [84, 34.5],
      [81, 19.5],
      [78, 26.5],
      [75, 7.5],
      [72, 56.5],
      [69, 23.5],
      [66, 24.5],
      [63, 33.5],
      [60, 6.5],
      [57, 24.5],
      [54, 29.5],
      [51, 46.5],
      [48, 59.5],
      [45, 28.5],
      [42, 22.5],
      [39, 26.5],
      [36, 23.5],
      [33, 16.5],
      [30, 21.5],
      [27, 35.5],
      [24, 15.5],
      [21, 27.5],
      [18, 5.5],
      [15, 7.5],
      [12, 48.5],
      [9, 2.5656000000000034],
      [6, 6.5],
      [3, 15.5],
      [0, 39.5],
    ],
  },
  {
    top: [
      [2, 137.5],
      [5, 141.5],
      [8, 103.5],
      [11, 106.5],
      [14, 130.5],
      [17, 113.5],
      [20, 140.5],
      [23, 119.5],
      [26, 143.5],
      [29, 143.5],
      [32, 104.5],
      [35, 136.5],
      [38, 144.875],
      [41, 126.5],
      [44, 144.1054],
      [47, 109.5],
      [50, 131.5],
      [53, 138.5],
      [56, 144.4976],
      [59, 135.5],
      [62, 135.5],
      [65, 130.5],
      [68, 106.5],
      [71, 116.5],
      [74, 130.5],
      [77, 128.5],
      [80, 128.5],
      [83, 121.5],
      [86, 136.5],
      [89, 144.5],
      [92, 105.5],
      [95, 131.5],
      [98, 129.5],
      [101, 125.5],
      [104, 126.5],
      [107, 117.5],
      [110, 117.5],
      [113, 145.5],
      [116, 126.5],
      [119, 144.5],
      [122, 122.5],
      [125, 136.5],
      [128, 100.5],
      [131, 112.5],
      [134, 122.5],
      [137, 107.5],
      [140, 136.5],
      [143, 120.5],
      [146, 130.5],
      [149, 144.875],
      [152, 112.5],
      [155, 121.5],
      [158, 136.5],
      [161, 119.5],
      [164, 133.5],
      [167, 100.5],
      [170, 128.5],
      [173, 137.5],
      [176, 130.5],
      [179, 142.5],
      [182, 112.5],
      [185, 125.5],
      [188, 144.4976],
      [191, 111.5],
      [194, 109.5],
      [197, 100.5],
      [200, 141.5],
      [203, 119.5],
      [206, 114.5],
      [209, 143.6984],
      [212, 102.5],
      [215, 124.5],
      [218, 134.5],
      [221, 115.5],
      [224, 132.5],
      [227, 130.5],
      [230, 129.5],
      [233, 137.5],
      [236, 111.5],
      [239, 121.5],
      [242, 136.5],
      [245, 125.5],
      [248, 136.5],
      [251, 113.5],
      [254, 108.5],
      [257, 107.5],
      [260, 129.5],
      [263, 136.5],
      [266, 112.5],
      [269, 122.5],
      [272, 108.5],
      [275, 143.5],
      [278, 135.5],
      [281, 124.5],
      [284, 118.5],
      [287, 115.5],
      [290, 109.5],
      [293, 128.5],
      [296, 113.5],
      [299, 112.5],
      [302, 125.5],
      [305, 133.5],
      [308, 136.5],
      [311, 103.5],
      [314, 124.5],
      [317, 113.5],
      [320, 122.5],
      [323, 115.5],
      [326, 122.5],
      [329, 127.5],
      [332, 112.5],
      [335, 129.5],
      [338, 127.5],
      [341, 121.5],
      [344, 112.5],
      [347, 104.5],
      [350, 135.5],
      [353, 125.5],
      [356, 111.5],
      [359, 118.5],
      [362, 112.5],
      [365, 128.5],
      [368, 90.5],
      [371, 111.5],
      [374, 120.5],
      [377, 132.5],
      [380, 127.5],
      [383, 114.5],
      [386, 123.5],
      [389, 128.5],
      [392, 108.5],
      [395, 125.5],
      [398, 128.5],
      [401, 109.5],
      [404, 100.5],
      [407, 112.5],
      [410, 128.5],
      [413, 123.5],
      [416, 123.5],
      [419, 109.5],
      [422, 113.5],
      [425, 134.5],
      [428, 133.5],
      [431, 116.5],
      [434, 121.5],
      [437, 118.5],
      [440, 124.5],
      [443, 117.5],
      [446, 132.5],
      [449, 117.5],
      [452, 100.5],
      [455, 126.5],
      [458, 127.5],
      [461, 111.5],
      [464, 103.5],
      [467, 105.5],
      [470, 127.5],
      [473, 128.5],
      [476, 114.5],
      [479, 128.5],
      [482, 110.5],
      [485, 126.5],
      [488, 130.5],
      [491, 103.5],
      [494, 110.5],
      [497, 100.5],
      [500, 124.5],
      [503, 117.5],
      [506, 115.5],
      [509, 113.5],
      [512, 96.5],
      [515, 122.5],
      [518, 123.5],
      [521, 106.5],
      [524, 107.5],
      [527, 112.5],
      [530, 108.5],
      [533, 127.5],
      [536, 125.5],
      [539, 115.5],
      [542, 114.5],
      [545, 118.5],
      [548, 109.5],
      [551, 104.5],
      [554, 103.5],
      [557, 121.5],
      [560, 120.5],
      [563, 130.5],
      [566, 128.5],
      [569, 128.5],
      [572, 96.5],
      [575, 135.5],
      [578, 143.5],
      [581, 116.5],
      [584, 108.5],
      [587, 108.5],
      [590, 127.5],
      [593, 118.5],
      [596, 135.5],
      [599, 112.5],
      [602, 127.5],
      [605, 119.5],
      [608, 117.5],
      [611, 100.5],
      [614, 117.5],
      [617, 97.5],
      [620, 130.5],
      [623, 123.5],
      [626, 121.5],
      [629, 128.5],
      [632, 100.5],
      [635, 118.5],
      [638, 124.5],
      [641, 113.5],
      [644, 111.5],
      [647, 104.5],
      [650, 114.5],
      [653, 114.5],
      [656, 113.5],
      [659, 105.5],
      [662, 115.5],
      [665, 111.5],
      [668, 115.5],
      [671, 116.5],
      [674, 107.5],
      [677, 123.5],
      [680, 122.5],
      [683, 112.5],
      [686, 128.5],
      [689, 126.5],
      [692, 109.5],
      [695, 114.5],
      [698, 109.5],
      [701, 119.5],
      [704, 111.5],
      [707, 90.5],
      [710, 103.5],
      [713, 113.5],
      [716, 100.5],
      [719, 113.5],
      [722, 103.5],
      [725, 111.5],
      [728, 129.5],
      [731, 116.5],
      [734, 105.5],
      [737, 105.5],
      [740, 117.5],
      [743, 114.5],
      [746, 130.5],
      [749, 108.5],
      [752, 114.5],
      [755, 115.5],
      [758, 113.5],
      [761, 114.5],
      [764, 105.5],
      [767, 93.5],
      [770, 120.5],
      [773, 117.5],
      [776, 114.5],
      [779, 122.5],
      [782, 110.5],
      [785, 105.5],
      [788, 98.5],
      [791, 98.5],
      [794, 111.5],
      [797, 104.5],
      [800, 115.5],
      [803, 125.5],
      [806, 119.5],
      [809, 119.5],
      [812, 92.5],
      [815, 116.5],
      [818, 121.5],
      [821, 102.5],
      [824, 113.5],
      [827, 116.5],
      [830, 122.5],
      [833, 120.5],
      [836, 126.5],
      [839, 100.5],
      [842, 118.5],
      [845, 114.5],
      [848, 109.5],
      [851, 108.5],
      [854, 101.5],
      [857, 95.5],
      [860, 116.5],
      [863, 129.5],
      [866, 130.5],
      [869, 111.5],
      [872, 96.5],
      [875, 124.5],
      [878, 126.5],
      [881, 121.5],
      [884, 111.5],
      [887, 110.5],
      [890, 122.5],
      [893, 113.5],
      [896, 120.5],
      [899, 110.5],
      [902, 112.5],
      [905, 108.5],
      [908, 111.5],
      [911, 105.5],
      [914, 102.5],
      [917, 111.5],
      [920, 125.5],
      [923, 113.5],
      [926, 126.5],
      [929, 128.5],
      [932, 102.5],
      [935, 108.5],
      [938, 105.5],
      [941, 110.5],
      [944, 106.5],
      [947, 101.5],
      [950, 118.5],
      [953, 109.5],
      [956, 108.5],
      [959, 109.5],
      [962, 102.5],
      [965, 109.5],
      [968, 106.5],
      [971, 103.5],
      [974, 109.5],
      [977, 108.5],
      [980, 130.5],
      [983, 122.5],
      [986, 105.5],
      [989, 114.5],
      [992, 107.5],
      [995, 103.5],
      [998, 104.5],
      [1001, 109.5],
      [1004, 109.5],
      [1007, 104.5],
      [1010, 118.5],
      [1013, 133.5],
      [1016, 123.5],
      [1019, 128.5],
      [1022, 105.5],
      [1025, 119.5],
      [1028, 125.5],
      [1031, 105.5],
      [1034, 101.5],
      [1037, 98.5],
      [1040, 120.5],
      [1043, 118.5],
      [1046, 104.5],
      [1049, 126.5],
      [1052, 97.5],
      [1055, 116.5],
      [1058, 120.5],
      [1061, 96.5],
      [1064, 113.5],
      [1067, 100.5],
      [1070, 117.5],
      [1073, 136.5],
      [1076, 103.5],
      [1079, 122.5],
      [1082, 112.5],
      [1085, 113.5],
      [1088, 109.5],
      [1091, 94.5],
      [1094, 99.5],
      [1097, 95.5],
      [1100, 113.5],
      [1103, 134.5],
      [1106, 105.5],
      [1109, 115.5],
      [1112, 95.5],
      [1115, 120.5],
      [1118, 113.5],
      [1121, 101.5],
      [1124, 103.5],
      [1127, 103.5],
      [1130, 119.5],
      [1133, 139.5],
      [1136, 108.5],
      [1139, 102.5],
      [1142, 107.5],
      [1145, 113.5],
      [1148, 118.5],
      [1151, 95.5],
      [1154, 102.5],
      [1157, 104.5],
      [1160, 117.5],
      [1163, 122.5],
      [1166, 108.5],
      [1169, 114.5],
      [1172, 96.5],
      [1175, 114.5],
      [1178, 137.5],
      [1181, 105.5],
      [1184, 109.5],
      [1187, 93.5],
      [1190, 107.5],
      [1193, 116.5],
      [1196, 113.5],
      [1199, 123.5],
      [1202, 98.5],
      [1205, 112.5],
      [1208, 111.5],
      [1211, 92.5],
      [1214, 99.5],
      [1217, 95.5],
      [1220, 105.5],
      [1223, 120.5],
      [1226, 110.5],
      [1229, 110.5],
      [1232, 109.5],
      [1235, 111.5],
      [1238, 113.5],
      [1241, 105.5],
      [1244, 114.5],
      [1247, 92.5],
      [1250, 100.5],
      [1253, 136.5],
      [1256, 99.5],
      [1259, 105.5],
      [1262, 107.5],
      [1265, 113.5],
      [1268, 111.5],
      [1271, 110.5],
      [1274, 115.5],
      [1277, 115.5],
      [1280, 132.5],
      [1283, 137.5],
      [1286, 112.5],
      [1289, 122.5],
      [1292, 93.5],
      [1295, 103.5],
      [1298, 107.5],
      [1301, 97.5],
      [1304, 106.5],
      [1307, 102.5],
      [1310, 117.5],
      [1313, 135.5],
      [1316, 113.5],
      [1319, 102.5],
      [1322, 109.5],
      [1325, 119.5],
      [1328, 128.5],
      [1331, 103.5],
      [1334, 102.5],
      [1337, 95.5],
      [1340, 112.5],
      [1343, 134.5],
      [1346, 97.5],
      [1349, 113.5],
      [1352, 93.5],
      [1355, 115.5],
      [1358, 114.5],
      [1361, 106.5],
      [1364, 107.5],
      [1367, 103.5],
      [1370, 103.5],
      [1373, 132.5],
      [1376, 101.5],
      [1379, 108.5],
      [1382, 119.5],
      [1385, 114.5],
      [1388, 114.5],
      [1391, 100.5],
      [1394, 111.5],
      [1397, 105.5],
      [1400, 115.5],
      [1403, 121.5],
      [1406, 105.5],
      [1409, 115.5],
      [1412, 88.5],
      [1415, 101.5],
      [1418, 111.5],
      [1421, 105.5],
      [1424, 105.5],
      [1427, 99.5],
      [1430, 138.5],
      [1433, 120.5],
      [1436, 124.5],
      [1439, 102.5],
      [1442, 108.5],
      [1445, 110.5],
      [1448, 108.5],
      [1451, 103.5],
      [1454, 103.5],
      [1457, 102.5],
      [1460, 123.5],
      [1463, 121.5],
      [1466, 116.5],
      [1469, 100.5],
      [1472, 99.5],
      [1475, 111.5],
      [1478, 126.5],
      [1481, 111.5],
      [1484, 114.5],
      [1487, 105.5],
      [1490, 108.5],
      [1493, 122.5],
      [1496, 113.5],
      [1499, 97.5],
      [1502, 95.5],
      [1505, 110.5],
      [1508, 103.5],
      [1511, 111.5],
      [1514, 101.5],
      [1517, 100.5],
      [1520, 113.5],
      [1523, 94.5],
      [1526, 95.5],
      [1529, 87.5],
      [1532, 86.5],
      [1535, 78.5],
      [1538, 76.5],
      [1541, 75.5],
      [1544, 75.5],
      [1547, 75.5],
      [1550, 75.5],
    ],
    bottom: [
      [1548, 75.5],
      [1545, 75.5],
      [1542, 75.5],
      [1539, 74.5],
      [1536, 73.5],
      [1533, 67.5],
      [1530, 59.5],
      [1527, 57.5],
      [1524, 54.5],
      [1521, 28.5],
      [1518, 34.5],
      [1515, 41.5],
      [1512, 46.5],
      [1509, 46.5],
      [1506, 46.5],
      [1503, 45.5],
      [1500, 39.5],
      [1497, 35.5],
      [1494, 52.5],
      [1491, 28.5],
      [1488, 37.5],
      [1485, 36.5],
      [1482, 45.5],
      [1479, 26.5],
      [1476, 46.5],
      [1473, 41.5],
      [1470, 35.5],
      [1467, 32.5],
      [1464, 45.5],
      [1461, 34.5],
      [1458, 35.5],
      [1455, 42.5],
      [1452, 45.5],
      [1449, 52.5],
      [1446, 49.5],
      [1443, 35.5],
      [1440, 33.5],
      [1437, 43.5],
      [1434, 36.5],
      [1431, 33.5],
      [1428, 32.5],
      [1425, 36.5],
      [1422, 50.5],
      [1419, 44.5],
      [1416, 55.5],
      [1413, 45.5],
      [1410, 50.5],
      [1407, 43.5],
      [1404, 49.5],
      [1401, 42.5],
      [1398, 30.5],
      [1395, 32.5],
      [1392, 51.5],
      [1389, 47.5],
      [1386, 46.5],
      [1383, 37.5],
      [1380, 16.5],
      [1377, 49.5],
      [1374, 52.5],
      [1371, 38.5],
      [1368, 50.5],
      [1365, 38.5],
      [1362, 49.5],
      [1359, 46.5],
      [1356, 39.5],
      [1353, 34.5],
      [1350, 44.5],
      [1347, 52.5],
      [1344, 39.5],
      [1341, 37.5],
      [1338, 32.5],
      [1335, 34.5],
      [1332, 52.5],
      [1329, 10.5],
      [1326, 49.5],
      [1323, 40.5],
      [1320, 39.5],
      [1317, 49.5],
      [1314, 36.5],
      [1311, 38.5],
      [1308, 36.5],
      [1305, 41.5],
      [1302, 51.5],
      [1299, 52.5],
      [1296, 51.5],
      [1293, 37.5],
      [1290, 48.5],
      [1287, 55.5],
      [1284, 35.5],
      [1281, 33.5],
      [1278, 14.5],
      [1275, 35.5],
      [1272, 48.5],
      [1269, 37.5],
      [1266, 49.5],
      [1263, 36.5],
      [1260, 38.5],
      [1257, 44.5],
      [1254, 37.5],
      [1251, 48.5],
      [1248, 37.5],
      [1245, 35.5],
      [1242, 36.5],
      [1239, 44.5],
      [1236, 50.5],
      [1233, 41.5],
      [1230, 15.5],
      [1227, 48.5],
      [1224, 27.5],
      [1221, 47.5],
      [1218, 34.5],
      [1215, 39.5],
      [1212, 61.5],
      [1209, 38.5],
      [1206, 58.5],
      [1203, 41.5],
      [1200, 40.5],
      [1197, 47.5],
      [1194, 49.5],
      [1191, 51.5],
      [1188, 46.5],
      [1185, 34.5],
      [1182, 45.5],
      [1179, 36.5],
      [1176, 50.5],
      [1173, 39.5],
      [1170, 53.5],
      [1167, 53.5],
      [1164, 26.5],
      [1161, 40.5],
      [1158, 31.5],
      [1155, 39.5],
      [1152, 57.5],
      [1149, 45.5],
      [1146, 43.5],
      [1143, 41.5],
      [1140, 36.5],
      [1137, 56.5],
      [1134, 37.5],
      [1131, 53.5],
      [1128, 25.5],
      [1125, 34.5],
      [1122, 50.5],
      [1119, 44.5],
      [1116, 46.5],
      [1113, 38.5],
      [1110, 33.5],
      [1107, 56.5],
      [1104, 28.5],
      [1101, 47.5],
      [1098, 33.5],
      [1095, 37.5],
      [1092, 59.5],
      [1089, 39.5],
      [1086, 46.5],
      [1083, 35.5],
      [1080, 19.5],
      [1077, 43.5],
      [1074, 32.5],
      [1071, 56.5],
      [1068, 34.5],
      [1065, 34.5],
      [1062, 45.5],
      [1059, 39.5],
      [1056, 47.5],
      [1053, 34.5],
      [1050, 51.5],
      [1047, 61.5],
      [1044, 40.5],
      [1041, 51.5],
      [1038, 33.5],
      [1035, 34.5],
      [1032, 40.5],
      [1029, 17.5],
      [1026, 38.5],
      [1023, 35.5],
      [1020, 26.5],
      [1017, 43.5],
      [1014, 13.5],
      [1011, 36.5],
      [1008, 41.5],
      [1005, 32.5],
      [1002, 39.5],
      [999, 48.5],
      [996, 43.5],
      [993, 48.5],
      [990, 25.5],
      [987, 43.5],
      [984, 15.5],
      [981, 43.5],
      [978, 26.5],
      [975, 40.5],
      [972, 46.5],
      [969, 26.5],
      [966, 43.5],
      [963, 46.5],
      [960, 24.5],
      [957, 43.5],
      [954, 33.5],
      [951, 48.5],
      [948, 42.5],
      [945, 39.5],
      [942, 49.5],
      [939, 34.5],
      [936, 44.5],
      [933, 40.5],
      [930, 23.5],
      [927, 31.5],
      [924, 28.5],
      [921, 30.5],
      [918, 48.5],
      [915, 40.5],
      [912, 42.5],
      [909, 42.5],
      [906, 46.5],
      [903, 38.5],
      [900, 34.5],
      [897, 44.5],
      [894, 26.5],
      [891, 44.5],
      [888, 46.5],
      [885, 36.5],
      [882, 26.5],
      [879, 37.5],
      [876, 21.5],
      [873, 43.5],
      [870, 33.5],
      [867, 38.5],
      [864, 20.5],
      [861, 46.5],
      [858, 42.5],
      [855, 32.5],
      [852, 47.5],
      [849, 38.5],
      [846, 45.5],
      [843, 40.5],
      [840, 25.5],
      [837, 47.5],
      [834, 35.5],
      [831, 55.5],
      [828, 15.5],
      [825, 37.5],
      [822, 39.5],
      [819, 48.5],
      [816, 38.5],
      [813, 31.5],
      [810, 46.5],
      [807, 49.5],
      [804, 23.5],
      [801, 50.5],
      [798, 36.5],
      [795, 38.5],
      [792, 61.5],
      [789, 42.5],
      [786, 40.5],
      [783, 33.5],
      [780, 28.5],
      [777, 35.5],
      [774, 27.5],
      [771, 52.5],
      [768, 55.5],
      [765, 29.5],
      [762, 42.5],
      [759, 37.5],
      [756, 34.5],
      [753, 39.5],
      [750, 30.5],
      [747, 42.5],
      [744, 36.5],
      [741, 36.5],
      [738, 55.5],
      [735, 49.5],
      [732, 37.5],
      [729, 46.5],
      [726, 22.5],
      [723, 33.5],
      [720, 39.5],
      [717, 52.5],
      [714, 42.5],
      [711, 56.5],
      [708, 41.5],
      [705, 47.5],
      [702, 41.5],
      [699, 40.5],
      [696, 42.5],
      [693, 38.5],
      [690, 27.5],
      [687, 32.5],
      [684, 36.5],
      [681, 39.5],
      [678, 36.5],
      [675, 35.5],
      [672, 41.5],
      [669, 42.5],
      [666, 32.5],
      [663, 36.5],
      [660, 36.5],
      [657, 34.5],
      [654, 41.5],
      [651, 49.5],
      [648, 38.5],
      [645, 40.5],
      [642, 49.5],
      [639, 30.5],
      [636, 35.5],
      [633, 34.5],
      [630, 36.5],
      [627, 40.5],
      [624, 36.5],
      [621, 39.5],
      [618, 28.5],
      [615, 20.5],
      [612, 56.5],
      [609, 30.5],
      [606, 50.5],
      [603, 25.5],
      [600, 23.5],
      [597, 35.5],
      [594, 42.5],
      [591, 51.5],
      [588, 33.5],
      [585, 30.5],
      [582, 30.5],
      [579, 36.5],
      [576, 32.5],
      [573, 35.5],
      [570, 40.5],
      [567, 44.5],
      [564, 37.5],
      [561, 39.5],
      [558, 20.5],
      [555, 30.5],
      [552, 59.5],
      [549, 26.5],
      [546, 42.5],
      [543, 25.5],
      [540, 33.5],
      [537, 39.5],
      [534, 49.5],
      [531, 55.5],
      [528, 24.5],
      [525, 21.5],
      [522, 36.5],
      [519, 36.5],
      [516, 41.5],
      [513, 22.5],
      [510, 37.5],
      [507, 44.5],
      [504, 39.5],
      [501, 36.5],
      [498, 28.5],
      [495, 33.5],
      [492, 54.5],
      [489, 15.5],
      [486, 44.5],
      [483, 29.5],
      [480, 27.5],
      [477, 21.5],
      [474, 41.5],
      [471, 35.5],
      [468, 24.5],
      [465, 27.5],
      [462, 36.5],
      [459, 35.5],
      [456, 34.5],
      [453, 34.5],
      [450, 16.5],
      [447, 15.5],
      [444, 39.5],
      [441, 36.5],
      [438, 16.5],
      [435, 24.5],
      [432, 22.5],
      [429, 36.5],
      [426, 6.125],
      [423, 39.5],
      [420, 18.5],
      [417, 29.5],
      [414, 31.5],
      [411, 27.5],
      [408, 35.5],
      [405, 34.5],
      [402, 37.5],
      [399, 21.5],
      [396, 32.5],
      [393, 23.5],
      [390, 16.5],
      [387, 20.5],
      [384, 30.5],
      [381, 35.5],
      [378, 12.5],
      [375, 9.5],
      [372, 31.5],
      [369, 43.5],
      [366, 41.5],
      [363, 48.5],
      [360, 16.5],
      [357, 30.5],
      [354, 23.5],
      [351, 39.5],
      [348, 15.5],
      [345, 17.5],
      [342, 32.5],
      [339, 32.5],
      [336, 26.5],
      [333, 21.5],
      [330, 18.5],
      [327, 33.5],
      [324, 44.5],
      [321, 32.5],
      [318, 14.5],
      [315, 20.5],
      [312, 52.5],
      [309, 24.5],
      [306, 35.5],
      [303, 19.5],
      [300, 7.5],
      [297, 47.5],
      [294, 34.5],
      [291, 44.5],
      [288, 10.5],
      [285, 29.5],
      [282, 24.5],
      [279, 38.5],
      [276, 33.5],
      [273, 29.5],
      [270, 8.5],
      [267, 43.5],
      [264, 35.5],
      [261, 37.5],
      [258, 18.5],
      [255, 24.5],
      [252, 48.5],
      [249, 21.5],
      [246, 35.5],
      [243, 28.5],
      [240, 17.5],
      [237, 25.5],
      [234, 35.5],
      [231, 38.5],
      [228, 24.5],
      [225, 7.723399999999998],
      [222, 22.5],
      [219, 37.5],
      [216, 44.5],
      [213, 15.5],
      [210, 34.5],
      [207, 51.5],
      [204, 21.5],
      [201, 21.5],
      [198, 17.5],
      [195, 16.5],
      [192, 30.5],
      [189, 39.5],
      [186, 38.5],
      [183, 16.5],
      [180, 7.301600000000008],
      [177, 41.5],
      [174, 23.5],
      [171, 43.5],
      [168, 22.5],
      [165, 12.5],
      [162, 33.5],
      [159, 31.5],
      [156, 22.5],
      [153, 32.5],
      [150, 5.081599999999995],
      [147, 27.5],
      [144, 21.5],
      [141, 37.5],
      [138, 30.5],
      [135, 11.5],
      [132, 55.5],
      [129, 34.5],
      [126, 7.723399999999998],
      [123, 35.5],
      [120, 19.5],
      [117, 43.5],
      [114, 39.5],
      [111, 46.5],
      [108, 57.5],
      [105, 26.5],
      [102, 26.5],
      [99, 33.5],
      [96, 36.5],
      [93, 20.5],
      [90, 21.5],
      [87, 34.5],
      [84, 37.5],
      [81, 18.5],
      [78, 28.5],
      [75, 7.5],
      [72, 56.5],
      [69, 24.5],
      [66, 27.5],
      [63, 33.5],
      [60, 5.5],
      [57, 24.5],
      [54, 32.5],
      [51, 47.5],
      [48, 60.5],
      [45, 27.5],
      [42, 26.5],
      [39, 26.5],
      [36, 24.5],
      [33, 18.5],
      [30, 21.5],
      [27, 35.5],
      [24, 14.5],
      [21, 28.5],
      [18, 5.5],
      [15, 5.5],
      [12, 47.5],
      [9, 2.950400000000002],
      [6, 8.5],
      [3, 15.5],
      [0, 41.5],
    ],
  },
  {
    top: [
      [2, 135.5],
      [5, 138.5],
      [8, 102.5],
      [11, 105.5],
      [14, 130.5],
      [17, 112.5],
      [20, 140.5],
      [23, 119.5],
      [26, 143.5],
      [29, 143.5],
      [32, 104.5],
      [35, 135.5],
      [38, 144.4976],
      [41, 123.5],
      [44, 145.5],
      [47, 107.5],
      [50, 132.5],
      [53, 135.5],
      [56, 145.2376],
      [59, 134.5],
      [62, 135.5],
      [65, 131.5],
      [68, 107.5],
      [71, 118.5],
      [74, 130.5],
      [77, 129.5],
      [80, 128.5],
      [83, 119.5],
      [86, 135.5],
      [89, 143.2766],
      [92, 106.5],
      [95, 132.5],
      [98, 127.5],
      [101, 124.5],
      [104, 128.5],
      [107, 116.5],
      [110, 120.5],
      [113, 141.5],
      [116, 123.5],
      [119, 145.5],
      [122, 123.5],
      [125, 136.5],
      [128, 98.5],
      [131, 109.5],
      [134, 123.5],
      [137, 108.5],
      [140, 134.5],
      [143, 121.5],
      [146, 128.5],
      [149, 143.6984],
      [152, 112.5],
      [155, 121.5],
      [158, 135.5],
      [161, 119.5],
      [164, 133.5],
      [167, 101.5],
      [170, 126.5],
      [173, 138.5],
      [176, 129.5],
      [179, 142.5],
      [182, 115.5],
      [185, 124.5],
      [188, 143.6984],
      [191, 111.5],
      [194, 111.5],
      [197, 99.5],
      [200, 140.5],
      [203, 119.5],
      [206, 115.5],
      [209, 144.1054],
      [212, 103.5],
      [215, 125.5],
      [218, 136.5],
      [221, 114.5],
      [224, 133.5],
      [227, 129.5],
      [230, 128.5],
      [233, 137.5],
      [236, 113.5],
      [239, 121.5],
      [242, 135.5],
      [245, 130.5],
      [248, 136.5],
      [251, 111.5],
      [254, 107.5],
      [257, 108.5],
      [260, 128.5],
      [263, 136.5],
      [266, 111.5],
      [269, 121.5],
      [272, 107.5],
      [275, 143.5],
      [278, 135.5],
      [281, 123.5],
      [284, 118.5],
      [287, 114.5],
      [290, 110.5],
      [293, 129.5],
      [296, 116.5],
      [299, 111.5],
      [302, 122.5],
      [305, 130.5],
      [308, 136.5],
      [311, 103.5],
      [314, 126.5],
      [317, 112.5],
      [320, 124.5],
      [323, 114.5],
      [326, 123.5],
      [329, 128.5],
      [332, 113.5],
      [335, 130.5],
      [338, 130.5],
      [341, 117.5],
      [344, 111.5],
      [347, 102.5],
      [350, 135.5],
      [353, 124.5],
      [356, 112.5],
      [359, 118.5],
      [362, 111.5],
      [365, 130.5],
      [368, 90.5],
      [371, 111.5],
      [374, 120.5],
      [377, 132.5],
      [380, 128.5],
      [383, 115.5],
      [386, 121.5],
      [389, 128.5],
      [392, 109.5],
      [395, 126.5],
      [398, 127.5],
      [401, 109.5],
      [404, 100.5],
      [407, 113.5],
      [410, 127.5],
      [413, 121.5],
      [416, 123.5],
      [419, 110.5],
      [422, 114.5],
      [425, 134.5],
      [428, 132.5],
      [431, 117.5],
      [434, 123.5],
      [437, 119.5],
      [440, 127.5],
      [443, 117.5],
      [446, 133.5],
      [449, 117.5],
      [452, 101.5],
      [455, 126.5],
      [458, 128.5],
      [461, 112.5],
      [464, 102.5],
      [467, 104.5],
      [470, 127.5],
      [473, 126.5],
      [476, 114.5],
      [479, 126.5],
      [482, 109.5],
      [485, 125.5],
      [488, 128.5],
      [491, 104.5],
      [494, 110.5],
      [497, 101.5],
      [500, 123.5],
      [503, 114.5],
      [506, 114.5],
      [509, 113.5],
      [512, 96.5],
      [515, 120.5],
      [518, 122.5],
      [521, 104.5],
      [524, 108.5],
      [527, 112.5],
      [530, 107.5],
      [533, 131.5],
      [536, 125.5],
      [539, 115.5],
      [542, 114.5],
      [545, 117.5],
      [548, 108.5],
      [551, 104.5],
      [554, 102.5],
      [557, 120.5],
      [560, 119.5],
      [563, 127.5],
      [566, 129.5],
      [569, 126.5],
      [572, 99.5],
      [575, 134.5],
      [578, 142.5],
      [581, 116.5],
      [584, 107.5],
      [587, 107.5],
      [590, 125.5],
      [593, 119.5],
      [596, 135.5],
      [599, 115.5],
      [602, 124.5],
      [605, 120.5],
      [608, 117.5],
      [611, 99.5],
      [614, 117.5],
      [617, 97.5],
      [620, 130.5],
      [623, 123.5],
      [626, 119.5],
      [629, 128.5],
      [632, 98.5],
      [635, 115.5],
      [638, 123.5],
      [641, 113.5],
      [644, 113.5],
      [647, 105.5],
      [650, 114.5],
      [653, 113.5],
      [656, 113.5],
      [659, 106.5],
      [662, 112.5],
      [665, 110.5],
      [668, 114.5],
      [671, 117.5],
      [674, 108.5],
      [677, 123.5],
      [680, 122.5],
      [683, 108.5],
      [686, 128.5],
      [689, 124.5],
      [692, 107.5],
      [695, 113.5],
      [698, 109.5],
      [701, 117.5],
      [704, 109.5],
      [707, 90.5],
      [710, 104.5],
      [713, 111.5],
      [716, 100.5],
      [719, 110.5],
      [722, 104.5],
      [725, 113.5],
      [728, 129.5],
      [731, 113.5],
      [734, 105.5],
      [737, 104.5],
      [740, 116.5],
      [743, 112.5],
      [746, 130.5],
      [749, 107.5],
      [752, 115.5],
      [755, 114.5],
      [758, 113.5],
      [761, 112.5],
      [764, 103.5],
      [767, 92.5],
      [770, 119.5],
      [773, 117.5],
      [776, 115.5],
      [779, 121.5],
      [782, 108.5],
      [785, 106.5],
      [788, 99.5],
      [791, 97.5],
      [794, 110.5],
      [797, 104.5],
      [800, 114.5],
      [803, 123.5],
      [806, 119.5],
      [809, 118.5],
      [812, 92.5],
      [815, 116.5],
      [818, 119.5],
      [821, 101.5],
      [824, 111.5],
      [827, 115.5],
      [830, 120.5],
      [833, 120.5],
      [836, 126.5],
      [839, 101.5],
      [842, 115.5],
      [845, 112.5],
      [848, 109.5],
      [851, 108.5],
      [854, 100.5],
      [857, 95.5],
      [860, 116.5],
      [863, 130.5],
      [866, 130.5],
      [869, 110.5],
      [872, 97.5],
      [875, 123.5],
      [878, 126.5],
      [881, 119.5],
      [884, 109.5],
      [887, 110.5],
      [890, 123.5],
      [893, 113.5],
      [896, 120.5],
      [899, 109.5],
      [902, 112.5],
      [905, 106.5],
      [908, 111.5],
      [911, 103.5],
      [914, 101.5],
      [917, 109.5],
      [920, 121.5],
      [923, 113.5],
      [926, 124.5],
      [929, 127.5],
      [932, 103.5],
      [935, 108.5],
      [938, 104.5],
      [941, 111.5],
      [944, 105.5],
      [947, 102.5],
      [950, 118.5],
      [953, 107.5],
      [956, 108.5],
      [959, 109.5],
      [962, 101.5],
      [965, 109.5],
      [968, 106.5],
      [971, 102.5],
      [974, 108.5],
      [977, 108.5],
      [980, 127.5],
      [983, 122.5],
      [986, 105.5],
      [989, 114.5],
      [992, 105.5],
      [995, 102.5],
      [998, 101.5],
      [1001, 109.5],
      [1004, 108.5],
      [1007, 101.5],
      [1010, 117.5],
      [1013, 133.5],
      [1016, 122.5],
      [1019, 128.5],
      [1022, 104.5],
      [1025, 119.5],
      [1028, 125.5],
      [1031, 104.5],
      [1034, 99.5],
      [1037, 100.5],
      [1040, 123.5],
      [1043, 118.5],
      [1046, 103.5],
      [1049, 126.5],
      [1052, 97.5],
      [1055, 114.5],
      [1058, 117.5],
      [1061, 94.5],
      [1064, 110.5],
      [1067, 100.5],
      [1070, 115.5],
      [1073, 136.5],
      [1076, 103.5],
      [1079, 122.5],
      [1082, 109.5],
      [1085, 115.5],
      [1088, 106.5],
      [1091, 93.5],
      [1094, 100.5],
      [1097, 97.5],
      [1100, 112.5],
      [1103, 134.5],
      [1106, 105.5],
      [1109, 113.5],
      [1112, 94.5],
      [1115, 117.5],
      [1118, 115.5],
      [1121, 100.5],
      [1124, 102.5],
      [1127, 103.5],
      [1130, 118.5],
      [1133, 139.5],
      [1136, 110.5],
      [1139, 102.5],
      [1142, 109.5],
      [1145, 113.5],
      [1148, 119.5],
      [1151, 95.5],
      [1154, 102.5],
      [1157, 105.5],
      [1160, 114.5],
      [1163, 121.5],
      [1166, 108.5],
      [1169, 114.5],
      [1172, 96.5],
      [1175, 113.5],
      [1178, 137.5],
      [1181, 104.5],
      [1184, 107.5],
      [1187, 94.5],
      [1190, 105.5],
      [1193, 115.5],
      [1196, 112.5],
      [1199, 123.5],
      [1202, 98.5],
      [1205, 115.5],
      [1208, 110.5],
      [1211, 92.5],
      [1214, 100.5],
      [1217, 94.5],
      [1220, 104.5],
      [1223, 120.5],
      [1226, 109.5],
      [1229, 110.5],
      [1232, 108.5],
      [1235, 113.5],
      [1238, 114.5],
      [1241, 104.5],
      [1244, 115.5],
      [1247, 92.5],
      [1250, 100.5],
      [1253, 136.5],
      [1256, 99.5],
      [1259, 104.5],
      [1262, 109.5],
      [1265, 113.5],
      [1268, 109.5],
      [1271, 109.5],
      [1274, 113.5],
      [1277, 114.5],
      [1280, 131.5],
      [1283, 137.5],
      [1286, 112.5],
      [1289, 122.5],
      [1292, 92.5],
      [1295, 103.5],
      [1298, 106.5],
      [1301, 100.5],
      [1304, 105.5],
      [1307, 103.5],
      [1310, 117.5],
      [1313, 135.5],
      [1316, 113.5],
      [1319, 102.5],
      [1322, 107.5],
      [1325, 117.5],
      [1328, 128.5],
      [1331, 103.5],
      [1334, 102.5],
      [1337, 96.5],
      [1340, 111.5],
      [1343, 134.5],
      [1346, 98.5],
      [1349, 116.5],
      [1352, 93.5],
      [1355, 114.5],
      [1358, 112.5],
      [1361, 105.5],
      [1364, 105.5],
      [1367, 104.5],
      [1370, 103.5],
      [1373, 132.5],
      [1376, 101.5],
      [1379, 107.5],
      [1382, 118.5],
      [1385, 116.5],
      [1388, 112.5],
      [1391, 99.5],
      [1394, 108.5],
      [1397, 106.5],
      [1400, 117.5],
      [1403, 121.5],
      [1406, 104.5],
      [1409, 118.5],
      [1412, 89.5],
      [1415, 101.5],
      [1418, 113.5],
      [1421, 104.5],
      [1424, 102.5],
      [1427, 98.5],
      [1430, 137.5],
      [1433, 118.5],
      [1436, 124.5],
      [1439, 102.5],
      [1442, 107.5],
      [1445, 110.5],
      [1448, 108.5],
      [1451, 102.5],
      [1454, 104.5],
      [1457, 101.5],
      [1460, 124.5],
      [1463, 120.5],
      [1466, 116.5],
      [1469, 99.5],
      [1472, 99.5],
      [1475, 110.5],
      [1478, 125.5],
      [1481, 110.5],
      [1484, 112.5],
      [1487, 108.5],
      [1490, 107.5],
      [1493, 122.5],
      [1496, 113.5],
      [1499, 98.5],
      [1502, 94.5],
      [1505, 110.5],
      [1508, 102.5],
      [1511, 110.5],
      [1514, 105.5],
      [1517, 99.5],
      [1520, 114.5],
      [1523, 94.5],
      [1526, 95.5],
      [1529, 86.5],
      [1532, 85.5],
      [1535, 78.5],
      [1538, 76.5],
      [1541, 75.5],
      [1544, 75.5],
      [1547, 75.5],
      [1550, 75.5],
    ],
    bottom: [
      [1548, 75.5],
      [1545, 75.5],
      [1542, 75.5],
      [1539, 74.5],
      [1536, 73.5],
      [1533, 68.5],
      [1530, 59.5],
      [1527, 58.5],
      [1524, 54.5],
      [1521, 28.5],
      [1518, 34.5],
      [1515, 36.5],
      [1512, 45.5],
      [1509, 49.5],
      [1506, 46.5],
      [1503, 45.5],
      [1500, 38.5],
      [1497, 35.5],
      [1494, 49.5],
      [1491, 28.5],
      [1488, 34.5],
      [1485, 37.5],
      [1482, 47.5],
      [1479, 26.5],
      [1476, 46.5],
      [1473, 41.5],
      [1470, 36.5],
      [1467, 33.5],
      [1464, 45.5],
      [1461, 35.5],
      [1458, 37.5],
      [1455, 43.5],
      [1452, 46.5],
      [1449, 52.5],
      [1446, 48.5],
      [1443, 35.5],
      [1440, 32.5],
      [1437, 43.5],
      [1434, 37.5],
      [1431, 34.5],
      [1428, 33.5],
      [1425, 38.5],
      [1422, 51.5],
      [1419, 43.5],
      [1416, 53.5],
      [1413, 42.5],
      [1410, 47.5],
      [1407, 44.5],
      [1404, 51.5],
      [1401, 42.5],
      [1398, 29.5],
      [1395, 35.5],
      [1392, 51.5],
      [1389, 48.5],
      [1386, 46.5],
      [1383, 36.5],
      [1380, 17.5],
      [1377, 48.5],
      [1374, 53.5],
      [1371, 38.5],
      [1368, 47.5],
      [1365, 41.5],
      [1362, 48.5],
      [1359, 46.5],
      [1356, 41.5],
      [1353, 37.5],
      [1350, 43.5],
      [1347, 52.5],
      [1344, 39.5],
      [1341, 37.5],
      [1338, 33.5],
      [1335, 34.5],
      [1332, 52.5],
      [1329, 10.5],
      [1326, 51.5],
      [1323, 38.5],
      [1320, 37.5],
      [1317, 50.5],
      [1314, 37.5],
      [1311, 38.5],
      [1308, 36.5],
      [1305, 39.5],
      [1302, 50.5],
      [1299, 53.5],
      [1296, 52.5],
      [1293, 37.5],
      [1290, 48.5],
      [1287, 55.5],
      [1284, 35.5],
      [1281, 33.5],
      [1278, 14.5],
      [1275, 36.5],
      [1272, 49.5],
      [1269, 38.5],
      [1266, 49.5],
      [1263, 34.5],
      [1260, 39.5],
      [1257, 43.5],
      [1254, 37.5],
      [1251, 48.5],
      [1248, 37.5],
      [1245, 36.5],
      [1242, 39.5],
      [1239, 45.5],
      [1236, 50.5],
      [1233, 40.5],
      [1230, 16.5],
      [1227, 49.5],
      [1224, 27.5],
      [1221, 46.5],
      [1218, 35.5],
      [1215, 39.5],
      [1212, 61.5],
      [1209, 38.5],
      [1206, 57.5],
      [1203, 40.5],
      [1200, 39.5],
      [1197, 47.5],
      [1194, 48.5],
      [1191, 52.5],
      [1188, 47.5],
      [1185, 34.5],
      [1182, 46.5],
      [1179, 36.5],
      [1176, 51.5],
      [1173, 38.5],
      [1170, 54.5],
      [1167, 54.5],
      [1164, 27.5],
      [1161, 42.5],
      [1158, 32.5],
      [1155, 38.5],
      [1152, 58.5],
      [1149, 44.5],
      [1146, 44.5],
      [1143, 41.5],
      [1140, 36.5],
      [1137, 55.5],
      [1134, 37.5],
      [1131, 54.5],
      [1128, 25.5],
      [1125, 36.5],
      [1122, 51.5],
      [1119, 45.5],
      [1116, 47.5],
      [1113, 37.5],
      [1110, 33.5],
      [1107, 57.5],
      [1104, 28.5],
      [1101, 47.5],
      [1098, 31.5],
      [1095, 35.5],
      [1092, 59.5],
      [1089, 40.5],
      [1086, 46.5],
      [1083, 36.5],
      [1080, 19.5],
      [1077, 43.5],
      [1074, 32.5],
      [1071, 57.5],
      [1068, 30.5],
      [1065, 35.5],
      [1062, 47.5],
      [1059, 42.5],
      [1056, 48.5],
      [1053, 36.5],
      [1050, 52.5],
      [1047, 61.5],
      [1044, 40.5],
      [1041, 49.5],
      [1038, 33.5],
      [1035, 35.5],
      [1032, 40.5],
      [1029, 17.5],
      [1026, 40.5],
      [1023, 38.5],
      [1020, 26.5],
      [1017, 43.5],
      [1014, 13.5],
      [1011, 34.5],
      [1008, 41.5],
      [1005, 36.5],
      [1002, 41.5],
      [999, 50.5],
      [996, 44.5],
      [993, 50.5],
      [990, 25.5],
      [987, 43.5],
      [984, 15.5],
      [981, 44.5],
      [978, 26.5],
      [975, 42.5],
      [972, 46.5],
      [969, 27.5],
      [966, 44.5],
      [963, 45.5],
      [960, 24.5],
      [957, 45.5],
      [954, 37.5],
      [951, 50.5],
      [948, 44.5],
      [945, 39.5],
      [942, 49.5],
      [939, 35.5],
      [936, 46.5],
      [933, 39.5],
      [930, 25.5],
      [927, 31.5],
      [924, 28.5],
      [921, 32.5],
      [918, 49.5],
      [915, 41.5],
      [912, 43.5],
      [909, 42.5],
      [906, 47.5],
      [903, 38.5],
      [900, 36.5],
      [897, 45.5],
      [894, 26.5],
      [891, 44.5],
      [888, 45.5],
      [885, 37.5],
      [882, 29.5],
      [879, 38.5],
      [876, 23.5],
      [873, 43.5],
      [870, 32.5],
      [867, 38.5],
      [864, 20.5],
      [861, 46.5],
      [858, 45.5],
      [855, 32.5],
      [852, 45.5],
      [849, 38.5],
      [846, 45.5],
      [843, 40.5],
      [840, 23.5],
      [837, 47.5],
      [834, 35.5],
      [831, 56.5],
      [828, 15.5],
      [825, 38.5],
      [822, 41.5],
      [819, 48.5],
      [816, 39.5],
      [813, 32.5],
      [810, 47.5],
      [807, 49.5],
      [804, 23.5],
      [801, 50.5],
      [798, 32.5],
      [795, 37.5],
      [792, 61.5],
      [789, 42.5],
      [786, 39.5],
      [783, 34.5],
      [780, 29.5],
      [777, 34.5],
      [774, 26.5],
      [771, 53.5],
      [768, 56.5],
      [765, 31.5],
      [762, 44.5],
      [759, 39.5],
      [756, 36.5],
      [753, 40.5],
      [750, 30.5],
      [747, 42.5],
      [744, 37.5],
      [741, 37.5],
      [738, 56.5],
      [735, 48.5],
      [732, 39.5],
      [729, 47.5],
      [726, 22.5],
      [723, 36.5],
      [720, 38.5],
      [717, 53.5],
      [714, 43.5],
      [711, 55.5],
      [708, 40.5],
      [705, 49.5],
      [702, 42.5],
      [699, 42.5],
      [696, 43.5],
      [693, 39.5],
      [690, 29.5],
      [687, 32.5],
      [684, 39.5],
      [681, 39.5],
      [678, 36.5],
      [675, 35.5],
      [672, 39.5],
      [669, 43.5],
      [666, 35.5],
      [663, 38.5],
      [660, 35.5],
      [657, 34.5],
      [654, 42.5],
      [651, 49.5],
      [648, 37.5],
      [645, 41.5],
      [642, 50.5],
      [639, 32.5],
      [636, 37.5],
      [633, 36.5],
      [630, 37.5],
      [627, 42.5],
      [624, 35.5],
      [621, 41.5],
      [618, 30.5],
      [615, 19.5],
      [612, 57.5],
      [609, 30.5],
      [606, 48.5],
      [603, 28.5],
      [600, 23.5],
      [597, 35.5],
      [594, 42.5],
      [591, 51.5],
      [588, 34.5],
      [585, 33.5],
      [582, 31.5],
      [579, 37.5],
      [576, 32.5],
      [573, 35.5],
      [570, 40.5],
      [567, 43.5],
      [564, 39.5],
      [561, 39.5],
      [558, 21.5],
      [555, 31.5],
      [552, 59.5],
      [549, 28.5],
      [546, 43.5],
      [543, 27.5],
      [540, 36.5],
      [537, 38.5],
      [534, 48.5],
      [531, 54.5],
      [528, 24.5],
      [525, 22.5],
      [522, 39.5],
      [519, 36.5],
      [516, 40.5],
      [513, 24.5],
      [510, 36.5],
      [507, 45.5],
      [504, 40.5],
      [501, 38.5],
      [498, 29.5],
      [495, 35.5],
      [492, 54.5],
      [489, 16.5],
      [486, 44.5],
      [483, 30.5],
      [480, 28.5],
      [477, 21.5],
      [474, 41.5],
      [471, 35.5],
      [468, 23.5],
      [465, 26.5],
      [462, 36.5],
      [459, 36.5],
      [456, 34.5],
      [453, 36.5],
      [450, 15.5],
      [447, 14.5],
      [444, 39.5],
      [441, 36.5],
      [438, 16.5],
      [435, 23.5],
      [432, 21.5],
      [429, 37.5],
      [426, 6.125],
      [423, 40.5],
      [420, 18.5],
      [417, 29.5],
      [414, 32.5],
      [411, 29.5],
      [408, 35.5],
      [405, 29.5],
      [402, 38.5],
      [399, 24.5],
      [396, 33.5],
      [393, 24.5],
      [390, 15.5],
      [387, 20.5],
      [384, 29.5],
      [381, 36.5],
      [378, 11.5],
      [375, 9.5],
      [372, 31.5],
      [369, 44.5],
      [366, 40.5],
      [363, 48.5],
      [360, 13.5],
      [357, 30.5],
      [354, 25.5],
      [351, 40.5],
      [348, 18.5],
      [345, 16.5],
      [342, 31.5],
      [339, 30.5],
      [336, 27.5],
      [333, 21.5],
      [330, 17.5],
      [327, 33.5],
      [324, 43.5],
      [321, 33.5],
      [318, 15.5],
      [315, 19.5],
      [312, 52.5],
      [309, 24.5],
      [306, 37.5],
      [303, 23.5],
      [300, 10.5],
      [297, 48.5],
      [294, 34.5],
      [291, 42.5],
      [288, 13.5],
      [285, 28.5],
      [282, 24.5],
      [279, 35.5],
      [276, 32.5],
      [273, 31.5],
      [270, 11.5],
      [267, 42.5],
      [264, 34.5],
      [261, 37.5],
      [258, 16.5],
      [255, 21.5],
      [252, 47.5],
      [249, 22.5],
      [246, 34.5],
      [243, 28.5],
      [240, 20.5],
      [237, 26.5],
      [234, 34.5],
      [231, 39.5],
      [228, 26.5],
      [225, 5.5],
      [222, 24.5],
      [219, 36.5],
      [216, 43.5],
      [213, 14.5],
      [210, 33.5],
      [207, 50.5],
      [204, 24.5],
      [201, 22.5],
      [198, 19.5],
      [195, 15.5],
      [192, 29.5],
      [189, 40.5],
      [186, 37.5],
      [183, 17.5],
      [180, 6.894599999999997],
      [177, 41.5],
      [174, 22.5],
      [171, 42.5],
      [168, 23.5],
      [165, 12.5],
      [162, 34.5],
      [159, 29.5],
      [156, 22.5],
      [153, 33.5],
      [150, 5.7623999999999995],
      [147, 29.5],
      [144, 19.5],
      [141, 37.5],
      [138, 28.5],
      [135, 10.5],
      [132, 56.5],
      [129, 34.5],
      [126, 7.723399999999998],
      [123, 35.5],
      [120, 18.5],
      [117, 44.5],
      [114, 40.5],
      [111, 46.5],
      [108, 57.5],
      [105, 25.5],
      [102, 27.5],
      [99, 32.5],
      [96, 36.5],
      [93, 19.5],
      [90, 21.5],
      [87, 34.5],
      [84, 40.5],
      [81, 20.5],
      [78, 27.5],
      [75, 6.5],
      [72, 57.5],
      [69, 25.5],
      [66, 28.5],
      [63, 33.5],
      [60, 6.5],
      [57, 24.5],
      [54, 33.5],
      [51, 47.5],
      [48, 60.5],
      [45, 28.5],
      [42, 28.5],
      [39, 27.5],
      [36, 25.5],
      [33, 19.5],
      [30, 20.5],
      [27, 35.5],
      [24, 14.5],
      [21, 30.5],
      [18, 5.5],
      [15, 5.5],
      [12, 46.5],
      [9, 3.164999999999992],
      [6, 11.5],
      [3, 16.5],
      [0, 42.5],
    ],
  },
  {
    top: [
      [2, 133.5],
      [5, 135.5],
      [8, 102.5],
      [11, 105.5],
      [14, 130.5],
      [17, 112.5],
      [20, 140.5],
      [23, 119.5],
      [26, 143.5],
      [29, 141.5],
      [32, 105.5],
      [35, 132.5],
      [38, 144.1054],
      [41, 122.5],
      [44, 144.1054],
      [47, 108.5],
      [50, 133.5],
      [53, 138.5],
      [56, 145.2376],
      [59, 133.5],
      [62, 138.5],
      [65, 130.5],
      [68, 107.5],
      [71, 117.5],
      [74, 130.5],
      [77, 129.5],
      [80, 128.5],
      [83, 120.5],
      [86, 137.5],
      [89, 144.5],
      [92, 110.5],
      [95, 132.5],
      [98, 126.5],
      [101, 125.5],
      [104, 128.5],
      [107, 116.5],
      [110, 116.5],
      [113, 140.5],
      [116, 123.5],
      [119, 143.5],
      [122, 128.5],
      [125, 135.5],
      [128, 101.5],
      [131, 109.5],
      [134, 123.5],
      [137, 109.5],
      [140, 135.5],
      [143, 121.5],
      [146, 126.5],
      [149, 144.4976],
      [152, 114.5],
      [155, 119.5],
      [158, 136.5],
      [161, 120.5],
      [164, 134.5],
      [167, 101.5],
      [170, 124.5],
      [173, 142.5],
      [176, 130.5],
      [179, 140.5],
      [182, 118.5],
      [185, 127.5],
      [188, 143.5],
      [191, 111.5],
      [194, 110.5],
      [197, 101.5],
      [200, 142.5],
      [203, 118.5],
      [206, 118.5],
      [209, 144.5],
      [212, 103.5],
      [215, 124.5],
      [218, 134.5],
      [221, 115.5],
      [224, 134.5],
      [227, 130.5],
      [230, 131.5],
      [233, 134.5],
      [236, 113.5],
      [239, 122.5],
      [242, 133.5],
      [245, 127.5],
      [248, 134.5],
      [251, 114.5],
      [254, 109.5],
      [257, 108.5],
      [260, 129.5],
      [263, 134.5],
      [266, 112.5],
      [269, 120.5],
      [272, 109.5],
      [275, 143.5],
      [278, 134.5],
      [281, 122.5],
      [284, 117.5],
      [287, 113.5],
      [290, 109.5],
      [293, 131.5],
      [296, 115.5],
      [299, 110.5],
      [302, 124.5],
      [305, 132.5],
      [308, 137.5],
      [311, 103.5],
      [314, 126.5],
      [317, 111.5],
      [320, 128.5],
      [323, 114.5],
      [326, 124.5],
      [329, 127.5],
      [332, 117.5],
      [335, 134.5],
      [338, 132.5],
      [341, 116.5],
      [344, 110.5],
      [347, 102.5],
      [350, 135.5],
      [353, 127.5],
      [356, 109.5],
      [359, 118.5],
      [362, 118.5],
      [365, 136.5],
      [368, 90.5],
      [371, 110.5],
      [374, 118.5],
      [377, 132.5],
      [380, 131.5],
      [383, 115.5],
      [386, 121.5],
      [389, 129.5],
      [392, 116.5],
      [395, 135.5],
      [398, 127.5],
      [401, 109.5],
      [404, 101.5],
      [407, 113.5],
      [410, 127.5],
      [413, 123.5],
      [416, 122.5],
      [419, 109.5],
      [422, 118.5],
      [425, 135.5],
      [428, 132.5],
      [431, 119.5],
      [434, 122.5],
      [437, 119.5],
      [440, 124.5],
      [443, 117.5],
      [446, 133.5],
      [449, 119.5],
      [452, 104.5],
      [455, 131.5],
      [458, 126.5],
      [461, 111.5],
      [464, 102.5],
      [467, 103.5],
      [470, 124.5],
      [473, 132.5],
      [476, 113.5],
      [479, 125.5],
      [482, 109.5],
      [485, 122.5],
      [488, 127.5],
      [491, 104.5],
      [494, 111.5],
      [497, 101.5],
      [500, 118.5],
      [503, 113.5],
      [506, 111.5],
      [509, 118.5],
      [512, 98.5],
      [515, 123.5],
      [518, 125.5],
      [521, 104.5],
      [524, 108.5],
      [527, 111.5],
      [530, 108.5],
      [533, 129.5],
      [536, 123.5],
      [539, 121.5],
      [542, 124.5],
      [545, 119.5],
      [548, 111.5],
      [551, 106.5],
      [554, 104.5],
      [557, 119.5],
      [560, 117.5],
      [563, 128.5],
      [566, 127.5],
      [569, 135.5],
      [572, 104.5],
      [575, 136.5],
      [578, 143.5],
      [581, 114.5],
      [584, 109.5],
      [587, 109.5],
      [590, 127.5],
      [593, 123.5],
      [596, 132.5],
      [599, 122.5],
      [602, 128.5],
      [605, 133.5],
      [608, 120.5],
      [611, 99.5],
      [614, 117.5],
      [617, 98.5],
      [620, 133.5],
      [623, 128.5],
      [626, 119.5],
      [629, 138.5],
      [632, 104.5],
      [635, 128.5],
      [638, 132.5],
      [641, 111.5],
      [644, 116.5],
      [647, 106.5],
      [650, 121.5],
      [653, 121.5],
      [656, 112.5],
      [659, 112.5],
      [662, 125.5],
      [665, 116.5],
      [668, 121.5],
      [671, 121.5],
      [674, 107.5],
      [677, 124.5],
      [680, 129.5],
      [683, 115.5],
      [686, 125.5],
      [689, 124.5],
      [692, 117.5],
      [695, 119.5],
      [698, 116.5],
      [701, 122.5],
      [704, 117.5],
      [707, 91.5],
      [710, 108.5],
      [713, 114.5],
      [716, 101.5],
      [719, 111.5],
      [722, 108.5],
      [725, 114.5],
      [728, 130.5],
      [731, 116.5],
      [734, 109.5],
      [737, 106.5],
      [740, 115.5],
      [743, 122.5],
      [746, 129.5],
      [749, 118.5],
      [752, 121.5],
      [755, 123.5],
      [758, 117.5],
      [761, 124.5],
      [764, 105.5],
      [767, 98.5],
      [770, 122.5],
      [773, 123.5],
      [776, 114.5],
      [779, 123.5],
      [782, 117.5],
      [785, 116.5],
      [788, 103.5],
      [791, 98.5],
      [794, 119.5],
      [797, 111.5],
      [800, 122.5],
      [803, 126.5],
      [806, 117.5],
      [809, 128.5],
      [812, 99.5],
      [815, 118.5],
      [818, 132.5],
      [821, 107.5],
      [824, 117.5],
      [827, 115.5],
      [830, 124.5],
      [833, 124.5],
      [836, 124.5],
      [839, 107.5],
      [842, 130.5],
      [845, 127.5],
      [848, 122.5],
      [851, 118.5],
      [854, 108.5],
      [857, 100.5],
      [860, 122.5],
      [863, 135.5],
      [866, 129.5],
      [869, 120.5],
      [872, 105.5],
      [875, 137.5],
      [878, 126.5],
      [881, 128.5],
      [884, 114.5],
      [887, 115.5],
      [890, 128.5],
      [893, 114.5],
      [896, 118.5],
      [899, 114.5],
      [902, 115.5],
      [905, 116.5],
      [908, 119.5],
      [911, 115.5],
      [914, 111.5],
      [917, 114.5],
      [920, 127.5],
      [923, 116.5],
      [926, 124.5],
      [929, 125.5],
      [932, 112.5],
      [935, 117.5],
      [938, 109.5],
      [941, 121.5],
      [944, 117.5],
      [947, 111.5],
      [950, 127.5],
      [953, 116.5],
      [956, 116.5],
      [959, 116.5],
      [962, 108.5],
      [965, 117.5],
      [968, 108.5],
      [971, 112.5],
      [974, 119.5],
      [977, 108.5],
      [980, 128.5],
      [983, 121.5],
      [986, 108.5],
      [989, 116.5],
      [992, 116.5],
      [995, 106.5],
      [998, 108.5],
      [1001, 118.5],
      [1004, 120.5],
      [1007, 110.5],
      [1010, 122.5],
      [1013, 131.5],
      [1016, 130.5],
      [1019, 132.5],
      [1022, 115.5],
      [1025, 127.5],
      [1028, 125.5],
      [1031, 107.5],
      [1034, 103.5],
      [1037, 106.5],
      [1040, 126.5],
      [1043, 117.5],
      [1046, 108.5],
      [1049, 130.5],
      [1052, 103.5],
      [1055, 132.5],
      [1058, 125.5],
      [1061, 103.5],
      [1064, 120.5],
      [1067, 101.5],
      [1070, 124.5],
      [1073, 133.5],
      [1076, 109.5],
      [1079, 124.5],
      [1082, 119.5],
      [1085, 127.5],
      [1088, 123.5],
      [1091, 102.5],
      [1094, 110.5],
      [1097, 101.5],
      [1100, 121.5],
      [1103, 130.5],
      [1106, 116.5],
      [1109, 125.5],
      [1112, 100.5],
      [1115, 123.5],
      [1118, 130.5],
      [1121, 107.5],
      [1124, 110.5],
      [1127, 102.5],
      [1130, 118.5],
      [1133, 139.5],
      [1136, 122.5],
      [1139, 112.5],
      [1142, 114.5],
      [1145, 125.5],
      [1148, 134.5],
      [1151, 105.5],
      [1154, 111.5],
      [1157, 110.5],
      [1160, 126.5],
      [1163, 119.5],
      [1166, 114.5],
      [1169, 123.5],
      [1172, 101.5],
      [1175, 121.5],
      [1178, 136.5],
      [1181, 108.5],
      [1184, 119.5],
      [1187, 97.5],
      [1190, 112.5],
      [1193, 128.5],
      [1196, 124.5],
      [1199, 122.5],
      [1202, 102.5],
      [1205, 120.5],
      [1208, 112.5],
      [1211, 93.5],
      [1214, 103.5],
      [1217, 98.5],
      [1220, 109.5],
      [1223, 118.5],
      [1226, 117.5],
      [1229, 110.5],
      [1232, 115.5],
      [1235, 117.5],
      [1238, 122.5],
      [1241, 115.5],
      [1244, 129.5],
      [1247, 98.5],
      [1250, 106.5],
      [1253, 133.5],
      [1256, 106.5],
      [1259, 109.5],
      [1262, 121.5],
      [1265, 126.5],
      [1268, 123.5],
      [1271, 118.5],
      [1274, 127.5],
      [1277, 118.5],
      [1280, 130.5],
      [1283, 134.5],
      [1286, 119.5],
      [1289, 122.5],
      [1292, 95.5],
      [1295, 119.5],
      [1298, 121.5],
      [1301, 106.5],
      [1304, 117.5],
      [1307, 105.5],
      [1310, 121.5],
      [1313, 132.5],
      [1316, 120.5],
      [1319, 108.5],
      [1322, 118.5],
      [1325, 132.5],
      [1328, 128.5],
      [1331, 103.5],
      [1334, 108.5],
      [1337, 98.5],
      [1340, 114.5],
      [1343, 131.5],
      [1346, 102.5],
      [1349, 124.5],
      [1352, 100.5],
      [1355, 127.5],
      [1358, 126.5],
      [1361, 113.5],
      [1364, 113.5],
      [1367, 108.5],
      [1370, 108.5],
      [1373, 130.5],
      [1376, 103.5],
      [1379, 107.5],
      [1382, 116.5],
      [1385, 119.5],
      [1388, 123.5],
      [1391, 102.5],
      [1394, 115.5],
      [1397, 108.5],
      [1400, 118.5],
      [1403, 121.5],
      [1406, 103.5],
      [1409, 124.5],
      [1412, 91.5],
      [1415, 106.5],
      [1418, 120.5],
      [1421, 106.5],
      [1424, 108.5],
      [1427, 98.5],
      [1430, 136.5],
      [1433, 126.5],
      [1436, 124.5],
      [1439, 101.5],
      [1442, 107.5],
      [1445, 111.5],
      [1448, 118.5],
      [1451, 116.5],
      [1454, 110.5],
      [1457, 107.5],
      [1460, 123.5],
      [1463, 123.5],
      [1466, 116.5],
      [1469, 102.5],
      [1472, 105.5],
      [1475, 115.5],
      [1478, 126.5],
      [1481, 110.5],
      [1484, 119.5],
      [1487, 110.5],
      [1490, 107.5],
      [1493, 126.5],
      [1496, 112.5],
      [1499, 102.5],
      [1502, 100.5],
      [1505, 122.5],
      [1508, 113.5],
      [1511, 117.5],
      [1514, 111.5],
      [1517, 99.5],
      [1520, 113.5],
      [1523, 96.5],
      [1526, 95.5],
      [1529, 86.5],
      [1532, 86.5],
      [1535, 79.5],
      [1538, 76.5],
      [1541, 75.5],
      [1544, 76.5],
      [1547, 75.5],
      [1550, 75.5],
    ],
    bottom: [
      [1548, 75.5],
      [1545, 75.5],
      [1542, 75.5],
      [1539, 74.5],
      [1536, 73.5],
      [1533, 66.5],
      [1530, 59.5],
      [1527, 58.5],
      [1524, 52.5],
      [1521, 30.5],
      [1518, 32.5],
      [1515, 30.5],
      [1512, 42.5],
      [1509, 38.5],
      [1506, 33.5],
      [1503, 36.5],
      [1500, 30.5],
      [1497, 38.5],
      [1494, 47.5],
      [1491, 30.5],
      [1488, 31.5],
      [1485, 32.5],
      [1482, 45.5],
      [1479, 27.5],
      [1476, 44.5],
      [1473, 34.5],
      [1470, 30.5],
      [1467, 35.5],
      [1464, 41.5],
      [1461, 38.5],
      [1458, 33.5],
      [1455, 33.5],
      [1452, 33.5],
      [1449, 42.5],
      [1446, 47.5],
      [1443, 36.5],
      [1440, 32.5],
      [1437, 45.5],
      [1434, 30.5],
      [1431, 36.5],
      [1428, 31.5],
      [1425, 35.5],
      [1422, 48.5],
      [1419, 39.5],
      [1416, 51.5],
      [1413, 37.5],
      [1410, 45.5],
      [1407, 44.5],
      [1404, 48.5],
      [1401, 42.5],
      [1398, 25.5],
      [1395, 28.5],
      [1392, 48.5],
      [1389, 39.5],
      [1386, 41.5],
      [1383, 33.5],
      [1380, 17.5],
      [1377, 46.5],
      [1374, 50.5],
      [1371, 39.5],
      [1368, 43.5],
      [1365, 31.5],
      [1362, 39.5],
      [1359, 35.5],
      [1356, 30.5],
      [1353, 25.5],
      [1350, 37.5],
      [1347, 50.5],
      [1344, 36.5],
      [1341, 40.5],
      [1338, 29.5],
      [1335, 28.5],
      [1332, 50.5],
      [1329, 10.5],
      [1326, 43.5],
      [1323, 28.5],
      [1320, 21.5],
      [1317, 48.5],
      [1314, 35.5],
      [1311, 40.5],
      [1308, 32.5],
      [1305, 33.5],
      [1302, 43.5],
      [1299, 43.5],
      [1296, 38.5],
      [1293, 29.5],
      [1290, 45.5],
      [1287, 54.5],
      [1284, 35.5],
      [1281, 34.5],
      [1278, 14.5],
      [1275, 22.5],
      [1272, 41.5],
      [1269, 25.5],
      [1266, 41.5],
      [1263, 22.5],
      [1260, 24.5],
      [1257, 41.5],
      [1254, 38.5],
      [1251, 48.5],
      [1248, 23.5],
      [1245, 20.5],
      [1242, 23.5],
      [1239, 36.5],
      [1236, 48.5],
      [1233, 36.5],
      [1230, 15.5],
      [1227, 49.5],
      [1224, 26.5],
      [1221, 46.5],
      [1218, 26.5],
      [1215, 32.5],
      [1212, 59.5],
      [1209, 36.5],
      [1206, 54.5],
      [1203, 36.5],
      [1200, 35.5],
      [1197, 47.5],
      [1194, 38.5],
      [1191, 47.5],
      [1188, 43.5],
      [1185, 21.5],
      [1182, 38.5],
      [1179, 36.5],
      [1176, 45.5],
      [1173, 35.5],
      [1170, 45.5],
      [1167, 50.5],
      [1164, 28.5],
      [1161, 35.5],
      [1158, 31.5],
      [1155, 26.5],
      [1152, 50.5],
      [1149, 34.5],
      [1146, 32.5],
      [1143, 32.5],
      [1140, 23.5],
      [1137, 49.5],
      [1134, 37.5],
      [1131, 52.5],
      [1128, 26.5],
      [1125, 27.5],
      [1122, 47.5],
      [1119, 35.5],
      [1116, 41.5],
      [1113, 30.5],
      [1110, 22.5],
      [1107, 50.5],
      [1104, 31.5],
      [1101, 42.5],
      [1098, 26.5],
      [1095, 27.5],
      [1092, 52.5],
      [1089, 25.5],
      [1086, 37.5],
      [1083, 24.5],
      [1080, 16.5],
      [1077, 41.5],
      [1074, 34.5],
      [1071, 56.5],
      [1068, 26.5],
      [1065, 29.5],
      [1062, 34.5],
      [1059, 38.5],
      [1056, 36.5],
      [1053, 18.5],
      [1050, 48.5],
      [1047, 58.5],
      [1044, 42.5],
      [1041, 45.5],
      [1038, 25.5],
      [1035, 31.5],
      [1032, 33.5],
      [1029, 18.5],
      [1026, 33.5],
      [1023, 22.5],
      [1020, 28.5],
      [1017, 31.5],
      [1014, 15.5],
      [1011, 29.5],
      [1008, 35.5],
      [1005, 21.5],
      [1002, 31.5],
      [999, 48.5],
      [996, 36.5],
      [993, 40.5],
      [990, 23.5],
      [987, 32.5],
      [984, 20.5],
      [981, 39.5],
      [978, 27.5],
      [975, 34.5],
      [972, 35.5],
      [969, 25.5],
      [966, 36.5],
      [963, 41.5],
      [960, 17.5],
      [957, 37.5],
      [954, 31.5],
      [951, 43.5],
      [948, 32.5],
      [945, 30.5],
      [942, 42.5],
      [939, 29.5],
      [936, 34.5],
      [933, 28.5],
      [930, 23.5],
      [927, 32.5],
      [924, 30.5],
      [921, 31.5],
      [918, 43.5],
      [915, 31.5],
      [912, 31.5],
      [909, 37.5],
      [906, 36.5],
      [903, 35.5],
      [900, 26.5],
      [897, 41.5],
      [894, 29.5],
      [891, 39.5],
      [888, 43.5],
      [885, 34.5],
      [882, 23.5],
      [879, 36.5],
      [876, 12.5],
      [873, 32.5],
      [870, 23.5],
      [867, 33.5],
      [864, 23.5],
      [861, 39.5],
      [858, 35.5],
      [855, 21.5],
      [852, 42.5],
      [849, 27.5],
      [846, 37.5],
      [843, 26.5],
      [840, 17.5],
      [837, 46.5],
      [834, 37.5],
      [831, 51.5],
      [828, 16.5],
      [825, 33.5],
      [822, 30.5],
      [819, 40.5],
      [816, 32.5],
      [813, 16.5],
      [810, 43.5],
      [807, 48.5],
      [804, 26.5],
      [801, 46.5],
      [798, 27.5],
      [795, 27.5],
      [792, 57.5],
      [789, 37.5],
      [786, 30.5],
      [783, 20.5],
      [780, 26.5],
      [777, 34.5],
      [774, 28.5],
      [771, 52.5],
      [768, 50.5],
      [765, 23.5],
      [762, 41.5],
      [759, 33.5],
      [756, 29.5],
      [753, 32.5],
      [750, 20.5],
      [747, 39.5],
      [744, 33.5],
      [741, 35.5],
      [738, 56.5],
      [735, 43.5],
      [732, 36.5],
      [729, 46.5],
      [726, 22.5],
      [723, 27.5],
      [720, 40.5],
      [717, 51.5],
      [714, 40.5],
      [711, 52.5],
      [708, 39.5],
      [705, 42.5],
      [702, 37.5],
      [699, 34.5],
      [696, 35.5],
      [693, 31.5],
      [690, 26.5],
      [687, 34.5],
      [684, 32.5],
      [681, 33.5],
      [678, 36.5],
      [675, 33.5],
      [672, 35.5],
      [669, 37.5],
      [666, 22.5],
      [663, 30.5],
      [660, 27.5],
      [657, 35.5],
      [654, 37.5],
      [651, 45.5],
      [648, 33.5],
      [645, 36.5],
      [642, 49.5],
      [639, 26.5],
      [636, 26.5],
      [633, 24.5],
      [630, 27.5],
      [627, 42.5],
      [624, 32.5],
      [621, 37.5],
      [618, 29.5],
      [615, 21.5],
      [612, 56.5],
      [609, 24.5],
      [606, 41.5],
      [603, 18.5],
      [600, 16.5],
      [597, 37.5],
      [594, 40.5],
      [591, 51.5],
      [588, 33.5],
      [585, 28.5],
      [582, 32.5],
      [579, 35.5],
      [576, 32.5],
      [573, 24.5],
      [570, 35.5],
      [567, 44.5],
      [564, 38.5],
      [561, 41.5],
      [558, 23.5],
      [555, 29.5],
      [552, 58.5],
      [549, 23.5],
      [546, 38.5],
      [543, 15.5],
      [540, 25.5],
      [537, 40.5],
      [534, 49.5],
      [531, 54.5],
      [528, 25.5],
      [525, 23.5],
      [522, 39.5],
      [519, 36.5],
      [516, 38.5],
      [513, 17.5],
      [510, 30.5],
      [507, 47.5],
      [504, 41.5],
      [501, 41.5],
      [498, 27.5],
      [495, 32.5],
      [492, 54.5],
      [489, 17.5],
      [486, 45.5],
      [483, 30.5],
      [480, 26.5],
      [477, 22.5],
      [474, 40.5],
      [471, 37.5],
      [468, 25.5],
      [465, 26.5],
      [462, 38.5],
      [459, 37.5],
      [456, 32.5],
      [453, 27.5],
      [450, 9.5],
      [447, 16.5],
      [444, 38.5],
      [441, 38.5],
      [438, 17.5],
      [435, 22.5],
      [432, 20.5],
      [429, 38.5],
      [426, 6.125],
      [423, 34.5],
      [420, 17.5],
      [417, 31.5],
      [414, 32.5],
      [411, 25.5],
      [408, 34.5],
      [405, 28.5],
      [402, 37.5],
      [399, 21.5],
      [396, 28.5],
      [393, 13.5],
      [390, 7.5],
      [387, 23.5],
      [384, 29.5],
      [381, 35.5],
      [378, 12.5],
      [375, 10.5],
      [372, 29.5],
      [369, 45.5],
      [366, 39.5],
      [363, 46.5],
      [360, 7.5],
      [357, 32.5],
      [354, 25.5],
      [351, 40.5],
      [348, 20.5],
      [345, 17.5],
      [342, 33.5],
      [339, 29.5],
      [336, 25.5],
      [333, 16.5],
      [330, 13.5],
      [327, 32.5],
      [324, 43.5],
      [321, 29.5],
      [318, 13.5],
      [315, 19.5],
      [312, 51.5],
      [309, 22.5],
      [306, 35.5],
      [303, 13.5],
      [300, 14.5],
      [297, 48.5],
      [294, 33.5],
      [291, 45.5],
      [288, 13.5],
      [285, 29.5],
      [282, 26.5],
      [279, 36.5],
      [276, 32.5],
      [273, 31.5],
      [270, 8.5],
      [267, 43.5],
      [264, 34.5],
      [261, 36.5],
      [258, 18.5],
      [255, 19.5],
      [252, 46.5],
      [249, 19.5],
      [246, 37.5],
      [243, 30.5],
      [240, 17.5],
      [237, 25.5],
      [234, 35.5],
      [231, 38.5],
      [228, 24.5],
      [225, 7.723399999999998],
      [222, 22.5],
      [219, 37.5],
      [216, 44.5],
      [213, 12.5],
      [210, 34.5],
      [207, 50.5],
      [204, 25.5],
      [201, 22.5],
      [198, 14.5],
      [195, 15.5],
      [192, 31.5],
      [189, 41.5],
      [186, 37.5],
      [183, 13.5],
      [180, 6.894599999999997],
      [177, 41.5],
      [174, 20.5],
      [171, 45.5],
      [168, 24.5],
      [165, 14.5],
      [162, 31.5],
      [159, 29.5],
      [156, 24.5],
      [153, 27.5],
      [150, 4.763400000000004],
      [147, 28.5],
      [144, 18.5],
      [141, 35.5],
      [138, 27.5],
      [135, 10.5],
      [132, 57.5],
      [129, 33.5],
      [126, 7.723399999999998],
      [123, 34.5],
      [120, 18.5],
      [117, 44.5],
      [114, 40.5],
      [111, 48.5],
      [108, 57.5],
      [105, 25.5],
      [102, 26.5],
      [99, 32.5],
      [96, 37.5],
      [93, 19.5],
      [90, 21.5],
      [87, 33.5],
      [84, 38.5],
      [81, 20.5],
      [78, 30.5],
      [75, 6.5],
      [72, 56.5],
      [69, 22.5],
      [66, 28.5],
      [63, 33.5],
      [60, 6.5],
      [57, 24.5],
      [54, 34.5],
      [51, 46.5],
      [48, 60.5],
      [45, 27.5],
      [42, 27.5],
      [39, 28.5],
      [36, 26.5],
      [33, 21.5],
      [30, 20.5],
      [27, 36.5],
      [24, 14.5],
      [21, 32.5],
      [18, 5.5],
      [15, 7.5],
      [12, 45.5],
      [9, 3.6385999999999967],
      [6, 14.5],
      [3, 19.5],
      [0, 43.5],
    ],
  },
  {
    top: [
      [2, 131.5],
      [5, 133.5],
      [8, 102.5],
      [11, 105.5],
      [14, 129.5],
      [17, 112.5],
      [20, 139.5],
      [23, 118.5],
      [26, 142.5],
      [29, 143.5],
      [32, 105.5],
      [35, 129.5],
      [38, 143.6984],
      [41, 121.5],
      [44, 145.5],
      [47, 108.5],
      [50, 133.5],
      [53, 135.5],
      [56, 145.2376],
      [59, 132.5],
      [62, 141.5],
      [65, 131.5],
      [68, 108.5],
      [71, 118.5],
      [74, 129.5],
      [77, 129.5],
      [80, 128.5],
      [83, 119.5],
      [86, 135.5],
      [89, 142.5],
      [92, 112.5],
      [95, 135.5],
      [98, 125.5],
      [101, 124.5],
      [104, 128.5],
      [107, 116.5],
      [110, 118.5],
      [113, 140.5],
      [116, 124.5],
      [119, 140.5],
      [122, 133.5],
      [125, 135.5],
      [128, 101.5],
      [131, 108.5],
      [134, 123.5],
      [137, 109.5],
      [140, 135.5],
      [143, 123.5],
      [146, 129.5],
      [149, 143.6984],
      [152, 115.5],
      [155, 122.5],
      [158, 131.5],
      [161, 119.5],
      [164, 134.5],
      [167, 100.5],
      [170, 125.5],
      [173, 140.5],
      [176, 130.5],
      [179, 138.5],
      [182, 122.5],
      [185, 127.5],
      [188, 143.5],
      [191, 110.5],
      [194, 108.5],
      [197, 101.5],
      [200, 142.5],
      [203, 120.5],
      [206, 119.5],
      [209, 141.5],
      [212, 105.5],
      [215, 126.5],
      [218, 136.5],
      [221, 114.5],
      [224, 133.5],
      [227, 129.5],
      [230, 128.5],
      [233, 133.5],
      [236, 113.5],
      [239, 124.5],
      [242, 135.5],
      [245, 129.5],
      [248, 134.5],
      [251, 115.5],
      [254, 108.5],
      [257, 108.5],
      [260, 132.5],
      [263, 134.5],
      [266, 112.5],
      [269, 119.5],
      [272, 111.5],
      [275, 144.5],
      [278, 133.5],
      [281, 122.5],
      [284, 114.5],
      [287, 114.5],
      [290, 108.5],
      [293, 130.5],
      [296, 115.5],
      [299, 110.5],
      [302, 125.5],
      [305, 133.5],
      [308, 136.5],
      [311, 104.5],
      [314, 125.5],
      [317, 111.5],
      [320, 125.5],
      [323, 113.5],
      [326, 124.5],
      [329, 123.5],
      [332, 118.5],
      [335, 139.5],
      [338, 131.5],
      [341, 117.5],
      [344, 110.5],
      [347, 103.5],
      [350, 135.5],
      [353, 127.5],
      [356, 109.5],
      [359, 117.5],
      [362, 118.5],
      [365, 142.5],
      [368, 89.5],
      [371, 111.5],
      [374, 122.5],
      [377, 131.5],
      [380, 129.5],
      [383, 115.5],
      [386, 118.5],
      [389, 127.5],
      [392, 117.5],
      [395, 138.5],
      [398, 131.5],
      [401, 108.5],
      [404, 101.5],
      [407, 112.5],
      [410, 125.5],
      [413, 122.5],
      [416, 122.5],
      [419, 107.5],
      [422, 119.5],
      [425, 136.5],
      [428, 132.5],
      [431, 118.5],
      [434, 119.5],
      [437, 119.5],
      [440, 124.5],
      [443, 115.5],
      [446, 129.5],
      [449, 118.5],
      [452, 104.5],
      [455, 137.5],
      [458, 125.5],
      [461, 110.5],
      [464, 102.5],
      [467, 102.5],
      [470, 123.5],
      [473, 132.5],
      [476, 113.5],
      [479, 125.5],
      [482, 109.5],
      [485, 119.5],
      [488, 127.5],
      [491, 103.5],
      [494, 110.5],
      [497, 100.5],
      [500, 119.5],
      [503, 117.5],
      [506, 108.5],
      [509, 116.5],
      [512, 99.5],
      [515, 131.5],
      [518, 129.5],
      [521, 104.5],
      [524, 108.5],
      [527, 111.5],
      [530, 107.5],
      [533, 127.5],
      [536, 119.5],
      [539, 120.5],
      [542, 125.5],
      [545, 123.5],
      [548, 115.5],
      [551, 105.5],
      [554, 103.5],
      [557, 117.5],
      [560, 115.5],
      [563, 127.5],
      [566, 124.5],
      [569, 134.5],
      [572, 104.5],
      [575, 139.5],
      [578, 141.5],
      [581, 115.5],
      [584, 107.5],
      [587, 106.5],
      [590, 128.5],
      [593, 119.5],
      [596, 128.5],
      [599, 121.5],
      [602, 128.5],
      [605, 135.5],
      [608, 126.5],
      [611, 100.5],
      [614, 115.5],
      [617, 97.5],
      [620, 132.5],
      [623, 129.5],
      [626, 118.5],
      [629, 135.5],
      [632, 106.5],
      [635, 130.5],
      [638, 137.5],
      [641, 114.5],
      [644, 114.5],
      [647, 107.5],
      [650, 119.5],
      [653, 118.5],
      [656, 109.5],
      [659, 111.5],
      [662, 128.5],
      [665, 117.5],
      [668, 127.5],
      [671, 122.5],
      [674, 106.5],
      [677, 123.5],
      [680, 126.5],
      [683, 112.5],
      [686, 121.5],
      [689, 124.5],
      [692, 117.5],
      [695, 120.5],
      [698, 117.5],
      [701, 120.5],
      [704, 115.5],
      [707, 90.5],
      [710, 107.5],
      [713, 113.5],
      [716, 99.5],
      [719, 109.5],
      [722, 108.5],
      [725, 112.5],
      [728, 129.5],
      [731, 115.5],
      [734, 107.5],
      [737, 104.5],
      [740, 116.5],
      [743, 118.5],
      [746, 125.5],
      [749, 118.5],
      [752, 120.5],
      [755, 123.5],
      [758, 120.5],
      [761, 124.5],
      [764, 106.5],
      [767, 97.5],
      [770, 120.5],
      [773, 121.5],
      [776, 112.5],
      [779, 123.5],
      [782, 117.5],
      [785, 117.5],
      [788, 105.5],
      [791, 102.5],
      [794, 116.5],
      [797, 109.5],
      [800, 121.5],
      [803, 123.5],
      [806, 114.5],
      [809, 126.5],
      [812, 99.5],
      [815, 122.5],
      [818, 136.5],
      [821, 111.5],
      [824, 117.5],
      [827, 115.5],
      [830, 124.5],
      [833, 122.5],
      [836, 120.5],
      [839, 107.5],
      [842, 130.5],
      [845, 128.5],
      [848, 122.5],
      [851, 122.5],
      [854, 109.5],
      [857, 98.5],
      [860, 119.5],
      [863, 131.5],
      [866, 126.5],
      [869, 119.5],
      [872, 105.5],
      [875, 137.5],
      [878, 126.5],
      [881, 132.5],
      [884, 115.5],
      [887, 117.5],
      [890, 127.5],
      [893, 113.5],
      [896, 115.5],
      [899, 118.5],
      [902, 116.5],
      [905, 119.5],
      [908, 122.5],
      [911, 119.5],
      [914, 109.5],
      [917, 112.5],
      [920, 126.5],
      [923, 115.5],
      [926, 125.5],
      [929, 126.5],
      [932, 111.5],
      [935, 119.5],
      [938, 110.5],
      [941, 119.5],
      [944, 115.5],
      [947, 109.5],
      [950, 124.5],
      [953, 113.5],
      [956, 115.5],
      [959, 114.5],
      [962, 109.5],
      [965, 117.5],
      [968, 108.5],
      [971, 111.5],
      [974, 117.5],
      [977, 108.5],
      [980, 129.5],
      [983, 120.5],
      [986, 106.5],
      [989, 114.5],
      [992, 116.5],
      [995, 109.5],
      [998, 110.5],
      [1001, 120.5],
      [1004, 119.5],
      [1007, 108.5],
      [1010, 121.5],
      [1013, 126.5],
      [1016, 126.5],
      [1019, 131.5],
      [1022, 116.5],
      [1025, 128.5],
      [1028, 126.5],
      [1031, 110.5],
      [1034, 107.5],
      [1037, 105.5],
      [1040, 125.5],
      [1043, 114.5],
      [1046, 106.5],
      [1049, 130.5],
      [1052, 103.5],
      [1055, 131.5],
      [1058, 130.5],
      [1061, 106.5],
      [1064, 122.5],
      [1067, 102.5],
      [1070, 122.5],
      [1073, 128.5],
      [1076, 108.5],
      [1079, 123.5],
      [1082, 119.5],
      [1085, 129.5],
      [1088, 123.5],
      [1091, 103.5],
      [1094, 112.5],
      [1097, 102.5],
      [1100, 120.5],
      [1103, 125.5],
      [1106, 113.5],
      [1109, 124.5],
      [1112, 101.5],
      [1115, 127.5],
      [1118, 131.5],
      [1121, 107.5],
      [1124, 113.5],
      [1127, 103.5],
      [1130, 119.5],
      [1133, 134.5],
      [1136, 118.5],
      [1139, 110.5],
      [1142, 116.5],
      [1145, 124.5],
      [1148, 132.5],
      [1151, 104.5],
      [1154, 112.5],
      [1157, 110.5],
      [1160, 123.5],
      [1163, 116.5],
      [1166, 112.5],
      [1169, 120.5],
      [1172, 99.5],
      [1175, 122.5],
      [1178, 137.5],
      [1181, 107.5],
      [1184, 118.5],
      [1187, 97.5],
      [1190, 109.5],
      [1193, 126.5],
      [1196, 124.5],
      [1199, 118.5],
      [1202, 101.5],
      [1205, 118.5],
      [1208, 116.5],
      [1211, 95.5],
      [1214, 105.5],
      [1217, 100.5],
      [1220, 107.5],
      [1223, 115.5],
      [1226, 116.5],
      [1229, 110.5],
      [1232, 112.5],
      [1235, 117.5],
      [1238, 123.5],
      [1241, 113.5],
      [1244, 127.5],
      [1247, 98.5],
      [1250, 105.5],
      [1253, 128.5],
      [1256, 104.5],
      [1259, 107.5],
      [1262, 119.5],
      [1265, 127.5],
      [1268, 124.5],
      [1271, 121.5],
      [1274, 127.5],
      [1277, 120.5],
      [1280, 132.5],
      [1283, 129.5],
      [1286, 117.5],
      [1289, 123.5],
      [1292, 96.5],
      [1295, 119.5],
      [1298, 125.5],
      [1301, 108.5],
      [1304, 120.5],
      [1307, 109.5],
      [1310, 123.5],
      [1313, 127.5],
      [1316, 118.5],
      [1319, 107.5],
      [1322, 119.5],
      [1325, 130.5],
      [1328, 129.5],
      [1331, 103.5],
      [1334, 109.5],
      [1337, 100.5],
      [1340, 117.5],
      [1343, 128.5],
      [1346, 100.5],
      [1349, 121.5],
      [1352, 100.5],
      [1355, 130.5],
      [1358, 126.5],
      [1361, 117.5],
      [1364, 113.5],
      [1367, 112.5],
      [1370, 106.5],
      [1373, 126.5],
      [1376, 102.5],
      [1379, 107.5],
      [1382, 118.5],
      [1385, 122.5],
      [1388, 124.5],
      [1391, 109.5],
      [1394, 115.5],
      [1397, 109.5],
      [1400, 120.5],
      [1403, 120.5],
      [1406, 103.5],
      [1409, 122.5],
      [1412, 91.5],
      [1415, 109.5],
      [1418, 119.5],
      [1421, 108.5],
      [1424, 109.5],
      [1427, 100.5],
      [1430, 137.5],
      [1433, 122.5],
      [1436, 121.5],
      [1439, 101.5],
      [1442, 104.5],
      [1445, 113.5],
      [1448, 117.5],
      [1451, 115.5],
      [1454, 111.5],
      [1457, 105.5],
      [1460, 124.5],
      [1463, 122.5],
      [1466, 112.5],
      [1469, 102.5],
      [1472, 105.5],
      [1475, 115.5],
      [1478, 128.5],
      [1481, 112.5],
      [1484, 121.5],
      [1487, 110.5],
      [1490, 106.5],
      [1493, 121.5],
      [1496, 109.5],
      [1499, 103.5],
      [1502, 100.5],
      [1505, 124.5],
      [1508, 115.5],
      [1511, 120.5],
      [1514, 113.5],
      [1517, 101.5],
      [1520, 111.5],
      [1523, 95.5],
      [1526, 93.5],
      [1529, 86.5],
      [1532, 86.5],
      [1535, 79.5],
      [1538, 76.5],
      [1541, 76.5],
      [1544, 76.5],
      [1547, 75.5],
      [1550, 75.5],
    ],
    bottom: [
      [1548, 75.5],
      [1545, 74.5],
      [1542, 75.5],
      [1539, 74.5],
      [1536, 73.5],
      [1533, 66.5],
      [1530, 59.5],
      [1527, 59.5],
      [1524, 52.5],
      [1521, 33.5],
      [1518, 28.5],
      [1515, 29.5],
      [1512, 42.5],
      [1509, 36.5],
      [1506, 32.5],
      [1503, 35.5],
      [1500, 29.5],
      [1497, 40.5],
      [1494, 47.5],
      [1491, 33.5],
      [1488, 29.5],
      [1485, 30.5],
      [1482, 45.5],
      [1479, 26.5],
      [1476, 45.5],
      [1473, 34.5],
      [1470, 30.5],
      [1467, 38.5],
      [1464, 41.5],
      [1461, 39.5],
      [1458, 32.5],
      [1455, 34.5],
      [1452, 33.5],
      [1449, 43.5],
      [1446, 47.5],
      [1443, 38.5],
      [1440, 33.5],
      [1437, 47.5],
      [1434, 34.5],
      [1431, 34.5],
      [1428, 33.5],
      [1425, 34.5],
      [1422, 45.5],
      [1419, 42.5],
      [1416, 48.5],
      [1413, 35.5],
      [1410, 46.5],
      [1407, 44.5],
      [1404, 48.5],
      [1401, 43.5],
      [1398, 22.5],
      [1395, 25.5],
      [1392, 45.5],
      [1389, 36.5],
      [1386, 40.5],
      [1383, 32.5],
      [1380, 17.5],
      [1377, 47.5],
      [1374, 52.5],
      [1371, 41.5],
      [1368, 41.5],
      [1365, 28.5],
      [1362, 36.5],
      [1359, 35.5],
      [1356, 28.5],
      [1353, 25.5],
      [1350, 38.5],
      [1347, 51.5],
      [1344, 39.5],
      [1341, 42.5],
      [1338, 22.5],
      [1335, 22.5],
      [1332, 48.5],
      [1329, 10.5],
      [1326, 44.5],
      [1323, 26.5],
      [1320, 22.5],
      [1317, 50.5],
      [1314, 39.5],
      [1311, 43.5],
      [1308, 28.5],
      [1305, 25.5],
      [1302, 40.5],
      [1299, 40.5],
      [1296, 37.5],
      [1293, 27.5],
      [1290, 43.5],
      [1287, 56.5],
      [1284, 38.5],
      [1281, 34.5],
      [1278, 14.5],
      [1275, 22.5],
      [1272, 41.5],
      [1269, 23.5],
      [1266, 39.5],
      [1263, 24.5],
      [1260, 26.5],
      [1257, 44.5],
      [1254, 41.5],
      [1251, 50.5],
      [1248, 25.5],
      [1245, 22.5],
      [1242, 26.5],
      [1239, 38.5],
      [1236, 46.5],
      [1233, 37.5],
      [1230, 15.5],
      [1227, 49.5],
      [1224, 29.5],
      [1221, 48.5],
      [1218, 28.5],
      [1215, 31.5],
      [1212, 58.5],
      [1209, 34.5],
      [1206, 54.5],
      [1203, 38.5],
      [1200, 37.5],
      [1197, 46.5],
      [1194, 41.5],
      [1191, 48.5],
      [1188, 45.5],
      [1185, 21.5],
      [1182, 40.5],
      [1179, 36.5],
      [1176, 45.5],
      [1173, 35.5],
      [1170, 47.5],
      [1167, 50.5],
      [1164, 32.5],
      [1161, 35.5],
      [1158, 31.5],
      [1155, 22.5],
      [1152, 51.5],
      [1149, 35.5],
      [1146, 32.5],
      [1143, 29.5],
      [1140, 25.5],
      [1137, 50.5],
      [1134, 40.5],
      [1131, 53.5],
      [1128, 25.5],
      [1125, 22.5],
      [1122, 46.5],
      [1119, 32.5],
      [1116, 38.5],
      [1113, 27.5],
      [1110, 23.5],
      [1107, 52.5],
      [1104, 35.5],
      [1101, 42.5],
      [1098, 26.5],
      [1095, 24.5],
      [1092, 49.5],
      [1089, 24.5],
      [1086, 33.5],
      [1083, 22.5],
      [1080, 18.5],
      [1077, 42.5],
      [1074, 38.5],
      [1071, 57.5],
      [1068, 26.5],
      [1065, 27.5],
      [1062, 32.5],
      [1059, 32.5],
      [1056, 36.5],
      [1053, 20.5],
      [1050, 47.5],
      [1047, 58.5],
      [1044, 45.5],
      [1041, 46.5],
      [1038, 28.5],
      [1035, 26.5],
      [1032, 31.5],
      [1029, 16.5],
      [1026, 33.5],
      [1023, 21.5],
      [1020, 22.5],
      [1017, 34.5],
      [1014, 21.5],
      [1011, 31.5],
      [1008, 38.5],
      [1005, 20.5],
      [1002, 33.5],
      [999, 44.5],
      [996, 35.5],
      [993, 41.5],
      [990, 23.5],
      [987, 35.5],
      [984, 22.5],
      [981, 40.5],
      [978, 26.5],
      [975, 36.5],
      [972, 36.5],
      [969, 29.5],
      [966, 36.5],
      [963, 41.5],
      [960, 20.5],
      [957, 37.5],
      [954, 33.5],
      [951, 43.5],
      [948, 35.5],
      [945, 33.5],
      [942, 42.5],
      [939, 31.5],
      [936, 33.5],
      [933, 29.5],
      [930, 24.5],
      [927, 31.5],
      [924, 33.5],
      [921, 29.5],
      [918, 45.5],
      [915, 33.5],
      [912, 28.5],
      [909, 35.5],
      [906, 34.5],
      [903, 32.5],
      [900, 24.5],
      [897, 40.5],
      [894, 32.5],
      [891, 40.5],
      [888, 42.5],
      [885, 34.5],
      [882, 20.5],
      [879, 36.5],
      [876, 12.5],
      [873, 32.5],
      [870, 24.5],
      [867, 36.5],
      [864, 26.5],
      [861, 40.5],
      [858, 38.5],
      [855, 21.5],
      [852, 39.5],
      [849, 22.5],
      [846, 34.5],
      [843, 27.5],
      [840, 17.5],
      [837, 47.5],
      [834, 40.5],
      [831, 52.5],
      [828, 16.5],
      [825, 35.5],
      [822, 28.5],
      [819, 37.5],
      [816, 29.5],
      [813, 17.5],
      [810, 42.5],
      [807, 49.5],
      [804, 30.5],
      [801, 46.5],
      [798, 28.5],
      [795, 31.5],
      [792, 57.5],
      [789, 33.5],
      [786, 27.5],
      [783, 21.5],
      [780, 24.5],
      [777, 34.5],
      [774, 32.5],
      [771, 53.5],
      [768, 51.5],
      [765, 25.5],
      [762, 39.5],
      [759, 29.5],
      [756, 27.5],
      [753, 31.5],
      [750, 22.5],
      [747, 40.5],
      [744, 37.5],
      [741, 33.5],
      [738, 57.5],
      [735, 45.5],
      [732, 36.5],
      [729, 46.5],
      [726, 22.5],
      [723, 26.5],
      [720, 40.5],
      [717, 52.5],
      [714, 41.5],
      [711, 53.5],
      [708, 40.5],
      [705, 44.5],
      [702, 40.5],
      [699, 35.5],
      [696, 37.5],
      [693, 30.5],
      [690, 28.5],
      [687, 37.5],
      [684, 35.5],
      [681, 36.5],
      [678, 37.5],
      [675, 35.5],
      [672, 35.5],
      [669, 34.5],
      [666, 21.5],
      [663, 28.5],
      [660, 28.5],
      [657, 38.5],
      [654, 39.5],
      [651, 46.5],
      [648, 32.5],
      [645, 38.5],
      [642, 49.5],
      [639, 21.5],
      [636, 20.5],
      [633, 22.5],
      [630, 28.5],
      [627, 41.5],
      [624, 34.5],
      [621, 39.5],
      [618, 30.5],
      [615, 22.5],
      [612, 56.5],
      [609, 20.5],
      [606, 38.5],
      [603, 17.5],
      [600, 17.5],
      [597, 40.5],
      [594, 42.5],
      [591, 51.5],
      [588, 34.5],
      [585, 30.5],
      [582, 33.5],
      [579, 31.5],
      [576, 32.5],
      [573, 21.5],
      [570, 35.5],
      [567, 46.5],
      [564, 40.5],
      [561, 40.5],
      [558, 25.5],
      [555, 31.5],
      [552, 59.5],
      [549, 18.5],
      [546, 33.5],
      [543, 12.5],
      [540, 26.5],
      [537, 43.5],
      [534, 50.5],
      [531, 55.5],
      [528, 24.5],
      [525, 22.5],
      [522, 37.5],
      [519, 36.5],
      [516, 32.5],
      [513, 16.5],
      [510, 30.5],
      [507, 49.5],
      [504, 37.5],
      [501, 40.5],
      [498, 27.5],
      [495, 32.5],
      [492, 54.5],
      [489, 18.5],
      [486, 46.5],
      [483, 31.5],
      [480, 29.5],
      [477, 22.5],
      [474, 41.5],
      [471, 37.5],
      [468, 28.5],
      [465, 28.5],
      [462, 38.5],
      [459, 36.5],
      [456, 29.5],
      [453, 26.5],
      [450, 9.5],
      [447, 20.5],
      [444, 40.5],
      [441, 37.5],
      [438, 20.5],
      [435, 24.5],
      [432, 20.5],
      [429, 37.5],
      [426, 6.125],
      [423, 33.5],
      [420, 17.5],
      [417, 32.5],
      [414, 31.5],
      [411, 25.5],
      [408, 35.5],
      [405, 26.5],
      [402, 38.5],
      [399, 19.5],
      [396, 23.5],
      [393, 9.5],
      [390, 8.5],
      [387, 27.5],
      [384, 26.5],
      [381, 36.5],
      [378, 14.5],
      [375, 10.5],
      [372, 26.5],
      [369, 44.5],
      [366, 35.5],
      [363, 44.5],
      [360, 8.5],
      [357, 33.5],
      [354, 25.5],
      [351, 40.5],
      [348, 22.5],
      [345, 19.5],
      [342, 31.5],
      [339, 30.5],
      [336, 22.5],
      [333, 13.5],
      [330, 14.5],
      [327, 33.5],
      [324, 44.5],
      [321, 31.5],
      [318, 16.5],
      [315, 18.5],
      [312, 52.5],
      [309, 22.5],
      [306, 37.5],
      [303, 9.5],
      [300, 12.5],
      [297, 49.5],
      [294, 35.5],
      [291, 46.5],
      [288, 12.5],
      [285, 30.5],
      [282, 26.5],
      [279, 37.5],
      [276, 33.5],
      [273, 28.5],
      [270, 10.5],
      [267, 44.5],
      [264, 35.5],
      [261, 35.5],
      [258, 18.5],
      [255, 20.5],
      [252, 46.5],
      [249, 20.5],
      [246, 34.5],
      [243, 30.5],
      [240, 17.5],
      [237, 24.5],
      [234, 34.5],
      [231, 40.5],
      [228, 23.5],
      [225, 6.5],
      [222, 24.5],
      [219, 36.5],
      [216, 43.5],
      [213, 10.5],
      [210, 35.5],
      [207, 49.5],
      [204, 26.5],
      [201, 21.5],
      [198, 15.5],
      [195, 16.5],
      [192, 31.5],
      [189, 42.5],
      [186, 38.5],
      [183, 9.5],
      [180, 7.301600000000008],
      [177, 40.5],
      [174, 22.5],
      [171, 45.5],
      [168, 26.5],
      [165, 16.5],
      [162, 31.5],
      [159, 31.5],
      [156, 27.5],
      [153, 23.5],
      [150, 5.7623999999999995],
      [147, 27.5],
      [144, 17.5],
      [141, 34.5],
      [138, 28.5],
      [135, 10.5],
      [132, 57.5],
      [129, 32.5],
      [126, 5.5],
      [123, 30.5],
      [120, 19.5],
      [117, 44.5],
      [114, 41.5],
      [111, 47.5],
      [108, 57.5],
      [105, 24.5],
      [102, 27.5],
      [99, 33.5],
      [96, 34.5],
      [93, 17.5],
      [90, 21.5],
      [87, 35.5],
      [84, 38.5],
      [81, 20.5],
      [78, 32.5],
      [75, 7.5],
      [72, 57.5],
      [69, 22.5],
      [66, 29.5],
      [63, 34.5],
      [60, 6.5],
      [57, 23.5],
      [54, 35.5],
      [51, 46.5],
      [48, 60.5],
      [45, 27.5],
      [42, 26.5],
      [39, 29.5],
      [36, 27.5],
      [33, 20.5],
      [30, 19.5],
      [27, 36.5],
      [24, 15.5],
      [21, 32.5],
      [18, 6.5],
      [15, 8.5],
      [12, 45.5],
      [9, 3.897599999999997],
      [6, 14.5],
      [3, 21.5],
      [0, 42.5],
    ],
  },
  {
    top: [
      [2, 128.5],
      [5, 133.5],
      [8, 101.5],
      [11, 106.5],
      [14, 129.5],
      [17, 111.5],
      [20, 138.5],
      [23, 117.5],
      [26, 142.5],
      [29, 143.6984],
      [32, 105.5],
      [35, 130.5],
      [38, 143.2766],
      [41, 119.5],
      [44, 143.6984],
      [47, 108.5],
      [50, 133.5],
      [53, 135.5],
      [56, 144.1054],
      [59, 134.5],
      [62, 138.5],
      [65, 134.5],
      [68, 109.5],
      [71, 116.5],
      [74, 130.5],
      [77, 129.5],
      [80, 128.5],
      [83, 117.5],
      [86, 139.5],
      [89, 143.5],
      [92, 110.5],
      [95, 135.5],
      [98, 124.5],
      [101, 124.5],
      [104, 128.5],
      [107, 116.5],
      [110, 120.5],
      [113, 140.5],
      [116, 130.5],
      [119, 137.5],
      [122, 129.5],
      [125, 134.5],
      [128, 100.5],
      [131, 109.5],
      [134, 123.5],
      [137, 107.5],
      [140, 134.5],
      [143, 123.5],
      [146, 134.5],
      [149, 144.1054],
      [152, 112.5],
      [155, 119.5],
      [158, 130.5],
      [161, 120.5],
      [164, 134.5],
      [167, 98.5],
      [170, 127.5],
      [173, 140.5],
      [176, 128.5],
      [179, 138.5],
      [182, 120.5],
      [185, 125.5],
      [188, 143.5],
      [191, 109.5],
      [194, 110.5],
      [197, 99.5],
      [200, 140.5],
      [203, 118.5],
      [206, 121.5],
      [209, 140.5],
      [212, 105.5],
      [215, 124.5],
      [218, 134.5],
      [221, 114.5],
      [224, 132.5],
      [227, 129.5],
      [230, 128.5],
      [233, 137.5],
      [236, 112.5],
      [239, 123.5],
      [242, 134.5],
      [245, 125.5],
      [248, 135.5],
      [251, 115.5],
      [254, 106.5],
      [257, 107.5],
      [260, 131.5],
      [263, 136.5],
      [266, 114.5],
      [269, 119.5],
      [272, 109.5],
      [275, 142.5],
      [278, 134.5],
      [281, 120.5],
      [284, 112.5],
      [287, 114.5],
      [290, 110.5],
      [293, 137.5],
      [296, 118.5],
      [299, 110.5],
      [302, 123.5],
      [305, 130.5],
      [308, 135.5],
      [311, 105.5],
      [314, 123.5],
      [317, 110.5],
      [320, 128.5],
      [323, 116.5],
      [326, 125.5],
      [329, 122.5],
      [332, 116.5],
      [335, 134.5],
      [338, 130.5],
      [341, 120.5],
      [344, 107.5],
      [347, 103.5],
      [350, 137.5],
      [353, 130.5],
      [356, 112.5],
      [359, 116.5],
      [362, 115.5],
      [365, 137.5],
      [368, 90.5],
      [371, 112.5],
      [374, 121.5],
      [377, 131.5],
      [380, 132.5],
      [383, 119.5],
      [386, 123.5],
      [389, 125.5],
      [392, 115.5],
      [395, 134.5],
      [398, 128.5],
      [401, 106.5],
      [404, 100.5],
      [407, 112.5],
      [410, 128.5],
      [413, 124.5],
      [416, 124.5],
      [419, 108.5],
      [422, 116.5],
      [425, 134.5],
      [428, 131.5],
      [431, 116.5],
      [434, 119.5],
      [437, 118.5],
      [440, 129.5],
      [443, 119.5],
      [446, 132.5],
      [449, 117.5],
      [452, 102.5],
      [455, 130.5],
      [458, 121.5],
      [461, 108.5],
      [464, 100.5],
      [467, 103.5],
      [470, 122.5],
      [473, 129.5],
      [476, 113.5],
      [479, 125.5],
      [482, 108.5],
      [485, 117.5],
      [488, 126.5],
      [491, 103.5],
      [494, 108.5],
      [497, 101.5],
      [500, 125.5],
      [503, 120.5],
      [506, 110.5],
      [509, 115.5],
      [512, 97.5],
      [515, 126.5],
      [518, 124.5],
      [521, 104.5],
      [524, 111.5],
      [527, 112.5],
      [530, 114.5],
      [533, 139.5],
      [536, 120.5],
      [539, 120.5],
      [542, 121.5],
      [545, 119.5],
      [548, 111.5],
      [551, 102.5],
      [554, 107.5],
      [557, 125.5],
      [560, 128.5],
      [563, 136.5],
      [566, 123.5],
      [569, 133.5],
      [572, 103.5],
      [575, 136.5],
      [578, 142.5],
      [581, 115.5],
      [584, 110.5],
      [587, 112.5],
      [590, 135.5],
      [593, 129.5],
      [596, 128.5],
      [599, 120.5],
      [602, 126.5],
      [605, 129.5],
      [608, 121.5],
      [611, 100.5],
      [614, 117.5],
      [617, 101.5],
      [620, 137.5],
      [623, 138.5],
      [626, 118.5],
      [629, 136.5],
      [632, 104.5],
      [635, 125.5],
      [638, 130.5],
      [641, 114.5],
      [644, 118.5],
      [647, 109.5],
      [650, 126.5],
      [653, 122.5],
      [656, 107.5],
      [659, 111.5],
      [662, 125.5],
      [665, 114.5],
      [668, 121.5],
      [671, 119.5],
      [674, 110.5],
      [677, 122.5],
      [680, 128.5],
      [683, 114.5],
      [686, 120.5],
      [689, 122.5],
      [692, 114.5],
      [695, 116.5],
      [698, 112.5],
      [701, 115.5],
      [704, 111.5],
      [707, 89.5],
      [710, 104.5],
      [713, 111.5],
      [716, 97.5],
      [719, 106.5],
      [722, 106.5],
      [725, 112.5],
      [728, 129.5],
      [731, 114.5],
      [734, 108.5],
      [737, 109.5],
      [740, 119.5],
      [743, 119.5],
      [746, 122.5],
      [749, 114.5],
      [752, 117.5],
      [755, 118.5],
      [758, 117.5],
      [761, 123.5],
      [764, 110.5],
      [767, 98.5],
      [770, 127.5],
      [773, 125.5],
      [776, 112.5],
      [779, 121.5],
      [782, 115.5],
      [785, 113.5],
      [788, 103.5],
      [791, 101.5],
      [794, 120.5],
      [797, 113.5],
      [800, 128.5],
      [803, 133.5],
      [806, 113.5],
      [809, 125.5],
      [812, 97.5],
      [815, 119.5],
      [818, 133.5],
      [821, 109.5],
      [824, 121.5],
      [827, 116.5],
      [830, 129.5],
      [833, 126.5],
      [836, 119.5],
      [839, 106.5],
      [842, 127.5],
      [845, 124.5],
      [848, 119.5],
      [851, 120.5],
      [854, 110.5],
      [857, 102.5],
      [860, 128.5],
      [863, 134.5],
      [866, 123.5],
      [869, 118.5],
      [872, 103.5],
      [875, 132.5],
      [878, 126.5],
      [881, 130.5],
      [884, 118.5],
      [887, 120.5],
      [890, 129.5],
      [893, 114.5],
      [896, 115.5],
      [899, 118.5],
      [902, 115.5],
      [905, 116.5],
      [908, 118.5],
      [911, 116.5],
      [914, 109.5],
      [917, 116.5],
      [920, 127.5],
      [923, 114.5],
      [926, 123.5],
      [929, 127.5],
      [932, 108.5],
      [935, 114.5],
      [938, 106.5],
      [941, 114.5],
      [944, 111.5],
      [947, 104.5],
      [950, 119.5],
      [953, 109.5],
      [956, 110.5],
      [959, 109.5],
      [962, 107.5],
      [965, 116.5],
      [968, 107.5],
      [971, 109.5],
      [974, 118.5],
      [977, 108.5],
      [980, 132.5],
      [983, 117.5],
      [986, 105.5],
      [989, 112.5],
      [992, 115.5],
      [995, 108.5],
      [998, 110.5],
      [1001, 120.5],
      [1004, 117.5],
      [1007, 111.5],
      [1010, 129.5],
      [1013, 126.5],
      [1016, 125.5],
      [1019, 128.5],
      [1022, 115.5],
      [1025, 127.5],
      [1028, 126.5],
      [1031, 110.5],
      [1034, 108.5],
      [1037, 107.5],
      [1040, 132.5],
      [1043, 112.5],
      [1046, 107.5],
      [1049, 128.5],
      [1052, 102.5],
      [1055, 129.5],
      [1058, 129.5],
      [1061, 105.5],
      [1064, 122.5],
      [1067, 105.5],
      [1070, 130.5],
      [1073, 126.5],
      [1076, 108.5],
      [1079, 123.5],
      [1082, 120.5],
      [1085, 127.5],
      [1088, 122.5],
      [1091, 103.5],
      [1094, 112.5],
      [1097, 104.5],
      [1100, 122.5],
      [1103, 124.5],
      [1106, 113.5],
      [1109, 123.5],
      [1112, 101.5],
      [1115, 128.5],
      [1118, 129.5],
      [1121, 108.5],
      [1124, 113.5],
      [1127, 103.5],
      [1130, 119.5],
      [1133, 131.5],
      [1136, 117.5],
      [1139, 109.5],
      [1142, 115.5],
      [1145, 121.5],
      [1148, 128.5],
      [1151, 102.5],
      [1154, 111.5],
      [1157, 109.5],
      [1160, 123.5],
      [1163, 114.5],
      [1166, 113.5],
      [1169, 115.5],
      [1172, 97.5],
      [1175, 118.5],
      [1178, 136.5],
      [1181, 106.5],
      [1184, 112.5],
      [1187, 94.5],
      [1190, 106.5],
      [1193, 120.5],
      [1196, 120.5],
      [1199, 117.5],
      [1202, 100.5],
      [1205, 121.5],
      [1208, 117.5],
      [1211, 97.5],
      [1214, 108.5],
      [1217, 101.5],
      [1220, 109.5],
      [1223, 113.5],
      [1226, 113.5],
      [1229, 110.5],
      [1232, 113.5],
      [1235, 121.5],
      [1238, 123.5],
      [1241, 112.5],
      [1244, 126.5],
      [1247, 98.5],
      [1250, 107.5],
      [1253, 127.5],
      [1256, 104.5],
      [1259, 105.5],
      [1262, 120.5],
      [1265, 130.5],
      [1268, 123.5],
      [1271, 123.5],
      [1274, 125.5],
      [1277, 119.5],
      [1280, 132.5],
      [1283, 126.5],
      [1286, 120.5],
      [1289, 125.5],
      [1292, 97.5],
      [1295, 121.5],
      [1298, 124.5],
      [1301, 108.5],
      [1304, 121.5],
      [1307, 109.5],
      [1310, 125.5],
      [1313, 125.5],
      [1316, 119.5],
      [1319, 107.5],
      [1322, 119.5],
      [1325, 129.5],
      [1328, 128.5],
      [1331, 104.5],
      [1334, 110.5],
      [1337, 100.5],
      [1340, 116.5],
      [1343, 126.5],
      [1346, 101.5],
      [1349, 122.5],
      [1352, 100.5],
      [1355, 129.5],
      [1358, 125.5],
      [1361, 116.5],
      [1364, 115.5],
      [1367, 110.5],
      [1370, 104.5],
      [1373, 125.5],
      [1376, 104.5],
      [1379, 107.5],
      [1382, 119.5],
      [1385, 120.5],
      [1388, 123.5],
      [1391, 107.5],
      [1394, 114.5],
      [1397, 106.5],
      [1400, 118.5],
      [1403, 117.5],
      [1406, 102.5],
      [1409, 118.5],
      [1412, 90.5],
      [1415, 108.5],
      [1418, 114.5],
      [1421, 106.5],
      [1424, 106.5],
      [1427, 99.5],
      [1430, 137.5],
      [1433, 122.5],
      [1436, 117.5],
      [1439, 103.5],
      [1442, 109.5],
      [1445, 116.5],
      [1448, 118.5],
      [1451, 112.5],
      [1454, 109.5],
      [1457, 108.5],
      [1460, 121.5],
      [1463, 118.5],
      [1466, 110.5],
      [1469, 104.5],
      [1472, 106.5],
      [1475, 114.5],
      [1478, 129.5],
      [1481, 112.5],
      [1484, 120.5],
      [1487, 113.5],
      [1490, 106.5],
      [1493, 118.5],
      [1496, 108.5],
      [1499, 105.5],
      [1502, 101.5],
      [1505, 122.5],
      [1508, 117.5],
      [1511, 122.5],
      [1514, 113.5],
      [1517, 103.5],
      [1520, 111.5],
      [1523, 94.5],
      [1526, 93.5],
      [1529, 86.5],
      [1532, 86.5],
      [1535, 79.5],
      [1538, 76.5],
      [1541, 76.5],
      [1544, 76.5],
      [1547, 75.5],
      [1550, 75.5],
    ],
    bottom: [
      [1548, 75.5],
      [1545, 74.5],
      [1542, 74.5],
      [1539, 74.5],
      [1536, 73.5],
      [1533, 66.5],
      [1530, 59.5],
      [1527, 59.5],
      [1524, 52.5],
      [1521, 35.5],
      [1518, 29.5],
      [1515, 29.5],
      [1512, 37.5],
      [1509, 35.5],
      [1506, 32.5],
      [1503, 35.5],
      [1500, 27.5],
      [1497, 39.5],
      [1494, 48.5],
      [1491, 33.5],
      [1488, 29.5],
      [1485, 29.5],
      [1482, 43.5],
      [1479, 25.5],
      [1476, 43.5],
      [1473, 32.5],
      [1470, 29.5],
      [1467, 39.5],
      [1464, 44.5],
      [1461, 40.5],
      [1458, 29.5],
      [1455, 33.5],
      [1452, 35.5],
      [1449, 43.5],
      [1446, 47.5],
      [1443, 30.5],
      [1440, 29.5],
      [1437, 48.5],
      [1434, 36.5],
      [1431, 34.5],
      [1428, 32.5],
      [1425, 35.5],
      [1422, 49.5],
      [1419, 44.5],
      [1416, 48.5],
      [1413, 37.5],
      [1410, 49.5],
      [1407, 47.5],
      [1404, 49.5],
      [1401, 46.5],
      [1398, 27.5],
      [1395, 27.5],
      [1392, 47.5],
      [1389, 38.5],
      [1386, 40.5],
      [1383, 31.5],
      [1380, 16.5],
      [1377, 47.5],
      [1374, 51.5],
      [1371, 42.5],
      [1368, 43.5],
      [1365, 28.5],
      [1362, 37.5],
      [1359, 36.5],
      [1356, 28.5],
      [1353, 24.5],
      [1350, 37.5],
      [1347, 52.5],
      [1344, 39.5],
      [1341, 42.5],
      [1338, 22.5],
      [1335, 23.5],
      [1332, 49.5],
      [1329, 11.5],
      [1326, 45.5],
      [1323, 27.5],
      [1320, 23.5],
      [1317, 50.5],
      [1314, 38.5],
      [1311, 43.5],
      [1308, 26.5],
      [1305, 25.5],
      [1302, 39.5],
      [1299, 40.5],
      [1296, 37.5],
      [1293, 27.5],
      [1290, 41.5],
      [1287, 55.5],
      [1284, 39.5],
      [1281, 34.5],
      [1278, 14.5],
      [1275, 23.5],
      [1272, 40.5],
      [1269, 23.5],
      [1266, 39.5],
      [1263, 24.5],
      [1260, 28.5],
      [1257, 44.5],
      [1254, 41.5],
      [1251, 51.5],
      [1248, 24.5],
      [1245, 23.5],
      [1242, 27.5],
      [1239, 38.5],
      [1236, 43.5],
      [1233, 37.5],
      [1230, 16.5],
      [1227, 49.5],
      [1224, 31.5],
      [1221, 46.5],
      [1218, 25.5],
      [1215, 29.5],
      [1212, 56.5],
      [1209, 32.5],
      [1206, 51.5],
      [1203, 38.5],
      [1200, 38.5],
      [1197, 48.5],
      [1194, 43.5],
      [1191, 52.5],
      [1188, 46.5],
      [1185, 29.5],
      [1182, 43.5],
      [1179, 36.5],
      [1176, 48.5],
      [1173, 38.5],
      [1170, 50.5],
      [1167, 50.5],
      [1164, 34.5],
      [1161, 35.5],
      [1158, 29.5],
      [1155, 24.5],
      [1152, 52.5],
      [1149, 37.5],
      [1146, 35.5],
      [1143, 32.5],
      [1140, 26.5],
      [1137, 51.5],
      [1134, 43.5],
      [1131, 52.5],
      [1128, 25.5],
      [1125, 22.5],
      [1122, 45.5],
      [1119, 33.5],
      [1116, 40.5],
      [1113, 28.5],
      [1110, 22.5],
      [1107, 52.5],
      [1104, 36.5],
      [1101, 40.5],
      [1098, 21.5],
      [1095, 22.5],
      [1092, 50.5],
      [1089, 26.5],
      [1086, 35.5],
      [1083, 23.5],
      [1080, 17.5],
      [1077, 43.5],
      [1074, 39.5],
      [1071, 52.5],
      [1068, 22.5],
      [1065, 23.5],
      [1062, 34.5],
      [1059, 32.5],
      [1056, 38.5],
      [1053, 22.5],
      [1050, 48.5],
      [1047, 58.5],
      [1044, 46.5],
      [1041, 44.5],
      [1038, 21.5],
      [1035, 23.5],
      [1032, 32.5],
      [1029, 16.5],
      [1026, 35.5],
      [1023, 23.5],
      [1020, 24.5],
      [1017, 36.5],
      [1014, 24.5],
      [1011, 25.5],
      [1008, 32.5],
      [1005, 20.5],
      [1002, 33.5],
      [999, 42.5],
      [996, 36.5],
      [993, 41.5],
      [990, 26.5],
      [987, 36.5],
      [984, 26.5],
      [981, 38.5],
      [978, 27.5],
      [975, 35.5],
      [972, 39.5],
      [969, 27.5],
      [966, 38.5],
      [963, 41.5],
      [960, 25.5],
      [957, 42.5],
      [954, 36.5],
      [951, 47.5],
      [948, 40.5],
      [945, 38.5],
      [942, 46.5],
      [939, 35.5],
      [936, 38.5],
      [933, 33.5],
      [930, 23.5],
      [927, 31.5],
      [924, 34.5],
      [921, 28.5],
      [918, 44.5],
      [915, 33.5],
      [912, 31.5],
      [909, 37.5],
      [906, 37.5],
      [903, 34.5],
      [900, 25.5],
      [897, 39.5],
      [894, 33.5],
      [891, 37.5],
      [888, 38.5],
      [885, 27.5],
      [882, 22.5],
      [879, 37.5],
      [876, 17.5],
      [873, 34.5],
      [870, 26.5],
      [867, 35.5],
      [864, 26.5],
      [861, 38.5],
      [858, 33.5],
      [855, 17.5],
      [852, 39.5],
      [849, 25.5],
      [846, 37.5],
      [843, 31.5],
      [840, 18.5],
      [837, 47.5],
      [834, 39.5],
      [831, 51.5],
      [828, 14.5],
      [825, 30.5],
      [822, 29.5],
      [819, 40.5],
      [816, 33.5],
      [813, 20.5],
      [810, 43.5],
      [807, 50.5],
      [804, 27.5],
      [801, 41.5],
      [798, 21.5],
      [795, 27.5],
      [792, 56.5],
      [789, 36.5],
      [786, 30.5],
      [783, 25.5],
      [780, 25.5],
      [777, 34.5],
      [774, 29.5],
      [771, 50.5],
      [768, 49.5],
      [765, 20.5],
      [762, 36.5],
      [759, 33.5],
      [756, 31.5],
      [753, 35.5],
      [750, 27.5],
      [747, 43.5],
      [744, 36.5],
      [741, 31.5],
      [738, 52.5],
      [735, 44.5],
      [732, 37.5],
      [729, 46.5],
      [726, 22.5],
      [723, 31.5],
      [720, 40.5],
      [717, 55.5],
      [714, 44.5],
      [711, 55.5],
      [708, 45.5],
      [705, 47.5],
      [702, 44.5],
      [699, 40.5],
      [696, 40.5],
      [693, 33.5],
      [690, 30.5],
      [687, 37.5],
      [684, 34.5],
      [681, 34.5],
      [678, 38.5],
      [675, 33.5],
      [672, 36.5],
      [669, 37.5],
      [666, 26.5],
      [663, 31.5],
      [660, 29.5],
      [657, 39.5],
      [654, 36.5],
      [651, 41.5],
      [648, 29.5],
      [645, 36.5],
      [642, 49.5],
      [639, 28.5],
      [636, 25.5],
      [633, 25.5],
      [630, 28.5],
      [627, 41.5],
      [624, 27.5],
      [621, 34.5],
      [618, 23.5],
      [615, 18.5],
      [612, 55.5],
      [609, 26.5],
      [606, 42.5],
      [603, 21.5],
      [600, 19.5],
      [597, 40.5],
      [594, 36.5],
      [591, 46.5],
      [588, 29.5],
      [585, 23.5],
      [582, 34.5],
      [579, 33.5],
      [576, 32.5],
      [573, 25.5],
      [570, 36.5],
      [567, 47.5],
      [564, 35.5],
      [561, 31.5],
      [558, 17.5],
      [555, 21.5],
      [552, 59.5],
      [549, 24.5],
      [546, 37.5],
      [543, 18.5],
      [540, 26.5],
      [537, 43.5],
      [534, 45.5],
      [531, 51.5],
      [528, 23.5],
      [525, 23.5],
      [522, 38.5],
      [519, 38.5],
      [516, 36.5],
      [513, 21.5],
      [510, 31.5],
      [507, 50.5],
      [504, 35.5],
      [501, 36.5],
      [498, 25.5],
      [495, 35.5],
      [492, 54.5],
      [489, 19.5],
      [486, 46.5],
      [483, 32.5],
      [480, 28.5],
      [477, 22.5],
      [474, 40.5],
      [471, 37.5],
      [468, 31.5],
      [465, 29.5],
      [462, 40.5],
      [459, 40.5],
      [456, 34.5],
      [453, 29.5],
      [450, 14.5],
      [447, 20.5],
      [444, 38.5],
      [441, 33.5],
      [438, 18.5],
      [435, 25.5],
      [432, 22.5],
      [429, 37.5],
      [426, 6.502399999999994],
      [423, 36.5],
      [420, 18.5],
      [417, 33.5],
      [414, 29.5],
      [411, 23.5],
      [408, 35.5],
      [405, 29.5],
      [402, 39.5],
      [399, 22.5],
      [396, 27.5],
      [393, 13.5],
      [390, 10.5],
      [387, 25.5],
      [384, 23.5],
      [381, 33.5],
      [378, 11.5],
      [375, 10.5],
      [372, 28.5],
      [369, 44.5],
      [366, 37.5],
      [363, 46.5],
      [360, 8.5],
      [357, 32.5],
      [354, 19.5],
      [351, 38.5],
      [348, 18.5],
      [345, 21.5],
      [342, 31.5],
      [339, 30.5],
      [336, 25.5],
      [333, 18.5],
      [330, 16.5],
      [327, 31.5],
      [324, 41.5],
      [321, 29.5],
      [318, 16.5],
      [315, 20.5],
      [312, 52.5],
      [309, 22.5],
      [306, 37.5],
      [303, 16.5],
      [300, 12.5],
      [297, 47.5],
      [294, 30.5],
      [291, 43.5],
      [288, 13.5],
      [285, 32.5],
      [282, 28.5],
      [279, 37.5],
      [276, 33.5],
      [273, 31.5],
      [270, 10.5],
      [267, 43.5],
      [264, 33.5],
      [261, 36.5],
      [258, 19.5],
      [255, 21.5],
      [252, 47.5],
      [249, 20.5],
      [246, 36.5],
      [243, 29.5],
      [240, 17.5],
      [237, 23.5],
      [234, 34.5],
      [231, 41.5],
      [228, 24.5],
      [225, 5.5],
      [222, 23.5],
      [219, 38.5],
      [216, 42.5],
      [213, 10.5],
      [210, 34.5],
      [207, 48.5],
      [204, 23.5],
      [201, 22.5],
      [198, 16.5],
      [195, 16.5],
      [192, 30.5],
      [189, 42.5],
      [186, 39.5],
      [183, 13.5],
      [180, 7.723399999999998],
      [177, 40.5],
      [174, 22.5],
      [171, 43.5],
      [168, 26.5],
      [165, 16.5],
      [162, 32.5],
      [159, 32.5],
      [156, 29.5],
      [153, 28.5],
      [150, 6.502399999999994],
      [147, 22.5],
      [144, 18.5],
      [141, 36.5],
      [138, 31.5],
      [135, 11.5],
      [132, 56.5],
      [129, 31.5],
      [126, 6.5],
      [123, 32.5],
      [120, 22.5],
      [117, 39.5],
      [114, 41.5],
      [111, 47.5],
      [108, 57.5],
      [105, 24.5],
      [102, 26.5],
      [99, 34.5],
      [96, 35.5],
      [93, 19.5],
      [90, 23.5],
      [87, 33.5],
      [84, 39.5],
      [81, 20.5],
      [78, 29.5],
      [75, 7.5],
      [72, 57.5],
      [69, 23.5],
      [66, 24.5],
      [63, 34.5],
      [60, 6.5],
      [57, 26.5],
      [54, 33.5],
      [51, 46.5],
      [48, 60.5],
      [45, 27.5],
      [42, 27.5],
      [39, 28.5],
      [36, 27.5],
      [33, 20.5],
      [30, 17.5],
      [27, 36.5],
      [24, 15.5],
      [21, 33.5],
      [18, 7.5],
      [15, 9.5],
      [12, 45.5],
      [9, 3.897599999999997],
      [6, 14.5],
      [3, 23.5],
      [0, 44.5],
    ],
  },
  {
    top: [
      [2, 126.5],
      [5, 133.5],
      [8, 101.5],
      [11, 106.5],
      [14, 129.5],
      [17, 112.5],
      [20, 138.5],
      [23, 117.5],
      [26, 142.5],
      [29, 145.5],
      [32, 104.5],
      [35, 131.5],
      [38, 144.875],
      [41, 124.5],
      [44, 144.1054],
      [47, 108.5],
      [50, 131.5],
      [53, 135.5],
      [56, 144.5],
      [59, 134.5],
      [62, 137.5],
      [65, 134.5],
      [68, 108.5],
      [71, 117.5],
      [74, 129.5],
      [77, 128.5],
      [80, 126.5],
      [83, 119.5],
      [86, 138.5],
      [89, 143.5],
      [92, 107.5],
      [95, 133.5],
      [98, 122.5],
      [101, 125.5],
      [104, 128.5],
      [107, 116.5],
      [110, 119.5],
      [113, 141.5],
      [116, 133.5],
      [119, 140.5],
      [122, 125.5],
      [125, 134.5],
      [128, 99.5],
      [131, 110.5],
      [134, 123.5],
      [137, 105.5],
      [140, 131.5],
      [143, 124.5],
      [146, 136.5],
      [149, 145.5],
      [152, 112.5],
      [155, 117.5],
      [158, 130.5],
      [161, 121.5],
      [164, 133.5],
      [167, 98.5],
      [170, 126.5],
      [173, 141.5],
      [176, 128.5],
      [179, 135.5],
      [182, 119.5],
      [185, 123.5],
      [188, 143.5],
      [191, 108.5],
      [194, 108.5],
      [197, 100.5],
      [200, 136.5],
      [203, 118.5],
      [206, 121.5],
      [209, 141.5],
      [212, 103.5],
      [215, 123.5],
      [218, 134.5],
      [221, 114.5],
      [224, 127.5],
      [227, 128.5],
      [230, 127.5],
      [233, 134.5],
      [236, 112.5],
      [239, 121.5],
      [242, 133.5],
      [245, 126.5],
      [248, 134.5],
      [251, 114.5],
      [254, 107.5],
      [257, 105.5],
      [260, 131.5],
      [263, 137.5],
      [266, 115.5],
      [269, 118.5],
      [272, 109.5],
      [275, 142.5],
      [278, 134.5],
      [281, 119.5],
      [284, 116.5],
      [287, 114.5],
      [290, 109.5],
      [293, 140.5],
      [296, 118.5],
      [299, 108.5],
      [302, 120.5],
      [305, 127.5],
      [308, 135.5],
      [311, 106.5],
      [314, 122.5],
      [317, 111.5],
      [320, 127.5],
      [323, 118.5],
      [326, 125.5],
      [329, 120.5],
      [332, 113.5],
      [335, 129.5],
      [338, 129.5],
      [341, 121.5],
      [344, 108.5],
      [347, 103.5],
      [350, 139.5],
      [353, 131.5],
      [356, 113.5],
      [359, 114.5],
      [362, 113.5],
      [365, 132.5],
      [368, 90.5],
      [371, 110.5],
      [374, 121.5],
      [377, 131.5],
      [380, 135.5],
      [383, 121.5],
      [386, 123.5],
      [389, 123.5],
      [392, 114.5],
      [395, 130.5],
      [398, 126.5],
      [401, 106.5],
      [404, 100.5],
      [407, 110.5],
      [410, 133.5],
      [413, 126.5],
      [416, 124.5],
      [419, 107.5],
      [422, 112.5],
      [425, 133.5],
      [428, 131.5],
      [431, 115.5],
      [434, 117.5],
      [437, 119.5],
      [440, 130.5],
      [443, 121.5],
      [446, 132.5],
      [449, 114.5],
      [452, 100.5],
      [455, 124.5],
      [458, 118.5],
      [461, 107.5],
      [464, 98.5],
      [467, 102.5],
      [470, 122.5],
      [473, 127.5],
      [476, 113.5],
      [479, 123.5],
      [482, 105.5],
      [485, 118.5],
      [488, 123.5],
      [491, 101.5],
      [494, 108.5],
      [497, 103.5],
      [500, 127.5],
      [503, 121.5],
      [506, 111.5],
      [509, 113.5],
      [512, 95.5],
      [515, 121.5],
      [518, 122.5],
      [521, 103.5],
      [524, 113.5],
      [527, 112.5],
      [530, 116.5],
      [533, 138.5],
      [536, 119.5],
      [539, 117.5],
      [542, 117.5],
      [545, 117.5],
      [548, 106.5],
      [551, 100.5],
      [554, 110.5],
      [557, 128.5],
      [560, 130.5],
      [563, 136.5],
      [566, 121.5],
      [569, 130.5],
      [572, 100.5],
      [575, 134.5],
      [578, 141.5],
      [581, 115.5],
      [584, 115.5],
      [587, 113.5],
      [590, 136.5],
      [593, 129.5],
      [596, 125.5],
      [599, 118.5],
      [602, 122.5],
      [605, 124.5],
      [608, 117.5],
      [611, 101.5],
      [614, 121.5],
      [617, 103.5],
      [620, 138.5],
      [623, 136.5],
      [626, 117.5],
      [629, 132.5],
      [632, 100.5],
      [635, 120.5],
      [638, 125.5],
      [641, 115.5],
      [644, 122.5],
      [647, 111.5],
      [650, 127.5],
      [653, 122.5],
      [656, 106.5],
      [659, 109.5],
      [662, 120.5],
      [665, 110.5],
      [668, 117.5],
      [671, 120.5],
      [674, 112.5],
      [677, 121.5],
      [680, 128.5],
      [683, 114.5],
      [686, 117.5],
      [689, 119.5],
      [692, 110.5],
      [695, 112.5],
      [698, 107.5],
      [701, 113.5],
      [704, 106.5],
      [707, 89.5],
      [710, 101.5],
      [713, 108.5],
      [716, 95.5],
      [719, 106.5],
      [722, 103.5],
      [725, 112.5],
      [728, 128.5],
      [731, 114.5],
      [734, 108.5],
      [737, 110.5],
      [740, 117.5],
      [743, 117.5],
      [746, 119.5],
      [749, 109.5],
      [752, 111.5],
      [755, 116.5],
      [758, 117.5],
      [761, 126.5],
      [764, 112.5],
      [767, 98.5],
      [770, 126.5],
      [773, 126.5],
      [776, 111.5],
      [779, 121.5],
      [782, 111.5],
      [785, 111.5],
      [788, 104.5],
      [791, 103.5],
      [794, 122.5],
      [797, 113.5],
      [800, 128.5],
      [803, 132.5],
      [806, 111.5],
      [809, 123.5],
      [812, 95.5],
      [815, 117.5],
      [818, 136.5],
      [821, 109.5],
      [824, 123.5],
      [827, 116.5],
      [830, 128.5],
      [833, 124.5],
      [836, 117.5],
      [839, 103.5],
      [842, 123.5],
      [845, 123.5],
      [848, 120.5],
      [851, 119.5],
      [854, 110.5],
      [857, 103.5],
      [860, 128.5],
      [863, 132.5],
      [866, 121.5],
      [869, 115.5],
      [872, 102.5],
      [875, 129.5],
      [878, 125.5],
      [881, 130.5],
      [884, 119.5],
      [887, 120.5],
      [890, 128.5],
      [893, 112.5],
      [896, 113.5],
      [899, 114.5],
      [902, 112.5],
      [905, 115.5],
      [908, 117.5],
      [911, 115.5],
      [914, 108.5],
      [917, 117.5],
      [920, 125.5],
      [923, 112.5],
      [926, 122.5],
      [929, 127.5],
      [932, 105.5],
      [935, 110.5],
      [938, 102.5],
      [941, 109.5],
      [944, 107.5],
      [947, 100.5],
      [950, 115.5],
      [953, 106.5],
      [956, 106.5],
      [959, 105.5],
      [962, 107.5],
      [965, 120.5],
      [968, 107.5],
      [971, 109.5],
      [974, 117.5],
      [977, 108.5],
      [980, 131.5],
      [983, 114.5],
      [986, 102.5],
      [989, 111.5],
      [992, 115.5],
      [995, 110.5],
      [998, 111.5],
      [1001, 121.5],
      [1004, 116.5],
      [1007, 111.5],
      [1010, 128.5],
      [1013, 123.5],
      [1016, 120.5],
      [1019, 126.5],
      [1022, 115.5],
      [1025, 127.5],
      [1028, 126.5],
      [1031, 110.5],
      [1034, 107.5],
      [1037, 106.5],
      [1040, 129.5],
      [1043, 111.5],
      [1046, 105.5],
      [1049, 127.5],
      [1052, 102.5],
      [1055, 125.5],
      [1058, 129.5],
      [1061, 105.5],
      [1064, 121.5],
      [1067, 105.5],
      [1070, 128.5],
      [1073, 125.5],
      [1076, 106.5],
      [1079, 121.5],
      [1082, 121.5],
      [1085, 126.5],
      [1088, 120.5],
      [1091, 104.5],
      [1094, 111.5],
      [1097, 103.5],
      [1100, 120.5],
      [1103, 122.5],
      [1106, 111.5],
      [1109, 122.5],
      [1112, 101.5],
      [1115, 128.5],
      [1118, 129.5],
      [1121, 108.5],
      [1124, 112.5],
      [1127, 102.5],
      [1130, 118.5],
      [1133, 126.5],
      [1136, 117.5],
      [1139, 108.5],
      [1142, 113.5],
      [1145, 118.5],
      [1148, 125.5],
      [1151, 100.5],
      [1154, 109.5],
      [1157, 108.5],
      [1160, 121.5],
      [1163, 111.5],
      [1166, 111.5],
      [1169, 110.5],
      [1172, 95.5],
      [1175, 115.5],
      [1178, 136.5],
      [1181, 104.5],
      [1184, 107.5],
      [1187, 92.5],
      [1190, 105.5],
      [1193, 118.5],
      [1196, 119.5],
      [1199, 120.5],
      [1202, 100.5],
      [1205, 121.5],
      [1208, 118.5],
      [1211, 97.5],
      [1214, 107.5],
      [1217, 99.5],
      [1220, 107.5],
      [1223, 113.5],
      [1226, 115.5],
      [1229, 109.5],
      [1232, 113.5],
      [1235, 121.5],
      [1238, 126.5],
      [1241, 110.5],
      [1244, 124.5],
      [1247, 97.5],
      [1250, 107.5],
      [1253, 127.5],
      [1256, 104.5],
      [1259, 105.5],
      [1262, 120.5],
      [1265, 128.5],
      [1268, 123.5],
      [1271, 121.5],
      [1274, 123.5],
      [1277, 117.5],
      [1280, 132.5],
      [1283, 127.5],
      [1286, 121.5],
      [1289, 124.5],
      [1292, 97.5],
      [1295, 119.5],
      [1298, 123.5],
      [1301, 107.5],
      [1304, 120.5],
      [1307, 106.5],
      [1310, 127.5],
      [1313, 125.5],
      [1316, 119.5],
      [1319, 107.5],
      [1322, 117.5],
      [1325, 126.5],
      [1328, 126.5],
      [1331, 102.5],
      [1334, 108.5],
      [1337, 98.5],
      [1340, 117.5],
      [1343, 125.5],
      [1346, 100.5],
      [1349, 123.5],
      [1352, 99.5],
      [1355, 126.5],
      [1358, 124.5],
      [1361, 114.5],
      [1364, 113.5],
      [1367, 108.5],
      [1370, 104.5],
      [1373, 123.5],
      [1376, 101.5],
      [1379, 107.5],
      [1382, 118.5],
      [1385, 117.5],
      [1388, 123.5],
      [1391, 107.5],
      [1394, 111.5],
      [1397, 104.5],
      [1400, 117.5],
      [1403, 114.5],
      [1406, 101.5],
      [1409, 112.5],
      [1412, 89.5],
      [1415, 105.5],
      [1418, 111.5],
      [1421, 103.5],
      [1424, 106.5],
      [1427, 97.5],
      [1430, 137.5],
      [1433, 120.5],
      [1436, 116.5],
      [1439, 102.5],
      [1442, 107.5],
      [1445, 116.5],
      [1448, 116.5],
      [1451, 111.5],
      [1454, 108.5],
      [1457, 108.5],
      [1460, 124.5],
      [1463, 121.5],
      [1466, 111.5],
      [1469, 103.5],
      [1472, 106.5],
      [1475, 117.5],
      [1478, 126.5],
      [1481, 111.5],
      [1484, 119.5],
      [1487, 113.5],
      [1490, 107.5],
      [1493, 121.5],
      [1496, 108.5],
      [1499, 105.5],
      [1502, 100.5],
      [1505, 123.5],
      [1508, 114.5],
      [1511, 121.5],
      [1514, 112.5],
      [1517, 103.5],
      [1520, 111.5],
      [1523, 95.5],
      [1526, 92.5],
      [1529, 86.5],
      [1532, 86.5],
      [1535, 79.5],
      [1538, 76.5],
      [1541, 76.5],
      [1544, 76.5],
      [1547, 75.5],
      [1550, 75.5],
    ],
    bottom: [
      [1548, 75.5],
      [1545, 74.5],
      [1542, 74.5],
      [1539, 74.5],
      [1536, 73.5],
      [1533, 67.5],
      [1530, 59.5],
      [1527, 59.5],
      [1524, 51.5],
      [1521, 36.5],
      [1518, 26.5],
      [1515, 31.5],
      [1512, 37.5],
      [1509, 36.5],
      [1506, 32.5],
      [1503, 36.5],
      [1500, 28.5],
      [1497, 41.5],
      [1494, 47.5],
      [1491, 33.5],
      [1488, 27.5],
      [1485, 31.5],
      [1482, 45.5],
      [1479, 27.5],
      [1476, 42.5],
      [1473, 32.5],
      [1470, 28.5],
      [1467, 38.5],
      [1464, 43.5],
      [1461, 40.5],
      [1458, 28.5],
      [1455, 35.5],
      [1452, 37.5],
      [1449, 46.5],
      [1446, 45.5],
      [1443, 30.5],
      [1440, 29.5],
      [1437, 48.5],
      [1434, 37.5],
      [1431, 35.5],
      [1428, 33.5],
      [1425, 36.5],
      [1422, 52.5],
      [1419, 48.5],
      [1416, 51.5],
      [1413, 41.5],
      [1410, 51.5],
      [1407, 50.5],
      [1404, 52.5],
      [1401, 47.5],
      [1398, 29.5],
      [1395, 30.5],
      [1392, 46.5],
      [1389, 40.5],
      [1386, 41.5],
      [1383, 32.5],
      [1380, 17.5],
      [1377, 49.5],
      [1374, 51.5],
      [1371, 43.5],
      [1368, 43.5],
      [1365, 31.5],
      [1362, 39.5],
      [1359, 37.5],
      [1356, 30.5],
      [1353, 25.5],
      [1350, 38.5],
      [1347, 52.5],
      [1344, 38.5],
      [1341, 42.5],
      [1338, 25.5],
      [1335, 25.5],
      [1332, 50.5],
      [1329, 13.5],
      [1326, 45.5],
      [1323, 28.5],
      [1320, 22.5],
      [1317, 50.5],
      [1314, 37.5],
      [1311, 42.5],
      [1308, 29.5],
      [1305, 26.5],
      [1302, 41.5],
      [1299, 41.5],
      [1296, 37.5],
      [1293, 26.5],
      [1290, 40.5],
      [1287, 55.5],
      [1284, 38.5],
      [1281, 33.5],
      [1278, 16.5],
      [1275, 25.5],
      [1272, 42.5],
      [1269, 23.5],
      [1266, 39.5],
      [1263, 25.5],
      [1260, 29.5],
      [1257, 44.5],
      [1254, 41.5],
      [1251, 49.5],
      [1248, 27.5],
      [1245, 23.5],
      [1242, 29.5],
      [1239, 38.5],
      [1236, 44.5],
      [1233, 36.5],
      [1230, 16.5],
      [1227, 48.5],
      [1224, 32.5],
      [1221, 46.5],
      [1218, 27.5],
      [1215, 31.5],
      [1212, 56.5],
      [1209, 31.5],
      [1206, 50.5],
      [1203, 37.5],
      [1200, 36.5],
      [1197, 48.5],
      [1194, 44.5],
      [1191, 51.5],
      [1188, 50.5],
      [1185, 35.5],
      [1182, 45.5],
      [1179, 37.5],
      [1176, 50.5],
      [1173, 42.5],
      [1170, 53.5],
      [1167, 52.5],
      [1164, 37.5],
      [1161, 37.5],
      [1158, 31.5],
      [1155, 28.5],
      [1152, 53.5],
      [1149, 40.5],
      [1146, 38.5],
      [1143, 34.5],
      [1140, 27.5],
      [1137, 52.5],
      [1134, 45.5],
      [1131, 52.5],
      [1128, 26.5],
      [1125, 24.5],
      [1122, 45.5],
      [1119, 34.5],
      [1116, 40.5],
      [1113, 30.5],
      [1110, 21.5],
      [1107, 51.5],
      [1104, 39.5],
      [1101, 42.5],
      [1098, 23.5],
      [1095, 23.5],
      [1092, 50.5],
      [1089, 26.5],
      [1086, 35.5],
      [1083, 21.5],
      [1080, 17.5],
      [1077, 43.5],
      [1074, 40.5],
      [1071, 53.5],
      [1068, 23.5],
      [1065, 23.5],
      [1062, 34.5],
      [1059, 31.5],
      [1056, 38.5],
      [1053, 22.5],
      [1050, 48.5],
      [1047, 59.5],
      [1044, 48.5],
      [1041, 45.5],
      [1038, 22.5],
      [1035, 25.5],
      [1032, 32.5],
      [1029, 17.5],
      [1026, 36.5],
      [1023, 21.5],
      [1020, 24.5],
      [1017, 39.5],
      [1014, 26.5],
      [1011, 27.5],
      [1008, 31.5],
      [1005, 22.5],
      [1002, 32.5],
      [999, 41.5],
      [996, 36.5],
      [993, 40.5],
      [990, 26.5],
      [987, 39.5],
      [984, 28.5],
      [981, 40.5],
      [978, 27.5],
      [975, 35.5],
      [972, 40.5],
      [969, 27.5],
      [966, 37.5],
      [963, 39.5],
      [960, 29.5],
      [957, 45.5],
      [954, 39.5],
      [951, 49.5],
      [948, 44.5],
      [945, 42.5],
      [942, 49.5],
      [939, 40.5],
      [936, 42.5],
      [933, 36.5],
      [930, 24.5],
      [927, 31.5],
      [924, 37.5],
      [921, 28.5],
      [918, 44.5],
      [915, 32.5],
      [912, 33.5],
      [909, 39.5],
      [906, 37.5],
      [903, 36.5],
      [900, 29.5],
      [897, 42.5],
      [894, 35.5],
      [891, 38.5],
      [888, 38.5],
      [885, 27.5],
      [882, 21.5],
      [879, 38.5],
      [876, 19.5],
      [873, 37.5],
      [870, 30.5],
      [867, 38.5],
      [864, 29.5],
      [861, 38.5],
      [858, 33.5],
      [855, 16.5],
      [852, 38.5],
      [849, 25.5],
      [846, 37.5],
      [843, 33.5],
      [840, 23.5],
      [837, 48.5],
      [834, 41.5],
      [831, 51.5],
      [828, 15.5],
      [825, 28.5],
      [822, 27.5],
      [819, 39.5],
      [816, 34.5],
      [813, 24.5],
      [810, 46.5],
      [807, 51.5],
      [804, 29.5],
      [801, 42.5],
      [798, 21.5],
      [795, 26.5],
      [792, 56.5],
      [789, 35.5],
      [786, 31.5],
      [783, 30.5],
      [780, 30.5],
      [777, 35.5],
      [774, 30.5],
      [771, 50.5],
      [768, 49.5],
      [765, 16.5],
      [762, 34.5],
      [759, 31.5],
      [756, 32.5],
      [753, 40.5],
      [750, 32.5],
      [747, 46.5],
      [744, 39.5],
      [741, 32.5],
      [738, 52.5],
      [735, 42.5],
      [732, 36.5],
      [729, 46.5],
      [726, 23.5],
      [723, 32.5],
      [720, 42.5],
      [717, 55.5],
      [714, 46.5],
      [711, 57.5],
      [708, 45.5],
      [705, 51.5],
      [702, 46.5],
      [699, 43.5],
      [696, 44.5],
      [693, 38.5],
      [690, 33.5],
      [687, 40.5],
      [684, 35.5],
      [681, 34.5],
      [678, 38.5],
      [675, 33.5],
      [672, 34.5],
      [669, 40.5],
      [666, 33.5],
      [663, 36.5],
      [660, 33.5],
      [657, 41.5],
      [654, 36.5],
      [651, 40.5],
      [648, 28.5],
      [645, 34.5],
      [642, 46.5],
      [639, 30.5],
      [636, 31.5],
      [633, 30.5],
      [630, 32.5],
      [627, 41.5],
      [624, 28.5],
      [621, 34.5],
      [618, 19.5],
      [615, 13.5],
      [612, 54.5],
      [609, 27.5],
      [606, 45.5],
      [603, 27.5],
      [600, 24.5],
      [597, 42.5],
      [594, 36.5],
      [591, 46.5],
      [588, 26.5],
      [585, 19.5],
      [582, 33.5],
      [579, 36.5],
      [576, 32.5],
      [573, 30.5],
      [570, 39.5],
      [567, 49.5],
      [564, 35.5],
      [561, 30.5],
      [558, 16.5],
      [555, 14.5],
      [552, 59.5],
      [549, 29.5],
      [546, 41.5],
      [543, 23.5],
      [540, 30.5],
      [537, 45.5],
      [534, 45.5],
      [531, 51.5],
      [528, 24.5],
      [525, 21.5],
      [522, 37.5],
      [519, 40.5],
      [516, 39.5],
      [513, 24.5],
      [510, 33.5],
      [507, 50.5],
      [504, 34.5],
      [501, 36.5],
      [498, 22.5],
      [495, 33.5],
      [492, 56.5],
      [489, 21.5],
      [486, 47.5],
      [483, 34.5],
      [480, 30.5],
      [477, 23.5],
      [474, 42.5],
      [471, 39.5],
      [468, 30.5],
      [465, 31.5],
      [462, 42.5],
      [459, 41.5],
      [456, 39.5],
      [453, 32.5],
      [450, 20.5],
      [447, 22.5],
      [444, 36.5],
      [441, 34.5],
      [438, 17.5],
      [435, 27.5],
      [432, 23.5],
      [429, 39.5],
      [426, 6.502399999999994],
      [423, 39.5],
      [420, 21.5],
      [417, 34.5],
      [414, 28.5],
      [411, 20.5],
      [408, 36.5],
      [405, 27.5],
      [402, 39.5],
      [399, 26.5],
      [396, 30.5],
      [393, 17.5],
      [390, 14.5],
      [387, 26.5],
      [384, 22.5],
      [381, 31.5],
      [378, 10.5],
      [375, 11.5],
      [372, 28.5],
      [369, 45.5],
      [366, 40.5],
      [363, 48.5],
      [360, 12.5],
      [357, 32.5],
      [354, 18.5],
      [351, 35.5],
      [348, 16.5],
      [345, 22.5],
      [342, 31.5],
      [339, 31.5],
      [336, 28.5],
      [333, 22.5],
      [330, 16.5],
      [327, 31.5],
      [324, 40.5],
      [321, 28.5],
      [318, 14.5],
      [315, 19.5],
      [312, 52.5],
      [309, 23.5],
      [306, 39.5],
      [303, 19.5],
      [300, 17.5],
      [297, 47.5],
      [294, 29.5],
      [291, 41.5],
      [288, 17.5],
      [285, 31.5],
      [282, 29.5],
      [279, 37.5],
      [276, 33.5],
      [273, 31.5],
      [270, 11.5],
      [267, 43.5],
      [264, 32.5],
      [261, 36.5],
      [258, 22.5],
      [255, 23.5],
      [252, 48.5],
      [249, 22.5],
      [246, 37.5],
      [243, 30.5],
      [240, 20.5],
      [237, 25.5],
      [234, 35.5],
      [231, 42.5],
      [228, 25.5],
      [225, 8.5],
      [222, 24.5],
      [219, 37.5],
      [216, 43.5],
      [213, 12.5],
      [210, 35.5],
      [207, 48.5],
      [204, 23.5],
      [201, 27.5],
      [198, 14.5],
      [195, 19.5],
      [192, 31.5],
      [189, 42.5],
      [186, 40.5],
      [183, 15.5],
      [180, 9.5],
      [177, 40.5],
      [174, 25.5],
      [171, 44.5],
      [168, 26.5],
      [165, 19.5],
      [162, 31.5],
      [159, 33.5],
      [156, 28.5],
      [153, 27.5],
      [150, 6.5],
      [147, 21.5],
      [144, 16.5],
      [141, 38.5],
      [138, 32.5],
      [135, 10.5],
      [132, 56.5],
      [129, 31.5],
      [126, 6.5],
      [123, 34.5],
      [120, 23.5],
      [117, 37.5],
      [114, 40.5],
      [111, 47.5],
      [108, 57.5],
      [105, 25.5],
      [102, 25.5],
      [99, 33.5],
      [96, 39.5],
      [93, 20.5],
      [90, 25.5],
      [87, 31.5],
      [84, 38.5],
      [81, 21.5],
      [78, 29.5],
      [75, 8.5],
      [72, 57.5],
      [69, 24.5],
      [66, 23.5],
      [63, 34.5],
      [60, 9.5],
      [57, 27.5],
      [54, 32.5],
      [51, 47.5],
      [48, 60.5],
      [45, 26.5],
      [42, 24.5],
      [39, 27.5],
      [36, 24.5],
      [33, 19.5],
      [30, 20.5],
      [27, 36.5],
      [24, 15.5],
      [21, 33.5],
      [18, 6.5],
      [15, 10.5],
      [12, 45.5],
      [9, 3.897599999999997],
      [6, 14.5],
      [3, 25.5],
      [0, 45.5],
    ],
  },
]
